/* eslint-disable */
import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An opaque cursor for pagination */
  Cursor: { input: any; output: any; }
  /**
   * A string representing a point in time in an [ISO Format](https://en.wikipedia.org/wiki/ISO_8601)
   *
   *   When providing a `DateInput` argument you can choose from multiple different formats:
   *   - `"yyyy-MM-dd"` for just a Date: e.g. `"2022-05-13"` will be interpreted as May 13th 2022, 00:00:00h _UTC_
   *   - `"yyyy-MM-dd[T]HH:mm"` or `"yyyy-MM-dd HH:mm"` for a date with time: e.g. `"2022-05-13 15:30"` will be interpreted as May 13th 2022, 15:30:00h in our _default timezone Europe/Vienna_, which is 14:30 _UTC_
   *   - `"yyyy-MM-dd[T]HH:mm:ss[Z]"` for a UTC timestamp: e.g. `"2022-05-13T15:30:00Z"` with the Z denoting zero UTC offset will be interpreted as May 13th 2022, 15:30:00h _UTC_
   *   - `"yyyy-MM-dd[T]HH:mm:ss[±]hh:mm"` for a timestamp with an arbitrary UTC offset: e.g. `"2022-05-13T15:30:00+03:00"` for 15:30 Djibouti time (with a 03:00h UTC offset) will be interpreted as May 13th 2022, 15:30:00h _Djibouti time_, which is 12:30 _UTC_
   */
  DateInput: { input: any; output: any; }
  /** A time string representing a day of the year in the format `"MM-dd"` */
  DateMonthDay: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: Date | string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /** A local date string (i.e., with no associated timezone) in `YYYY-MM-DD` format, e.g. `2020-01-01`. */
  LocalDate: { input: any; output: any; }
  /** A string representing time in the format `"HH:mm"` */
  Time: { input: any; output: any; }
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: { input: string; output: string; }
  /** A URL */
  URL: { input: string; output: string; }
};

export type AcceptBookingRequestResponse = BookingRequest | ExpectedErrors;

export type ActivateAutoCommunicationResponse = AutoCommunication | ExpectedErrors;

export type ActivatePenaltyRuleResponse = ExpectedErrors | PenaltyRule;

export type Activity = {
  __typename: 'Activity';
  activityGroup: ActivityGroup;
  appointments: AppointmentConnection;
  availabilitySchedule: Maybe<PrivateSessionAvailabilitySchedule>;
  cancelPeriod: Maybe<Scalars['Int']['output']>;
  cancelPeriodUnit: Maybe<ActivityTimespanUnit>;
  cancellationConditions: Maybe<Scalars['String']['output']>;
  defaultDuration: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  hasTeachersWithoutBookableAvailability: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  internalType: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isTemplate: Scalars['Boolean']['output'];
  maxParticipants: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  participationValue: Maybe<Scalars['Int']['output']>;
  picture: Maybe<Picture>;
  products: ProductConnection;
  registrationEnd: Maybe<Scalars['Int']['output']>;
  registrationEndUnit: Maybe<ActivityTimespanUnit>;
  registrationStart: Maybe<Scalars['Int']['output']>;
  registrationStartUnit: Maybe<ActivityTimespanUnit>;
  resourceCount: Scalars['Int']['output'];
  resources: ActivityResourceConnection;
  roomSharingConfig: Array<ActivityRoomSharingConfig>;
  settings: Maybe<PrivateSessionOfferSettings>;
  sport: Sport;
  type: ActivityType;
  visibility: ActivityVisibility;
};


export type ActivityAppointmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type ActivityProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ActivityResourceCountArgs = {
  types?: InputMaybe<Array<ActivityResourceType>>;
};


export type ActivityResourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<ActivityResourceType>>;
};

export enum ActivityAppointmentStartTime {
  EVERY_10_MINUTES = 'EVERY_10_MINUTES',
  EVERY_15_MINUTES = 'EVERY_15_MINUTES',
  EVERY_30_MINUTES = 'EVERY_30_MINUTES',
  EVERY_HOUR = 'EVERY_HOUR'
}

export enum ActivityBookingType {
  DIRECT = 'DIRECT',
  REQUEST = 'REQUEST'
}

/** A _paginated_ result set of "Activity" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type ActivityConnection = {
  __typename: 'ActivityConnection';
  /** The `Edges` "Activity" items */
  edges: Array<ActivityEdge>;
  /** The actual "Activity" items */
  nodes: Array<Activity>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type ActivityEdge = {
  __typename: 'ActivityEdge';
  cursor: Scalars['Cursor']['output'];
  node: Activity;
};

export type ActivityGroup = {
  __typename: 'ActivityGroup';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  venue: Venue;
};

/** A _paginated_ result set of "ActivityGroup" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type ActivityGroupConnection = {
  __typename: 'ActivityGroupConnection';
  /** The `Edges` "ActivityGroup" items */
  edges: Array<ActivityGroupEdge>;
  /** The actual "ActivityGroup" items */
  nodes: Array<ActivityGroup>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type ActivityGroupEdge = {
  __typename: 'ActivityGroupEdge';
  cursor: Scalars['Cursor']['output'];
  node: ActivityGroup;
};

export enum ActivityPaymentOption {
  ONLINE_ONLY = 'ONLINE_ONLY',
  ONLINE_OR_LATER = 'ONLINE_OR_LATER'
}

export type ActivityResource = Resource | Teacher;

/** A _paginated_ result set of "ActivityResource" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type ActivityResourceConnection = {
  __typename: 'ActivityResourceConnection';
  /** The `Edges` "ActivityResource" items */
  edges: Array<ActivityResourceEdge>;
  /** The actual "ActivityResource" items */
  nodes: Array<ActivityResource>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type ActivityResourceEdge = {
  __typename: 'ActivityResourceEdge';
  cursor: Scalars['Cursor']['output'];
  node: ActivityResource;
};

export enum ActivityResourceType {
  ROOM = 'ROOM',
  TRAINER = 'TRAINER'
}

export type ActivityRoomSharingConfig = {
  __typename: 'ActivityRoomSharingConfig';
  isRoomSharingAllowed: Scalars['Boolean']['output'];
  roomId: Scalars['String']['output'];
};

export enum ActivityTimespanUnit {
  DAYS = 'DAYS',
  HOURS = 'HOURS',
  MINUTES = 'MINUTES',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS'
}

/** A classification into certain common categories of activities */
export enum ActivityType {
  ACTIVITY_TYPE_CAMP = 'ACTIVITY_TYPE_CAMP',
  ACTIVITY_TYPE_CLASS = 'ACTIVITY_TYPE_CLASS',
  ACTIVITY_TYPE_COURSE = 'ACTIVITY_TYPE_COURSE',
  ACTIVITY_TYPE_EDUCATION = 'ACTIVITY_TYPE_EDUCATION',
  ACTIVITY_TYPE_EVENT = 'ACTIVITY_TYPE_EVENT',
  ACTIVITY_TYPE_OPEN_TRAINING = 'ACTIVITY_TYPE_OPEN_TRAINING',
  ACTIVITY_TYPE_PRIVATE = 'ACTIVITY_TYPE_PRIVATE',
  ACTIVITY_TYPE_RENTAL = 'ACTIVITY_TYPE_RENTAL',
  ACTIVITY_TYPE_RETREAT = 'ACTIVITY_TYPE_RETREAT',
  ACTIVITY_TYPE_TRAINING = 'ACTIVITY_TYPE_TRAINING',
  ACTIVITY_TYPE_WORKSHOP = 'ACTIVITY_TYPE_WORKSHOP'
}

export enum ActivityVisibility {
  BOOKABLE = 'BOOKABLE',
  DISPLAY = 'DISPLAY',
  HIDE = 'HIDE'
}

export type Address = {
  __typename: 'Address';
  address: Scalars['String']['output'];
  city: Maybe<Scalars['String']['output']>;
  countryISO: Maybe<Scalars['String']['output']>;
  detail: Maybe<Scalars['String']['output']>;
  municipality: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  street: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export type Aggregator = {
  __typename: 'Aggregator';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  venues: Array<Venue>;
};


export type AggregatorVenuesArgs = {
  companyId: Scalars['String']['input'];
};

export enum AnalyticsGranularity {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY'
}

export type AnalyticsResult = {
  __typename: 'AnalyticsResult';
  timespanValues: Array<TimespanValue>;
  total: Array<TotalValue>;
};

export type Appointment = {
  __typename: 'Appointment';
  activity: Maybe<Activity>;
  assignedFloorPlan: Maybe<AssignedFloorPlan>;
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  cancelledBy: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentTeacher: Maybe<Teacher>;
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  internalNote: Maybe<Scalars['String']['output']>;
  isCancelled: Scalars['Boolean']['output'];
  location: Location;
  maxParticipations: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  participants: CustomerConnection;
  /** The participations, each with the price it was booked at */
  participations: AppointmentParticipationConnection;
  /** The recurring series this appointment belongs to, if any */
  recurringSettings: Maybe<RecurringSettings>;
  room: Maybe<Resource>;
  start: Scalars['DateTime']['output'];
  venue: Venue;
};


export type AppointmentParticipantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<ParticipationState>>;
};


export type AppointmentParticipationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<ParticipationState>>;
};

export type AppointmentConflictResult = {
  __typename: 'AppointmentConflictResult';
  conflicts: Array<ConflictDetail>;
  hasConflicts: Scalars['Boolean']['output'];
};

/** A _paginated_ result set of "Appointment" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type AppointmentConnection = {
  __typename: 'AppointmentConnection';
  /** The `Edges` "Appointment" items */
  edges: Array<AppointmentEdge>;
  /** The actual "Appointment" items */
  nodes: Array<Appointment>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type AppointmentEdge = {
  __typename: 'AppointmentEdge';
  cursor: Scalars['Cursor']['output'];
  node: Appointment;
};

/** A customer signed in to an appointment */
export type AppointmentParticipation = {
  __typename: 'AppointmentParticipation';
  customer: Customer;
  id: Scalars['ID']['output'];
  /** The participation's own price in cents of the venue currency, not that of a linked product. Null if it has none. */
  price: Maybe<Price>;
};

/** A _paginated_ result set of "AppointmentParticipation" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type AppointmentParticipationConnection = {
  __typename: 'AppointmentParticipationConnection';
  /** The `Edges` "AppointmentParticipation" items */
  edges: Array<AppointmentParticipationEdge>;
  /** The actual "AppointmentParticipation" items */
  nodes: Array<AppointmentParticipation>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type AppointmentParticipationEdge = {
  __typename: 'AppointmentParticipationEdge';
  cursor: Scalars['Cursor']['output'];
  node: AppointmentParticipation;
};

export type AppointmentSubstitutionAcceptedResult = {
  __typename: 'AppointmentSubstitutionAcceptedResult';
  appointmentId: Scalars['String']['output'];
};

export type AppointmentSubstitutionFailedResult = {
  __typename: 'AppointmentSubstitutionFailedResult';
  appointmentId: Scalars['String']['output'];
  errorType: SubstitutionErrorType;
};

export type ArchiveActivityResponse = Activity | ExpectedErrors;

export type ArchiveAutoCommunicationResponse = AutoCommunication | ExpectedErrors;

export type ArchiveRentalRuleResponse = ArchivedRentalRule | ExpectedErrors;

/** The rental rule that was archived. */
export type ArchivedRentalRule = {
  __typename: 'ArchivedRentalRule';
  aspect: RentalRuleType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum Area {
  INDOOR = 'INDOOR',
  OUTDOOR = 'OUTDOOR'
}

export type AssignAvailabilityRuleResponse = AssignedCourts | ExpectedErrors;

export type AssignCancellationRuleResponse = AssignedCourts | ExpectedErrors;

export type AssignEligibilityRuleResponse = AssignedCourts | ExpectedErrors;

export type AssignPriceRuleResponse = AssignedCourts | ExpectedErrors;

export type AssignSlotRuleResponse = AssignedCourts | ExpectedErrors;

export type AssignTagResult = {
  __typename: 'AssignTagResult';
  result: Scalars['Boolean']['output'];
};

export type AssignWidgetToOverviewMutationResponse = CompanyWidgetOverview | ExpectedErrors;

export type AssignedBookableSpot = {
  __typename: 'AssignedBookableSpot';
  assignedFloorPlanId: Scalars['String']['output'];
  bookableIcon: Maybe<BookableSpotIconType>;
  customer: Maybe<Customer>;
  id: Scalars['ID']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isPriority: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

/** The courts whose rule assignment changed. */
export type AssignedCourts = {
  __typename: 'AssignedCourts';
  courts: Array<Court>;
};

export type AssignedFloorPlan = {
  __typename: 'AssignedFloorPlan';
  assignedSpotsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  spots: Array<AssignedSpotUnionType>;
  totalBookableSpotsCount: Scalars['Int']['output'];
};

export enum AssignedMembershipSegment {
  ENDED = 'ENDED',
  EXISTING = 'EXISTING',
  NEW = 'NEW',
  OVERALL = 'OVERALL',
  PAUSED = 'PAUSED',
  TERMINATED = 'TERMINATED'
}

export type AssignedNonBookableSpot = {
  __typename: 'AssignedNonBookableSpot';
  assignedFloorPlanId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  nonBookableIcon: NonBookableItemIconType;
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type AssignedProduct = {
  __typename: 'AssignedProduct';
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  type: ProductType;
};

export type AssignedSpotUnionType = AssignedBookableSpot | AssignedNonBookableSpot;

export type AutoCommunication = {
  __typename: 'AutoCommunication';
  audience: Maybe<Scalars['String']['output']>;
  content: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  recipientsCount: Scalars['Int']['output'];
  scheduleAt: Maybe<Scalars['String']['output']>;
  state: AutoCommunicationState;
  trigger: Maybe<Scalars['String']['output']>;
};

/** A _paginated_ result set of "AutoCommunication" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type AutoCommunicationConnection = {
  __typename: 'AutoCommunicationConnection';
  /** The `Edges` "AutoCommunication" items */
  edges: Array<AutoCommunicationEdge>;
  /** The actual "AutoCommunication" items */
  nodes: Array<AutoCommunication>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type AutoCommunicationCounts = {
  __typename: 'AutoCommunicationCounts';
  active: Scalars['Int']['output'];
  archived: Scalars['Int']['output'];
  draft: Scalars['Int']['output'];
  inactive: Scalars['Int']['output'];
};

export type AutoCommunicationEdge = {
  __typename: 'AutoCommunicationEdge';
  cursor: Scalars['Cursor']['output'];
  node: AutoCommunication;
};

export enum AutoCommunicationState {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  INACTIVE = 'INACTIVE'
}

/** A rule answering the availability aspect of court booking: a weekly schedule of bookable hours. */
export type AvailabilityRule = {
  __typename: 'AvailabilityRule';
  /** The courts this rule is assigned to, ordered by name. Archived courts are excluded. Empty if the rule is assigned to no court. */
  assignedCourts: Array<Court>;
  /** When the rule was created. */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  schedule: Array<AvailabilityRuleScheduleEntry>;
  /** When the rule was last modified. Equals `createdAt` until the rule is first edited. */
  updatedAt: Scalars['DateTime']['output'];
};

export type AvailabilityRuleScheduleEntry = {
  __typename: 'AvailabilityRuleScheduleEntry';
  /** Day of week (0-6, Sunday=0) this entry applies to */
  dayOfWeek: Scalars['Int']['output'];
  openingHours: AvailabilityRuleTimeRange;
};

export type AvailabilityRuleScheduleEntryInput = {
  /** Day of week (0-6, Sunday=0) this entry applies to */
  dayOfWeek: Scalars['Int']['input'];
  openingHours: AvailabilityRuleTimeRangeInput;
};

export type AvailabilityRuleTimeRange = {
  __typename: 'AvailabilityRuleTimeRange';
  from: Scalars['Time']['output'];
  /** `00:00` means the end of the day. */
  until: Scalars['Time']['output'];
};

export type AvailabilityRuleTimeRangeInput = {
  from: Scalars['Time']['input'];
  /** `00:00` means the end of the day. */
  until: Scalars['Time']['input'];
};

export type BillingSubscription = {
  __typename: 'BillingSubscription';
  createdAt: Scalars['DateTime']['output'];
  /** Manual override for minimum contract duration (Mindestvertragslaufzeit) for special deals */
  customMinValidUntil: Maybe<Scalars['DateTime']['output']>;
  dueDayOfInterval: Maybe<Scalars['Int']['output']>;
  dueMonth: Maybe<Scalars['Int']['output']>;
  end: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  interval: Maybe<BillingSubscriptionInterval>;
  plan: Maybe<BillingSubscriptionPlan>;
  pricePerInterval: Maybe<Scalars['Int']['output']>;
  /** Historical snapshot of all subscription plans at the time the subscription was created */
  signedPlans: Maybe<Scalars['JSONObject']['output']>;
  start: Maybe<Scalars['DateTime']['output']>;
  state: BillingSubscriptionState;
  title: Scalars['String']['output'];
  type: BillingSubscriptionType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum BillingSubscriptionInterval {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY'
}

export enum BillingSubscriptionPlan {
  ACCELERATE = 'ACCELERATE',
  AGGREGATOR_LIGHT = 'AGGREGATOR_LIGHT',
  CHAMPION = 'CHAMPION',
  FREEMIUM = 'FREEMIUM',
  INFLUENCER = 'INFLUENCER',
  PROFESSIONAL = 'PROFESSIONAL',
  STARTER = 'STARTER'
}

export enum BillingSubscriptionState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum BillingSubscriptionType {
  BASE = 'BASE',
  EXTENSION = 'EXTENSION'
}

export type BookableSpot = {
  __typename: 'BookableSpot';
  bookableIcon: Maybe<BookableSpotIconType>;
  floorPlanId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isPriority: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export enum BookableSpotIconType {
  BOXES = 'BOXES',
  CIRCLE = 'CIRCLE',
  FITNESS_BENCHES = 'FITNESS_BENCHES',
  MATS = 'MATS',
  POLE = 'POLE',
  PUNCHING_BAGS = 'PUNCHING_BAGS',
  REFORMERS = 'REFORMERS',
  ROWING_MACHINES = 'ROWING_MACHINES',
  SKI_ERGOMETERS = 'SKI_ERGOMETERS',
  SPINNING_BICYCLES = 'SPINNING_BICYCLES',
  STEPPERS = 'STEPPERS',
  TREADMILLS = 'TREADMILLS',
  WEIGHTS = 'WEIGHTS'
}

export enum BookingCountSegment {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  LATE_CANCELLED = 'LATE_CANCELLED',
  ON_TIME_CANCELLED = 'ON_TIME_CANCELLED'
}

export type BookingRequest = {
  __typename: 'BookingRequest';
  activity: Activity;
  answers: Array<BookingRequestAnswer>;
  assignedProduct: Maybe<AssignedProduct>;
  declineIndicator: BookingRequestDeclineIndicator;
  end: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Internal note visible to staff who can manage booking requests (max 1000 characters) */
  internalNote: Maybe<Scalars['String']['output']>;
  location: Maybe<Location>;
  name: Scalars['String']['output'];
  requestedAt: Maybe<Scalars['DateTime']['output']>;
  requestedBy: Maybe<Customer>;
  resource: Maybe<Resource>;
  start: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<BookingRequestStatus>;
  suggestedResource: Maybe<Resource>;
  suggestedTeacher: Maybe<Teacher>;
  teacher: Maybe<Teacher>;
};

export type BookingRequestAnswer = {
  __typename: 'BookingRequestAnswer';
  answeredAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  status: BookingRequestAnswerStatus;
};

export enum BookingRequestAnswerStatus {
  ACCEPTED = 'ACCEPTED',
  ACCEPTED_AS_ADMIN = 'ACCEPTED_AS_ADMIN',
  DECLINED = 'DECLINED',
  DECLINED_AS_ADMIN = 'DECLINED_AS_ADMIN'
}

export type BookingRequestConnection = {
  __typename: 'BookingRequestConnection';
  /** The `Edges` "BookingRequest" items */
  edges: Array<BookingRequestEdge>;
  /** The actual "BookingRequest" items */
  nodes: Array<BookingRequest>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum BookingRequestDeclineIndicator {
  ALL_TEACHERS_DECLINED = 'ALL_TEACHERS_DECLINED',
  NO_DECLINE = 'NO_DECLINE',
  PREFERRED_TEACHER_DECLINED = 'PREFERRED_TEACHER_DECLINED',
  YOU_AND_ALL_TEACHERS_DECLINED = 'YOU_AND_ALL_TEACHERS_DECLINED',
  YOU_DECLINED = 'YOU_DECLINED'
}

export type BookingRequestEdge = {
  __typename: 'BookingRequestEdge';
  cursor: Scalars['Cursor']['output'];
  node: BookingRequest;
};

export enum BookingRequestStatus {
  ABORTED = 'ABORTED',
  APPROVED = 'APPROVED',
  CANCELED_BY_CUSTOMER = 'CANCELED_BY_CUSTOMER',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  REQUESTED = 'REQUESTED'
}

export type BookingSetting = {
  __typename: 'BookingSetting';
  notificationReceiver: Maybe<Scalars['String']['output']>;
  notificationReplyTo: Maybe<Scalars['String']['output']>;
};

/** The type of bookings this rate applies to */
export enum BookingType {
  RECURRING = 'RECURRING',
  SINGLE = 'SINGLE'
}

export type BookkeepingAccount = {
  __typename: 'BookkeepingAccount';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** An In App message sent by a venue to several customers at once */
export type Broadcast = {
  __typename: 'Broadcast';
  /** HTML */
  body: Scalars['String']['output'];
  /** Serialized contact filters, as used by customersV3Count */
  filters: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Number of times the broadcast was opened (mocked) */
  openedCount: Scalars['Int']['output'];
  /** Number of recipients that the broadcast reached (mocked) */
  reachedCount: Scalars['Int']['output'];
  /** Number of customers the broadcast was sent to, null until then */
  recipientCount: Maybe<Scalars['Int']['output']>;
  /** When every recipient got the message, null until then */
  sentAt: Maybe<Scalars['DateTime']['output']>;
  state: BroadcastState;
  /** The venue that sent the broadcast */
  venue: Venue;
};

/** A _paginated_ result set of "Broadcast" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type BroadcastConnection = {
  __typename: 'BroadcastConnection';
  /** The `Edges` "Broadcast" items */
  edges: Array<BroadcastEdge>;
  /** The actual "Broadcast" items */
  nodes: Array<Broadcast>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type BroadcastEdge = {
  __typename: 'BroadcastEdge';
  cursor: Scalars['Cursor']['output'];
  node: Broadcast;
};

export enum BroadcastState {
  DRAFT = 'DRAFT',
  FAILED = 'FAILED',
  SENDING = 'SENDING',
  SENT = 'SENT'
}

export type CancelAppointmentResponse = Appointment | ExpectedErrors;

export type CancelRecurringPrivateSessionResponse = CancelRecurringPrivateSessionResult | ExpectedErrors;

export type CancelRecurringPrivateSessionResult = {
  __typename: 'CancelRecurringPrivateSessionResult';
  /** Successfully cancelled appointments */
  cancelledAppointments: Array<Appointment>;
  /** UUIDs of appointments that failed to cancel */
  failedAppointmentIds: Array<Scalars['String']['output']>;
};

/** A rule answering the cancellation aspect of court booking: how long before the booking starts a customer can still cancel for free. */
export type CancellationRule = {
  __typename: 'CancellationRule';
  /** The courts this rule is assigned to, ordered by name. Archived courts are excluded. Empty if the rule is assigned to no court. */
  assignedCourts: Array<Court>;
  /** When the rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** How many hours before the booking starts a customer can still cancel for free. 0 means free cancellation right up to the start. */
  hoursBeforeStart: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** When the rule was last modified. Equals `createdAt` until the rule is first edited. */
  updatedAt: Scalars['DateTime']['output'];
};

export type CancellationRuleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  type: CancellationRuleType;
  unit?: InputMaybe<CancellationRuleUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export enum CancellationRuleType {
  INDIVIDUAL = 'INDIVIDUAL',
  TWENTY_FOUR_HOURS = 'TWENTY_FOUR_HOURS'
}

export enum CancellationRuleUnit {
  DAYS = 'DAYS',
  HOURS = 'HOURS',
  MINUTES = 'MINUTES',
  WEEKS = 'WEEKS'
}

export type CashRegisterUser = {
  __typename: 'CashRegisterUser';
  firstname: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastname: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type City = {
  __typename: 'City';
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Communication = Email | Note | PhoneCall;

/** A _paginated_ result set of "Communication" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type CommunicationConnection = {
  __typename: 'CommunicationConnection';
  /** The `Edges` "Communication" items */
  edges: Array<CommunicationEdge>;
  /** The actual "Communication" items */
  nodes: Array<Communication>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type CommunicationEdge = {
  __typename: 'CommunicationEdge';
  cursor: Scalars['Cursor']['output'];
  node: Communication;
};

export type Company = {
  __typename: 'Company';
  activeActivityTypes: Array<ActivityType>;
  activities: ActivityConnection;
  activityGroups: ActivityGroupConnection;
  address: Address;
  aggregators: Array<Aggregator>;
  appointmentsCountV2: Scalars['Int']['output'];
  appointmentsV2: AppointmentConnection;
  autoCommunications: AutoCommunicationConnection;
  autoCommunicationsCount: AutoCommunicationCounts;
  bookingCount: AnalyticsResult;
  bookkeepingAccounts: Array<BookkeepingAccount>;
  brandedApp: Maybe<CompanyBrandedApp>;
  /** Broadcasts of the company in every state, most recently updated first (Communication extension only) */
  broadcasts: BroadcastConnection;
  city: City;
  conflictingAppointments: AppointmentConflictResult;
  conflictingAppointmentsV2: AppointmentConflictResult;
  contractFileId: Maybe<Scalars['String']['output']>;
  contractFileUrl: Maybe<Scalars['String']['output']>;
  /** Conversations of the company, most recent message first */
  conversations: ConversationConnection;
  customerCount: AnalyticsResult;
  customerGroups: Array<CustomerGroup>;
  customers: CustomerConnection;
  customersV3: CustomersV3Response;
  customersV3Count: Scalars['Int']['output'];
  emailCampaigns: EmailCampaignConnection;
  emailCampaignsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isLtd: Scalars['Boolean']['output'];
  marketplaceHostname: Scalars['String']['output'];
  membershipCount: AnalyticsResult;
  name: Scalars['String']['output'];
  penaltyRules: PenaltyRuleConnection;
  penaltyRulesCount: Scalars['Float']['output'];
  productGroups: ProductGroupConnection;
  products: ProductConnection;
  productsCount: Scalars['Int']['output'];
  recordingCategories: RecordingCategoryConnection;
  referralConfig: Maybe<CompanyReferralConfig>;
  representatives: CompanyRepresentativeConnection;
  /** Retrieve revenue per month for a given set of years */
  revenue: AnalyticsResult;
  settings: Settings;
  sports: SportConnection;
  substitutionsCount: Scalars['Int']['output'];
  substitutionsV2: SubstitutionConnection;
  tags: TagConnection;
  tagsCount: Scalars['Float']['output'];
  taxInformation: TaxInformationUnion;
  teachers: TeacherConnection;
  uniqueContactableCustomersCount: Scalars['Int']['output'];
  utilization: Utilization;
  venues: Array<Venue>;
  viewerIsCompanyAdmin: Scalars['Boolean']['output'];
  widgetBrandSettings: Maybe<CompanyWidgetBrandSettings>;
  widgets: Array<CompanyWidget>;
};


export type CompanyActiveActivityTypesArgs = {
  venueIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type CompanyActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<ActivityType>>;
  venueShortIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type CompanyActivityGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type CompanyAppointmentsCountV2Args = {
  end: Scalars['DateTime']['input'];
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  roomIds?: InputMaybe<Array<Scalars['String']['input']>>;
  start: Scalars['DateTime']['input'];
  trainerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  venueShortId: Scalars['String']['input'];
};


export type CompanyAppointmentsV2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  end: Scalars['DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  roomIds?: InputMaybe<Array<Scalars['String']['input']>>;
  start: Scalars['DateTime']['input'];
  trainerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  venueShortId: Scalars['String']['input'];
};


export type CompanyAutoCommunicationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyBookingCountArgs = {
  bookingCountSegment?: InputMaybe<BookingCountSegment>;
  granularity?: InputMaybe<AnalyticsGranularity>;
  venueShortIds: Array<Scalars['String']['input']>;
  years: Array<Scalars['Float']['input']>;
};


export type CompanyBroadcastsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyConflictingAppointmentsArgs = {
  endTime: Scalars['DateTime']['input'];
  excludeAppointmentId?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['DateTime']['input'];
  teacherId?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyConflictingAppointmentsV2Args = {
  endTime: Scalars['DateTime']['input'];
  excludeAppointmentId?: InputMaybe<Scalars['String']['input']>;
  recurrenceSettings?: InputMaybe<UpdateRecurringAppointmentSettingsInput>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['DateTime']['input'];
  teacherId?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyConversationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyCustomerCountArgs = {
  granularity?: InputMaybe<AnalyticsGranularity>;
  venueShortIds: Array<Scalars['String']['input']>;
  years: Array<Scalars['Float']['input']>;
};


export type CompanyCustomersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: Scalars['Int']['input'];
  segment: CustomerSegment;
  venueShortId?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyCustomersV3Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type CompanyCustomersV3CountArgs = {
  distinct?: Scalars['Boolean']['input'];
  filters?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyEmailCampaignsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};


export type CompanyMembershipCountArgs = {
  assignedMembershipSegment?: InputMaybe<AssignedMembershipSegment>;
  granularity?: InputMaybe<AnalyticsGranularity>;
  venueShortIds: Array<Scalars['String']['input']>;
  years: Array<Scalars['Float']['input']>;
};


export type CompanyPenaltyRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProductGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActivityBasedParticipationRules?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  productGroups?: InputMaybe<Array<ProductGroupFilterInput>>;
  productTypes?: InputMaybe<Array<ProductType>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<ProductState>>;
  venueShortId?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProductsCountArgs = {
  hasActivityBasedParticipationRules?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  productGroups?: InputMaybe<Array<ProductGroupFilterInput>>;
  productTypes?: InputMaybe<Array<ProductType>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<ProductState>>;
  venueShortId?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyRecordingCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type CompanyRepresentativesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<CompanyRepresentativeType>>;
};


export type CompanyRevenueArgs = {
  granularity?: InputMaybe<AnalyticsGranularity>;
  revenueSegment?: InputMaybe<RevenueSegment>;
  venueShortIds: Array<Scalars['String']['input']>;
  years: Array<Scalars['Float']['input']>;
};


export type CompanySportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type CompanySubstitutionsCountArgs = {
  includeNoTeacherAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  range?: InputMaybe<SubstitutionFilterRange>;
  status?: InputMaybe<SubstitutionStatus>;
  statuses?: InputMaybe<Array<SubstitutionStatus>>;
  submittedForTeacherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  venueIds?: InputMaybe<Array<Scalars['String']['input']>>;
  venueShortId: Scalars['String']['input'];
};


export type CompanySubstitutionsV2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeNoTeacherAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  range?: InputMaybe<SubstitutionFilterRange>;
  sort?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<SubstitutionStatus>;
  statuses?: InputMaybe<Array<SubstitutionStatus>>;
  submittedForTeacherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  venueIds?: InputMaybe<Array<Scalars['String']['input']>>;
  venueShortId: Scalars['String']['input'];
};


export type CompanyTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyTeachersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type CompanyUtilizationArgs = {
  granularity?: InputMaybe<AnalyticsGranularity>;
  venueShortIds: Array<Scalars['String']['input']>;
  years: Array<Scalars['Float']['input']>;
};


export type CompanyVenuesArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  venueIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type CompanyWidgetsArgs = {
  types?: InputMaybe<Array<CompanyWidgetType>>;
};

export type CompanyBrandedApp = CompanyBrandedAppInterface & {
  __typename: 'CompanyBrandedApp';
  backgroundColor: Scalars['String']['output'];
  cardBackgroundColor: Scalars['String']['output'];
  cardTextColor: Scalars['String']['output'];
  fontFamily: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoicingVenue: Venue;
  primaryColor: Scalars['String']['output'];
  secondaryColor: Maybe<Scalars['String']['output']>;
  textColor: Scalars['String']['output'];
  widgets: Array<CompanyWidget>;
};

export type CompanyBrandedAppInterface = {
  id: Scalars['ID']['output'];
};

export type CompanyBrandedAppMutationResponse = CompanyBrandedApp | ExpectedErrors;

export type CompanyReferralConfig = {
  __typename: 'CompanyReferralConfig';
  /** Whether refer-a-friend is currently enabled for the provider */
  isActive: Scalars['Boolean']['output'];
  newCustomerDiscountType: Maybe<DiscountType>;
  /** Discount value for the referred customer */
  newCustomerDiscountValue: Maybe<Scalars['Float']['output']>;
  newCustomerRewardType: NewCustomerRewardType;
  referrerDiscountType: Maybe<DiscountType>;
  /** Discount value for the referrer */
  referrerDiscountValue: Maybe<Scalars['Float']['output']>;
  /** Custom thank-you text shown when referrer reward type = message */
  referrerMessage: Maybe<Scalars['String']['output']>;
  referrerRewardType: ReferrerRewardType;
};

export type CompanyRepresentative = {
  __typename: 'CompanyRepresentative';
  id: Scalars['ID']['output'];
  legalName: Scalars['String']['output'];
  location: Location;
  taxNumber: Maybe<Scalars['String']['output']>;
  type: CompanyRepresentativeType;
};

/** A _paginated_ result set of "CompanyRepresentative" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type CompanyRepresentativeConnection = {
  __typename: 'CompanyRepresentativeConnection';
  /** The `Edges` "CompanyRepresentative" items */
  edges: Array<CompanyRepresentativeEdge>;
  /** The actual "CompanyRepresentative" items */
  nodes: Array<CompanyRepresentative>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type CompanyRepresentativeEdge = {
  __typename: 'CompanyRepresentativeEdge';
  cursor: Scalars['Cursor']['output'];
  node: CompanyRepresentative;
};

export enum CompanyRepresentativeType {
  LEGAL = 'LEGAL',
  TAX = 'TAX'
}

export type CompanyWidget = CompanyWidgetActivities | CompanyWidgetActivitySchedule | CompanyWidgetNewsletter | CompanyWidgetOverview | CompanyWidgetPrices | CompanyWidgetVideos | CompanyWidgetVouchers;

export type CompanyWidgetActivities = CompanyWidgetInterface & {
  __typename: 'CompanyWidgetActivities';
  /** @deprecated Deprecated due to the use of activityTypes */
  activityGroups: ActivityGroupConnection;
  activityTypes: Array<ActivityType>;
  colorBackground: Maybe<Scalars['String']['output']>;
  colorBackgroundCard: Maybe<Scalars['String']['output']>;
  colorButton: Maybe<Scalars['String']['output']>;
  colorFont: Maybe<Scalars['String']['output']>;
  colorFontCard: Maybe<Scalars['String']['output']>;
  colorHeading: Maybe<Scalars['String']['output']>;
  defaultEndDate: Maybe<Scalars['DateTime']['output']>;
  defaultStartDate: Maybe<Scalars['DateTime']['output']>;
  defaultVenues: VenueConnection;
  fontFamily: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActivityGroupFilterHidden: Scalars['Boolean']['output'];
  isDateFilterHidden: Scalars['Boolean']['output'];
  isDeletable: Scalars['Boolean']['output'];
  isInOverviewWidget: Scalars['Boolean']['output'];
  isMyBookingsLinkVisible: Scalars['Boolean']['output'];
  isOnlyWidgetOfThisType: Scalars['Boolean']['output'];
  isTrainerFilterHidden: Scalars['Boolean']['output'];
  isVenueFilterHidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  trainers: TeacherConnection;
  widgetPageURL: Scalars['URL']['output'];
};


export type CompanyWidgetActivitiesActivityGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyWidgetActivitiesDefaultVenuesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyWidgetActivitiesTrainersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyWidgetActivitiesWidgetPageUrlArgs = {
  venueId: Scalars['String']['input'];
};

export type CompanyWidgetActivitiesMutationResponse = CompanyWidgetActivities | ExpectedErrors;

export type CompanyWidgetActivitySchedule = CompanyWidgetInterface & {
  __typename: 'CompanyWidgetActivitySchedule';
  colorBackground: Maybe<Scalars['String']['output']>;
  colorButton: Maybe<Scalars['String']['output']>;
  colorFont: Maybe<Scalars['String']['output']>;
  colorFontCard: Maybe<Scalars['String']['output']>;
  defaultActivityGroups: Maybe<ActivityGroupConnection>;
  defaultSports: Maybe<SportConnection>;
  defaultTeachers: Maybe<TeacherConnection>;
  defaultVenues: Maybe<VenueConnection>;
  fontFamily: Maybe<Scalars['String']['output']>;
  groupSchedule: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isActivityGroupFilterHidden: Scalars['Boolean']['output'];
  isDeletable: Scalars['Boolean']['output'];
  isInOverviewWidget: Scalars['Boolean']['output'];
  isMyBookingsLinkVisible: Scalars['Boolean']['output'];
  isOnlyWidgetOfThisType: Scalars['Boolean']['output'];
  isSportFilterHidden: Scalars['Boolean']['output'];
  isTeacherFilterHidden: Scalars['Boolean']['output'];
  isVenueFilterHidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  showCompactViewMobile: Maybe<Scalars['Boolean']['output']>;
  showLevel: Scalars['Boolean']['output'];
  showResource: Scalars['Boolean']['output'];
  showTrainer: Scalars['Boolean']['output'];
  spotLimitDisplayType: Maybe<SpotLimitDisplayType>;
  widgetPageURL: Scalars['URL']['output'];
};


export type CompanyWidgetActivityScheduleDefaultActivityGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyWidgetActivityScheduleDefaultSportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyWidgetActivityScheduleDefaultTeachersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyWidgetActivityScheduleDefaultVenuesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyWidgetActivityScheduleWidgetPageUrlArgs = {
  venueId: Scalars['String']['input'];
};

export type CompanyWidgetActivityScheduleMutationResponse = CompanyWidgetActivitySchedule | ExpectedErrors;

export type CompanyWidgetBrandSettings = {
  __typename: 'CompanyWidgetBrandSettings';
  backgroundColor: Scalars['String']['output'];
  cardBackgroundColor: Scalars['String']['output'];
  cardTextColor: Scalars['String']['output'];
  displayName: Maybe<Scalars['String']['output']>;
  floorPlanBackgroundColor: Maybe<Scalars['String']['output']>;
  fontFamily: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo: Maybe<Picture>;
  primaryColor: Scalars['String']['output'];
  spotBookableBackgroundColor: Maybe<Scalars['String']['output']>;
  spotBookableTextColor: Maybe<Scalars['String']['output']>;
  spotNonBookableBackgroundColor: Maybe<Scalars['String']['output']>;
  spotNonBookableTextColor: Maybe<Scalars['String']['output']>;
  textColor: Scalars['String']['output'];
};

export type CompanyWidgetInterface = {
  id: Scalars['ID']['output'];
  isDeletable: Scalars['Boolean']['output'];
  isInOverviewWidget: Scalars['Boolean']['output'];
  isOnlyWidgetOfThisType: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  widgetPageURL: Scalars['URL']['output'];
};


export type CompanyWidgetInterfaceWidgetPageUrlArgs = {
  venueId: Scalars['String']['input'];
};

export type CompanyWidgetNewsletter = CompanyWidgetInterface & {
  __typename: 'CompanyWidgetNewsletter';
  allowedDomains: Maybe<Array<Scalars['String']['output']>>;
  colorBackground: Maybe<Scalars['String']['output']>;
  colorButton: Maybe<Scalars['String']['output']>;
  colorFont: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  fontFamily: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeletable: Scalars['Boolean']['output'];
  isInOverviewWidget: Scalars['Boolean']['output'];
  isOnlyWidgetOfThisType: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  widgetPageURL: Scalars['URL']['output'];
};


export type CompanyWidgetNewsletterWidgetPageUrlArgs = {
  venueId: Scalars['String']['input'];
};

export type CompanyWidgetNewsletterMutationResponse = CompanyWidgetNewsletter | ExpectedErrors;

export type CompanyWidgetOverview = CompanyWidgetInterface & {
  __typename: 'CompanyWidgetOverview';
  id: Scalars['ID']['output'];
  isDeletable: Scalars['Boolean']['output'];
  isInOverviewWidget: Scalars['Boolean']['output'];
  isOnlyWidgetOfThisType: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  overviewPageURL: Scalars['URL']['output'];
  widgetPageURL: Scalars['URL']['output'];
  widgets: Array<CompanyWidgetInterface>;
};


export type CompanyWidgetOverviewWidgetPageUrlArgs = {
  venueId: Scalars['String']['input'];
};

export type CompanyWidgetPrices = CompanyWidgetInterface & {
  __typename: 'CompanyWidgetPrices';
  colorBackground: Maybe<Scalars['String']['output']>;
  colorBackgroundCard: Maybe<Scalars['String']['output']>;
  colorButton: Maybe<Scalars['String']['output']>;
  colorFont: Maybe<Scalars['String']['output']>;
  colorFontCard: Maybe<Scalars['String']['output']>;
  colorHeading: Maybe<Scalars['String']['output']>;
  fontFamily: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoicingVenue: Venue;
  isDeletable: Scalars['Boolean']['output'];
  isInOverviewWidget: Scalars['Boolean']['output'];
  isMyProductsLinkVisible: Scalars['Boolean']['output'];
  isOnlyWidgetOfThisType: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  productGroups: Maybe<ProductGroupConnection>;
  widgetPageURL: Scalars['URL']['output'];
};


export type CompanyWidgetPricesProductGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyWidgetPricesWidgetPageUrlArgs = {
  venueId: Scalars['String']['input'];
};

export type CompanyWidgetPricesMutationResponse = CompanyWidgetPrices | ExpectedErrors;

export enum CompanyWidgetType {
  COMPANY_WIDGET_TYPE_ACTIVITIES = 'COMPANY_WIDGET_TYPE_ACTIVITIES',
  COMPANY_WIDGET_TYPE_ACTIVITY_SCHEDULE = 'COMPANY_WIDGET_TYPE_ACTIVITY_SCHEDULE',
  COMPANY_WIDGET_TYPE_NEWSLETTER = 'COMPANY_WIDGET_TYPE_NEWSLETTER',
  COMPANY_WIDGET_TYPE_OVERVIEW = 'COMPANY_WIDGET_TYPE_OVERVIEW',
  COMPANY_WIDGET_TYPE_PRICES = 'COMPANY_WIDGET_TYPE_PRICES',
  COMPANY_WIDGET_TYPE_VIDEOS = 'COMPANY_WIDGET_TYPE_VIDEOS',
  COMPANY_WIDGET_TYPE_VOUCHERS = 'COMPANY_WIDGET_TYPE_VOUCHERS'
}

export type CompanyWidgetVideos = CompanyWidgetInterface & {
  __typename: 'CompanyWidgetVideos';
  colorBackground: Maybe<Scalars['String']['output']>;
  colorBackgroundCard: Maybe<Scalars['String']['output']>;
  colorButton: Maybe<Scalars['String']['output']>;
  colorFont: Maybe<Scalars['String']['output']>;
  colorFontCard: Maybe<Scalars['String']['output']>;
  colorHeading: Maybe<Scalars['String']['output']>;
  defaultLanguages: Array<RecordingSupportedLanguage>;
  defaultLevels: Array<RecordingDifficultyLevel>;
  defaultSports: Maybe<SportConnection>;
  defaultTeachers: Maybe<TeacherConnection>;
  defaultVenues: VenueConnection;
  fontFamily: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeletable: Scalars['Boolean']['output'];
  isDurationFilterHidden: Scalars['Boolean']['output'];
  isInOverviewWidget: Scalars['Boolean']['output'];
  isLanguageFilterHidden: Scalars['Boolean']['output'];
  isLevelFilterHidden: Scalars['Boolean']['output'];
  isMyVideosLinkVisible: Scalars['Boolean']['output'];
  isOnlyWidgetOfThisType: Scalars['Boolean']['output'];
  isSportFilterHidden: Scalars['Boolean']['output'];
  isTeacherFilterHidden: Scalars['Boolean']['output'];
  isVenueFilterHidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  recordingCategories: RecordingCategoryConnection;
  widgetPageURL: Scalars['URL']['output'];
};


export type CompanyWidgetVideosDefaultSportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyWidgetVideosDefaultTeachersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyWidgetVideosDefaultVenuesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyWidgetVideosRecordingCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyWidgetVideosWidgetPageUrlArgs = {
  venueId: Scalars['String']['input'];
};

export type CompanyWidgetVideosMutationResponse = CompanyWidgetVideos | ExpectedErrors;

export type CompanyWidgetVouchers = CompanyWidgetInterface & {
  __typename: 'CompanyWidgetVouchers';
  colorBackground: Maybe<Scalars['String']['output']>;
  colorBackgroundCard: Maybe<Scalars['String']['output']>;
  colorButton: Maybe<Scalars['String']['output']>;
  colorFontCard: Maybe<Scalars['String']['output']>;
  fontFamily: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoicingVenue: Venue;
  invoicingVenueId: Scalars['Int']['output'];
  isDeletable: Scalars['Boolean']['output'];
  isInOverviewWidget: Scalars['Boolean']['output'];
  isOnlyWidgetOfThisType: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  widgetPageURL: Scalars['URL']['output'];
};


export type CompanyWidgetVouchersWidgetPageUrlArgs = {
  venueId: Scalars['String']['input'];
};

export type CompanyWidgetVouchersMutationResponse = CompanyWidgetVouchers | ExpectedErrors;

export type ConflictDetail = {
  __typename: 'ConflictDetail';
  appointment: Appointment;
  conflictType: ConflictType;
};

/** The type of scheduling conflict */
export enum ConflictType {
  ROOM_CONFLICT = 'ROOM_CONFLICT',
  TEACHER_CONFLICT = 'TEACHER_CONFLICT'
}

/** The type of consumer eligible for a specific rate */
export enum ConsumerType {
  CUSTOMERGROUP = 'CUSTOMERGROUP',
  DEFAULT = 'DEFAULT',
  GUEST = 'GUEST'
}

export type ContactDetails = {
  __typename: 'ContactDetails';
  email: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
};

export type ContractInformation = {
  __typename: 'ContractInformation';
  /** Number of months the contract automatically renews for */
  autoRenewalPeriodMonths: Scalars['Int']['output'];
  /** Date when the current contract period ends */
  contractEndDate: Scalars['DateTime']['output'];
  /** Date when the contract starts */
  contractStartDate: Scalars['DateTime']['output'];
  /** Custom minimum contract duration (Mindestvertragslaufzeit) for special deals - overrides automatic calculation */
  customMinValidUntil: Maybe<Scalars['DateTime']['output']>;
  /** Contract end date after the next renewal period */
  nextContractEndDate: Scalars['DateTime']['output'];
  /** Number of days notice required before contract end to cancel */
  noticePeriodDays: Scalars['Int']['output'];
  /** How often the subscription is billed (monthly or yearly) */
  paymentFrequency: BillingSubscriptionInterval;
  /** Last day to cancel before auto-renewal (contract end date minus notice period) */
  regularCancellationDeadline: Scalars['DateTime']['output'];
  /** Optional special cancellation period in months from contract start */
  specialCancellationPeriodMonths: Maybe<Scalars['Int']['output']>;
  /** Optional early termination deadline within special cancellation period */
  specialTerminationDate: Maybe<Scalars['DateTime']['output']>;
};

/** A conversation between the company (one of its venues) and a customer. MVP: one-way, the provider sends messages. */
export type Conversation = {
  __typename: 'Conversation';
  customer: Customer;
  id: Scalars['ID']['output'];
  lastMessage: Maybe<ConversationMessage>;
  lastMessageAt: Scalars['DateTime']['output'];
  /** Messages, most recent first */
  messages: ConversationMessageConnection;
  venue: Venue;
};


/** A conversation between the company (one of its venues) and a customer. MVP: one-way, the provider sends messages. */
export type ConversationMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A _paginated_ result set of "Conversation" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type ConversationConnection = {
  __typename: 'ConversationConnection';
  /** The `Edges` "Conversation" items */
  edges: Array<ConversationEdge>;
  /** The actual "Conversation" items */
  nodes: Array<Conversation>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type ConversationEdge = {
  __typename: 'ConversationEdge';
  cursor: Scalars['Cursor']['output'];
  node: Conversation;
};

export type ConversationMessage = {
  __typename: 'ConversationMessage';
  body: Scalars['String']['output'];
  /** When the message was sent */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

/** A _paginated_ result set of "ConversationMessage" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type ConversationMessageConnection = {
  __typename: 'ConversationMessageConnection';
  /** The `Edges` "ConversationMessage" items */
  edges: Array<ConversationMessageEdge>;
  /** The actual "ConversationMessage" items */
  nodes: Array<ConversationMessage>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type ConversationMessageEdge = {
  __typename: 'ConversationMessageEdge';
  cursor: Scalars['Cursor']['output'];
  node: ConversationMessage;
};

export type Court = {
  __typename: 'Court';
  description: Maybe<Scalars['String']['output']>;
  environment: Environment;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The price for this court at the given date and time */
  price: Maybe<Price>;
  /** The pricing rules configured for this court */
  pricingRules: Array<PricingRule>;
  /** The rental rules assigned to this court */
  rentalRules: CourtRentalRules;
  /** The size configuration of this court */
  size: Maybe<Size>;
  sport: Sport;
  /** The surface configuration of this court */
  surface: Maybe<Surface>;
};


export type CourtPriceArgs = {
  date: Scalars['DateTime']['input'];
};

/** A _paginated_ result set of "Court" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type CourtConnection = {
  __typename: 'CourtConnection';
  /** The `Edges` "Court" items */
  edges: Array<CourtEdge>;
  /** The actual "Court" items */
  nodes: Array<Court>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type CourtEdge = {
  __typename: 'CourtEdge';
  cursor: Scalars['Cursor']['output'];
  node: Court;
};

/** A group of `Resource` objects sharing the same courtbooking modality (i.e. same opening hours and rates) */
export type CourtGroup = {
  __typename: 'CourtGroup';
  areas: Array<Area>;
  /** The Courts in this Courtgroup */
  courts: Array<Resource>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The Seasons of this Courtgroup */
  seasons: Array<ValidatedSeason>;
  sports: Array<Sport>;
  surfaces: Array<Scalars['String']['output']>;
};

/** The rental rules assigned to a court, grouped by the aspect of booking they answer. */
export type CourtRentalRules = {
  __typename: 'CourtRentalRules';
  /** The availability rule assigned to this court. Null while the court has none. */
  availability: Maybe<AvailabilityRule>;
  /** The cancellation rule assigned to this court. Null while the court has none. */
  cancellation: Maybe<CancellationRule>;
  /** The eligibility rule assigned to this court. Null while the court has none. */
  eligibility: Maybe<EligibilityRule>;
  /** The price rule assigned to this court. Null while the court has none. */
  price: Maybe<PriceRule>;
  /** The slot rule assigned to this court. Null while the court has none. */
  slot: Maybe<SlotRule>;
};

export type Courts = {
  __typename: 'Courts';
  courts: Array<Court>;
};

export type CreateBrandSettingsResponse = CompanyWidgetBrandSettings | ExpectedErrors;

export type CreateCustomerAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryISO?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerCommunicationInput = {
  /** Direct messages */
  directMessages?: Scalars['Boolean']['input'];
  /** Important updates & information */
  importantUpdates?: Scalars['Boolean']['input'];
  /** Marketing communication */
  marketing?: Scalars['Boolean']['input'];
};

export type CreateCustomerInput = {
  /** Required for company customers */
  address?: InputMaybe<CreateCustomerAddressInput>;
  communication?: InputMaybe<CreateCustomerCommunicationInput>;
  /** Required for company customers */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** ID of the customer group */
  customerGroupId: Scalars['String']['input'];
  customerType?: CustomerType;
  dateOfBirth?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Required to invite the customer */
  email?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  gender?: CustomerGender;
  lastname: Scalars['String']['input'];
  /** Note, visible only to teachers and admins */
  note?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** IDs of existing tags of the company */
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  vatId?: InputMaybe<Scalars['String']['input']>;
  /** Warning, visible only to teachers and admins */
  warning?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerResponse = Customer | ExpectedErrors;

export type CreateLocationArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryISO?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePenaltyRuleResponse = ExpectedErrors | PenaltyRule;

export type CreatePrivateSessionOfferResponse = Activity | ExpectedErrors;

export type CreatePrivateSessionResponse = ExpectedErrors | PrivateSession;

export type CreateRecurringAppointmentResponse = ExpectedErrors | RecurringSettings;

export type CreateReservationResponse = Appointment | ExpectedErrors | RentalViolations;

export type CreateTeacherCalendarIntegrationResponse = ExpectedErrors | TeacherCalendarIntegration;

export enum CreditType {
  INDIVIDUAL = 'INDIVIDUAL',
  STANDARD = 'STANDARD'
}

export type Currency = {
  __typename: 'Currency';
  code: Scalars['String']['output'];
  exchangeRate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type Customer = {
  __typename: 'Customer';
  aggregators: Array<Aggregator>;
  communicationSettings: CustomerCommunicationSettings;
  communications: CommunicationConnection;
  customerGroup: Maybe<Scalars['String']['output']>;
  /** Customer number defined by the venue */
  customerNumber: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstname: Maybe<Scalars['String']['output']>;
  gender: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastEmailSentAt: Maybe<Scalars['DateTime']['output']>;
  lastParticipatedAt: Maybe<Scalars['DateTime']['output']>;
  lastname: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  participationCount: Maybe<Scalars['Float']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  profilePicture: Maybe<Picture>;
  tags: CustomerTagConnection;
  totalParticipationCount: Maybe<Scalars['Float']['output']>;
};


export type CustomerCommunicationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerParticipationCountArgs = {
  isCustomerSegmentsAggregationsEnabled: Scalars['Boolean']['input'];
  segment: CustomerSegment;
};


export type CustomerTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerCommunicationSettings = {
  __typename: 'CustomerCommunicationSettings';
  commercialEnabled: Scalars['Boolean']['output'];
  /** @deprecated deprecated in favour of `hasValidEmail`,`isTempEmail` and `notificationsEnabled` */
  contactable: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated deprecated in favour of `hasValidEmail` */
  hasMail: Scalars['Boolean']['output'];
  hasTempEmail: Scalars['Boolean']['output'];
  hasValidEmail: Scalars['Boolean']['output'];
  notificationsEnabled: Scalars['Boolean']['output'];
};

/** A _paginated_ result set of "Customer" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type CustomerConnection = {
  __typename: 'CustomerConnection';
  /** The `Edges` "Customer" items */
  edges: Array<CustomerEdge>;
  /** The actual "Customer" items */
  nodes: Array<Customer>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type CustomerEdge = {
  __typename: 'CustomerEdge';
  cursor: Scalars['Cursor']['output'];
  node: Customer;
};

export enum CustomerGender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  NOT_SPECIFIED = 'NOT_SPECIFIED'
}

export type CustomerGroup = {
  __typename: 'CustomerGroup';
  /** Hex colour of the group, e.g. #9C27B0 */
  color: Maybe<Scalars['String']['output']>;
  groupPresetType: Maybe<GroupPresetType>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
};

/** The customer field which matched a search term */
export enum CustomerSearchField {
  CUSTOMER_NUMBER = 'CUSTOMER_NUMBER',
  EMAIL = 'EMAIL',
  NAME = 'NAME',
  PHONE = 'PHONE'
}

/** A customer found by a search term */
export type CustomerSearchResult = {
  __typename: 'CustomerSearchResult';
  customer: Customer;
  matchedField: CustomerSearchField;
};

/** A _paginated_ result set of "CustomerSearchResult" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type CustomerSearchResultConnection = {
  __typename: 'CustomerSearchResultConnection';
  /** The `Edges` "CustomerSearchResult" items */
  edges: Array<CustomerSearchResultEdge>;
  /** The actual "CustomerSearchResult" items */
  nodes: Array<CustomerSearchResult>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type CustomerSearchResultEdge = {
  __typename: 'CustomerSearchResultEdge';
  cursor: Scalars['Cursor']['output'];
  node: CustomerSearchResult;
};

export enum CustomerSegment {
  ACTIVE = 'ACTIVE',
  ACTIVE_MEMBERS = 'ACTIVE_MEMBERS',
  NEW_CUSTOMERS = 'NEW_CUSTOMERS',
  NEW_LEADS = 'NEW_LEADS',
  SLIPPING_AWAY = 'SLIPPING_AWAY',
  TERMINATING_MEMBERS = 'TERMINATING_MEMBERS'
}

/** A tag assigned to a customer */
export type CustomerTag = {
  __typename: 'CustomerTag';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** A _paginated_ result set of "CustomerTag" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type CustomerTagConnection = {
  __typename: 'CustomerTagConnection';
  /** The `Edges` "CustomerTag" items */
  edges: Array<CustomerTagEdge>;
  /** The actual "CustomerTag" items */
  nodes: Array<CustomerTag>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type CustomerTagEdge = {
  __typename: 'CustomerTagEdge';
  cursor: Scalars['Cursor']['output'];
  node: CustomerTag;
};

/** A company customer gets the company name on invoices and receipts instead of the customer name */
export enum CustomerType {
  COMPANY = 'COMPANY',
  PERSON = 'PERSON'
}

export type CustomerV3 = {
  __typename: 'CustomerV3';
  communicationSettings: CustomerCommunicationSettings;
  email: Maybe<Scalars['String']['output']>;
  firstname: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastParticipatedAt: Maybe<Scalars['DateTime']['output']>;
  lastname: Maybe<Scalars['String']['output']>;
};

export type CustomerV3Edge = {
  __typename: 'CustomerV3Edge';
  cursor: Scalars['Cursor']['output'];
  node: CustomerV3;
};

export type CustomersV3Response = {
  __typename: 'CustomersV3Response';
  /** The `Edges` "CustomerV3" items */
  edges: Array<CustomerV3Edge>;
  /** The actual "CustomerV3" items */
  nodes: Array<CustomerV3>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type DeactivateAutoCommunicationResponse = AutoCommunication | ExpectedErrors;

export type DeactivatePenaltyRuleResponse = ExpectedErrors | PenaltyRule;

export type DeleteRoomAvailabilityRuleResponse = ExpectedErrors | RoomAvailabilityRule;

/** Types of errors that can occur during substitution deletion */
export enum DeleteSubstitutionErrorType {
  CANNOT_DELETE_COMPLETED_SUBSTITUTION = 'CANNOT_DELETE_COMPLETED_SUBSTITUTION',
  SUBSTITUTION_NOT_FOUND = 'SUBSTITUTION_NOT_FOUND',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  USER_NOT_AUTHORIZED = 'USER_NOT_AUTHORIZED'
}

export type DeleteSubstitutionResult = {
  __typename: 'DeleteSubstitutionResult';
  errorType: Maybe<DeleteSubstitutionErrorType>;
  success: Scalars['Boolean']['output'];
};

export type DeleteTagResult = {
  __typename: 'DeleteTagResult';
  result: Scalars['Boolean']['output'];
};

export enum DeliveryStatus {
  BOUNCE = 'BOUNCE',
  CLICK = 'CLICK',
  COMPLAINT = 'COMPLAINT',
  DELIVERY = 'DELIVERY',
  OPEN = 'OPEN',
  REJECT = 'REJECT',
  SEND = 'SEND'
}

export enum DiscountType {
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE'
}

export type Document = {
  __typename: 'Document';
  url: Scalars['String']['output'];
};

export type DraftMessage = {
  body?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type DuplicateAutoCommunicationResponse = AutoCommunication | ExpectedErrors;

/** Type of e-invoice document (invoice or credit note) */
export enum EInvoiceDocumentType {
  CREDIT_NOTE = 'CREDIT_NOTE',
  INVOICE = 'INVOICE'
}

export type EInvoiceSubmission = {
  __typename: 'EInvoiceSubmission';
  createdAt: Scalars['DateTime']['output'];
  /** Type of e-invoice document (invoice or credit note) */
  documentType: Maybe<EInvoiceDocumentType>;
  /** Error message if submission failed */
  errorMessage: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The invoice submitted */
  invoice: Invoice;
  peppolDocumentId: Maybe<Scalars['ID']['output']>;
  /** Peppol recipient identifier */
  peppolRecipientId: Maybe<Scalars['ID']['output']>;
  /** When the document was sent to the recipient */
  sentAt: Maybe<Scalars['DateTime']['output']>;
  status: EInvoiceSubmissionStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** A _paginated_ result set of "EInvoiceSubmission" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type EInvoiceSubmissionConnection = {
  __typename: 'EInvoiceSubmissionConnection';
  /** The `Edges` "EInvoiceSubmission" items */
  edges: Array<EInvoiceSubmissionEdge>;
  /** The actual "EInvoiceSubmission" items */
  nodes: Array<EInvoiceSubmission>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type EInvoiceSubmissionEdge = {
  __typename: 'EInvoiceSubmissionEdge';
  cursor: Scalars['Cursor']['output'];
  node: EInvoiceSubmission;
};

/** Status of an e-invoice submission */
export enum EInvoiceSubmissionStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

export enum EditorType {
  RICH_TEXT = 'RICH_TEXT',
  UNLAYER = 'UNLAYER'
}

/** A rule answering the eligibility aspect of court booking: who may book the slot. Customers qualify by matching at least one condition — they are OR-ed. */
export type EligibilityRule = {
  __typename: 'EligibilityRule';
  /** The courts this rule is assigned to, ordered by name. Archived courts are excluded. Empty if the rule is assigned to no court. */
  assignedCourts: Array<Court>;
  audience: EligibilityRuleAudience;
  /** Empty unless `audience` is TAGGED_CUSTOMERS. */
  conditions: Array<EligibilityRuleCondition>;
  /** When the rule was created. */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The booking horizon applied regardless of audience. */
  registration: EligibilityRuleRegistrationWindow;
  /** When the rule was last modified. Equals `createdAt` until the rule is first edited. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Who is allowed to book. The three modes are mutually exclusive. */
export enum EligibilityRuleAudience {
  EVERYONE = 'EVERYONE',
  STAFF_ONLY = 'STAFF_ONLY',
  TAGGED_CUSTOMERS = 'TAGGED_CUSTOMERS'
}

/** One authored condition, e.g. "Student OR VIP" or "Senior AND VIP". */
export type EligibilityRuleCondition = {
  __typename: 'EligibilityRuleCondition';
  match: EligibilityRuleTagMatch;
  /** The customer tags this condition matches on. */
  tags: Array<EligibilityRuleTag>;
};

export type EligibilityRuleConditionInput = {
  /** How the tags of this condition combine. */
  match: EligibilityRuleTagMatch;
  /** The uuids of the customer tags this condition matches on. */
  tagIds: Array<Scalars['ID']['input']>;
};

/** The booking horizon: how far ahead of a slot start registration opens and how long before its start it closes. */
export type EligibilityRuleRegistrationInput = {
  /** How long before the slot start registration closes; 0 sets no limit, so a started slot stays bookable. */
  end: EligibilityRuleRegistrationOffsetInput;
  /** How far ahead of the slot start registration opens. */
  start: EligibilityRuleRegistrationOffsetInput;
};

/** A span relative to a slot start, e.g. 14 days. */
export type EligibilityRuleRegistrationOffset = {
  __typename: 'EligibilityRuleRegistrationOffset';
  unit: EligibilityRuleRegistrationUnit;
  value: Scalars['Int']['output'];
};

/** A span relative to a slot start, e.g. 14 days. */
export type EligibilityRuleRegistrationOffsetInput = {
  /** Unit the offset is expressed in. */
  unit: EligibilityRuleRegistrationUnit;
  /** Magnitude of the offset. */
  value: Scalars['Int']['input'];
};

/** The unit a registration offset is expressed in. */
export enum EligibilityRuleRegistrationUnit {
  DAYS = 'DAYS',
  HOURS = 'HOURS',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS'
}

/** The booking horizon of the rule: how far ahead of a slot start registration opens and how long before its start it closes. */
export type EligibilityRuleRegistrationWindow = {
  __typename: 'EligibilityRuleRegistrationWindow';
  /** How long before the slot start registration closes; 0 sets no limit, so a started slot stays bookable. */
  end: EligibilityRuleRegistrationOffset;
  /** How far ahead of the slot start registration opens. */
  start: EligibilityRuleRegistrationOffset;
};

/** A customer tag referenced by an eligibility condition. */
export type EligibilityRuleTag = {
  __typename: 'EligibilityRuleTag';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** How the tags within a single condition combine. */
export enum EligibilityRuleTagMatch {
  ALL = 'ALL',
  ANY = 'ANY'
}

export type Email = {
  __typename: 'Email';
  attachments: Array<EmailAttachment>;
  createdAt: Scalars['DateTime']['output'];
  deliveryEvents: Array<EmailDeliveryEvent>;
  deliveryStatus: Maybe<DeliveryStatus>;
  executedBy: Maybe<User>;
  from: EmailAddress;
  html: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastDeliveryError: Maybe<Scalars['String']['output']>;
  recipient: Maybe<Scalars['String']['output']>;
  sender: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  tag: Scalars['String']['output'];
  text: Maybe<Scalars['String']['output']>;
  to: EmailAddress;
  updatedAt: Scalars['DateTime']['output'];
  via: Maybe<EmailAddress>;
};

export type EmailAddress = {
  __typename: 'EmailAddress';
  address: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type EmailAttachment = {
  __typename: 'EmailAttachment';
  filename: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type EmailCampaign = {
  __typename: 'EmailCampaign';
  body: Maybe<Scalars['String']['output']>;
  editorContent: Maybe<Scalars['String']['output']>;
  editorType: EditorType;
  filters: Maybe<Scalars['String']['output']>;
  from: SenderDetails;
  id: Scalars['ID']['output'];
  recipientCount: Scalars['Int']['output'];
  renderedContent: Maybe<Scalars['String']['output']>;
  replyTo: SenderDetails;
  /** @deprecated Use sendingGroup instead */
  senderGroupId: Maybe<Scalars['String']['output']>;
  sendingGroup: Maybe<SendingGroup>;
  sentAt: Maybe<Scalars['DateTime']['output']>;
  state: Maybe<EmailCampaignState>;
  subject: Maybe<Scalars['String']['output']>;
};

/** A _paginated_ result set of "EmailCampaign" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type EmailCampaignConnection = {
  __typename: 'EmailCampaignConnection';
  /** The `Edges` "EmailCampaign" items */
  edges: Array<EmailCampaignEdge>;
  /** The actual "EmailCampaign" items */
  nodes: Array<EmailCampaign>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type EmailCampaignEdge = {
  __typename: 'EmailCampaignEdge';
  cursor: Scalars['Cursor']['output'];
  node: EmailCampaign;
};

export enum EmailCampaignState {
  DRAFT = 'DRAFT',
  ERROR = 'ERROR',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  SENT = 'SENT'
}

export type EmailDeliveryEvent = {
  __typename: 'EmailDeliveryEvent';
  payload: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  type: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export enum Environment {
  INDOOR = 'INDOOR',
  OUTDOOR = 'OUTDOOR'
}

export type ExpectedError = {
  __typename: 'ExpectedError';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  path: Maybe<Scalars['String']['output']>;
};

export type ExpectedErrors = {
  __typename: 'ExpectedErrors';
  errors: Array<ExpectedError>;
};

export enum ExportType {
  BOOKING = 'BOOKING',
  BOOKING_ACTIVE = 'BOOKING_ACTIVE',
  BOOKING_CANCELLED = 'BOOKING_CANCELLED',
  BOOKING_LATE_CANCELLED = 'BOOKING_LATE_CANCELLED',
  BOOKING_ON_TIME_CANCELLED = 'BOOKING_ON_TIME_CANCELLED',
  CUSTOMER = 'CUSTOMER',
  DOUBLE_ENTRY_REVENUE = 'DOUBLE_ENTRY_REVENUE',
  DOUBLE_ENTRY_REVENUE_PER_TAXACCOUNT = 'DOUBLE_ENTRY_REVENUE_PER_TAXACCOUNT',
  INCOME_EXPENSE_REVENUE = 'INCOME_EXPENSE_REVENUE',
  INCOME_EXPENSE_REVENUE_PER_TAXACCOUNT = 'INCOME_EXPENSE_REVENUE_PER_TAXACCOUNT',
  MEMBERSHIP_ENDED = 'MEMBERSHIP_ENDED',
  MEMBERSHIP_EXISTING = 'MEMBERSHIP_EXISTING',
  MEMBERSHIP_NEW = 'MEMBERSHIP_NEW',
  MEMBERSHIP_OVERALL = 'MEMBERSHIP_OVERALL',
  MEMBERSHIP_OVERALL_GROUPED_BY_MONTH = 'MEMBERSHIP_OVERALL_GROUPED_BY_MONTH',
  MEMBERSHIP_PAUSED = 'MEMBERSHIP_PAUSED',
  MEMBERSHIP_TERMINATED = 'MEMBERSHIP_TERMINATED',
  REFERRAL_INSIGHTS = 'REFERRAL_INSIGHTS',
  UNPAID_REVENUE = 'UNPAID_REVENUE',
  VOUCHER_SALES = 'VOUCHER_SALES',
  VOUCHER_SALES_TRANSACTIONS = 'VOUCHER_SALES_TRANSACTIONS'
}

export type Extension = {
  __typename: 'Extension';
  defaultPercent: Maybe<Scalars['Float']['output']>;
  defaultPrice: Maybe<Scalars['Float']['output']>;
  defaultPriceCap: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: ExtensionName;
  priceType: Scalars['String']['output'];
};

export enum ExtensionName {
  ACCESS_CONTROL = 'ACCESS_CONTROL',
  ACCOUNTING = 'ACCOUNTING',
  ACTIVITIES = 'ACTIVITIES',
  ADDON = 'ADDON',
  ADS_CONVERSION_TRACKING = 'ADS_CONVERSION_TRACKING',
  ADVANCED_ANALYTICS = 'ADVANCED_ANALYTICS',
  AUTOMATED_SEPA = 'AUTOMATED_SEPA',
  BODDY_API = 'BODDY_API',
  BOOKING_CALENDAR = 'BOOKING_CALENDAR',
  BOOKING_INQUIRY = 'BOOKING_INQUIRY',
  BRANDED_APP = 'BRANDED_APP',
  CASH_REGISTER = 'CASH_REGISTER',
  CLASSPASS_API = 'CLASSPASS_API',
  COMMUNICATION = 'COMMUNICATION',
  CONVERSION_TRACKING = 'CONVERSION_TRACKING',
  CUSTOMERS = 'CUSTOMERS',
  DATEV_API = 'DATEV_API',
  EGYM_API = 'EGYM_API',
  EINVOICING_BELGIUM = 'EINVOICING_BELGIUM',
  FISCALIZATION_ITALY = 'FISCALIZATION_ITALY',
  FISCAL_COMPLIANCE_SPAIN = 'FISCAL_COMPLIANCE_SPAIN',
  GROUPS = 'GROUPS',
  HELLOCASH_API = 'HELLOCASH_API',
  INVENTORY_MANAGEMENT = 'INVENTORY_MANAGEMENT',
  KOACHER_API = 'KOACHER_API',
  LIGHT_CONTROL = 'LIGHT_CONTROL',
  MAILCHIMP_INTEGRATION = 'MAILCHIMP_INTEGRATION',
  MARKETING = 'MARKETING',
  MYCLUBS_API = 'MYCLUBS_API',
  MYFITNESSCARD_API = 'MYFITNESSCARD_API',
  NF525 = 'NF525',
  OFFISY_API = 'OFFISY_API',
  ONEFIT_API = 'ONEFIT_API',
  PAYROLL = 'PAYROLL',
  PENALTIES = 'PENALTIES',
  PRIVATE_SESSIONS = 'PRIVATE_SESSIONS',
  PROVIDER_API = 'PROVIDER_API',
  SEAMLESS_ONLINE_ACTIVITY_STREAMING = 'SEAMLESS_ONLINE_ACTIVITY_STREAMING',
  SELF_CHECK_IN = 'SELF_CHECK_IN',
  SEPA_XML = 'SEPA_XML',
  SPOT_BOOKING = 'SPOT_BOOKING',
  STOCK = 'STOCK',
  SUBSTITUTION_MANAGEMENT = 'SUBSTITUTION_MANAGEMENT',
  THIRD_PARTY_ONLINE_ACTIVITY_STREAMING = 'THIRD_PARTY_ONLINE_ACTIVITY_STREAMING',
  TSE_GERMANY = 'TSE_GERMANY',
  USC_API = 'USC_API',
  VIDEO_RECORDING = 'VIDEO_RECORDING',
  WELLHUB_API = 'WELLHUB_API',
  WORKIT_API = 'WORKIT_API',
  ZENSPOTTING_API = 'ZENSPOTTING_API',
  ZOOM_INTEGRATION = 'ZOOM_INTEGRATION'
}

export type FeaturePreview = {
  __typename: 'FeaturePreview';
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  on: Scalars['Boolean']['output'];
  rolloutPercentage: Scalars['Int']['output'];
};

export type File = {
  __typename: 'File';
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  path: Scalars['String']['output'];
  url: FileUrl;
};

export type FileUploadRequest = {
  __typename: 'FileUploadRequest';
  fields: Scalars['JSONObject']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FileUrl = Document | Picture;

export type FilterWithConfidence = {
  __typename: 'FilterWithConfidence';
  confidence: Scalars['Float']['output'];
  filter: Scalars['JSON']['output'];
  matchedEntities: Maybe<Array<Scalars['String']['output']>>;
};

export type FiscalizationSoftwareInformation = {
  __typename: 'FiscalizationSoftwareInformation';
  license: Scalars['String']['output'];
  name: Scalars['String']['output'];
  responsibilityDeclaration: Maybe<Scalars['String']['output']>;
  softwareCompany: SoftwareCompany;
  version: Scalars['String']['output'];
};

export type FloorPlan = {
  __typename: 'FloorPlan';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  numberOfAssignedFloorPlans: Scalars['Int']['output'];
  spots: Array<SpotUnionType>;
};

/** A _paginated_ result set of "FloorPlan" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type FloorPlanConnection = {
  __typename: 'FloorPlanConnection';
  /** The `Edges` "FloorPlan" items */
  edges: Array<FloorPlanEdge>;
  /** The actual "FloorPlan" items */
  nodes: Array<FloorPlan>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type FloorPlanEdge = {
  __typename: 'FloorPlanEdge';
  cursor: Scalars['Cursor']['output'];
  node: FloorPlan;
};

export type GenerateQuicksightAnalyticsEmbedUrl = {
  __typename: 'GenerateQuicksightAnalyticsEmbedUrl';
  embedUrl: Scalars['String']['output'];
};

export type GenerateQuicksightAnalyticsEmbedUrlResult = ExpectedErrors | GenerateQuicksightAnalyticsEmbedUrl;

export type GenerateTaxAgreementResult = {
  __typename: 'GenerateTaxAgreementResult';
  /** Base64 encoded PDF content */
  pdfBase64: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GenericTaxInformation = {
  __typename: 'GenericTaxInformation';
  /** Tax identification number of the company */
  tin: Maybe<Scalars['String']['output']>;
};

export type GoogleAdsConfiguration = {
  __typename: 'GoogleAdsConfiguration';
  conversionActionId: Maybe<Scalars['String']['output']>;
  /** When the saved refresh token stops being valid (beta-only: tokens issued while the OAuth consent screen is in Google testing status expire after 7 days) */
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  googleAdsAccountId: Maybe<Scalars['String']['output']>;
  /** Whether a Google Ads refresh token is still active for this provider */
  isAccountConnected: Scalars['Boolean']['output'];
};

export enum GroupPresetType {
  EXTERNALS = 'EXTERNALS',
  GUESTS = 'GUESTS'
}

export type HidePrivateSessionFromCalendarResponse = Appointment | ExpectedErrors;

export type HideRecurringPrivateSessionFromCalendarResponse = ExpectedErrors | HideRecurringPrivateSessionFromCalendarResult;

export type HideRecurringPrivateSessionFromCalendarResult = {
  __typename: 'HideRecurringPrivateSessionFromCalendarResult';
  /** UUIDs of appointments that failed to hide */
  failedAppointmentIds: Array<Scalars['String']['output']>;
  /** Successfully hidden appointments */
  hiddenAppointments: Array<Appointment>;
};

export enum ImportRunState {
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  FAILED = 'FAILED',
  RUNNING = 'RUNNING'
}

export enum ImportUploadState {
  COMPLETED = 'COMPLETED',
  INVALID = 'INVALID',
  PREPARED = 'PREPARED'
}

export enum IntervalType {
  HOURS = 'HOURS',
  MINUTES = 'MINUTES'
}

export type Invoice = {
  __typename: 'Invoice';
  /** Amount in cents */
  amount: Scalars['Int']['output'];
  comment: Maybe<Scalars['String']['output']>;
  dueAt: Maybe<Scalars['DateTime']['output']>;
  eInvoiceSubmissions: Array<EInvoiceSubmission>;
  id: Scalars['ID']['output'];
  issuedAt: Maybe<Scalars['DateTime']['output']>;
  /** Net amount in cents */
  netAmount: Maybe<Scalars['Int']['output']>;
  number: Maybe<Scalars['Int']['output']>;
  /** Formatted invoice number for display */
  numberFormatted: Maybe<Scalars['String']['output']>;
  /** Amount paid in cents */
  paid: Maybe<Scalars['Int']['output']>;
  recipient: Maybe<InvoiceRecipient>;
  showVat: Maybe<Scalars['Boolean']['output']>;
  type: InvoiceType;
};

/** A _paginated_ result set of "Invoice" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type InvoiceConnection = {
  __typename: 'InvoiceConnection';
  /** The `Edges` "Invoice" items */
  edges: Array<InvoiceEdge>;
  /** The actual "Invoice" items */
  nodes: Array<Invoice>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type InvoiceEdge = {
  __typename: 'InvoiceEdge';
  cursor: Scalars['Cursor']['output'];
  node: Invoice;
};

export type InvoiceRecipient = {
  __typename: 'InvoiceRecipient';
  /** Street address */
  addressLine1: Maybe<Scalars['String']['output']>;
  /** City and postal code */
  addressLine2: Maybe<Scalars['String']['output']>;
  /** Country */
  addressLine3: Maybe<Scalars['String']['output']>;
  /** Customer type (e.g., company, individual) */
  customerType: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  /** Personal/tax identification number (varies by country) */
  fiscalCode: Maybe<Scalars['String']['output']>;
  gender: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  /** French business activity code (NAF/APE) */
  naf: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Name of the person the purchase was made for */
  purchasedForCustomer: Maybe<Scalars['String']['output']>;
  /** French business identification number (SIRET) */
  siret: Maybe<Scalars['String']['output']>;
  telephone: Maybe<Scalars['String']['output']>;
  /** VAT ID */
  vatId: Maybe<Scalars['ID']['output']>;
  /** Postal code */
  zip: Maybe<Scalars['String']['output']>;
};

/** Type of invoice */
export enum InvoiceType {
  BILL = 'BILL',
  REVERSAL = 'REVERSAL'
}

export type Location = {
  __typename: 'Location';
  address: Scalars['String']['output'];
  city: Maybe<Scalars['String']['output']>;
  countryISO: Maybe<Scalars['String']['output']>;
  detail: Maybe<Scalars['String']['output']>;
  hasAppointments: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  municipality: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  street: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

/** A _paginated_ result set of "Location" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type LocationConnection = {
  __typename: 'LocationConnection';
  /** The `Edges` "Location" items */
  edges: Array<LocationEdge>;
  /** The actual "Location" items */
  nodes: Array<Location>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type LocationEdge = {
  __typename: 'LocationEdge';
  cursor: Scalars['Cursor']['output'];
  node: Location;
};

export type LogoFileInput = {
  base64Data?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

export type Me = {
  __typename: 'Me';
  accessibleVenues: Array<Venue>;
  email: Scalars['String']['output'];
  featurePreviews: Array<FeaturePreview>;
  firstname: Scalars['String']['output'];
  /** Create/retrieve Hubspot token for user */
  hubspotToken: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEversportsAdmin: Scalars['Boolean']['output'];
  isTrainer: Scalars['Boolean']['output'];
  lastname: Scalars['String']['output'];
  locale: Maybe<Scalars['String']['output']>;
  profilePicture: Maybe<Picture>;
  quicksightAnalyticsDashboards: Array<QuicksightAnalyticsDashboard>;
};


export type MeFeaturePreviewsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<ProviderFeaturePreview>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MeQuicksightAnalyticsDashboardsArgs = {
  shortId: Scalars['String']['input'];
};

export type Message = {
  body: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type Mfa = {
  __typename: 'Mfa';
  verified: Scalars['Boolean']['output'];
};

/**
 * This type represents any kind of monetary value, such as price or balance.
 * It is a combination of a `value` in cents, and a `currency` as an
 * [ISO 4217 Currency Code](https://www.xe.com/iso4217.php).
 *
 * ### Example
 *
 * A price of `1, 99 €` will be represented as
 *
 * ```
 * {
 *     value: 199,
 *     currency: "EUR"
 *   }
 * ```
 */
export type MonetaryValue = {
  __typename: 'MonetaryValue';
  currency: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type Mutation = {
  __typename: 'Mutation';
  acceptBookingRequest: AcceptBookingRequestResponse;
  acceptSubstitutionRequest: SubstitutionRequestResult;
  activateAutoCommunication: ActivateAutoCommunicationResponse;
  activatePenaltyRule: ActivatePenaltyRuleResponse;
  addNote: Note;
  addPhoneCall: PhoneCall;
  archiveActivity: ArchiveActivityResponse;
  archiveAutoCommunication: ArchiveAutoCommunicationResponse;
  archiveFloorPlan: Scalars['Boolean']['output'];
  /** Archive a rental rule: it disappears from the venue listing and is unassigned from every court. */
  archiveRentalRule: ArchiveRentalRuleResponse;
  /** Assign an availability rule to courts, replacing whatever each court had before. A court has at most one availability rule; the same rule can apply to many courts. */
  assignAvailabilityRule: AssignAvailabilityRuleResponse;
  /** Assign a cancellation rule to courts, replacing whatever each court had before. A court has at most one cancellation rule; the same rule can apply to many courts. */
  assignCancellationRule: AssignCancellationRuleResponse;
  /** Assign an eligibility rule to courts, replacing whatever each court had before. A court has at most one eligibility rule; the same rule can apply to many courts. */
  assignEligibilityRule: AssignEligibilityRuleResponse;
  /** Assign a price rule to courts, replacing whatever each court had before. A court has at most one price rule; the same rule can apply to many courts. */
  assignPriceRule: AssignPriceRuleResponse;
  /** Assign a slot rule to courts, replacing whatever each court had before. A court has at most one slot rule; the same rule can apply to many courts. */
  assignSlotRule: AssignSlotRuleResponse;
  assignTagsV2: AssignTagResult;
  assignWidgetToOverview: AssignWidgetToOverviewMutationResponse;
  /** Cancel an appointment. Cancels the appointment and updates state. */
  cancelAppointment: CancelAppointmentResponse;
  /** Cancel all future appointments in a recurring private session series */
  cancelRecurringPrivateSession: CancelRecurringPrivateSessionResponse;
  changeOrganization: Maybe<Session>;
  confirmFileUpload: File;
  createActivityGroup: ActivityGroup;
  createCompanyBrandedApp: CompanyBrandedAppMutationResponse;
  createCompanyRepresentative: CompanyRepresentative;
  createCompanyWidgetActivities: CompanyWidgetActivitiesMutationResponse;
  createCompanyWidgetActivitySchedule: CompanyWidgetActivityScheduleMutationResponse;
  createCompanyWidgetBrandSettings: CompanyWidgetBrandSettings;
  createCompanyWidgetBrandSettingsV2: CreateBrandSettingsResponse;
  createCompanyWidgetNewsletter: CompanyWidgetNewsletterMutationResponse;
  createCompanyWidgetPrices: CompanyWidgetPricesMutationResponse;
  createCompanyWidgetVideos: CompanyWidgetVideosMutationResponse;
  createCompanyWidgetVouchers: CompanyWidgetVouchersMutationResponse;
  /** Create a customer (person or company) of the venue, e.g. to assign it to a private session */
  createCustomer: CreateCustomerResponse;
  createFloorPlan: FloorPlan;
  createPenaltyRule: CreatePenaltyRuleResponse;
  /** Creates a period with rates */
  createPeriod: PeriodMutationResult;
  createPrivateSession: CreatePrivateSessionResponse;
  createPrivateSessionOffer: CreatePrivateSessionOfferResponse;
  /** Create a new recurring appointment series with all appointment instances */
  createRecurringAppointment: CreateRecurringAppointmentResponse;
  /** Reserve a court, either to rent it out or to close it off. */
  createReservation: CreateReservationResponse;
  createSeason: SeasonMutationResult;
  createSubstitutionRequestFromExisting: SubstitutionRequest;
  createSubstitutionRequestV2: SubstitutionRequest;
  createTag: Tag;
  createTeacherCalendarIntegration: CreateTeacherCalendarIntegrationResponse;
  deactivateAutoCommunication: DeactivateAutoCommunicationResponse;
  deactivatePenaltyRule: DeactivatePenaltyRuleResponse;
  declineBookingRequest: BookingRequest;
  declineSubstitutionRequest: SubstitutionRequestResult;
  deleteCompanyRepresentative: CompanyRepresentative;
  deleteCompanyWidget: Scalars['Boolean']['output'];
  deleteDefaultTeacherAvailabilitySchedules: Scalars['Boolean']['output'];
  deleteEmailCampaign: Scalars['Boolean']['output'];
  deleteEmailCampaigns: Scalars['Boolean']['output'];
  deletePrivateSessionDaySpecificAvailability: Scalars['Boolean']['output'];
  deleteRoomAvailabilityRule: DeleteRoomAvailabilityRuleResponse;
  deleteSpot: Scalars['Boolean']['output'];
  deleteSubstitution: DeleteSubstitutionResult;
  deleteTag: DeleteTagResult;
  deleteTeacherCalendarIntegration: Scalars['Boolean']['output'];
  deleteTeacherDaySpecificAvailability: Scalars['Boolean']['output'];
  duplicateAutoCommunication: DuplicateAutoCommunicationResponse;
  duplicateEmailCampaignAsDraft: EmailCampaign;
  export: Scalars['Boolean']['output'];
  exportTechnicalEventLog: Scalars['Boolean']['output'];
  generateCustomerFiltersFromText: TextToCustomerFiltersResponse;
  generateQuicksightAnalyticsEmbedUrl: GenerateQuicksightAnalyticsEmbedUrlResult;
  generateTaxAgreement: GenerateTaxAgreementResult;
  generateToken: VenueImportToken;
  generateUnlayerTemplate: UnlayerTemplateOutput;
  generateVenueCommunication: RichTextOutput;
  /** Hide a cancelled private session from the calendar. Only works on already cancelled appointments. */
  hidePrivateSessionFromCalendar: HidePrivateSessionFromCalendarResponse;
  /** Hide all future cancelled appointments in a recurring private session series from the calendar. */
  hideRecurringPrivateSessionFromCalendar: HideRecurringPrivateSessionFromCalendarResponse;
  login: Maybe<Session>;
  logout: Scalars['Boolean']['output'];
  makeCourtUnavailable: Scalars['Boolean']['output'];
  maskerade: Maybe<Session>;
  publishFloorPlan: Scalars['Boolean']['output'];
  recoverMfa: Maybe<Session>;
  removeNote: Scalars['Boolean']['output'];
  /** Removes a Period and all its rates from a Season of a Courtgroup */
  removePeriod: Scalars['Boolean']['output'];
  removePhoneCall: Scalars['Boolean']['output'];
  removeSeason: Scalars['Boolean']['output'];
  requestFileUpload: FileUploadRequest;
  requestPasswordReset: Scalars['Boolean']['output'];
  resendCommunication: Scalars['Boolean']['output'];
  resetPassword: Scalars['Boolean']['output'];
  saveAutoCommunication: SaveAutoCommunicationResponse;
  saveAvailabilityRule: SaveAvailabilityRuleResponse;
  /** Saves an In App message as a draft: creates it, or updates it when an id is passed. It is only sent with sendBroadcast */
  saveBroadcast: SaveBroadcastResponse;
  saveCancellationRule: SaveCancellationRuleResponse;
  saveCompanyReferralConfig: SaveCompanyReferralConfigResponse;
  saveCourts: SaveCourtsResponse;
  saveDefaultPrivateSessionAvailabilitySchedule: SaveDefaultPrivateSessionAvailabilityScheduleResponse;
  saveDefaultTeacherAvailabilitySchedule: SaveDefaultPrivateSessionAvailabilityScheduleResponse;
  saveDefaultTeacherAvailabilitySchedules: SaveDefaultPrivateSessionAvailabilitySchedulesResponse;
  saveEligibilityRule: SaveEligibilityRuleResponse;
  saveEmailCampaign: SaveEmailCampaignResponse;
  saveGoogleAdsConfiguration: SaveGoogleAdsConfigurationResponse;
  savePriceRule: SavePriceRuleResponse;
  savePricingRule: SavePricingRuleResponse;
  savePrivateSessionDaySpecificAvailability: SavePrivateSessionDaySpecificAvailabilityResponse;
  savePrivateSessionSettings: PrivateSessionSettings;
  saveRoomAvailabilityRule: SaveRoomAvailabilityRuleResponse;
  saveSlotRule: SaveSlotRuleResponse;
  saveSubstitutionNotificationSettings: SubstitutionNotification;
  saveTeacherDaySpecificAvailabilities: SaveTeacherDaySpecificAvailabilitiesResponse;
  saveTeacherDaySpecificAvailability: SaveTrainerDaySpecificAvailabilityResponse;
  /** Sends a draft as an In App message to all eligible customers */
  sendBroadcast: SendBroadcastResponse;
  sendEmailCampaign: Scalars['Boolean']['output'];
  sendEmailCampaignToMe: Scalars['Boolean']['output'];
  sendMailToMe: SendingJobResult;
  sendMails: SendingBatchJobResult;
  setOrganization: Maybe<Session>;
  setStripePayoutSettings: StripePayoutSettings;
  setupMfa: Maybe<Session>;
  softDeleteAutoCommunication: Scalars['Boolean']['output'];
  startImport: VenueImportRun;
  syncBookableSpots: Array<BookableSpot>;
  syncNonBookableSpots: Array<NonBookableSpot>;
  syncTeacherCalendarIntegration: SyncTeacherCalendarIntegrationResponse;
  unassignWidgetFromOverview: UnassignWidgetFromOverviewMutationResponse;
  updateCompanyBrandedApp: CompanyBrandedAppMutationResponse;
  updateCompanyMunicipality: Scalars['Boolean']['output'];
  updateCompanyRepresentative: CompanyRepresentative;
  updateCompanyWidgetActivities: CompanyWidgetActivitiesMutationResponse;
  updateCompanyWidgetActivitySchedule: CompanyWidgetActivityScheduleMutationResponse;
  updateCompanyWidgetBrandSettings: CompanyWidgetBrandSettings;
  updateCompanyWidgetBrandSettingsV2: UpdateBrandSettingsResponse;
  updateCompanyWidgetNewsletter: CompanyWidgetNewsletterMutationResponse;
  updateCompanyWidgetPrices: CompanyWidgetPricesMutationResponse;
  updateCompanyWidgetVideos: CompanyWidgetVideosMutationResponse;
  updateCompanyWidgetVouchers: CompanyWidgetVouchersMutationResponse;
  updateFloorPlan: FloorPlan;
  updatePenaltyRule: UpdatePenaltyRuleResponse;
  /** Changes a period along with all its rates */
  updatePeriod: PeriodMutationResult;
  /** Update a private session appointment. Supports null to remove optional fields, undefined to keep existing values. */
  updatePrivateSession: UpdatePrivateSessionResponse;
  updatePrivateSessionOffer: UpdatePrivateSessionOfferResponse;
  updateSchedulerSettings: SchedulerSettings;
  updateSeason: SeasonMutationResult;
  updateTag: Tag;
  uploadSignedTaxAgreement: UploadSignedTaxAgreementResult;
  upsertCompanyWidgetBrandSettings: CompanyWidgetBrandSettings;
  verifyMfa: Maybe<Session>;
  verifyTechnicalEventLogSignatureIntegrity: Scalars['Boolean']['output'];
};


export type MutationAcceptBookingRequestArgs = {
  answeredAsAdmin?: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  teacherId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAcceptSubstitutionRequestArgs = {
  appointmentIds: Array<Scalars['String']['input']>;
  substitutionRequestId: Scalars['String']['input'];
};


export type MutationActivateAutoCommunicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivatePenaltyRuleArgs = {
  id: Scalars['String']['input'];
};


export type MutationAddNoteArgs = {
  createdAt: Scalars['DateTime']['input'];
  customerId: Scalars['ID']['input'];
  html?: InputMaybe<Scalars['String']['input']>;
  unreachable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAddPhoneCallArgs = {
  createdAt: Scalars['DateTime']['input'];
  customerId: Scalars['ID']['input'];
  html?: InputMaybe<Scalars['String']['input']>;
  unreachable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationArchiveActivityArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveAutoCommunicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveFloorPlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveRentalRuleArgs = {
  aspect: RentalRuleType;
  id: Scalars['ID']['input'];
  venueId: Scalars['ID']['input'];
};


export type MutationAssignAvailabilityRuleArgs = {
  availabilityRuleId?: InputMaybe<Scalars['ID']['input']>;
  courtIds: Array<Scalars['ID']['input']>;
  venueId: Scalars['ID']['input'];
};


export type MutationAssignCancellationRuleArgs = {
  cancellationRuleId?: InputMaybe<Scalars['ID']['input']>;
  courtIds: Array<Scalars['ID']['input']>;
  venueId: Scalars['ID']['input'];
};


export type MutationAssignEligibilityRuleArgs = {
  courtIds: Array<Scalars['ID']['input']>;
  eligibilityRuleId?: InputMaybe<Scalars['ID']['input']>;
  venueId: Scalars['ID']['input'];
};


export type MutationAssignPriceRuleArgs = {
  courtIds: Array<Scalars['ID']['input']>;
  priceRuleId?: InputMaybe<Scalars['ID']['input']>;
  venueId: Scalars['ID']['input'];
};


export type MutationAssignSlotRuleArgs = {
  courtIds: Array<Scalars['ID']['input']>;
  slotRuleId?: InputMaybe<Scalars['ID']['input']>;
  venueId: Scalars['ID']['input'];
};


export type MutationAssignTagsV2Args = {
  companyId: Scalars['String']['input'];
  deselectedCustomerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['String']['input']>;
  isSelectAllChecked?: InputMaybe<Scalars['Boolean']['input']>;
  selectedCustomerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tagIds: Array<Scalars['String']['input']>;
};


export type MutationAssignWidgetToOverviewArgs = {
  widgetId: Scalars['ID']['input'];
};


export type MutationCancelAppointmentArgs = {
  appointmentId: Scalars['String']['input'];
  cancellationMessage?: InputMaybe<Scalars['String']['input']>;
  isParticipantNotificationEnabled?: Scalars['Boolean']['input'];
  showCancelledInCalendar?: Scalars['Boolean']['input'];
};


export type MutationCancelRecurringPrivateSessionArgs = {
  appointmentId: Scalars['String']['input'];
  cancellationMessage?: InputMaybe<Scalars['String']['input']>;
  isParticipantNotificationEnabled?: Scalars['Boolean']['input'];
  recurringAppointmentId: Scalars['String']['input'];
  showCancelledInCalendar?: Scalars['Boolean']['input'];
};


export type MutationChangeOrganizationArgs = {
  password: Scalars['String']['input'];
  resourceIdentifier: Scalars['String']['input'];
};


export type MutationConfirmFileUploadArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  venueId: Scalars['String']['input'];
};


export type MutationCreateActivityGroupArgs = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  venueId: Scalars['String']['input'];
};


export type MutationCreateCompanyBrandedAppArgs = {
  backgroundColor: Scalars['String']['input'];
  cardBackgroundColor: Scalars['String']['input'];
  cardTextColor: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  companyWidgetIds: Array<Scalars['ID']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  invoicingVenueId: Scalars['ID']['input'];
  primaryColor: Scalars['String']['input'];
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  textColor: Scalars['String']['input'];
};


export type MutationCreateCompanyRepresentativeArgs = {
  companyId: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  location: CreateLocationArgs;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  type: CompanyRepresentativeType;
};


export type MutationCreateCompanyWidgetActivitiesArgs = {
  activityGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  activityTypes: Array<ActivityType>;
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBackgroundCard?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  colorHeading?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  defaultEnd?: InputMaybe<Scalars['DateTime']['input']>;
  defaultStart?: InputMaybe<Scalars['DateTime']['input']>;
  defaultVenueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  isActivityGroupFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isDateFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isMyBookingsLinkVisible?: InputMaybe<Scalars['Boolean']['input']>;
  isTrainerFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isVenueFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  trainerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationCreateCompanyWidgetActivityScheduleArgs = {
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  defaultActivityGroupIds: Array<Scalars['ID']['input']>;
  defaultSportIds: Array<Scalars['ID']['input']>;
  defaultTeacherIds: Array<Scalars['ID']['input']>;
  defaultVenueIds: Array<Scalars['ID']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  groupSchedule: Scalars['Boolean']['input'];
  isActivityGroupFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isMyBookingsLinkVisible?: InputMaybe<Scalars['Boolean']['input']>;
  isSportFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacherFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isVenueFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  showCompactViewMobile?: InputMaybe<Scalars['Boolean']['input']>;
  showLevel: Scalars['Boolean']['input'];
  showResource: Scalars['Boolean']['input'];
  showTrainer: Scalars['Boolean']['input'];
  spotLimitDisplayType?: InputMaybe<SpotLimitDisplayType>;
};


export type MutationCreateCompanyWidgetBrandSettingsArgs = {
  backgroundColor: Scalars['String']['input'];
  cardBackgroundColor: Scalars['String']['input'];
  cardTextColor: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  floorPlanBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  logoFile?: InputMaybe<LogoFileInput>;
  primaryColor: Scalars['String']['input'];
  spotBookableBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  spotBookableTextColor?: InputMaybe<Scalars['String']['input']>;
  spotNonBookableBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  spotNonBookableTextColor?: InputMaybe<Scalars['String']['input']>;
  textColor: Scalars['String']['input'];
};


export type MutationCreateCompanyWidgetBrandSettingsV2Args = {
  backgroundColor: Scalars['String']['input'];
  cardBackgroundColor: Scalars['String']['input'];
  cardTextColor: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  floorPlanBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  logoFile?: InputMaybe<LogoFileInput>;
  primaryColor: Scalars['String']['input'];
  spotBookableBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  spotBookableTextColor?: InputMaybe<Scalars['String']['input']>;
  spotNonBookableBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  spotNonBookableTextColor?: InputMaybe<Scalars['String']['input']>;
  textColor: Scalars['String']['input'];
};


export type MutationCreateCompanyWidgetNewsletterArgs = {
  allowedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCompanyWidgetPricesArgs = {
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBackgroundCard?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  colorHeading?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  invoicingVenueId: Scalars['ID']['input'];
  isMyProductsLinkVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  productGroupIds: Array<Scalars['ID']['input']>;
};


export type MutationCreateCompanyWidgetVideosArgs = {
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBackgroundCard?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  colorHeading?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  defaultLanguages?: InputMaybe<Array<RecordingSupportedLanguage>>;
  defaultLevels?: InputMaybe<Array<RecordingDifficultyLevel>>;
  defaultSportIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  defaultTeacherIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  defaultVenueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  isDurationFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isLanguageFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isLevelFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVideosLinkVisible?: InputMaybe<Scalars['Boolean']['input']>;
  isSportFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacherFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isVenueFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  recordingCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationCreateCompanyWidgetVouchersArgs = {
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBackgroundCard?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  invoicingVenueId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
  venueId: Scalars['String']['input'];
};


export type MutationCreateFloorPlanArgs = {
  name: Scalars['String']['input'];
  venueId: Scalars['String']['input'];
};


export type MutationCreatePenaltyRuleArgs = {
  emailBody: Scalars['String']['input'];
  emailSubject: Scalars['String']['input'];
  fee?: InputMaybe<Scalars['Float']['input']>;
  feeBookkeepingAccountId?: InputMaybe<Scalars['Float']['input']>;
  isApplicableToAllProducts: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']>;
  status: PenaltyRuleStatus;
  type: PenaltyRuleType;
};


export type MutationCreatePeriodArgs = {
  courtGroupId: Scalars['ID']['input'];
  properties: PeriodInput;
  seasonId: Scalars['ID']['input'];
};


export type MutationCreatePrivateSessionArgs = {
  internalNote?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  participantCustomerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  privateSessionOfferId: Scalars['String']['input'];
  resourceId?: InputMaybe<Scalars['String']['input']>;
  startsAt: Scalars['DateTime']['input'];
  teacherId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreatePrivateSessionOfferArgs = {
  activityGroupId: Scalars['String']['input'];
  appointmentStartTime: ActivityAppointmentStartTime;
  bookingType: ActivityBookingType;
  bufferTimeInMinutes: Scalars['Int']['input'];
  cancellationRule: CancellationRuleInput;
  creditType: CreditType;
  creditsUsedPerAppointment?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  durationInMinutes: Scalars['Int']['input'];
  imageId: Scalars['String']['input'];
  isBookingRequestSelfManagingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['String']['input'];
  maxParticipants: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  paymentOption?: InputMaybe<ActivityPaymentOption>;
  productIds: ProductPaginationSelectionInput;
  productParticipationRules?: InputMaybe<Array<ProductParticipationRuleInput>>;
  registrationEnd?: InputMaybe<Scalars['Int']['input']>;
  registrationEndUnit?: InputMaybe<ActivityTimespanUnit>;
  registrationStart?: InputMaybe<Scalars['Int']['input']>;
  registrationStartUnit?: InputMaybe<ActivityTimespanUnit>;
  roomIds: PaginationSelectionInput;
  roomSharingConfig?: InputMaybe<Array<RoomSharingConfigInput>>;
  schedule?: InputMaybe<Array<PrivateSessionAvailabilityScheduleDayInput>>;
  sportId: Scalars['String']['input'];
  teacherIds: PaginationSelectionInput;
  venueId: Scalars['String']['input'];
  visibility: ActivityVisibility;
};


export type MutationCreateRecurringAppointmentArgs = {
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  duration: Scalars['Int']['input'];
  frequency: RecurringFrequency;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  interval: Scalars['Int']['input'];
  locationId: Scalars['String']['input'];
  occurrenceCount?: InputMaybe<Scalars['Int']['input']>;
  participantCustomerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  privateSessionOfferId: Scalars['String']['input'];
  recurrenceType?: InputMaybe<RecurrenceType>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  seriesEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  startsAt: Scalars['DateTime']['input'];
  teacherId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateReservationArgs = {
  courtId: Scalars['ID']['input'];
  customerId?: InputMaybe<Scalars['ID']['input']>;
  end: Scalars['DateTime']['input'];
  payment?: InputMaybe<ReservationPaymentInput>;
  price?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['DateTime']['input'];
};


export type MutationCreateSeasonArgs = {
  courtGroupId: Scalars['ID']['input'];
  properties: SeasonInput;
};


export type MutationCreateSubstitutionRequestFromExistingArgs = {
  deselectedSubstitutionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  includeNoTeacherAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  isSelectAllChecked?: InputMaybe<Scalars['Boolean']['input']>;
  selectedSubstitutionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  submittedForTeacherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  venueIds?: InputMaybe<Array<Scalars['String']['input']>>;
  venueShortId: Scalars['String']['input'];
};


export type MutationCreateSubstitutionRequestV2Args = {
  companyId: Scalars['ID']['input'];
  deselectedAppointmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  end: Scalars['DateTime']['input'];
  hasCancelledAppointments?: InputMaybe<Scalars['Boolean']['input']>;
  isSelectAllChecked?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
  selectedAppointmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  start: Scalars['DateTime']['input'];
  venueShortId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTagArgs = {
  color: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateTeacherCalendarIntegrationArgs = {
  url: Scalars['URL']['input'];
};


export type MutationDeactivateAutoCommunicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeactivatePenaltyRuleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeclineBookingRequestArgs = {
  answeredAsAdmin?: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeclineSubstitutionRequestArgs = {
  substitutionRequestId: Scalars['String']['input'];
};


export type MutationDeleteCompanyRepresentativeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCompanyWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDefaultTeacherAvailabilitySchedulesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteEmailCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmailCampaignsArgs = {
  emailCampaignIds: Array<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};


export type MutationDeletePrivateSessionDaySpecificAvailabilityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRoomAvailabilityRuleArgs = {
  roomId: Scalars['ID']['input'];
};


export type MutationDeleteSpotArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSubstitutionArgs = {
  substitutionId: Scalars['String']['input'];
};


export type MutationDeleteTagArgs = {
  companyId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteTeacherCalendarIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTeacherDaySpecificAvailabilityArgs = {
  id: Scalars['ID']['input'];
  venueShortId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDuplicateAutoCommunicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateEmailCampaignAsDraftArgs = {
  id: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
};


export type MutationExportArgs = {
  exportType: ExportType;
  loggedInVenueShortId: Scalars['String']['input'];
  timespans: Array<TimespanInput>;
  venueShortIds: Array<Scalars['String']['input']>;
};


export type MutationExportTechnicalEventLogArgs = {
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
  venueShortId: Scalars['String']['input'];
};


export type MutationGenerateCustomerFiltersFromTextArgs = {
  input: Scalars['String']['input'];
  venueShortId: Scalars['String']['input'];
};


export type MutationGenerateQuicksightAnalyticsEmbedUrlArgs = {
  dashboardId: Scalars['String']['input'];
  venueShortId: Scalars['String']['input'];
};


export type MutationGenerateTaxAgreementArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationGenerateTokenArgs = {
  venueShortId: Scalars['String']['input'];
};


export type MutationGenerateUnlayerTemplateArgs = {
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  venueShortId: Scalars['String']['input'];
};


export type MutationGenerateVenueCommunicationArgs = {
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  venueShortId: Scalars['String']['input'];
};


export type MutationHidePrivateSessionFromCalendarArgs = {
  appointmentId: Scalars['String']['input'];
};


export type MutationHideRecurringPrivateSessionFromCalendarArgs = {
  appointmentId: Scalars['String']['input'];
  recurringAppointmentId: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationMakeCourtUnavailableArgs = {
  id: Scalars['String']['input'];
};


export type MutationMaskeradeArgs = {
  email: Scalars['String']['input'];
};


export type MutationPublishFloorPlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRecoverMfaArgs = {
  recoveryCode: Scalars['String']['input'];
};


export type MutationRemoveNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePeriodArgs = {
  courtGroupId: Scalars['ID']['input'];
  periodId: Scalars['ID']['input'];
};


export type MutationRemovePhoneCallArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveSeasonArgs = {
  courtGroupId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};


export type MutationRequestFileUploadArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  venueId: Scalars['String']['input'];
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationResendCommunicationArgs = {
  communicationId: Scalars['String']['input'];
  venueShortId: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSaveAutoCommunicationArgs = {
  audience?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  scheduleAt?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};


export type MutationSaveAvailabilityRuleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  schedule: Array<AvailabilityRuleScheduleEntryInput>;
  venueId: Scalars['ID']['input'];
};


export type MutationSaveBroadcastArgs = {
  body: Scalars['String']['input'];
  filters: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  venueId: Scalars['ID']['input'];
};


export type MutationSaveCancellationRuleArgs = {
  hoursBeforeStart: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  venueId: Scalars['ID']['input'];
};


export type MutationSaveCompanyReferralConfigArgs = {
  isActive: Scalars['Boolean']['input'];
  newCustomerDiscountType?: InputMaybe<DiscountType>;
  newCustomerDiscountValue?: InputMaybe<Scalars['Float']['input']>;
  newCustomerRewardType: NewCustomerRewardType;
  referrerDiscountType?: InputMaybe<DiscountType>;
  referrerDiscountValue?: InputMaybe<Scalars['Float']['input']>;
  referrerMessage?: InputMaybe<Scalars['String']['input']>;
  referrerRewardType: ReferrerRewardType;
};


export type MutationSaveCourtsArgs = {
  availabilityRuleId?: InputMaybe<Scalars['ID']['input']>;
  cancellationRuleId?: InputMaybe<Scalars['ID']['input']>;
  courts: Array<SaveCourtInput>;
  eligibilityRuleId?: InputMaybe<Scalars['ID']['input']>;
  priceRuleId?: InputMaybe<Scalars['ID']['input']>;
  slotRuleId?: InputMaybe<Scalars['ID']['input']>;
  venueShortId: Scalars['String']['input'];
};


export type MutationSaveDefaultPrivateSessionAvailabilityScheduleArgs = {
  schedule: Array<SavePrivateSessionAvailabilityScheduleDayArgs>;
  venueId: Scalars['ID']['input'];
};


export type MutationSaveDefaultTeacherAvailabilityScheduleArgs = {
  companyId: Scalars['ID']['input'];
  schedule: Array<SavePrivateSessionAvailabilityScheduleDayArgs>;
  trainerId: Scalars['ID']['input'];
};


export type MutationSaveDefaultTeacherAvailabilitySchedulesArgs = {
  companyId: Scalars['ID']['input'];
  schedule: Array<SavePrivateSessionAvailabilityScheduleDayArgs>;
  trainerIds: Array<Scalars['ID']['input']>;
};


export type MutationSaveEligibilityRuleArgs = {
  audience: EligibilityRuleAudience;
  conditions?: InputMaybe<Array<EligibilityRuleConditionInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  registration?: InputMaybe<EligibilityRuleRegistrationInput>;
  venueId: Scalars['ID']['input'];
};


export type MutationSaveEmailCampaignArgs = {
  editorContent?: InputMaybe<Scalars['String']['input']>;
  editorType: EditorType;
  filters?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  message: DraftMessage;
  venueId: Scalars['ID']['input'];
};


export type MutationSaveGoogleAdsConfigurationArgs = {
  conversionActionId: Scalars['String']['input'];
  googleAdsAccountId: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSavePriceRuleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  tagPrices?: InputMaybe<Array<PriceRuleTagPriceInput>>;
  timeBoundRules?: InputMaybe<Array<PriceRuleTimeBoundRuleInput>>;
  value: Scalars['Int']['input'];
  venueId: Scalars['ID']['input'];
};


export type MutationSavePricingRuleArgs = {
  courtId: Scalars['String']['input'];
  currencyId: Scalars['String']['input'];
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type: PricingRuleType;
  validFromDate?: InputMaybe<Scalars['LocalDate']['input']>;
  validFromTime?: InputMaybe<Scalars['String']['input']>;
  validUntilDate?: InputMaybe<Scalars['LocalDate']['input']>;
  validUntilTime?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Int']['input'];
};


export type MutationSavePrivateSessionDaySpecificAvailabilityArgs = {
  availability: Array<SavePrivateSessionDaySpecificAvailabilityDateEntryArgs>;
  venueId: Scalars['ID']['input'];
};


export type MutationSavePrivateSessionSettingsArgs = {
  isSelfManagingAllowed: Scalars['Boolean']['input'];
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['String']['input'];
};


export type MutationSaveRoomAvailabilityRuleArgs = {
  maxPrivateSessions: Scalars['Int']['input'];
  maxPrivateSessionsWithGroup?: InputMaybe<Scalars['Int']['input']>;
  roomId: Scalars['ID']['input'];
};


export type MutationSaveSlotRuleArgs = {
  areGapsForbidden: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  maxDurationInMinutes: Scalars['Int']['input'];
  minDurationInMinutes: Scalars['Int']['input'];
  minExtensionInMinutes: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  startsOnInMinutes: Scalars['Int']['input'];
  venueId: Scalars['ID']['input'];
};


export type MutationSaveSubstitutionNotificationSettingsArgs = {
  companyId: Scalars['String']['input'];
  customerNotificationEmailTemplate?: InputMaybe<Scalars['String']['input']>;
  customerNotificationEnabled: Scalars['Boolean']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  successfullyCreated: Scalars['Boolean']['input'];
  successfullySubstituted: Scalars['Boolean']['input'];
};


export type MutationSaveTeacherDaySpecificAvailabilitiesArgs = {
  entries: Array<SaveTeacherDaySpecificAvailabilityForTrainerInput>;
  venueShortId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveTeacherDaySpecificAvailabilityArgs = {
  availability: Array<SaveTeacherDaySpecificAvailabilityEntryArgs>;
  trainerId: Scalars['ID']['input'];
  venueShortId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendBroadcastArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendEmailCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendEmailCampaignToMeArgs = {
  editorType: EditorType;
  message: Message;
  venueId: Scalars['ID']['input'];
};


export type MutationSendMailToMeArgs = {
  message: Message;
  segment: Scalars['String']['input'];
  venueShortId: Scalars['String']['input'];
};


export type MutationSendMailsArgs = {
  customerIds: Array<Scalars['String']['input']>;
  message: Message;
  segment: Scalars['String']['input'];
  venueShortId: Scalars['String']['input'];
};


export type MutationSetOrganizationArgs = {
  resourceIdentifier: Scalars['String']['input'];
};


export type MutationSetStripePayoutSettingsArgs = {
  executionDay: Scalars['Int']['input'];
  frequency: StripePayoutFrequency;
  venueShortId: Scalars['String']['input'];
};


export type MutationSoftDeleteAutoCommunicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStartImportArgs = {
  uploadId: Scalars['String']['input'];
  venueShortId: Scalars['String']['input'];
};


export type MutationSyncBookableSpotsArgs = {
  floorPlanId: Scalars['String']['input'];
  syncBookableSpots: Array<SyncBookableSpotInput>;
};


export type MutationSyncNonBookableSpotsArgs = {
  floorPlanId: Scalars['String']['input'];
  syncNonBookableSpots: Array<SyncNonBookableSpotInput>;
};


export type MutationSyncTeacherCalendarIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnassignWidgetFromOverviewArgs = {
  widgetId: Scalars['ID']['input'];
};


export type MutationUpdateCompanyBrandedAppArgs = {
  backgroundColor: Scalars['String']['input'];
  cardBackgroundColor: Scalars['String']['input'];
  cardTextColor: Scalars['String']['input'];
  companyWidgetIds: Array<Scalars['ID']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  invoicingVenueId: Scalars['ID']['input'];
  primaryColor: Scalars['String']['input'];
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  textColor: Scalars['String']['input'];
};


export type MutationUpdateCompanyMunicipalityArgs = {
  companyId: Scalars['String']['input'];
  municipality?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCompanyRepresentativeArgs = {
  id: Scalars['String']['input'];
  legalName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<UpdateLocationArgs>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CompanyRepresentativeType>;
};


export type MutationUpdateCompanyWidgetActivitiesArgs = {
  activityGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  activityTypes: Array<ActivityType>;
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBackgroundCard?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  colorHeading?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  defaultEnd?: InputMaybe<Scalars['DateTime']['input']>;
  defaultStart?: InputMaybe<Scalars['DateTime']['input']>;
  defaultVenueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActivityGroupFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isDateFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isMyBookingsLinkVisible?: InputMaybe<Scalars['Boolean']['input']>;
  isTrainerFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isVenueFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  trainerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationUpdateCompanyWidgetActivityScheduleArgs = {
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  defaultActivityGroupIds: Array<Scalars['ID']['input']>;
  defaultSportIds: Array<Scalars['ID']['input']>;
  defaultTeacherIds: Array<Scalars['ID']['input']>;
  defaultVenueIds: Array<Scalars['ID']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  groupSchedule: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  isActivityGroupFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isMyBookingsLinkVisible?: InputMaybe<Scalars['Boolean']['input']>;
  isSportFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacherFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isVenueFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  showCompactViewMobile?: InputMaybe<Scalars['Boolean']['input']>;
  showLevel: Scalars['Boolean']['input'];
  showResource: Scalars['Boolean']['input'];
  showTrainer: Scalars['Boolean']['input'];
  spotLimitDisplayType?: InputMaybe<SpotLimitDisplayType>;
};


export type MutationUpdateCompanyWidgetBrandSettingsArgs = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  cardBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  cardTextColor?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  floorPlanBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  logoFile?: InputMaybe<LogoFileInput>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  removeLogo?: InputMaybe<Scalars['Boolean']['input']>;
  spotBookableBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  spotBookableTextColor?: InputMaybe<Scalars['String']['input']>;
  spotNonBookableBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  spotNonBookableTextColor?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};


export type MutationUpdateCompanyWidgetBrandSettingsV2Args = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  cardBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  cardTextColor?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  floorPlanBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  logoFile?: InputMaybe<LogoFileInput>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  removeLogo?: InputMaybe<Scalars['Boolean']['input']>;
  spotBookableBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  spotBookableTextColor?: InputMaybe<Scalars['String']['input']>;
  spotNonBookableBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  spotNonBookableTextColor?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};


export type MutationUpdateCompanyWidgetNewsletterArgs = {
  allowedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCompanyWidgetPricesArgs = {
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBackgroundCard?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  colorHeading?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  invoicingVenueId: Scalars['ID']['input'];
  isMyProductsLinkVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  productGroupIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateCompanyWidgetVideosArgs = {
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBackgroundCard?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  colorHeading?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  defaultLanguages?: InputMaybe<Array<RecordingSupportedLanguage>>;
  defaultLevels?: InputMaybe<Array<RecordingDifficultyLevel>>;
  defaultSportIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  defaultTeacherIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  defaultVenueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDurationFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isLanguageFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isLevelFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isMyVideosLinkVisible?: InputMaybe<Scalars['Boolean']['input']>;
  isSportFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacherFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isVenueFilterHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  recordingCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationUpdateCompanyWidgetVouchersArgs = {
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBackgroundCard?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  invoicingVenueId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateFloorPlanArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  venueId: Scalars['String']['input'];
};


export type MutationUpdatePenaltyRuleArgs = {
  emailBody: Scalars['String']['input'];
  emailSubject: Scalars['String']['input'];
  fee?: InputMaybe<Scalars['Float']['input']>;
  feeBookkeepingAccountId?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  isApplicableToAllProducts: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']>;
  status: PenaltyRuleStatus;
  type: PenaltyRuleType;
};


export type MutationUpdatePeriodArgs = {
  courtGroupId: Scalars['ID']['input'];
  periodId: Scalars['ID']['input'];
  properties: PeriodInput;
};


export type MutationUpdatePrivateSessionArgs = {
  appointmentId: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  participantCustomerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recurrenceSettings?: InputMaybe<UpdateRecurringAppointmentSettingsInput>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updateSettings?: InputMaybe<UpdatePrivateSessionSettingsInput>;
};


export type MutationUpdatePrivateSessionOfferArgs = {
  activityGroupId: Scalars['String']['input'];
  activityId: Scalars['String']['input'];
  appointmentStartTime: ActivityAppointmentStartTime;
  bookingType: ActivityBookingType;
  bufferTimeInMinutes: Scalars['Int']['input'];
  cancellationRule: CancellationRuleInput;
  creditType: CreditType;
  creditsUsedPerAppointment?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  durationInMinutes: Scalars['Int']['input'];
  imageId: Scalars['String']['input'];
  isBookingRequestSelfManagingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['String']['input'];
  maxParticipants: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  paymentOption?: InputMaybe<ActivityPaymentOption>;
  productIds: ProductPaginationSelectionInput;
  productParticipationRules?: InputMaybe<Array<ProductParticipationRuleInput>>;
  registrationEnd?: InputMaybe<Scalars['Int']['input']>;
  registrationEndUnit?: InputMaybe<ActivityTimespanUnit>;
  registrationStart?: InputMaybe<Scalars['Int']['input']>;
  registrationStartUnit?: InputMaybe<ActivityTimespanUnit>;
  roomIds: PaginationSelectionInput;
  roomSharingConfig?: InputMaybe<Array<RoomSharingConfigInput>>;
  schedule?: InputMaybe<Array<PrivateSessionAvailabilityScheduleDayInput>>;
  sportId: Scalars['String']['input'];
  teacherIds: PaginationSelectionInput;
  visibility: ActivityVisibility;
};


export type MutationUpdateSchedulerSettingsArgs = {
  colorType: Scalars['String']['input'];
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
  venueId: Scalars['ID']['input'];
};


export type MutationUpdateSeasonArgs = {
  courtGroupId: Scalars['ID']['input'];
  properties: SeasonInput;
  seasonId: Scalars['ID']['input'];
};


export type MutationUpdateTagArgs = {
  color: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUploadSignedTaxAgreementArgs = {
  companyId: Scalars['String']['input'];
  signedPdfBase64: Scalars['String']['input'];
};


export type MutationUpsertCompanyWidgetBrandSettingsArgs = {
  companyId: Scalars['ID']['input'];
  floorPlanBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  spotBookableBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  spotBookableTextColor?: InputMaybe<Scalars['String']['input']>;
  spotNonBookableBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  spotNonBookableTextColor?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVerifyMfaArgs = {
  token: Scalars['String']['input'];
  trustDevice?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationVerifyTechnicalEventLogSignatureIntegrityArgs = {
  eventLogId: Scalars['String']['input'];
  venueShortId: Scalars['String']['input'];
};

export enum NewCustomerRewardType {
  DISCOUNT = 'DISCOUNT',
  NONE = 'NONE'
}

export enum NonBookableItemIconType {
  ASSISTANT = 'ASSISTANT',
  DOOR = 'DOOR',
  HORIZONTAL_BAR = 'HORIZONTAL_BAR',
  MIRROR = 'MIRROR',
  SCREEN = 'SCREEN',
  SPEAKER = 'SPEAKER',
  TEACHER = 'TEACHER',
  TEACHER_AVATAR = 'TEACHER_AVATAR',
  TEXT = 'TEXT',
  VERTICAL_BAR = 'VERTICAL_BAR',
  WINDOW = 'WINDOW'
}

export type NonBookableSpot = {
  __typename: 'NonBookableSpot';
  floorPlanId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  nonBookableIcon: NonBookableItemIconType;
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type Note = {
  __typename: 'Note';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  html: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OpeningHoursPeriod = {
  __typename: 'OpeningHoursPeriod';
  end: Scalars['Time']['output'];
  start: Scalars['Time']['output'];
  weekdays: Array<Weekday>;
};

export type Organization = {
  __typename: 'Organization';
  id: Scalars['String']['output'];
  resources: Array<OrganizationResource>;
};

export type OrganizationResource = {
  __typename: 'OrganizationResource';
  description: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  image: Maybe<Picture>;
  name: Scalars['String']['output'];
};

export type PageInfo = {
  __typename: 'PageInfo';
  /** The `Cursor` of the last item in this page. You can use it as the `after` input argument to retrieve the next page. */
  endCursor: Maybe<Scalars['Cursor']['output']>;
  /** Whether there are more results after the current page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there are results before the current page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The `Cursor` of the first item in this page. You can use it as the `before` input argument to retrieve the previous page. */
  startCursor: Maybe<Scalars['Cursor']['output']>;
};

export type PaginationSelectionInput = {
  deselectedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isSelectedAll?: Scalars['Boolean']['input'];
  selectedIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ParticipationState {
  ABORTED = 'Aborted',
  ACCEPTED = 'Accepted',
  CANCELLED = 'Cancelled',
  PENDING = 'Pending'
}

export type PenaltyRule = {
  __typename: 'PenaltyRule';
  emailBody: Scalars['String']['output'];
  emailSubject: Scalars['String']['output'];
  fee: Maybe<Scalars['Float']['output']>;
  feeBookkeepingAccountId: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isApplicableToAllProducts: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  penaltiesCount: Scalars['Float']['output'];
  productIds: Array<Scalars['String']['output']>;
  status: PenaltyRuleStatus;
  type: PenaltyRuleType;
};

/** A _paginated_ result set of "PenaltyRule" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type PenaltyRuleConnection = {
  __typename: 'PenaltyRuleConnection';
  /** The `Edges` "PenaltyRule" items */
  edges: Array<PenaltyRuleEdge>;
  /** The actual "PenaltyRule" items */
  nodes: Array<PenaltyRule>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type PenaltyRuleEdge = {
  __typename: 'PenaltyRuleEdge';
  cursor: Scalars['Cursor']['output'];
  node: PenaltyRule;
};

/** The status of penalty rule */
export enum PenaltyRuleStatus {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  DRAFT = 'DRAFT'
}

/** The type of penalty rule */
export enum PenaltyRuleType {
  LATE_CANCELLATION = 'LATE_CANCELLATION',
  NO_SHOW = 'NO_SHOW',
  NO_SHOW_AND_LATE_CANCELLATION = 'NO_SHOW_AND_LATE_CANCELLATION'
}

export type Period = {
  __typename: 'Period';
  end: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  interval: Scalars['Int']['output'];
  intervalType: IntervalType;
  name: Scalars['String']['output'];
  /** The Rates that apply during this Period */
  rates: Array<Rate>;
  start: Scalars['Time']['output'];
  weekdays: Array<Weekday>;
};


export type PeriodRatesArgs = {
  courtGroupId: Scalars['ID']['input'];
};

export type PeriodInput = {
  end: Scalars['Time']['input'];
  interval: Scalars['Int']['input'];
  intervalType: IntervalType;
  name: Scalars['String']['input'];
  rates: Array<RateInput>;
  start: Scalars['Time']['input'];
  weekdays: Array<Weekday>;
};

export type PeriodMutationResult = Period | PeriodValidation;

export type PeriodValidation = {
  __typename: 'PeriodValidation';
  errors: Array<PeriodValidationError>;
  isValid: Scalars['Boolean']['output'];
  overlapsWith: Array<Period>;
  rateValidations: Array<RateValidation>;
};

export enum PeriodValidationError {
  INVALID_RATES = 'INVALID_RATES',
  INVALID_TIME = 'INVALID_TIME',
  NO_RATES = 'NO_RATES',
  NO_WEEKDAY = 'NO_WEEKDAY',
  OVERLAPS = 'OVERLAPS'
}

export type PhoneCall = {
  __typename: 'PhoneCall';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  html: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  unreachable: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Picture = {
  __typename: 'Picture';
  id: Scalars['ID']['output'];
  large: Scalars['String']['output'];
  listBasic: Scalars['String']['output'];
  listPremium: Scalars['String']['output'];
  medium: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Maybe<Scalars['Float']['output']>;
  small: Scalars['String']['output'];
  xLarge: Scalars['String']['output'];
  xSmall: Scalars['String']['output'];
};

export enum PreviousSoftware {
  ACUITY_SCHEDULING = 'ACUITY_SCHEDULING',
  APPOINTMAN = 'APPOINTMAN',
  BOOKANDPLAY = 'BOOKANDPLAY',
  BOXCHAMP = 'BOXCHAMP',
  BOXPLANNER = 'BOXPLANNER',
  BSPORT = 'BSPORT',
  CALENDLY = 'CALENDLY',
  CENTERCOM = 'CENTERCOM',
  COURSIKA = 'COURSIKA',
  DECIPLUS = 'DECIPLUS',
  EASYSPORT = 'EASYSPORT',
  EBUSY = 'EBUSY',
  ESCHEDULE = 'ESCHEDULE',
  ETENNIS = 'ETENNIS',
  FITMANAGER = 'FITMANAGER',
  FITOGRAM = 'FITOGRAM',
  FYNDERY = 'FYNDERY',
  GURUBAY = 'GURUBAY',
  HELLOASSO = 'HELLOASSO',
  KURSIFANT = 'KURSIFANT',
  MAGICLINE = 'MAGICLINE',
  MINDBODY = 'MINDBODY',
  MOMENCE = 'MOMENCE',
  MOMOYOGA = 'MOMOYOGA',
  MYSPORTS = 'MYSPORTS',
  NONE = 'NONE',
  OTHER = 'OTHER',
  PLAYTOMIC = 'PLAYTOMIC',
  PREMIUM_PLANER = 'PREMIUM_PLANER',
  RESAMANIA = 'RESAMANIA',
  RESERVIO = 'RESERVIO',
  SHORE = 'SHORE',
  SIMPLYBOOK_ME = 'SIMPLYBOOK_ME',
  SMILE = 'SMILE',
  SPORTSNOW = 'SPORTSNOW',
  SUPERSAAS = 'SUPERSAAS',
  USCSCHEDULING = 'USCSCHEDULING',
  VIRTUAGYM = 'VIRTUAGYM',
  WEBFORM = 'WEBFORM',
  WIX = 'WIX',
  WODIFY = 'WODIFY',
  WORDPRESS = 'WORDPRESS',
  YOGO = 'YOGO',
  YOLAWO = 'YOLAWO',
  ZEN_PLANNER = 'ZEN_PLANNER'
}

export type Price = {
  __typename: 'Price';
  /** The currency this price is in */
  currency: Currency;
  /** Price in integer cents of the venue currency */
  value: Scalars['Int']['output'];
};

/** A rule answering the price aspect of court booking: how much a booking costs. */
export type PriceRule = {
  __typename: 'PriceRule';
  /** The courts this rule is assigned to, ordered by name. Archived courts are excluded. Empty if the rule is assigned to no court. */
  assignedCourts: Array<Court>;
  /** When the rule was created. */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The price a booking under this rule costs. */
  price: Price;
  /** Tag prices replacing the base price for matching customers. Empty if none are configured. */
  tagPrices: Array<PriceRuleTagPrice>;
  /** Time-bound price exceptions layered on top of the base price. Empty if none are configured. */
  timeBoundRules: Array<PriceRuleTimeBoundRule>;
  /** When the rule was last modified. Equals `createdAt` until the rule is first edited. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An inclusive calendar date range as `YYYY-MM-DD`. */
export type PriceRuleDateRange = {
  __typename: 'PriceRuleDateRange';
  from: Scalars['LocalDate']['output'];
  until: Scalars['LocalDate']['output'];
};

/** An inclusive calendar date range as `YYYY-MM-DD`. */
export type PriceRuleDateRangeInput = {
  from: Scalars['LocalDate']['input'];
  until: Scalars['LocalDate']['input'];
};

/** A customer tag referenced by a tag price. */
export type PriceRuleTag = {
  __typename: 'PriceRuleTag';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Which customer tags a tag price matches on, and how they combine. */
export type PriceRuleTagCondition = {
  __typename: 'PriceRuleTagCondition';
  /** The customer tags, combined by `match`. */
  items: Array<PriceRuleTag>;
  match: PriceRuleTagMatch;
};

/** Which customer tags a tag price matches on, and how they combine. */
export type PriceRuleTagConditionInput = {
  /** How the tags combine. */
  match: PriceRuleTagMatch;
  /** The uuids of the customer tags. */
  tagIds: Array<Scalars['ID']['input']>;
};

/** How the tags within a single tag price combine. */
export enum PriceRuleTagMatch {
  ALL = 'ALL',
  ANY = 'ANY'
}

/** A tag price, e.g. "Member" or "Junior and Student": replaces the price of its block for customers matching its tags. A customer matching several tag prices of a block pays the lowest. */
export type PriceRuleTagPrice = {
  __typename: 'PriceRuleTagPrice';
  /** The price a matching customer pays instead of the block price. */
  price: Price;
  /** The customer tags this tag price matches on. */
  tags: PriceRuleTagCondition;
};

/** A price replacing the price of its block for customers matching its tags. */
export type PriceRuleTagPriceInput = {
  /** The customer tags this tag price matches on. */
  tags: PriceRuleTagConditionInput;
  /** Price in integer cents of the venue currency. */
  value: Scalars['Int']['input'];
};

/** A price exception that only applies within its window. */
export type PriceRuleTimeBoundRule = {
  __typename: 'PriceRuleTimeBoundRule';
  /** An optional human-readable label for the exception. */
  label: Maybe<Scalars['String']['output']>;
  /** The price a booking under this exception costs. */
  price: Price;
  /** Tag prices replacing this exception's price for matching customers. Empty if none are configured. */
  tagPrices: Array<PriceRuleTagPrice>;
  window: PriceRuleWindow;
};

/** A price exception that only applies within its window. */
export type PriceRuleTimeBoundRuleInput = {
  /** An optional human-readable label for the exception. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Tag prices replacing this exception's price for matching customers. Sending the exceptions replaces them: pass an empty list, or omit it, when there are none. */
  tagPrices?: InputMaybe<Array<PriceRuleTagPriceInput>>;
  /** Price in integer cents of the venue currency. */
  value: Scalars['Int']['input'];
  window: PriceRuleWindowInput;
};

/** A time-of-day range as `HH:mm`. */
export type PriceRuleTimeRange = {
  __typename: 'PriceRuleTimeRange';
  from: Scalars['String']['output'];
  until: Scalars['String']['output'];
};

export type PriceRuleTimeRangeInput = {
  from: Scalars['Time']['input'];
  /** `00:00` means the end of the day. */
  until: Scalars['Time']['input'];
};

/** The window during which a time-bound price exception applies. */
export type PriceRuleWindow = {
  __typename: 'PriceRuleWindow';
  dates: Maybe<PriceRuleDateRange>;
  /** Days of week (0-6, Sunday=0) this exception applies to. */
  daysOfWeek: Maybe<Array<Scalars['Int']['output']>>;
  time: Maybe<PriceRuleTimeRange>;
};

/** The window during which the rule applies. Combining parts narrows the window; omit all to always apply. */
export type PriceRuleWindowInput = {
  dates?: InputMaybe<PriceRuleDateRangeInput>;
  /** Days of week (0-6, Sunday=0) this rule applies to. */
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  time?: InputMaybe<PriceRuleTimeRangeInput>;
};

export enum PriceType {
  EXTERNAL = 'EXTERNAL',
  FIX = 'FIX',
  FREE = 'FREE',
  TIER = 'TIER',
  VARIABLE = 'VARIABLE'
}

export type PricingRule = {
  __typename: 'PricingRule';
  /** Day of week (0-6, Sunday=0) this rule applies to */
  dayOfWeek: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  price: Price;
  type: PricingRuleType;
  validFromDate: Maybe<Scalars['LocalDate']['output']>;
  validFromTime: Maybe<Scalars['String']['output']>;
  validUntilDate: Maybe<Scalars['LocalDate']['output']>;
  validUntilTime: Maybe<Scalars['String']['output']>;
};

export enum PricingRuleType {
  BASE = 'BASE',
  FIXED = 'FIXED'
}

export type PrivateSession = {
  __typename: 'PrivateSession';
  id: Scalars['ID']['output'];
  internalNote: Maybe<Scalars['String']['output']>;
  location: Location;
  privateSessionOffer: Activity;
  resource: Maybe<Resource>;
  startsAt: Scalars['DateTime']['output'];
  teacher: Maybe<Teacher>;
};

export type PrivateSessionAvailabilitySchedule = {
  __typename: 'PrivateSessionAvailabilitySchedule';
  id: Scalars['ID']['output'];
  schedule: Array<PrivateSessionAvailabilityScheduleDay>;
};

export type PrivateSessionAvailabilityScheduleDay = {
  __typename: 'PrivateSessionAvailabilityScheduleDay';
  /** Day of the week (0 = Sunday, 6 = Saturday) */
  dayOfWeek: Scalars['Int']['output'];
  /** List of time slots for the day */
  timeSchedule: Array<PrivateSessionAvailabilityScheduleTime>;
};

export type PrivateSessionAvailabilityScheduleDayInput = {
  /** Day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday) */
  dayOfWeek: Scalars['Int']['input'];
  /** List of time slots for the day */
  timeSchedule: Array<PrivateSessionAvailabilityScheduleTimeInput>;
};

export type PrivateSessionAvailabilityScheduleList = {
  __typename: 'PrivateSessionAvailabilityScheduleList';
  /** List of saved default availability schedules */
  nodes: Array<PrivateSessionAvailabilitySchedule>;
};

export type PrivateSessionAvailabilityScheduleTime = {
  __typename: 'PrivateSessionAvailabilityScheduleTime';
  /** Availability from time (e.g., "09:00") */
  validFrom: Scalars['Time']['output'];
  /** Availability until time (e.g., "17:00") */
  validUntil: Scalars['Time']['output'];
};

export type PrivateSessionAvailabilityScheduleTimeInput = {
  /** Availability from time (e.g., "09:00") */
  validFrom: Scalars['Time']['input'];
  /** Availability until time (e.g., "17:00") */
  validUntil: Scalars['Time']['input'];
};

export type PrivateSessionDaySpecificAvailability = {
  __typename: 'PrivateSessionDaySpecificAvailability';
  /** The specific date this availability applies to */
  dateFrom: Scalars['LocalDate']['output'];
  id: Scalars['ID']['output'];
  /** List of time slots for this date */
  timeSlots: Array<PrivateSessionDaySpecificAvailabilityTime>;
};

/** A _paginated_ result set of "PrivateSessionDaySpecificAvailability" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type PrivateSessionDaySpecificAvailabilityConnection = {
  __typename: 'PrivateSessionDaySpecificAvailabilityConnection';
  /** The `Edges` "PrivateSessionDaySpecificAvailability" items */
  edges: Array<PrivateSessionDaySpecificAvailabilityEdge>;
  /** The actual "PrivateSessionDaySpecificAvailability" items */
  nodes: Array<PrivateSessionDaySpecificAvailability>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type PrivateSessionDaySpecificAvailabilityEdge = {
  __typename: 'PrivateSessionDaySpecificAvailabilityEdge';
  cursor: Scalars['Cursor']['output'];
  node: PrivateSessionDaySpecificAvailability;
};

export type PrivateSessionDaySpecificAvailabilityList = {
  __typename: 'PrivateSessionDaySpecificAvailabilityList';
  /** List of saved day-specific availabilities */
  nodes: Array<PrivateSessionDaySpecificAvailability>;
};

export type PrivateSessionDaySpecificAvailabilityTime = {
  __typename: 'PrivateSessionDaySpecificAvailabilityTime';
  /** Availability from time (e.g., "09:00") */
  validFrom: Scalars['Time']['output'];
  /** Availability until time (e.g., "17:00") */
  validUntil: Scalars['Time']['output'];
};

export type PrivateSessionOfferSettings = {
  __typename: 'PrivateSessionOfferSettings';
  appointmentStartTime: ActivityAppointmentStartTime;
  bookingType: ActivityBookingType;
  bufferTimeInMinutes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isBookingRequestSelfManagingAllowed: Scalars['Boolean']['output'];
  location: Maybe<Location>;
  paymentOption: Maybe<ActivityPaymentOption>;
};

export type PrivateSessionSettings = {
  __typename: 'PrivateSessionSettings';
  changedByUserId: Scalars['Int']['output'];
  defaultAvailabilitySchedule: Maybe<PrivateSessionAvailabilitySchedule>;
  defaultDaySpecificAvailability: PrivateSessionDaySpecificAvailabilityConnection;
  hasFullViewAccess: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isSelfManagingAllowed: Scalars['Boolean']['output'];
  notificationEmail: Maybe<Scalars['String']['output']>;
  venueId: Scalars['Int']['output'];
};


export type PrivateSessionSettingsDefaultDaySpecificAvailabilityArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Product = {
  __typename: 'Product';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Rules limiting how often the product can be used for specific activities and recordings. Empty when the product is not limited per activity */
  participationRules: Array<ProductParticipationRule>;
  productGroup: Maybe<Scalars['String']['output']>;
  state: ProductState;
  type: ProductType;
};

/** A _paginated_ result set of "Product" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type ProductConnection = {
  __typename: 'ProductConnection';
  /** The `Edges` "Product" items */
  edges: Array<ProductEdge>;
  /** The actual "Product" items */
  nodes: Array<Product>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type ProductEdge = {
  __typename: 'ProductEdge';
  cursor: Scalars['Cursor']['output'];
  node: Product;
};

export type ProductGroup = {
  __typename: 'ProductGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Float']['output'];
};

/** A _paginated_ result set of "ProductGroup" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type ProductGroupConnection = {
  __typename: 'ProductGroupConnection';
  /** The `Edges` "ProductGroup" items */
  edges: Array<ProductGroupEdge>;
  /** The actual "ProductGroup" items */
  nodes: Array<ProductGroup>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type ProductGroupEdge = {
  __typename: 'ProductGroupEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProductGroup;
};

export type ProductGroupFilterInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductPaginationSelectionInput = {
  deselectedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isSelectedAll?: Scalars['Boolean']['input'];
  productGroups?: InputMaybe<Array<ProductGroupFilterInput>>;
  productTypes?: InputMaybe<Array<ProductType>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  selectedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  states?: InputMaybe<Array<ProductState>>;
};

/** Limits how often a product can be used for the activities and recordings it covers */
export type ProductParticipationRule = {
  __typename: 'ProductParticipationRule';
  /** The activities of the product this rule was resolved from that it limits */
  activities: Array<Activity>;
  cycleUnit: Maybe<ProductParticipationRuleCycleUnit>;
  cycleValue: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Usages left over at the end of a cycle are carried over to the next one */
  isAccumulatingUnusedBookings: Scalars['Boolean']['output'];
  /** Cycles start at the beginning of the calendar unit instead of the purchase */
  isIntervalAlignedToCalendar: Scalars['Boolean']['output'];
  /** Number of usages allowed per cycle. `null` means unlimited */
  maxPerCycle: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** The videos of the product this rule was resolved from that it limits */
  recordings: Array<Recording>;
};


/** Limits how often a product can be used for the activities and recordings it covers */
export type ProductParticipationRuleActivitiesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Limits how often a product can be used for the activities and recordings it covers */
export type ProductParticipationRuleRecordingsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ProductParticipationRuleCycleUnit {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

export type ProductParticipationRuleInput = {
  /** UUID of the participation rule that applies to this activity */
  activityBasedParticipationRuleId: Scalars['String']['input'];
  /** UUID of the card or membership being linked */
  productId: Scalars['String']['input'];
};

export enum ProductState {
  ACTIVE = 'ACTIVE',
  ARCHIVE = 'ARCHIVE'
}

export enum ProductType {
  ARTICLE = 'ARTICLE',
  CARD = 'CARD',
  MEMBERSHIP = 'MEMBERSHIP',
  RECORDING = 'RECORDING',
  TICKET = 'TICKET',
  VOUCHER = 'VOUCHER'
}

export enum ProviderFeaturePreview {
  ADD_CREDIT_CARD_ENABLED = 'ADD_CREDIT_CARD_ENABLED',
  ANALYTICS_MODERN_EXISTING_MEMBERSHIP_DISABLED = 'ANALYTICS_MODERN_EXISTING_MEMBERSHIP_DISABLED',
  COMMUNICATION_EXTENSION = 'COMMUNICATION_EXTENSION',
  CUSTOMER_SEGMENTATION_AGGREGATION = 'CUSTOMER_SEGMENTATION_AGGREGATION',
  FINANCIAL_E_INVOICE_PEPPOL = 'FINANCIAL_E_INVOICE_PEPPOL',
  FINANCIAL_NF525_FRANCE_SIGNING = 'FINANCIAL_NF525_FRANCE_SIGNING',
  HIDE_BALLSPORT_VENUE_AUTOMATION = 'HIDE_BALLSPORT_VENUE_AUTOMATION',
  HIDE_CONTACTS_TOTAL_COUNT = 'HIDE_CONTACTS_TOTAL_COUNT',
  MARKETING_AUTOMATIONS_ACTIVITY_VISIT_TRIGGER = 'MARKETING_AUTOMATIONS_ACTIVITY_VISIT_TRIGGER',
  MARKETING_AUTOMATIONS_EMAIL_CONTENT_AI_INPUT = 'MARKETING_AUTOMATIONS_EMAIL_CONTENT_AI_INPUT',
  MARKETING_AUTOMATIONS_EMAIL_CONTENT_PROMPT_TESTING = 'MARKETING_AUTOMATIONS_EMAIL_CONTENT_PROMPT_TESTING',
  MARKETING_AUTOMATIONS_PURCHASE_TRIGGER = 'MARKETING_AUTOMATIONS_PURCHASE_TRIGGER',
  MARKETING_AUTOMATIONS_UNLAYER_TEMPLATE_AI_INPUT = 'MARKETING_AUTOMATIONS_UNLAYER_TEMPLATE_AI_INPUT',
  PROVIDER_2FA_FLOW = 'PROVIDER_2FA_FLOW',
  PROVIDER_10_MINUTES_APPOINTMENT_STARTTIME = 'PROVIDER_10_MINUTES_APPOINTMENT_STARTTIME',
  PROVIDER_AI_EXPERIMENT_TEXT_TO_FILTERS = 'PROVIDER_AI_EXPERIMENT_TEXT_TO_FILTERS',
  PROVIDER_APPOINTMENT_INTERNAL_NOTES = 'PROVIDER_APPOINTMENT_INTERNAL_NOTES',
  PROVIDER_BOOKING_REQUEST_SELF_MANAGING = 'PROVIDER_BOOKING_REQUEST_SELF_MANAGING',
  PROVIDER_BOOKING_REQUEST_SETTINGS = 'PROVIDER_BOOKING_REQUEST_SETTINGS',
  PROVIDER_CALENDAR_DRAG_ENABLED = 'PROVIDER_CALENDAR_DRAG_ENABLED',
  PROVIDER_CONTRACT_INFORMATION = 'PROVIDER_CONTRACT_INFORMATION',
  PROVIDER_FISCAL_COMPLIANCE_SPAIN_COMPANY_REPRESENTATIVE = 'PROVIDER_FISCAL_COMPLIANCE_SPAIN_COMPANY_REPRESENTATIVE',
  PROVIDER_FISCAL_COMPLIANCE_SPAIN_NIF_TERRITORY = 'PROVIDER_FISCAL_COMPLIANCE_SPAIN_NIF_TERRITORY',
  PROVIDER_FISCAL_COMPLIANCE_SPAIN_SOFTWARE_INFO = 'PROVIDER_FISCAL_COMPLIANCE_SPAIN_SOFTWARE_INFO',
  PROVIDER_HIDE_WIDGET_FILTERS = 'PROVIDER_HIDE_WIDGET_FILTERS',
  PROVIDER_IN_APP_MESSAGING = 'PROVIDER_IN_APP_MESSAGING',
  PROVIDER_MANAGE_TEACHER_AVAILABILITY = 'PROVIDER_MANAGE_TEACHER_AVAILABILITY',
  PROVIDER_NEW_WIDGET_BRAND_SETTINGS = 'PROVIDER_NEW_WIDGET_BRAND_SETTINGS',
  PROVIDER_PENALTY_FEES = 'PROVIDER_PENALTY_FEES',
  PROVIDER_PERSONAL_CALENDAR_SYNC = 'PROVIDER_PERSONAL_CALENDAR_SYNC',
  PROVIDER_PRIVATE_SESSIONS_ICAL_RECURRENCE = 'PROVIDER_PRIVATE_SESSIONS_ICAL_RECURRENCE',
  PROVIDER_PRIVATE_SESSIONS_TEACHER_MANAGEMENT = 'PROVIDER_PRIVATE_SESSIONS_TEACHER_MANAGEMENT',
  PROVIDER_PRIVATE_SESSION_ADDITIONAL_FEATURES = 'PROVIDER_PRIVATE_SESSION_ADDITIONAL_FEATURES',
  PROVIDER_PRIVATE_SESSION_DIRECT_BOOKING = 'PROVIDER_PRIVATE_SESSION_DIRECT_BOOKING',
  PROVIDER_PRIVATE_SESSION_MISSING_AVAILABILITY_WARNING = 'PROVIDER_PRIVATE_SESSION_MISSING_AVAILABILITY_WARNING',
  PROVIDER_PRODUCT_UPDATES = 'PROVIDER_PRODUCT_UPDATES',
  PROVIDER_ROOM_SHARING_RULES = 'PROVIDER_ROOM_SHARING_RULES',
  PROVIDER_SHARE_FEEDBACK = 'PROVIDER_SHARE_FEEDBACK',
  PROVIDER_SHOW_CALENDAR_BUTTON = 'PROVIDER_SHOW_CALENDAR_BUTTON',
  PROVIDER_SHOW_OLD_WIDGET_SUNSET_BANNER = 'PROVIDER_SHOW_OLD_WIDGET_SUNSET_BANNER',
  PROVIDER_SHOW_TRAINER_AND_ACTIVITY_GROUPS_FILTERS = 'PROVIDER_SHOW_TRAINER_AND_ACTIVITY_GROUPS_FILTERS',
  PROVIDER_SPOT_BOOKING_CUSTOMIZE_COLORS = 'PROVIDER_SPOT_BOOKING_CUSTOMIZE_COLORS',
  PROVIDER_STRIPE_PAYOUT = 'PROVIDER_STRIPE_PAYOUT',
  PROVIDER_SUBSTITUTION_FILTER_FUNCTIONALITY = 'PROVIDER_SUBSTITUTION_FILTER_FUNCTIONALITY',
  PROVIDER_TEACHER_AVAILABILITY = 'PROVIDER_TEACHER_AVAILABILITY',
  SUBSTITUTION_CUSTOMER_NOTIFICATION = 'SUBSTITUTION_CUSTOMER_NOTIFICATION',
  TEAM_BALL_AND_RACKET_SPORTS_COURT_MANAGEMENT = 'TEAM_BALL_AND_RACKET_SPORTS_COURT_MANAGEMENT'
}

export type PublicAppointment = {
  __typename: 'PublicAppointment';
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  venue: PublicVenue;
};

export type PublicVenue = {
  __typename: 'PublicVenue';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shortId: Scalars['String']['output'];
};

export type Query = {
  __typename: 'Query';
  activities: Array<Activity>;
  appointmentById: Appointment;
  appointmentsPreview: Array<Appointment>;
  autoCommunication: AutoCommunication;
  bookingRequest: Maybe<BookingRequest>;
  /** A single broadcast, e.g. to edit a draft */
  broadcast: Broadcast;
  company: Company;
  companyBrandedApp: CompanyBrandedApp;
  companyWidget: CompanyWidget;
  courtGroup: CourtGroup;
  courtGroupSeason: Season;
  customer: Customer;
  defaultPrivateSessionPaymentOption: ActivityPaymentOption;
  emailCampaign: EmailCampaign;
  getCustomerFiltersFromTextExamplePrompts: Array<Scalars['String']['output']>;
  googleAdsConfiguration: GoogleAdsConfiguration;
  /** Retrieve information about currently logged in user */
  me: Me;
  penaltyRule: PenaltyRule;
  products: Array<Product>;
  publicAppointments: Array<PublicAppointment>;
  quicksightAnalyticsDashboard: QuicksightAnalyticsDashboard;
  session: Maybe<Session>;
  substitutionRequestAppointments: Array<Appointment>;
  /** Returns the count of private session appointments that can be created/updated/cancelled in a recurring series. */
  updatePrivateSessionCount: UpdatePrivateSessionCountResponseUnion;
  /** Retrieve a single `Venue` by its `ID` */
  venue: Venue;
  /** Retrieve a single `Venue` by its `shortId` */
  venueByShortId: Venue;
};


export type QueryActivitiesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryAppointmentByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryAppointmentsPreviewArgs = {
  appointmentIds: Array<Scalars['String']['input']>;
};


export type QueryAutoCommunicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookingRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBroadcastArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyArgs = {
  id: Scalars['String']['input'];
};


export type QueryCompanyBrandedAppArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCourtGroupArgs = {
  courtGroupId: Scalars['ID']['input'];
};


export type QueryCourtGroupSeasonArgs = {
  courtGroupId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
};


export type QueryCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryDefaultPrivateSessionPaymentOptionArgs = {
  venueId: Scalars['String']['input'];
};


export type QueryEmailCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCustomerFiltersFromTextExamplePromptsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  venueShortId: Scalars['String']['input'];
};


export type QueryPenaltyRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryPublicAppointmentsArgs = {
  substitutionRequestId: Scalars['ID']['input'];
};


export type QueryQuicksightAnalyticsDashboardArgs = {
  dashboardId: Scalars['String']['input'];
};


export type QuerySubstitutionRequestAppointmentsArgs = {
  substitutionRequestId: Scalars['String']['input'];
  substitutionStatus?: InputMaybe<SubstitutionStatus>;
  venueShortId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUpdatePrivateSessionCountArgs = {
  appointmentId: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  recurrenceSettings?: InputMaybe<UpdateRecurringAppointmentSettingsInput>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryVenueArgs = {
  id: Scalars['String']['input'];
};


export type QueryVenueByShortIdArgs = {
  shortId: Scalars['String']['input'];
};

export type QuicksightAnalyticsDashboard = {
  __typename: 'QuicksightAnalyticsDashboard';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  state: QuicksightAnalyticsDashboardState;
};

export enum QuicksightAnalyticsDashboardState {
  DEFAULT = 'DEFAULT',
  NEW = 'NEW',
  TEASER = 'TEASER'
}

export type Rate = {
  __typename: 'Rate';
  bookingType: BookingType;
  consumerType: ConsumerType;
  /** The customer group this rate applies to */
  customerGroup: Maybe<CustomerGroup>;
  id: Scalars['ID']['output'];
  maxUnits: Maybe<Scalars['Int']['output']>;
  minUnits: Maybe<Scalars['Int']['output']>;
  /** Price in Integer Cents of the venue currency */
  price: Scalars['Int']['output'];
};

export type RateInput = {
  bookingType: BookingType;
  consumerType: ConsumerType;
  customerGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** optional ID, if given, updating existing. Otherwise creating a new one */
  id?: InputMaybe<Scalars['ID']['input']>;
  maxUnits?: InputMaybe<Scalars['Int']['input']>;
  minUnits?: InputMaybe<Scalars['Int']['input']>;
  /** Price in Integer Cents of the venue currency */
  price: Scalars['Int']['input'];
};

export type RateValidation = {
  __typename: 'RateValidation';
  alsoUsedIn: Array<Period>;
  errors: Array<RateValidationError>;
  isValid: Scalars['Boolean']['output'];
};

export enum RateValidationError {
  DUPLICATE = 'DUPLICATE',
  NO_CUSTOMERGROUP = 'NO_CUSTOMERGROUP',
  RECURRING_GUEST = 'RECURRING_GUEST'
}

/** A video a customer can watch, on demand instead of at an appointment */
export type Recording = {
  __typename: 'Recording';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type RecordingCategory = {
  __typename: 'RecordingCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  venue: Venue;
};

/** A _paginated_ result set of "RecordingCategory" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type RecordingCategoryConnection = {
  __typename: 'RecordingCategoryConnection';
  /** The `Edges` "RecordingCategory" items */
  edges: Array<RecordingCategoryEdge>;
  /** The actual "RecordingCategory" items */
  nodes: Array<RecordingCategory>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type RecordingCategoryEdge = {
  __typename: 'RecordingCategoryEdge';
  cursor: Scalars['Cursor']['output'];
  node: RecordingCategory;
};

export enum RecordingDifficultyLevel {
  ALL = 'ALL',
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE',
  PROFESSIONAL = 'PROFESSIONAL'
}

export enum RecordingSupportedLanguage {
  DUTCH = 'DUTCH',
  ENGLISH = 'ENGLISH',
  FRENCH = 'FRENCH',
  GERMAN = 'GERMAN',
  ITALIAN = 'ITALIAN',
  SPANISH = 'SPANISH'
}

/** Whether the recurrence pattern is a default or a custom one */
export enum RecurrenceType {
  CUSTOM = 'CUSTOM',
  DEFAULT = 'DEFAULT'
}

/** Frequency of recurring appointments */
export enum RecurringFrequency {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY'
}

export type RecurringSettings = {
  __typename: 'RecurringSettings';
  actualOccurrenceCount: Maybe<Scalars['Int']['output']>;
  dayOfMonth: Maybe<Scalars['Int']['output']>;
  daysOfWeek: Maybe<Array<Scalars['Int']['output']>>;
  frequency: RecurringFrequency;
  id: Scalars['ID']['output'];
  interval: Scalars['Int']['output'];
  /** RFC 5545 EXDATE - days removed from the series, so re-expanding it cannot bring them back. */
  recurrenceExceptionDates: Array<Scalars['LocalDate']['output']>;
  /** RFC 5545 RRULE value driving the series, e.g. "FREQ=WEEKLY;BYDAY=MO,WE;WKST=SU". The structured fields above are a convenience projection of it. Null on series that predate the recurrence migration and have not been backfilled. */
  recurrenceRule: Maybe<Scalars['String']['output']>;
  recurrenceType: RecurrenceType;
  seriesEndDate: Maybe<Scalars['DateTime']['output']>;
  seriesEndOccurrenceCount: Maybe<Scalars['Int']['output']>;
};

export type RecurringSettingsInput = {
  /** Day of month for monthly recurrence (1-31) */
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Days of week for weekly recurrence (0=Sunday, 6=Saturday) */
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Frequency of recurrence (daily, weekly, monthly, yearly) */
  frequency: RecurringFrequency;
  /** Interval (e.g., every N days/weeks/months) */
  interval: Scalars['Int']['input'];
  /** Maximum number of occurrences to generate */
  maxOccurrences?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the recurrence pattern is a default or a custom one; defaults to default */
  recurrenceType?: InputMaybe<RecurrenceType>;
  /** End date of the series (e.g., "2024-12-31") */
  untilDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export enum ReferrerRewardType {
  DISCOUNT = 'DISCOUNT',
  MESSAGE = 'MESSAGE',
  NONE = 'NONE'
}

/** The aspect of court booking a rental rule answers. */
export enum RentalRuleType {
  AVAILABILITY = 'AVAILABILITY',
  CANCELLATION = 'CANCELLATION',
  ELIGIBILITY = 'ELIGIBILITY',
  PRICE = 'PRICE',
  SLOT = 'SLOT'
}

/** One reason the rental rules refused a reservation. */
export type RentalViolation = {
  __typename: 'RentalViolation';
  /** The time-bound rule set that refused; null when the rule's base configuration did. */
  appliedRuleSet: Maybe<Scalars['String']['output']>;
  aspect: RentalRuleType;
  code: RentalViolationCode;
};

/** Why the rental rules refused a reservation. */
export enum RentalViolationCode {
  OUTSIDE_OPENING_HOURS = 'OUTSIDE_OPENING_HOURS',
  POLICY_NOT_ASSIGNED = 'POLICY_NOT_ASSIGNED',
  RESOURCE_ALREADY_BOOKED = 'RESOURCE_ALREADY_BOOKED'
}

/** The rental rules that a requested reservation breaks. */
export type RentalViolations = {
  __typename: 'RentalViolations';
  violations: Array<RentalViolation>;
};

export enum RequiredSessionAction {
  MFA_SETUP = 'MFA_SETUP',
  MFA_VERIFY = 'MFA_VERIFY',
  SET_ORGANIZATION = 'SET_ORGANIZATION'
}

/** A one-time payment taken on-site when the court is booked for a customer */
export type ReservationPaymentInput = {
  /** The id of one of the venue's `paymentOptions` */
  paymentMethodId: Scalars['ID']['input'];
};

export type Resource = {
  __typename: 'Resource';
  area: Area;
  availabilityRule: Maybe<RoomAvailabilityRule>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  surface: Maybe<Scalars['String']['output']>;
};

/** A _paginated_ result set of "Resource" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type ResourceConnection = {
  __typename: 'ResourceConnection';
  /** The `Edges` "Resource" items */
  edges: Array<ResourceEdge>;
  /** The actual "Resource" items */
  nodes: Array<Resource>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type ResourceEdge = {
  __typename: 'ResourceEdge';
  cursor: Scalars['Cursor']['output'];
  node: Resource;
};

export enum RevenueSegment {
  PAID = 'PAID',
  UNPAID = 'UNPAID'
}

export type RichTextOutput = {
  __typename: 'RichTextOutput';
  context: Maybe<Scalars['String']['output']>;
  html: Scalars['String']['output'];
  /** The content guardrail rejected the request, so there is no content. The verdict is the same for the same wording, so the user has to rephrase rather than retry. */
  isBlocked: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export enum Role {
  ACCOUNTING_MANAGER = 'ACCOUNTING_MANAGER',
  ADMIN = 'ADMIN',
  AGGREGATOR_ADMIN = 'AGGREGATOR_ADMIN',
  EMPLOYEE = 'EMPLOYEE',
  EVERSPORTS_ADMIN = 'EVERSPORTS_ADMIN',
  EXTERNAL_TEACHER = 'EXTERNAL_TEACHER',
  MANAGER = 'MANAGER',
  TEACHER = 'TEACHER'
}

export type RoomAvailabilityRule = {
  __typename: 'RoomAvailabilityRule';
  id: Scalars['ID']['output'];
  /** Max parallel private sessions a room can host on its own */
  maxPrivateSessions: Scalars['Int']['output'];
  /** Max parallel private sessions when the room is shared with group activities */
  maxPrivateSessionsWithGroup: Maybe<Scalars['Int']['output']>;
};

export type RoomSharingConfigInput = {
  isRoomSharingAllowed: Scalars['Boolean']['input'];
  roomId: Scalars['String']['input'];
};

export type RoomWithAvailabilityRuleConnection = {
  __typename: 'RoomWithAvailabilityRuleConnection';
  /** The `Edges` "RoomWithAvailabilityRule" items */
  edges: Array<RoomWithAvailabilityRuleEdge>;
  /** The actual "RoomWithAvailabilityRule" items */
  nodes: Array<Resource>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
  /** Total number of rooms of the venue that have a room availability rule */
  totalCount: Scalars['Int']['output'];
};

export type RoomWithAvailabilityRuleEdge = {
  __typename: 'RoomWithAvailabilityRuleEdge';
  cursor: Scalars['Cursor']['output'];
  node: Resource;
};

export type SaveAutoCommunicationResponse = AutoCommunication | ExpectedErrors;

export type SaveAvailabilityRuleResponse = AvailabilityRule | ExpectedErrors;

export type SaveBroadcastResponse = Broadcast | ExpectedErrors;

export type SaveCancellationRuleResponse = CancellationRule | ExpectedErrors;

export type SaveCompanyReferralConfigResponse = CompanyReferralConfig | ExpectedErrors;

export type SaveCourtInput = {
  courtSizeId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  environment: Environment;
  /** The uuid of an existing court to update; omit to create a new court */
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  sportId: Scalars['String']['input'];
  surfaceId?: InputMaybe<Scalars['String']['input']>;
};

export type SaveCourtsResponse = Courts | ExpectedErrors;

export type SaveDefaultPrivateSessionAvailabilityScheduleResponse = ExpectedErrors | PrivateSessionAvailabilitySchedule;

export type SaveDefaultPrivateSessionAvailabilitySchedulesResponse = ExpectedErrors | PrivateSessionAvailabilityScheduleList;

export type SaveEligibilityRuleResponse = EligibilityRule | ExpectedErrors;

export type SaveEmailCampaignResponse = EmailCampaign | ExpectedErrors;

export type SaveGoogleAdsConfigurationResponse = ExpectedErrors | GoogleAdsConfiguration;

export type SavePriceRuleResponse = ExpectedErrors | PriceRule;

export type SavePricingRuleResponse = ExpectedErrors | PricingRule;

export type SavePrivateSessionAvailabilityScheduleDayArgs = {
  /** Day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday) */
  dayOfWeek: Scalars['Int']['input'];
  /** List of time slots for the day */
  timeSchedule: Array<SavePrivateSessionAvailabilityScheduleTimeArgs>;
};

export type SavePrivateSessionAvailabilityScheduleTimeArgs = {
  /** Availability from time (e.g., "09:00") */
  validFrom: Scalars['Time']['input'];
  /** Availability until time (e.g., "17:00") */
  validUntil: Scalars['Time']['input'];
};

export type SavePrivateSessionDaySpecificAvailabilityDateEntryArgs = {
  /** The specific date for this availability (e.g., "2024-03-15") */
  dateFrom: Scalars['LocalDate']['input'];
  /** List of time slots for the date */
  timeSlots: Array<SavePrivateSessionDaySpecificAvailabilityTimeArgs>;
};

export type SavePrivateSessionDaySpecificAvailabilityResponse = ExpectedErrors | PrivateSessionDaySpecificAvailabilityList;

export type SavePrivateSessionDaySpecificAvailabilityTimeArgs = {
  /** Availability from time (e.g., "09:00") */
  validFrom: Scalars['Time']['input'];
  /** Availability until time (e.g., "17:00") */
  validUntil: Scalars['Time']['input'];
};

export type SaveRoomAvailabilityRuleResponse = ExpectedErrors | RoomAvailabilityRule;

export type SaveSlotRuleResponse = ExpectedErrors | SlotRule;

export type SaveTeacherDaySpecificAvailabilitiesResponse = ExpectedErrors | TeacherDaySpecificAvailabilityByTrainerList;

export type SaveTeacherDaySpecificAvailabilityEntryArgs = {
  /** Start date of the exception (e.g., "2024-03-15") */
  dateFrom: Scalars['LocalDate']['input'];
  /** End date of the exception (required for custom_hours) */
  dateTo?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Recurrence settings (only valid for time_off) */
  recurringSettings?: InputMaybe<RecurringSettingsInput>;
  /** List of time slots for the exception */
  timeSlots: Array<SaveTeacherDaySpecificAvailabilityTimeArgs>;
  /** Label for the exception (required for time_off entries) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Type of the availability exception */
  type: TrainerDaySpecificAvailabilityType;
  /** ID of the entry to update; omit to create a new one */
  uuid?: InputMaybe<Scalars['ID']['input']>;
  /** How the entry is presented (single day or date range); defaults to single */
  viewType?: InputMaybe<TrainerDaySpecificAvailabilityViewType>;
};

export type SaveTeacherDaySpecificAvailabilityForTrainerInput = {
  /** List of day-specific availability entries for this trainer */
  availability: Array<SaveTeacherDaySpecificAvailabilityEntryArgs>;
  /** ID of the trainer */
  trainerId: Scalars['ID']['input'];
};

export type SaveTeacherDaySpecificAvailabilityTimeArgs = {
  /** Day of the week this slot applies to (0=Sunday, 6=Saturday) */
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  /** Availability from time (e.g., "09:00") */
  validFrom: Scalars['Time']['input'];
  /** Availability until time (e.g., "17:00") */
  validUntil: Scalars['Time']['input'];
};

export type SaveTrainerDaySpecificAvailabilityResponse = ExpectedErrors | TeacherDaySpecificAvailabilityList;

export type SchedulerSettings = {
  __typename: 'SchedulerSettings';
  colorType: Scalars['String']['output'];
  defaultView: Scalars['String']['output'];
  end: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  start: Scalars['String']['output'];
};

export type Season = {
  __typename: 'Season';
  end: Scalars['DateMonthDay']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The Periods in this Season. Use CourtGroupId to filter */
  periods: Array<Period>;
  start: Scalars['DateMonthDay']['output'];
};


export type SeasonPeriodsArgs = {
  courtGroupId: Scalars['ID']['input'];
};

export type SeasonInput = {
  end: Scalars['DateMonthDay']['input'];
  name: Scalars['String']['input'];
  start: Scalars['DateMonthDay']['input'];
};

export type SeasonMutationResult = Season | SeasonValidation;

export type SeasonValidation = {
  __typename: 'SeasonValidation';
  alsoUsedIn: Array<CourtGroup>;
  conflictsIn: Array<CourtGroup>;
  isValid: Scalars['Boolean']['output'];
  overlaps: Array<Season>;
  overrides: Array<Season>;
};

export type SendBroadcastResponse = Broadcast | ExpectedErrors;

export type SenderDetails = {
  __typename: 'SenderDetails';
  address: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type SendingBatchJob = {
  __typename: 'SendingBatchJob';
  failed: Scalars['Float']['output'];
  id: Array<Scalars['String']['output']>;
};

export type SendingBatchJobResult = ExpectedErrors | SendingBatchJob;

export type SendingGroup = {
  __typename: 'SendingGroup';
  bouncedCount: Scalars['Float']['output'];
  clickedCount: Scalars['Float']['output'];
  complaintCount: Scalars['Float']['output'];
  deliveredCount: Scalars['Float']['output'];
  deliveredDelayCount: Scalars['Float']['output'];
  failedCount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  openedCount: Scalars['Float']['output'];
  processingCount: Scalars['Float']['output'];
  rejectCount: Scalars['Float']['output'];
  renderedFailureCount: Scalars['Float']['output'];
  sentCount: Scalars['Float']['output'];
  totalEmails: Scalars['Float']['output'];
  unsubscribedCount: Scalars['Float']['output'];
};

export type SendingJob = {
  __typename: 'SendingJob';
  id: Scalars['String']['output'];
};

export type SendingJobResult = ExpectedErrors | SendingJob;

export type Session = {
  __typename: 'Session';
  accessibleResources: Array<OrganizationResource>;
  currentOrganization: Maybe<Organization>;
  featurePreviews: Array<FeaturePreview>;
  /** Whether this session may be tracked in Amplitude. False for masquerade sessions. */
  isAmplitudeTrackingEnabled: Scalars['Boolean']['output'];
  isLoggedIn: Scalars['Boolean']['output'];
  language: Maybe<Scalars['String']['output']>;
  locale: Maybe<Scalars['String']['output']>;
  mfa: Maybe<Mfa>;
  mfaSetup: Maybe<Totp>;
  requiredAction: Maybe<RequiredSessionAction>;
  requiresMfa: Scalars['Boolean']['output'];
};


export type SessionFeaturePreviewsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<ProviderFeaturePreview>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Settings = {
  __typename: 'Settings';
  id: Scalars['String']['output'];
  softwareVersion: Maybe<SoftwareVersion>;
  substitutionNotification: Maybe<SubstitutionNotification>;
};

export type Size = {
  __typename: 'Size';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  numberOfPlayers: Scalars['Int']['output'];
  /** The sport this size belongs to */
  sport: Sport;
};

/** A rule answering the slot aspect of court booking: how long a booking may last and which clock mark it may start on. */
export type SlotRule = {
  __typename: 'SlotRule';
  /** Whether a booking is refused when it would leave behind a gap too short to book. */
  areGapsForbidden: Scalars['Boolean']['output'];
  /** The courts this rule is assigned to, ordered by name. Archived courts are excluded. Empty if the rule is assigned to no court. */
  assignedCourts: Array<Court>;
  /** When the rule was created. */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The longest bookable slot, in minutes. */
  maxDurationInMinutes: Scalars['Int']['output'];
  /** The shortest bookable slot, in minutes. */
  minDurationInMinutes: Scalars['Int']['output'];
  /** The shortest bookable slot extension, in minutes. */
  minExtensionInMinutes: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** The clock mark a slot may start on, in minutes. One of 30, 60 or 90. */
  startsOnInMinutes: Scalars['Int']['output'];
  /** When the rule was last modified. Equals `createdAt` until the rule is first edited. */
  updatedAt: Scalars['DateTime']['output'];
};

export type SoftwareCompany = {
  __typename: 'SoftwareCompany';
  legalName: Scalars['String']['output'];
  registered: Scalars['Boolean']['output'];
  /** Tax identification number of the company */
  tin: Scalars['String']['output'];
};

export type SoftwareVersion = {
  __typename: 'SoftwareVersion';
  id: Scalars['ID']['output'];
  versionName: Scalars['String']['output'];
};

/** The tax region for Spain */
export enum SpainTaxRegion {
  TICKETBAI = 'TICKETBAI',
  VERIFACTU = 'VERIFACTU'
}

/** The tax territory for Spain */
export enum SpainTaxTerritory {
  ARABA = 'ARABA',
  BIZKAIA = 'BIZKAIA',
  CANARY_ISLANDS = 'CANARY_ISLANDS',
  CEUTA = 'CEUTA',
  GIPUZKOA = 'GIPUZKOA',
  MELILLA = 'MELILLA',
  NAVARRE = 'NAVARRE',
  SPAIN_OTHER = 'SPAIN_OTHER'
}

export type SpanishTaxInformation = TaxInformation & {
  __typename: 'SpanishTaxInformation';
  fiscalizationSoftwareInformation: FiscalizationSoftwareInformation;
  taxRegion: Maybe<SpainTaxRegion>;
  taxTerritory: SpainTaxTerritory;
  /** Tax identification number of the company */
  tin: Maybe<Scalars['String']['output']>;
};

export type Sport = {
  __typename: 'Sport';
  /** The court sizes configured for this sport */
  courtSizes: Array<Size>;
  /** The court surfaces configured for this sport */
  courtSurfaces: Array<Surface>;
  id: Scalars['ID']['output'];
  /** The translated name of this sport */
  name: Scalars['String']['output'];
};

/** A _paginated_ result set of "Sport" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type SportConnection = {
  __typename: 'SportConnection';
  /** The `Edges` "Sport" items */
  edges: Array<SportEdge>;
  /** The actual "Sport" items */
  nodes: Array<Sport>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type SportEdge = {
  __typename: 'SportEdge';
  cursor: Scalars['Cursor']['output'];
  node: Sport;
};

export enum SpotLimitDisplayType {
  ACTIVITY_SPOT_LIMIT_DISPLAY_TYPE_FREE_SPOTS_COUNT = 'ACTIVITY_SPOT_LIMIT_DISPLAY_TYPE_FREE_SPOTS_COUNT',
  ACTIVITY_SPOT_LIMIT_DISPLAY_TYPE_PARTICIPANTS_COUNT = 'ACTIVITY_SPOT_LIMIT_DISPLAY_TYPE_PARTICIPANTS_COUNT'
}

export type SpotUnionType = BookableSpot | NonBookableSpot;

export type StripeBalance = {
  __typename: 'StripeBalance';
  available: Array<MonetaryValue>;
  pending: Array<MonetaryValue>;
};

export type StripeConnectedAccount = {
  __typename: 'StripeConnectedAccount';
  balance: StripeBalance;
  bankAccount: Maybe<StripeExternalAccount>;
  canAcceptPayments: Scalars['Boolean']['output'];
  canReceivePayouts: Scalars['Boolean']['output'];
  inTransit: Array<MonetaryValue>;
  isVerified: Scalars['Boolean']['output'];
  payoutSettings: Maybe<StripePayoutSettings>;
  persons: Array<StripePerson>;
};

export type StripeExternalAccount = {
  __typename: 'StripeExternalAccount';
  accountHolder: Maybe<Scalars['String']['output']>;
  bankName: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  last4: Maybe<Scalars['String']['output']>;
};

export type StripePayout = {
  __typename: 'StripePayout';
  amount: MonetaryValue;
  id: Scalars['String']['output'];
  initiatedAt: Scalars['DateTime']['output'];
  status: StripePayoutStatus;
  type: StripePayoutType;
};

export type StripePayoutConfirmation = {
  __typename: 'StripePayoutConfirmation';
  fileName: Scalars['String']['output'];
  pdfBase64: Scalars['String']['output'];
};

/** A _paginated_ result set of "StripePayout" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type StripePayoutConnection = {
  __typename: 'StripePayoutConnection';
  /** The `Edges` "StripePayout" items */
  edges: Array<StripePayoutEdge>;
  /** The actual "StripePayout" items */
  nodes: Array<StripePayout>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type StripePayoutEdge = {
  __typename: 'StripePayoutEdge';
  cursor: Scalars['Cursor']['output'];
  node: StripePayout;
};

/** Frequency of the payout - weekly or monthly */
export enum StripePayoutFrequency {
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

export type StripePayoutSettings = {
  __typename: 'StripePayoutSettings';
  executionDay: Scalars['Int']['output'];
  frequency: StripePayoutFrequency;
};

/** Status of a Stripe payout */
export enum StripePayoutStatus {
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
  IN_TRANSIT = 'IN_TRANSIT',
  PAID = 'PAID',
  PENDING = 'PENDING'
}

/** Whether the payout was triggered manually or automatically */
export enum StripePayoutType {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL'
}

export type StripePerson = {
  __typename: 'StripePerson';
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isVerified: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  roles: Array<StripePersonRole>;
  title: Maybe<Scalars['String']['output']>;
};

/** Role of the person in Stripe */
export enum StripePersonRole {
  AUTHORIZER = 'AUTHORIZER',
  DIRECTOR = 'DIRECTOR',
  EXECUTIVE = 'EXECUTIVE',
  LEGAL_GUARDIAN = 'LEGAL_GUARDIAN',
  OWNER = 'OWNER',
  REPRESENTATIVE = 'REPRESENTATIVE'
}

export type Substitution = {
  __typename: 'Substitution';
  appointment: Appointment;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<Teacher>;
  declined: Maybe<Array<Teacher>>;
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  status: Scalars['String']['output'];
  substitute: Maybe<Teacher>;
  venue: Venue;
};

/** A _paginated_ result set of "Substitution" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type SubstitutionConnection = {
  __typename: 'SubstitutionConnection';
  /** The `Edges` "Substitution" items */
  edges: Array<SubstitutionEdge>;
  /** The actual "Substitution" items */
  nodes: Array<Substitution>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type SubstitutionEdge = {
  __typename: 'SubstitutionEdge';
  cursor: Scalars['Cursor']['output'];
  node: Substitution;
};

/** Types of errors that can occur during substitution operations */
export enum SubstitutionErrorType {
  APPOINTMENT_NOT_FOUND = 'APPOINTMENT_NOT_FOUND',
  APPOINTMENT_TAKEN_BY_ANOTHER_TEACHER = 'APPOINTMENT_TAKEN_BY_ANOTHER_TEACHER',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  USER_NOT_AUTHORIZED = 'USER_NOT_AUTHORIZED',
  VENUE_ACCESS_DENIED = 'VENUE_ACCESS_DENIED'
}

/** Defines the time range for fetching substitutions */
export enum SubstitutionFilterRange {
  PAST = 'PAST',
  UPCOMING = 'UPCOMING'
}

export type SubstitutionNotification = {
  __typename: 'SubstitutionNotification';
  customerNotificationEmailTemplate: Maybe<Scalars['String']['output']>;
  customerNotificationEnabled: Scalars['Boolean']['output'];
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  successfullyCreated: Scalars['Boolean']['output'];
  successfullySubstituted: Scalars['Boolean']['output'];
};

export type SubstitutionRequest = {
  __typename: 'SubstitutionRequest';
  id: Scalars['ID']['output'];
};

export type SubstitutionRequestResult = {
  __typename: 'SubstitutionRequestResult';
  errorType: Maybe<SubstitutionErrorType>;
  failedAppointments: Maybe<Array<AppointmentSubstitutionFailedResult>>;
  success: Scalars['Boolean']['output'];
  successfulAppointments: Maybe<Array<AppointmentSubstitutionAcceptedResult>>;
};

/** The status of a substitution for an appointment */
export enum SubstitutionStatus {
  COMPLETED = 'COMPLETED',
  OPEN = 'OPEN'
}

export type Surface = {
  __typename: 'Surface';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SyncBookableSpotInput = {
  floorPlanId: Scalars['String']['input'];
  icon?: InputMaybe<BookableSpotIconType>;
  id?: InputMaybe<Scalars['String']['input']>;
  isAvailable: Scalars['Boolean']['input'];
  isPriority?: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type SyncNonBookableSpotInput = {
  floorPlanId: Scalars['String']['input'];
  icon: NonBookableItemIconType;
  id?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type SyncTeacherCalendarIntegrationResponse = ExpectedErrors | TeacherCalendarIntegration;

export type Tag = {
  __typename: 'Tag';
  color: Scalars['String']['output'];
  customerCount: Scalars['Float']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** A _paginated_ result set of "Tag" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type TagConnection = {
  __typename: 'TagConnection';
  /** The `Edges` "Tag" items */
  edges: Array<TagEdge>;
  /** The actual "Tag" items */
  nodes: Array<Tag>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type TagEdge = {
  __typename: 'TagEdge';
  cursor: Scalars['Cursor']['output'];
  node: Tag;
};

export type TaxArchive = {
  __typename: 'TaxArchive';
  createdAt: Scalars['DateTime']['output'];
  downloadUrl: Maybe<Scalars['String']['output']>;
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  toDate: Scalars['DateTime']['output'];
};

/** A _paginated_ result set of "TaxArchive" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type TaxArchiveConnection = {
  __typename: 'TaxArchiveConnection';
  /** The `Edges` "TaxArchive" items */
  edges: Array<TaxArchiveEdge>;
  /** The actual "TaxArchive" items */
  nodes: Array<TaxArchive>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type TaxArchiveEdge = {
  __typename: 'TaxArchiveEdge';
  cursor: Scalars['Cursor']['output'];
  node: TaxArchive;
};

export type TaxInformation = {
  /** Tax identification number of the company */
  tin: Maybe<Scalars['String']['output']>;
};

export type TaxInformationUnion = GenericTaxInformation | SpanishTaxInformation;

export type Teacher = {
  __typename: 'Teacher';
  active: Scalars['Boolean']['output'];
  availabilityStatus: TeacherAvailabilityStatus;
  calendarIntegrations: Array<TeacherCalendarIntegration>;
  contactDetails: Maybe<ContactDetails>;
  daySpecificAvailability: TeacherDaySpecificAvailabilityConnection;
  defaultAvailabilitySchedule: Maybe<PrivateSessionAvailabilitySchedule>;
  firstname: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastname: Maybe<Scalars['String']['output']>;
  nickname: Scalars['String']['output'];
  profilePicture: Maybe<Picture>;
};


export type TeacherDaySpecificAvailabilityArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isManualEntry?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueShortId?: InputMaybe<Scalars['String']['input']>;
};

export enum TeacherAvailabilityStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  MISSING = 'MISSING'
}

export type TeacherCalendarIntegration = {
  __typename: 'TeacherCalendarIntegration';
  id: Scalars['ID']['output'];
  /** Timestamp of the most recent attempted sync */
  lastAttemptedSyncAt: Maybe<Scalars['DateTime']['output']>;
  /** Error message from the most recent sync attempt, if it failed */
  lastError: Maybe<Scalars['String']['output']>;
  /** Timestamp of the most recent full sync */
  lastFullSyncAt: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of the most recent successful sync */
  lastSuccessfulSyncAt: Maybe<Scalars['DateTime']['output']>;
  /** Warning message from the most recent sync attempt, if there were any warnings */
  lastWarning: Maybe<Scalars['String']['output']>;
  /** Display name of the calendar integration */
  name: Scalars['String']['output'];
  /** Type of the calendar integration (e.g. "google" | "outlook" | "other") */
  type: Scalars['String']['output'];
};

/** A _paginated_ result set of "Teacher" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type TeacherConnection = {
  __typename: 'TeacherConnection';
  /** The `Edges` "Teacher" items */
  edges: Array<TeacherEdge>;
  /** The actual "Teacher" items */
  nodes: Array<Teacher>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type TeacherDaySpecificAvailability = {
  __typename: 'TeacherDaySpecificAvailability';
  /** Id of the calendar integration that created this entry, if any (absent for manual entries) */
  calendarIntegrationId: Maybe<Scalars['ID']['output']>;
  /** Start date of the exception */
  dateFrom: Scalars['LocalDate']['output'];
  /** End date of the exception */
  dateTo: Scalars['LocalDate']['output'];
  id: Scalars['ID']['output'];
  /** Recurrence settings (only present for recurring time_off entries) */
  recurringSettings: Maybe<TeacherDaySpecificAvailabilityRecurringSettings>;
  /** List of time slots for the exception */
  timeSlots: Array<TeacherDaySpecificAvailabilityTime>;
  /** Label for the exception (present for time_off entries) */
  title: Maybe<Scalars['String']['output']>;
  type: TrainerDaySpecificAvailabilityType;
  viewType: TrainerDaySpecificAvailabilityViewType;
};

export type TeacherDaySpecificAvailabilityByTrainer = {
  __typename: 'TeacherDaySpecificAvailabilityByTrainer';
  /** List of saved day-specific availabilities */
  nodes: Array<TeacherDaySpecificAvailability>;
  /** ID of the trainer these records belong to */
  trainerId: Scalars['ID']['output'];
};

export type TeacherDaySpecificAvailabilityByTrainerList = {
  __typename: 'TeacherDaySpecificAvailabilityByTrainerList';
  /** List of saved availabilities per trainer */
  nodes: Array<TeacherDaySpecificAvailabilityByTrainer>;
};

/** A _paginated_ result set of "TeacherDaySpecificAvailability" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type TeacherDaySpecificAvailabilityConnection = {
  __typename: 'TeacherDaySpecificAvailabilityConnection';
  /** The `Edges` "TeacherDaySpecificAvailability" items */
  edges: Array<TeacherDaySpecificAvailabilityEdge>;
  /** The actual "TeacherDaySpecificAvailability" items */
  nodes: Array<TeacherDaySpecificAvailability>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type TeacherDaySpecificAvailabilityEdge = {
  __typename: 'TeacherDaySpecificAvailabilityEdge';
  cursor: Scalars['Cursor']['output'];
  node: TeacherDaySpecificAvailability;
};

export type TeacherDaySpecificAvailabilityList = {
  __typename: 'TeacherDaySpecificAvailabilityList';
  /** List of saved day-specific availabilities */
  nodes: Array<TeacherDaySpecificAvailability>;
};

export type TeacherDaySpecificAvailabilityRecurringSettings = {
  __typename: 'TeacherDaySpecificAvailabilityRecurringSettings';
  dayOfMonth: Maybe<Scalars['Int']['output']>;
  daysOfWeek: Maybe<Array<Scalars['Int']['output']>>;
  /** RFC 5545 EXDATE - days excluded from the series. */
  exceptionDates: Array<Scalars['LocalDate']['output']>;
  /** Null when the rule cannot be projected onto it. */
  frequency: Maybe<RecurringFrequency>;
  /** Null when the rule cannot be projected onto it. */
  interval: Maybe<Scalars['Int']['output']>;
  maxOccurrences: Maybe<Scalars['Int']['output']>;
  /** RFC 5545 RRULE value. Null only on entries predating the recurrence migration, where the structured fields below carry the pattern instead. */
  recurrenceRule: Maybe<Scalars['String']['output']>;
  /** Whether the recurrence pattern is a pre-defined or a custom one. Not part of RFC 5545, so it is stored separately and is null for externally authored rules. */
  recurrenceType: Maybe<RecurrenceType>;
  untilDate: Maybe<Scalars['LocalDate']['output']>;
};

export type TeacherDaySpecificAvailabilityTime = {
  __typename: 'TeacherDaySpecificAvailabilityTime';
  /** Day of the week this slot applies to (0=Sunday, 6=Saturday) */
  dayOfWeek: Maybe<Scalars['Int']['output']>;
  /** Availability from time (e.g., "09:00") */
  validFrom: Scalars['Time']['output'];
  /** Availability until time (e.g., "17:00") */
  validUntil: Scalars['Time']['output'];
};

export type TeacherEdge = {
  __typename: 'TeacherEdge';
  cursor: Scalars['Cursor']['output'];
  node: Teacher;
};

export type TechnicalEventLog = {
  __typename: 'TechnicalEventLog';
  code: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  information: Maybe<Scalars['String']['output']>;
  invokedByUser: Maybe<User>;
  number: Scalars['Int']['output'];
  signature: Maybe<Scalars['String']['output']>;
};

/** A _paginated_ result set of "TechnicalEventLog" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type TechnicalEventLogConnection = {
  __typename: 'TechnicalEventLogConnection';
  /** The `Edges` "TechnicalEventLog" items */
  edges: Array<TechnicalEventLogEdge>;
  /** The actual "TechnicalEventLog" items */
  nodes: Array<TechnicalEventLog>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type TechnicalEventLogEdge = {
  __typename: 'TechnicalEventLogEdge';
  cursor: Scalars['Cursor']['output'];
  node: TechnicalEventLog;
};

export type TextToCustomerFiltersResponse = {
  __typename: 'TextToCustomerFiltersResponse';
  /** What the deterministic post-checks changed */
  adjustments: Array<TextToFiltersAdjustment>;
  /** Notes from the AI about what filters cannot express, in the user language */
  aiWarnings: Array<Scalars['String']['output']>;
  /** Values the AI filled in without the user stating them */
  assumptions: Array<TextToFiltersAssumption>;
  filters: Array<FilterWithConfidence>;
  /** Set when the AI returned no filters or dropped part of the request */
  reason: Maybe<TextToFiltersReason>;
  /** A rewritten request the available filters can fulfil, in the user language */
  suggestion: Maybe<Scalars['String']['output']>;
  /** Terms from the request that matched nothing in this venue */
  unmatchedTerms: Array<UnmatchedTerm>;
  validation: ValidationResult;
};

export type TextToFiltersAdjustment = {
  __typename: 'TextToFiltersAdjustment';
  /** Number of products filled in */
  count: Maybe<Scalars['Int']['output']>;
  /** Names the removed rule referred to */
  entityNames: Maybe<Array<Scalars['String']['output']>>;
  filterType: Scalars['String']['output'];
  kind: TextToFiltersAdjustmentKind;
  /** Product type that was filled in */
  productType: Maybe<Scalars['String']['output']>;
  ruleType: Scalars['String']['output'];
};

/** What a deterministic post-check changed in the AI output. DROPPED_UNMENTIONED_ENTITIES: an entity rule named things the request never mentioned. DROPPED_UNGROUNDED_TIMEFRAME: a timeframe the request did not state and the AI did not declare as an assumption. DROPPED_LAPSED_WITHOUT_PERIOD: a "0 visits in period" filter and its "at least 1 visit ever" companion were removed because no period was stated or declared. FILLED_PRODUCT_TYPE: an empty product selector was filled with every product of the mentioned type. DROPPED_EMPTY_RULE: an entity rule with an empty selection was removed. ADDED_LIFETIME_VISIT_RULE: a "0 visits in period" filter got a companion "at least 1 visit ever" filter. */
export enum TextToFiltersAdjustmentKind {
  ADDED_LIFETIME_VISIT_RULE = 'ADDED_LIFETIME_VISIT_RULE',
  DROPPED_EMPTY_RULE = 'DROPPED_EMPTY_RULE',
  DROPPED_LAPSED_WITHOUT_PERIOD = 'DROPPED_LAPSED_WITHOUT_PERIOD',
  DROPPED_UNGROUNDED_TIMEFRAME = 'DROPPED_UNGROUNDED_TIMEFRAME',
  DROPPED_UNMENTIONED_ENTITIES = 'DROPPED_UNMENTIONED_ENTITIES',
  FILLED_PRODUCT_TYPE = 'FILLED_PRODUCT_TYPE'
}

export type TextToFiltersAssumption = {
  __typename: 'TextToFiltersAssumption';
  /** Which part of the filters the assumption concerns: timeframe, products, activities, visits, other */
  field: Scalars['String']['output'];
  /** User-facing sentence in the language of the request */
  note: Scalars['String']['output'];
  /** The value the AI chose */
  value: Scalars['String']['output'];
};

/** Why the AI returned no filters or dropped part of the request. UNSUPPORTED_CRITERIA: the request needs a criterion filters cannot express. NO_ENTITY_MATCH: named products, activities, tags or groups do not exist. AMBIGUOUS: the request is too vague. BLOCKED: the content guardrail rejected the wording, and will reject it again, so the user has to rephrase rather than retry. */
export enum TextToFiltersReason {
  AMBIGUOUS = 'AMBIGUOUS',
  BLOCKED = 'BLOCKED',
  NO_ENTITY_MATCH = 'NO_ENTITY_MATCH',
  UNSUPPORTED_CRITERIA = 'UNSUPPORTED_CRITERIA'
}

export type Timespan = {
  __typename: 'Timespan';
  from: Scalars['DateTime']['output'];
  until: Scalars['DateTime']['output'];
};

export type TimespanInput = {
  from: Scalars['DateTime']['input'];
  until: Scalars['DateTime']['input'];
};

export type TimespanValue = {
  __typename: 'TimespanValue';
  timespan: Timespan;
  value: Scalars['Float']['output'];
};

export type TotalValue = {
  __typename: 'TotalValue';
  total: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
};

export type Totp = {
  __typename: 'Totp';
  recoveryCodes: Array<Scalars['String']['output']>;
  secretUri: Scalars['String']['output'];
};

/** Type of the availability exception (time_off or custom_hours) */
export enum TrainerDaySpecificAvailabilityType {
  CUSTOM_HOURS = 'CUSTOM_HOURS',
  TIME_OFF = 'TIME_OFF'
}

/** How the entry is presented (single day or date range) */
export enum TrainerDaySpecificAvailabilityViewType {
  RANGE = 'RANGE',
  SINGLE = 'SINGLE'
}

export type UnassignWidgetFromOverviewMutationResponse = CompanyWidgetOverview | ExpectedErrors;

export type UnlayerTemplateOutput = {
  __typename: 'UnlayerTemplateOutput';
  /** Full context prompt (admin-only debug) */
  context: Maybe<Scalars['String']['output']>;
  /** The content guardrail rejected the request, so there is no template. The verdict is the same for the same wording, so the user has to rephrase rather than retry. */
  isBlocked: Scalars['Boolean']['output'];
  /** The Unlayer JSON template structure. Absent when isBlocked is true. */
  template: Maybe<Scalars['JSON']['output']>;
};

export type UnmatchedTerm = {
  __typename: 'UnmatchedTerm';
  /** Closest catalog names, best match first, for a "did you mean" hint */
  similarEntities: Array<Scalars['String']['output']>;
  term: Scalars['String']['output'];
};

export type UpdateBrandSettingsResponse = CompanyWidgetBrandSettings | ExpectedErrors;

export type UpdateLocationArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryISO?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  municipality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePenaltyRuleResponse = ExpectedErrors | PenaltyRule;

export type UpdatePrivateSessionCountResponse = {
  __typename: 'UpdatePrivateSessionCountResponse';
  /** Number of private session appointments that can be cancelled in the series */
  cancelledCount: Scalars['Int']['output'];
  /** Number of private session appointments that can be created in the series */
  createdCount: Scalars['Int']['output'];
  /** Number of private session appointments that can be updated in the series */
  updatedCount: Scalars['Int']['output'];
};

export type UpdatePrivateSessionCountResponseUnion = ExpectedErrors | UpdatePrivateSessionCountResponse;

export type UpdatePrivateSessionOfferResponse = Activity | ExpectedErrors;

export type UpdatePrivateSessionResponse = ExpectedErrors | UpdatePrivateSessionResult;

export type UpdatePrivateSessionResult = {
  __typename: 'UpdatePrivateSessionResult';
  /** Participants who could not be notified because they have no valid email address */
  notNotifiableParticipants: Array<Customer>;
  /** Updated appointment (single path) */
  privateSession: Maybe<PrivateSession>;
  /** Updated recurring settings (recurring path) */
  recurringSettings: Maybe<RecurringSettings>;
};

export type UpdatePrivateSessionSettingsInput = {
  /** Whether to notify participants about the update */
  isParticipantNotificationEnabled?: Scalars['Boolean']['input'];
  /** Optional message sent to customers describing the reason for the update */
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRecurringAppointmentSettingsInput = {
  /** Day of the month for monthly recurrence (1-31) */
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Days of the week for weekly recurrence (0=Sunday, 1=Monday, ..., 6=Saturday) */
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** How often the appointment repeats (daily, weekly, monthly, yearly) */
  frequency?: InputMaybe<RecurringFrequency>;
  /** UUID of the existing recurring settings to update. When provided, must match the recurring series of the appointment. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Interval for recurrence (e.g., every N days/weeks/months/years) */
  interval?: InputMaybe<Scalars['Int']['input']>;
  /** Number of occurrences to generate (limits the series if fewer than seriesEndDate would produce) */
  occurrenceCount?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the recurrence pattern is a default or a custom one; defaults to default */
  recurrenceType?: InputMaybe<RecurrenceType>;
  /** End date of the recurring series */
  seriesEndDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UploadSignedTaxAgreementResult = {
  __typename: 'UploadSignedTaxAgreementResult';
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type User = {
  __typename: 'User';
  firstname: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastname: Maybe<Scalars['String']['output']>;
};

export type Utilization = {
  __typename: 'Utilization';
  total: Array<YearlyUtilization>;
};

export type ValidatedSeason = {
  __typename: 'ValidatedSeason';
  end: Scalars['DateMonthDay']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The Periods in this Season. Use CourtGroupId to filter */
  periods: Array<Period>;
  start: Scalars['DateMonthDay']['output'];
  validation: SeasonValidation;
};


export type ValidatedSeasonPeriodsArgs = {
  courtGroupId: Scalars['ID']['input'];
};

export type ValidationError = {
  __typename: 'ValidationError';
  filterId: Scalars['String']['output'];
  filterType: Scalars['String']['output'];
  message: Scalars['String']['output'];
  ruleType: Scalars['String']['output'];
  severity: ValidationSeverity;
};

export type ValidationResult = {
  __typename: 'ValidationResult';
  errors: Array<ValidationError>;
  isValid: Scalars['Boolean']['output'];
  warnings: Array<ValidationError>;
};

/** Severity level of a validation error */
export enum ValidationSeverity {
  ERROR = 'ERROR',
  WARNING = 'WARNING'
}

export type Venue = {
  __typename: 'Venue';
  activeActivityTypes: Array<ActivityType>;
  /** @deprecated use activeActivityTypes instead */
  activeEventSettings: Array<Scalars['String']['output']>;
  activities: ActivityConnection;
  activity: Activity;
  activityGroups: ActivityGroupConnection;
  address: VenueAddress;
  appointments: AppointmentConnection;
  billingSubscription: Maybe<BillingSubscription>;
  bookingRequests: BookingRequestConnection;
  bookingRequestsCount: Scalars['Int']['output'];
  bookingSetting: BookingSetting;
  cashRegisterUsers: Array<CashRegisterUser>;
  company: Company;
  contractInformation: Maybe<ContractInformation>;
  /** Retrieve a single `Court` of this venue by its `ID` */
  court: Maybe<Court>;
  /** The Court Groups of the venue */
  courtGroups: Array<CourtGroup>;
  /** The Courts available at this venue ordered by name ascending */
  courts: CourtConnection;
  currency: Currency;
  /** Search the customers of the venue to assign them to a private session. Matches like the customer selection of the sign-in. */
  customerSearch: CustomerSearchResultConnection;
  /** E-invoice submission history */
  eInvoiceSubmissions: EInvoiceSubmissionConnection;
  featurePreviews: Array<FeaturePreview>;
  /** Retrieve paginated floor plans for a venue */
  floorPlanConnection: FloorPlanConnection;
  /** Retrieve floor plans for a venue */
  floorPlans: Array<FloorPlan>;
  id: Scalars['ID']['output'];
  importToken: Maybe<VenueImportToken>;
  internalType: Maybe<VenueInternalsType>;
  internals: Maybe<VenueInternals>;
  /** Invoices */
  invoices: InvoiceConnection;
  isEligibleForWidgetOverview: Scalars['Boolean']['output'];
  latestRun: Maybe<VenueImportRun>;
  latestUpload: Maybe<VenueImportUpload>;
  locations: LocationConnection;
  logo: Maybe<Picture>;
  name: Scalars['String']['output'];
  /** The opening hours of the season currently in effect. Empty if the venue has none configured. */
  openingHours: Array<OpeningHoursPeriod>;
  /** The payment methods the viewer may take a one-time on-site payment with when booking a court. Empty when the venue has no cash register station. */
  paymentOptions: Array<VenuePaymentOption>;
  privateSessionOfferTemplates: ActivityConnection;
  privateSessionSettings: Maybe<PrivateSessionSettings>;
  /** The rental rules configured for this venue */
  rentalRules: VenueRentalRules;
  /** Total number of rooms/courts available at this venue (matches the `roomsV2` set without filters) */
  roomCount: Scalars['Int']['output'];
  /** The Rooms/Courts available at this venue */
  rooms: Array<Resource>;
  /** The Rooms/Courts available at this venue ordered by name ascending */
  roomsV2: ResourceConnection;
  /** Rooms of this venue that have a room availability rule, ordered by rule creation date (newest first) */
  roomsWithAvailabilityRule: RoomWithAvailabilityRuleConnection;
  schedulerSettings: Maybe<SchedulerSettings>;
  shortId: Scalars['String']['output'];
  sports: SportConnection;
  stripeConnectedAccount: Maybe<StripeConnectedAccount>;
  stripePayoutConfirmation: Maybe<StripePayoutConfirmation>;
  stripePayouts: Maybe<StripePayoutConnection>;
  taxArchives: TaxArchiveConnection;
  /** Total number of active teachers of this venue (matches the unfiltered `teachers` set) */
  teacherCount: Scalars['Int']['output'];
  teachers: TeacherConnection;
  technicalEventLogs: TechnicalEventLogConnection;
  timeZone: Scalars['TimeZone']['output'];
  type: Maybe<VenueType>;
  /** Retrieve extensions activated for a venue */
  venueExtensions: Array<VenueExtension>;
  viewerRole: Maybe<Role>;
  viewerTeacher: Maybe<Teacher>;
  wallet: Maybe<Wallet>;
  website: Maybe<Scalars['String']['output']>;
};


export type VenueActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  allowedTeacherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<ActivityType>>;
  visibility?: InputMaybe<ActivityVisibility>;
};


export type VenueActivityArgs = {
  id: Scalars['String']['input'];
};


export type VenueActivityGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type VenueAppointmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  types?: InputMaybe<Array<ActivityType>>;
};


export type VenueBookingRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<BookingRequestStatus>>;
};


export type VenueBookingRequestsCountArgs = {
  status?: InputMaybe<Array<BookingRequestStatus>>;
};


export type VenueCourtArgs = {
  id: Scalars['String']['input'];
};


export type VenueCourtsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type VenueCustomerSearchArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm: Scalars['String']['input'];
};


export type VenueEInvoiceSubmissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<EInvoiceSubmissionStatus>>;
};


export type VenueFeaturePreviewsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<ProviderFeaturePreview>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VenueFloorPlanConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type VenueInvoicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  eInvoiceSubmissionStatuses?: InputMaybe<Array<EInvoiceSubmissionStatus>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasEInvoiceSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type VenueLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type VenuePrivateSessionOfferTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type VenueRoomsV2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excludeRoomsWithRule?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type VenueRoomsWithAvailabilityRuleArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type VenueSportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type VenueStripePayoutConfirmationArgs = {
  payoutId: Scalars['String']['input'];
};


export type VenueStripePayoutsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type VenueTaxArchivesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type VenueTeachersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VenueTechnicalEventLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['DateTime']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  toDate: Scalars['DateTime']['input'];
};

export type VenueAddress = {
  __typename: 'VenueAddress';
  cityName: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

/** A _paginated_ result set of "Venue" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type VenueConnection = {
  __typename: 'VenueConnection';
  /** The `Edges` "Venue" items */
  edges: Array<VenueEdge>;
  /** The actual "Venue" items */
  nodes: Array<Venue>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type VenueEdge = {
  __typename: 'VenueEdge';
  cursor: Scalars['Cursor']['output'];
  node: Venue;
};

export type VenueExtension = {
  __typename: 'VenueExtension';
  activationDate: Maybe<Scalars['DateTime']['output']>;
  extension: Extension;
  id: Scalars['ID']['output'];
  issuingVenue: Maybe<Venue>;
  price: Maybe<MonetaryValue>;
  priceCap: Maybe<MonetaryValue>;
  priceType: PriceType;
};

export type VenueImportRun = {
  __typename: 'VenueImportRun';
  errors: Maybe<Scalars['JSONObject']['output']>;
  result: Maybe<Scalars['JSONObject']['output']>;
  state: ImportRunState;
  uploadId: Scalars['Float']['output'];
};

export type VenueImportToken = {
  __typename: 'VenueImportToken';
  token: Scalars['String']['output'];
};

export type VenueImportUpload = {
  __typename: 'VenueImportUpload';
  externalVenueId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  state: ImportUploadState;
  storagePath: Scalars['String']['output'];
};

export type VenueInternals = {
  __typename: 'VenueInternals';
  previousSoftware: Maybe<PreviousSoftware>;
};

export enum VenueInternalsType {
  BALLSPORTCLUB = 'BALLSPORTCLUB',
  BALLSPORTCOMMERCIAL = 'BALLSPORTCOMMERCIAL',
  CORPORATESPORTS = 'CORPORATESPORTS',
  DEMOTEST = 'DEMOTEST',
  FUNSPORT = 'FUNSPORT',
  KEINKUNDE = 'KEINKUNDE',
  SMILEINTERFACE = 'SMILEINTERFACE',
  STUDIODANCE = 'STUDIODANCE',
  STUDIOFITNESS = 'STUDIOFITNESS',
  STUDIOONLINE = 'STUDIOONLINE',
  STUDIOYOGA = 'STUDIOYOGA'
}

/** A payment method the venue accepts on-site, e.g. cash or card terminal. Pass its id as `payment.paymentMethodId` to `createReservation`. */
export type VenuePaymentOption = {
  __typename: 'VenuePaymentOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The rental rules of a venue, grouped by the aspect of booking they answer. */
export type VenueRentalRules = {
  __typename: 'VenueRentalRules';
  /** The availability rules of this venue. Empty if none have been created yet. */
  availability: Array<AvailabilityRule>;
  /** The cancellation rules of this venue. Empty if none have been created yet. */
  cancellation: Array<CancellationRule>;
  /** The eligibility rules of this venue. Empty if none have been created yet. */
  eligibility: Array<EligibilityRule>;
  /** The price rules of this venue. Empty if none have been created yet. */
  price: Array<PriceRule>;
  /** The slot rules of this venue. Empty if none have been created yet. */
  slot: Array<SlotRule>;
};

export enum VenueType {
  BALLSPORT = 'BALLSPORT',
  STUDIO = 'STUDIO'
}

export type Wallet = {
  __typename: 'Wallet';
  actionRequired: Scalars['Boolean']['output'];
  active: Scalars['Boolean']['output'];
  dataNeeded: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  paymentsEnabled: Scalars['Boolean']['output'];
  payoutsEnabled: Scalars['Boolean']['output'];
  provider: Scalars['String']['output'];
  pspId: Scalars['String']['output'];
  state: WalletVerificationState;
  verificationMessage: Maybe<Scalars['String']['output']>;
};

export enum WalletVerificationState {
  PENDING = 'PENDING',
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED'
}

export enum Weekday {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export type YearlyUtilization = {
  __typename: 'YearlyUtilization';
  maxParticipations: Scalars['Float']['output'];
  participations: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
};

export type RecoverAccountAccessMutationVariables = Exact<{
  recoveryCode: Scalars['String']['input'];
}>;


export type RecoverAccountAccessMutation = { recoverMfa: { __typename: 'Session', requiredAction: RequiredSessionAction | undefined } | undefined };

export type VerifyOtpTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
  trustDevice: Scalars['Boolean']['input'];
}>;


export type VerifyOtpTokenMutation = { verifyMfa: { __typename: 'Session', requiredAction: RequiredSessionAction | undefined, mfa: { __typename: 'Mfa', verified: boolean } | undefined } | undefined };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestPasswordResetMutation = { requestPasswordReset: boolean };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { login: { __typename: 'Session', requiredAction: RequiredSessionAction | undefined, requiresMfa: boolean, mfa: { __typename: 'Mfa', verified: boolean } | undefined } | undefined };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { logout: boolean };

export type MaskeradeMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type MaskeradeMutation = { maskerade: { __typename: 'Session' } | undefined };

export type PasswordResetMutationVariables = Exact<{
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type PasswordResetMutation = { resetPassword: boolean };

export type ChangeOrganizationMutationVariables = Exact<{
  resourceIdentifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type ChangeOrganizationMutation = { changeOrganization: { __typename: 'Session', isLoggedIn: boolean } | undefined };

export type SetupMfaSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type SetupMfaSessionQuery = { session: { __typename: 'Session', requiredAction: RequiredSessionAction | undefined } | undefined };

export type SetupMfaMutationVariables = Exact<{ [key: string]: never; }>;


export type SetupMfaMutation = { setupMfa: { __typename: 'Session', requiredAction: RequiredSessionAction | undefined, mfaSetup: { __typename: 'Totp', secretUri: string, recoveryCodes: Array<string> } | undefined } | undefined };

export type VerifyMfaTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type VerifyMfaTokenMutation = { verifyMfa: { __typename: 'Session', requiredAction: RequiredSessionAction | undefined, mfa: { __typename: 'Mfa', verified: boolean } | undefined } | undefined };

export type VenueSwitcherQueryVariables = Exact<{ [key: string]: never; }>;


export type VenueSwitcherQuery = { session: { __typename: 'Session', requiredAction: RequiredSessionAction | undefined, accessibleResources: Array<{ __typename: 'OrganizationResource', identifier: string, name: string, description: string, image: { __typename: 'Picture', id: string, xSmall: string } | undefined }> } | undefined };

export type VenueLandingPageQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type VenueLandingPageQuery = { venueByShortId: { __typename: 'Venue', id: string, shortId: string, viewerRole: Role | undefined, venueExtensions: Array<{ __typename: 'VenueExtension', extension: { __typename: 'Extension', id: string, name: ExtensionName } }> } };

export type VenueLandingPageSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type VenueLandingPageSessionQuery = { session: { __typename: 'Session', requiredAction: RequiredSessionAction | undefined, isLoggedIn: boolean, currentOrganization: { __typename: 'Organization', id: string, resources: Array<{ __typename: 'OrganizationResource', identifier: string }> } | undefined } | undefined };

export type SetOrganizationMutationVariables = Exact<{
  resourceIdentifier: Scalars['String']['input'];
}>;


export type SetOrganizationMutation = { setOrganization: { __typename: 'Session', isLoggedIn: boolean } | undefined };

export type GetAssignedFloorPlanQueryVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type GetAssignedFloorPlanQuery = { appointmentById: { __typename: 'Appointment', id: string, name: string, currentTeacher: { __typename: 'Teacher', id: string, nickname: string, profilePicture: { __typename: 'Picture', id: string, xSmall: string } | undefined } | undefined, venue: { __typename: 'Venue', id: string, internalType: VenueInternalsType | undefined }, assignedFloorPlan: { __typename: 'AssignedFloorPlan', id: string, name: string, totalBookableSpotsCount: number, assignedSpotsCount: number, spots: Array<{ __typename: 'AssignedBookableSpot', id: string, x: number, y: number, label: string, bookableIcon: BookableSpotIconType | undefined, isAvailable: boolean, isPriority: boolean, customer: { __typename: 'Customer', id: string, firstname: string | undefined, lastname: string | undefined, profilePicture: { __typename: 'Picture', id: string, xSmall: string } | undefined } | undefined } | { __typename: 'AssignedNonBookableSpot', id: string, x: number, y: number, label: string, nonBookableIcon: NonBookableItemIconType }> } | undefined } };

export type CancelAppointmentMutationVariables = Exact<{
  appointmentId: Scalars['String']['input'];
  showCancelledInCalendar: Scalars['Boolean']['input'];
  cancellationMessage?: InputMaybe<Scalars['String']['input']>;
  isParticipantNotificationEnabled: Scalars['Boolean']['input'];
}>;


export type CancelAppointmentMutation = { cancelAppointment: { __typename: 'Appointment', id: string, participants: { __typename: 'CustomerConnection', nodes: Array<{ __typename: 'Customer', id: string, firstname: string | undefined, lastname: string | undefined, email: string | undefined, phoneNumber: string | undefined, profilePicture: { __typename: 'Picture', small: string } | undefined }> } } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, path: string | undefined, message: string }> } };

export type PrivateSessionBannerVisibilityQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type PrivateSessionBannerVisibilityQuery = { venueByShortId: { __typename: 'Venue', id: string, bookablePrivateSessions: { __typename: 'ActivityConnection', nodes: Array<{ __typename: 'Activity', id: string }> }, company: { __typename: 'Company', id: string, widgets: Array<{ __typename: 'CompanyWidgetActivities', id: string, activityTypes: Array<ActivityType> } | { __typename: 'CompanyWidgetActivitySchedule' } | { __typename: 'CompanyWidgetNewsletter' } | { __typename: 'CompanyWidgetOverview' } | { __typename: 'CompanyWidgetPrices' } | { __typename: 'CompanyWidgetVideos' } | { __typename: 'CompanyWidgetVouchers' }> } } };

export type GetPrivateSessionsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type GetPrivateSessionsQuery = { venueByShortId: { __typename: 'Venue', id: string, internalType: VenueInternalsType | undefined, activities: { __typename: 'ActivityConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'Activity', id: string, name: string, defaultDuration: number | undefined, visibility: ActivityVisibility, hasTeachersWithoutBookableAvailability: boolean, activityGroup: { __typename: 'ActivityGroup', id: string, name: string }, settings: { __typename: 'PrivateSessionOfferSettings', bookingType: ActivityBookingType } | undefined, resources: { __typename: 'ActivityResourceConnection', nodes: Array<{ __typename: 'Resource' } | { __typename: 'Teacher', id: string, nickname: string, availabilityStatus: TeacherAvailabilityStatus, profilePicture: { __typename: 'Picture', xSmall: string } | undefined }> } }> } } };

export type SaveRoomSharingRuleMutationVariables = Exact<{
  roomId: Scalars['ID']['input'];
  maxPrivateSessions: Scalars['Int']['input'];
  maxPrivateSessionsWithGroup?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SaveRoomSharingRuleMutation = { saveRoomAvailabilityRule: { __typename: 'ExpectedErrors' } | { __typename: 'RoomAvailabilityRule', maxPrivateSessions: number, maxPrivateSessionsWithGroup: number | undefined } };

export type DeleteRoomSharingRuleMutationVariables = Exact<{
  roomId: Scalars['ID']['input'];
}>;


export type DeleteRoomSharingRuleMutation = { deleteRoomAvailabilityRule: { __typename: 'ExpectedErrors' } | { __typename: 'RoomAvailabilityRule', id: string } };

export type PrivateSessionOffersUsingRoomQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  roomId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type PrivateSessionOffersUsingRoomQuery = { venueByShortId: { __typename: 'Venue', id: string, activities: { __typename: 'ActivityConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'Activity', id: string, name: string, defaultDuration: number | undefined }> } } };

export type RoomsWithRulesQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type RoomsWithRulesQuery = { venueByShortId: { __typename: 'Venue', id: string, roomsWithAvailabilityRule: { __typename: 'RoomWithAvailabilityRuleConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'Resource', id: string, name: string, availabilityRule: { __typename: 'RoomAvailabilityRule', id: string, maxPrivateSessions: number, maxPrivateSessionsWithGroup: number | undefined } | undefined }> } } };

export type PrivateSessionsEditMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type PrivateSessionsEditMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string } };

export type PrivateSessionsEditVenueDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  id: Scalars['String']['input'];
}>;


export type PrivateSessionsEditVenueDataQuery = { venueByShortId: { __typename: 'Venue', id: string, shortId: string, internalType: VenueInternalsType | undefined, roomCount: number, teacherCount: number, sports: { __typename: 'SportConnection', nodes: Array<{ __typename: 'Sport', id: string, name: string }> }, locations: { __typename: 'LocationConnection', nodes: Array<{ __typename: 'Location', id: string, name: string, street: string | undefined, city: string | undefined, zip: string | undefined, detail: string | undefined }> }, activity: { __typename: 'Activity', id: string, name: string, defaultDuration: number | undefined, internalType: string, isActive: boolean, isTemplate: boolean, description: string | undefined, visibility: ActivityVisibility, maxParticipants: number | undefined, registrationStart: number | undefined, registrationStartUnit: ActivityTimespanUnit | undefined, registrationEnd: number | undefined, registrationEndUnit: ActivityTimespanUnit | undefined, type: ActivityType, cancelPeriod: number | undefined, cancellationConditions: string | undefined, cancelPeriodUnit: ActivityTimespanUnit | undefined, participationValue: number | undefined, availabilitySchedule: { __typename: 'PrivateSessionAvailabilitySchedule', id: string, schedule: Array<{ __typename: 'PrivateSessionAvailabilityScheduleDay', dayOfWeek: number, timeSchedule: Array<{ __typename: 'PrivateSessionAvailabilityScheduleTime', validFrom: any, validUntil: any }> }> } | undefined, settings: { __typename: 'PrivateSessionOfferSettings', bookingType: ActivityBookingType, isBookingRequestSelfManagingAllowed: boolean, appointmentStartTime: ActivityAppointmentStartTime, bufferTimeInMinutes: number, paymentOption: ActivityPaymentOption | undefined, location: { __typename: 'Location', id: string } | undefined } | undefined, sport: { __typename: 'Sport', id: string, name: string }, activityGroup: { __typename: 'ActivityGroup', id: string, name: string, color: string }, products: { __typename: 'ProductConnection', nodes: Array<{ __typename: 'Product', id: string, participationRules: Array<{ __typename: 'ProductParticipationRule', id: string, activities: Array<{ __typename: 'Activity', id: string }> }> }> }, picture: { __typename: 'Picture', id: string, mimeType: string, xSmall: string, size: number | undefined, name: string } | undefined, resources: { __typename: 'ActivityResourceConnection', nodes: Array<{ __typename: 'Resource', id: string, name: string } | { __typename: 'Teacher', id: string, nickname: string }> }, roomSharingConfig: Array<{ __typename: 'ActivityRoomSharingConfig', roomId: string, isRoomSharingAllowed: boolean }> }, activityGroups: { __typename: 'ActivityGroupConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'ActivityGroup', id: string, name: string, color: string }> } } };

export type UpdatePrivateSessionOfferMutationVariables = Exact<{
  activityId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sportId: Scalars['String']['input'];
  activityGroupId: Scalars['String']['input'];
  durationInMinutes: Scalars['Int']['input'];
  maxParticipants: Scalars['Int']['input'];
  roomIds: PaginationSelectionInput;
  teacherIds: PaginationSelectionInput;
  description: Scalars['String']['input'];
  imageId: Scalars['String']['input'];
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  productIds: ProductPaginationSelectionInput;
  creditType: CreditType;
  creditsUsedPerAppointment?: InputMaybe<Scalars['Int']['input']>;
  cancellationRule: CancellationRuleInput;
  visibility: ActivityVisibility;
  bookingType: ActivityBookingType;
  registrationStart?: InputMaybe<Scalars['Int']['input']>;
  registrationStartUnit?: InputMaybe<ActivityTimespanUnit>;
  registrationEnd?: InputMaybe<Scalars['Int']['input']>;
  registrationEndUnit?: InputMaybe<ActivityTimespanUnit>;
  appointmentStartTime: ActivityAppointmentStartTime;
  bufferTimeInMinutes: Scalars['Int']['input'];
  paymentOption?: InputMaybe<ActivityPaymentOption>;
  isBookingRequestSelfManagingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  schedule?: InputMaybe<Array<PrivateSessionAvailabilityScheduleDayInput> | PrivateSessionAvailabilityScheduleDayInput>;
  roomSharingConfig?: InputMaybe<Array<RoomSharingConfigInput> | RoomSharingConfigInput>;
  productParticipationRules?: InputMaybe<Array<ProductParticipationRuleInput> | ProductParticipationRuleInput>;
}>;


export type UpdatePrivateSessionOfferMutation = { updatePrivateSessionOffer: { __typename: 'Activity', id: string, type: ActivityType, name: string, description: string | undefined, defaultDuration: number | undefined, maxParticipants: number | undefined, participationValue: number | undefined, cancelPeriod: number | undefined, cancelPeriodUnit: ActivityTimespanUnit | undefined, cancellationConditions: string | undefined, sport: { __typename: 'Sport', id: string, name: string }, activityGroup: { __typename: 'ActivityGroup', id: string, name: string, color: string }, picture: { __typename: 'Picture', id: string, mimeType: string, xSmall: string, size: number | undefined, name: string } | undefined } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, path: string | undefined, message: string }> } };

export type PrivateSessionsMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type PrivateSessionsMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string } };

export type PrivateSessionsCityQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type PrivateSessionsCityQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, city: { __typename: 'City', id: string, country: string } } } };

export type PrivateSessionsTeachersQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type PrivateSessionsTeachersQuery = { venueByShortId: { __typename: 'Venue', id: string, teachers: { __typename: 'TeacherConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'Teacher', id: string, nickname: string }> } } };

export type PrivateSessionsRoomsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  excludeRoomsWithRule?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PrivateSessionsRoomsQuery = { venueByShortId: { __typename: 'Venue', id: string, roomsV2: { __typename: 'ResourceConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'Resource', id: string, name: string, availabilityRule: { __typename: 'RoomAvailabilityRule', maxPrivateSessions: number, maxPrivateSessionsWithGroup: number | undefined } | undefined }> } } };

export type PrivateSessionsTeachersWithAvailabilityQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type PrivateSessionsTeachersWithAvailabilityQuery = { venueByShortId: { __typename: 'Venue', id: string, teachers: { __typename: 'TeacherConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'Teacher', id: string, nickname: string, availabilityStatus: TeacherAvailabilityStatus, profilePicture: { __typename: 'Picture', xSmall: string } | undefined }> } } };

export type PrivateSessionsProductGroupsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type PrivateSessionsProductGroupsQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, productGroups: { __typename: 'ProductGroupConnection', nodes: Array<{ __typename: 'ProductGroup', id: string, name: string }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } } };

export type PrivateSessionOfferTemplatesQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type PrivateSessionOfferTemplatesQuery = { venueByShortId: { __typename: 'Venue', id: string, shortId: string, internalType: VenueInternalsType | undefined, sports: { __typename: 'SportConnection', nodes: Array<{ __typename: 'Sport', id: string, name: string }> }, locations: { __typename: 'LocationConnection', nodes: Array<{ __typename: 'Location', id: string, name: string, street: string | undefined, city: string | undefined, zip: string | undefined, detail: string | undefined }> }, activityGroups: { __typename: 'ActivityGroupConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'ActivityGroup', id: string, name: string, color: string }> }, privateSessionOfferTemplates: { __typename: 'ActivityConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'Activity', id: string, name: string, defaultDuration: number | undefined, maxParticipants: number | undefined, description: string | undefined, participationValue: number | undefined, cancelPeriod: number | undefined, cancelPeriodUnit: ActivityTimespanUnit | undefined, cancellationConditions: string | undefined, visibility: ActivityVisibility, registrationStart: number | undefined, registrationStartUnit: ActivityTimespanUnit | undefined, registrationEnd: number | undefined, registrationEndUnit: ActivityTimespanUnit | undefined, availabilitySchedule: { __typename: 'PrivateSessionAvailabilitySchedule', id: string, schedule: Array<{ __typename: 'PrivateSessionAvailabilityScheduleDay', dayOfWeek: number, timeSchedule: Array<{ __typename: 'PrivateSessionAvailabilityScheduleTime', validFrom: any, validUntil: any }> }> } | undefined, settings: { __typename: 'PrivateSessionOfferSettings', bookingType: ActivityBookingType, isBookingRequestSelfManagingAllowed: boolean, appointmentStartTime: ActivityAppointmentStartTime, bufferTimeInMinutes: number, paymentOption: ActivityPaymentOption | undefined, location: { __typename: 'Location', id: string } | undefined } | undefined, sport: { __typename: 'Sport', id: string, name: string }, activityGroup: { __typename: 'ActivityGroup', id: string, name: string, color: string }, picture: { __typename: 'Picture', id: string, mimeType: string, xSmall: string, size: number | undefined, name: string } | undefined, roomSharingConfig: Array<{ __typename: 'ActivityRoomSharingConfig', roomId: string, isRoomSharingAllowed: boolean }>, products: { __typename: 'ProductConnection', nodes: Array<{ __typename: 'Product', id: string, participationRules: Array<{ __typename: 'ProductParticipationRule', id: string, activities: Array<{ __typename: 'Activity', id: string }> }> }> } }> } } };

export type PrivateSessionOfferTemplateResourcesQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  activityId: Scalars['String']['input'];
}>;


export type PrivateSessionOfferTemplateResourcesQuery = { venueByShortId: { __typename: 'Venue', id: string, roomCount: number, teacherCount: number, activity: { __typename: 'Activity', id: string, resources: { __typename: 'ActivityResourceConnection', nodes: Array<{ __typename: 'Resource', id: string } | { __typename: 'Teacher', id: string }> } } } };

export type DefaultPrivateSessionPaymentOptionQueryVariables = Exact<{
  venueId: Scalars['String']['input'];
}>;


export type DefaultPrivateSessionPaymentOptionQuery = { defaultPrivateSessionPaymentOption: ActivityPaymentOption };

export type CreatePrivateSessionOfferMutationVariables = Exact<{
  venueId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sportId: Scalars['String']['input'];
  activityGroupId: Scalars['String']['input'];
  durationInMinutes: Scalars['Int']['input'];
  maxParticipants: Scalars['Int']['input'];
  roomIds: PaginationSelectionInput;
  teacherIds: PaginationSelectionInput;
  description: Scalars['String']['input'];
  imageId: Scalars['String']['input'];
  productIds: ProductPaginationSelectionInput;
  creditType: CreditType;
  creditsUsedPerAppointment?: InputMaybe<Scalars['Int']['input']>;
  cancellationRule: CancellationRuleInput;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  visibility: ActivityVisibility;
  bookingType: ActivityBookingType;
  registrationStart?: InputMaybe<Scalars['Int']['input']>;
  registrationStartUnit?: InputMaybe<ActivityTimespanUnit>;
  registrationEnd?: InputMaybe<Scalars['Int']['input']>;
  registrationEndUnit?: InputMaybe<ActivityTimespanUnit>;
  appointmentStartTime: ActivityAppointmentStartTime;
  bufferTimeInMinutes: Scalars['Int']['input'];
  paymentOption?: InputMaybe<ActivityPaymentOption>;
  isBookingRequestSelfManagingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  schedule?: InputMaybe<Array<PrivateSessionAvailabilityScheduleDayInput> | PrivateSessionAvailabilityScheduleDayInput>;
  roomSharingConfig?: InputMaybe<Array<RoomSharingConfigInput> | RoomSharingConfigInput>;
  productParticipationRules?: InputMaybe<Array<ProductParticipationRuleInput> | ProductParticipationRuleInput>;
}>;


export type CreatePrivateSessionOfferMutation = { createPrivateSessionOffer: { __typename: 'Activity', id: string, type: ActivityType, name: string, sport: { __typename: 'Sport', id: string, name: string } } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, path: string | undefined, message: string }> } };

export type ArchiveActivityMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchiveActivityMutation = { archiveActivity: { __typename: 'Activity', id: string, name: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, path: string | undefined, message: string }> } };

export type CreateActivityGroupMutationVariables = Exact<{
  venueId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  color: Scalars['String']['input'];
}>;


export type CreateActivityGroupMutation = { createActivityGroup: { __typename: 'ActivityGroup', id: string, name: string, color: string } };

export type BookingAvailabilityQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type BookingAvailabilityQuery = { venueByShortId: { __typename: 'Venue', id: string, privateSessionSettings: { __typename: 'PrivateSessionSettings', defaultAvailabilitySchedule: { __typename: 'PrivateSessionAvailabilitySchedule', id: string, schedule: Array<{ __typename: 'PrivateSessionAvailabilityScheduleDay', dayOfWeek: number, timeSchedule: Array<{ __typename: 'PrivateSessionAvailabilityScheduleTime', validUntil: any, validFrom: any }> }> } | undefined } | undefined, venueExtensions: Array<{ __typename: 'VenueExtension', id: string, extension: { __typename: 'Extension', name: ExtensionName } }> } };

export type ProductsWithParticipationRulesQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  productTypes?: InputMaybe<Array<ProductType> | ProductType>;
  states?: InputMaybe<Array<ProductState> | ProductState>;
  productGroups?: InputMaybe<Array<ProductGroupFilterInput> | ProductGroupFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type ProductsWithParticipationRulesQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, products: { __typename: 'ProductConnection', pageInfo: { __typename: 'PageInfo', startCursor: any | undefined, endCursor: any | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename: 'Product', id: string, name: string, state: ProductState, type: ProductType, productGroup: string | undefined, participationRules: Array<{ __typename: 'ProductParticipationRule', id: string, name: string, cycleUnit: ProductParticipationRuleCycleUnit | undefined, cycleValue: number | undefined, maxPerCycle: number | undefined }> }> } } } };

export type PrivateSessionsVenueDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type PrivateSessionsVenueDataQuery = { venueByShortId: { __typename: 'Venue', id: string, activityGroups: { __typename: 'ActivityGroupConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'ActivityGroup', id: string, name: string, color: string }> } } };

export type GetPrivateSessionOffersForCreateQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  allowedTeacherIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetPrivateSessionOffersForCreateQuery = { venueByShortId: { __typename: 'Venue', id: string, internalType: VenueInternalsType | undefined, activities: { __typename: 'ActivityConnection', nodes: Array<{ __typename: 'Activity', id: string, name: string, defaultDuration: number | undefined, maxParticipants: number | undefined, settings: { __typename: 'PrivateSessionOfferSettings', location: { __typename: 'Location', id: string } | undefined } | undefined, activityGroup: { __typename: 'ActivityGroup', id: string, name: string, color: string } }> }, locations: { __typename: 'LocationConnection', nodes: Array<{ __typename: 'Location', id: string, name: string, street: string | undefined, city: string | undefined, zip: string | undefined, detail: string | undefined }> } } };

export type GetPrivateSessionsVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type GetPrivateSessionsVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, internalType: VenueInternalsType | undefined } };

export type GetPrivateSessionOfferResourcesQueryVariables = Exact<{
  activityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPrivateSessionOfferResourcesQuery = { activities: Array<{ __typename: 'Activity', id: string, resources: { __typename: 'ActivityResourceConnection', nodes: Array<{ __typename: 'Resource', id: string, name: string } | { __typename: 'Teacher', id: string, nickname: string, firstname: string | undefined, lastname: string | undefined, contactDetails: { __typename: 'ContactDetails', email: string | undefined, phoneNumber: string | undefined } | undefined, profilePicture: { __typename: 'Picture', small: string } | undefined }> } }> };

export type CreatePrivateSessionMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  privateSessionOfferId: Scalars['String']['input'];
  resourceId?: InputMaybe<Scalars['String']['input']>;
  startsAt: Scalars['DateTime']['input'];
  teacherId?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  participantCustomerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreatePrivateSessionMutation = { createPrivateSession: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string, path: string | undefined }> } | { __typename: 'PrivateSession', id: string, startsAt: string } };

export type GetPrivateSessionVenueSettingsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type GetPrivateSessionVenueSettingsQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string, internalType: VenueInternalsType | undefined, viewerRole: Role | undefined, bookingRequestsCount: number, viewerTeacher: { __typename: 'Teacher', id: string, active: boolean } | undefined, schedulerSettings: { __typename: 'SchedulerSettings', id: string, start: string, end: string, defaultView: string } | undefined, privateSessionSettings: { __typename: 'PrivateSessionSettings', id: string, isSelfManagingAllowed: boolean, hasFullViewAccess: boolean } | undefined, venueExtensions: Array<{ __typename: 'VenueExtension', extension: { __typename: 'Extension', name: ExtensionName } }> } };

export type GetPrivateSessionViewerContextQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type GetPrivateSessionViewerContextQuery = { venueByShortId: { __typename: 'Venue', id: string, viewerRole: Role | undefined, viewerTeacher: { __typename: 'Teacher', id: string } | undefined } };

export type GetPrivateSessionCalendarAppointmentsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPrivateSessionCalendarAppointmentsQuery = { venueByShortId: { __typename: 'Venue', id: string, appointments: { __typename: 'AppointmentConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: any | undefined, startCursor: any | undefined }, nodes: Array<{ __typename: 'Appointment', id: string, name: string, start: string, end: string, isCancelled: boolean, recurringSettings: { __typename: 'RecurringSettings', id: string } | undefined, room: { __typename: 'Resource', id: string, name: string } | undefined, activity: { __typename: 'Activity', id: string, type: ActivityType, internalType: string, activityGroup: { __typename: 'ActivityGroup', id: string, color: string } } | undefined, participants: { __typename: 'CustomerConnection', nodes: Array<{ __typename: 'Customer', id: string, firstname: string | undefined, lastname: string | undefined }> }, currentTeacher: { __typename: 'Teacher', id: string, nickname: string, firstname: string | undefined, lastname: string | undefined } | undefined }> } } };

export type GetPrivateSessionAppointmentDetailQueryVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type GetPrivateSessionAppointmentDetailQuery = { appointmentById: { __typename: 'Appointment', id: string, internalNote: string | undefined, recurringSettings: { __typename: 'RecurringSettings', id: string, frequency: RecurringFrequency, recurrenceType: RecurrenceType, interval: number, daysOfWeek: Array<number> | undefined, dayOfMonth: number | undefined, seriesEndDate: string | undefined, seriesEndOccurrenceCount: number | undefined, recurrenceRule: string | undefined, recurrenceExceptionDates: Array<any> } | undefined, location: { __typename: 'Location', address: string }, currentTeacher: { __typename: 'Teacher', profilePicture: { __typename: 'Picture', small: string } | undefined, contactDetails: { __typename: 'ContactDetails', email: string | undefined, phoneNumber: string | undefined } | undefined } | undefined, participants: { __typename: 'CustomerConnection', nodes: Array<{ __typename: 'Customer', id: string, firstname: string | undefined, lastname: string | undefined, email: string | undefined, phoneNumber: string | undefined, profilePicture: { __typename: 'Picture', small: string } | undefined }> } } };

export type GetPrivateSessionBookingRequestsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPrivateSessionBookingRequestsQuery = { venueByShortId: { __typename: 'Venue', id: string, bookingRequests: { __typename: 'BookingRequestConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: any | undefined, startCursor: any | undefined }, nodes: Array<{ __typename: 'BookingRequest', id: string, name: string, start: string | undefined, end: string | undefined, declineIndicator: BookingRequestDeclineIndicator, requestedAt: string | undefined, requestedBy: { __typename: 'Customer', id: string, firstname: string | undefined, lastname: string | undefined, email: string | undefined, phoneNumber: string | undefined, profilePicture: { __typename: 'Picture', small: string } | undefined } | undefined, location: { __typename: 'Location', id: string, address: string } | undefined, resource: { __typename: 'Resource', id: string, name: string } | undefined, suggestedResource: { __typename: 'Resource', id: string, name: string } | undefined, activity: { __typename: 'Activity', id: string, defaultDuration: number | undefined, roomCount: number, trainerCount: number, activityGroup: { __typename: 'ActivityGroup', id: string, color: string } }, teacher: { __typename: 'Teacher', id: string, nickname: string, firstname: string | undefined, lastname: string | undefined, contactDetails: { __typename: 'ContactDetails', email: string | undefined, phoneNumber: string | undefined } | undefined, profilePicture: { __typename: 'Picture', small: string } | undefined } | undefined, suggestedTeacher: { __typename: 'Teacher', id: string, nickname: string, firstname: string | undefined, lastname: string | undefined, contactDetails: { __typename: 'ContactDetails', email: string | undefined, phoneNumber: string | undefined } | undefined, profilePicture: { __typename: 'Picture', small: string } | undefined } | undefined }> } } };

export type CreateRecurringAppointmentMutationVariables = Exact<{
  privateSessionOfferId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  resourceId?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  startsAt: Scalars['DateTime']['input'];
  duration: Scalars['Int']['input'];
  frequency: RecurringFrequency;
  interval: Scalars['Int']['input'];
  seriesEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  occurrenceCount?: InputMaybe<Scalars['Int']['input']>;
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  participantCustomerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateRecurringAppointmentMutation = { createRecurringAppointment: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string, path: string | undefined }> } | { __typename: 'RecurringSettings', id: string, frequency: RecurringFrequency, interval: number, daysOfWeek: Array<number> | undefined, dayOfMonth: number | undefined, seriesEndDate: string | undefined, actualOccurrenceCount: number | undefined } };

export type DeclineBookingRequestMutationVariables = Exact<{
  bookingRequestId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  answeredAsAdmin: Scalars['Boolean']['input'];
}>;


export type DeclineBookingRequestMutation = { declineBookingRequest: { __typename: 'BookingRequest', id: string } };

export type GetBookingRequestByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBookingRequestByIdQuery = { bookingRequest: { __typename: 'BookingRequest', id: string, name: string, start: string | undefined, end: string | undefined, status: BookingRequestStatus | undefined, internalNote: string | undefined, teacher: { __typename: 'Teacher', id: string, nickname: string, firstname: string | undefined, lastname: string | undefined, contactDetails: { __typename: 'ContactDetails', email: string | undefined, phoneNumber: string | undefined } | undefined, profilePicture: { __typename: 'Picture', small: string } | undefined } | undefined, resource: { __typename: 'Resource', id: string, name: string } | undefined, requestedBy: { __typename: 'Customer', id: string, firstname: string | undefined, lastname: string | undefined, email: string | undefined, phoneNumber: string | undefined, profilePicture: { __typename: 'Picture', small: string } | undefined } | undefined } | undefined };

export type GetBookingRequestStatusByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBookingRequestStatusByIdQuery = { bookingRequest: { __typename: 'BookingRequest', id: string, status: BookingRequestStatus | undefined } | undefined };

export type AcceptBookingRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  teacherId?: InputMaybe<Scalars['ID']['input']>;
  roomId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  answeredAsAdmin: Scalars['Boolean']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
}>;


export type AcceptBookingRequestMutation = { acceptBookingRequest: { __typename: 'BookingRequest', id: string, status: BookingRequestStatus | undefined } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string }> } };

export type GetPrivateSessionsForDragEventQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  teacherId?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  excludeAppointmentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPrivateSessionsForDragEventQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, conflictingAppointmentsV2: { __typename: 'AppointmentConflictResult', hasConflicts: boolean } }, appointments: { __typename: 'AppointmentConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: any | undefined, startCursor: any | undefined }, nodes: Array<{ __typename: 'Appointment', id: string, name: string, start: string, end: string, participants: { __typename: 'CustomerConnection', nodes: Array<{ __typename: 'Customer', id: string, firstname: string | undefined, lastname: string | undefined, phoneNumber: string | undefined, profilePicture: { __typename: 'Picture', small: string } | undefined }> }, currentTeacher: { __typename: 'Teacher', id: string, nickname: string, firstname: string | undefined, lastname: string | undefined, profilePicture: { __typename: 'Picture', small: string } | undefined, contactDetails: { __typename: 'ContactDetails', email: string | undefined, phoneNumber: string | undefined } | undefined } | undefined }> } } };

export type GetViewerIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewerIdQuery = { me: { __typename: 'Me', id: string } };

export type GetMyAvailabilitySettingsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type GetMyAvailabilitySettingsQuery = { me: { __typename: 'Me', isEversportsAdmin: boolean }, venueByShortId: { __typename: 'Venue', id: string, internalType: VenueInternalsType | undefined, viewerRole: Role | undefined, viewerTeacher: { __typename: 'Teacher', id: string, active: boolean } | undefined } };

export type GetDefaultTeacherAvailabilityQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type GetDefaultTeacherAvailabilityQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string }, viewerTeacher: { __typename: 'Teacher', id: string, nickname: string, defaultAvailabilitySchedule: { __typename: 'PrivateSessionAvailabilitySchedule', id: string, schedule: Array<{ __typename: 'PrivateSessionAvailabilityScheduleDay', dayOfWeek: number, timeSchedule: Array<{ __typename: 'PrivateSessionAvailabilityScheduleTime', validFrom: any, validUntil: any }> }> } | undefined } | undefined } };

export type GetTargetTeacherAvailabilityQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  teacherUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  first: Scalars['Int']['input'];
}>;


export type GetTargetTeacherAvailabilityQuery = { venueByShortId: { __typename: 'Venue', id: string, internalType: VenueInternalsType | undefined, company: { __typename: 'Company', id: string }, teachers: { __typename: 'TeacherConnection', nodes: Array<{ __typename: 'Teacher', id: string, nickname: string, availabilityStatus: TeacherAvailabilityStatus, profilePicture: { __typename: 'Picture', xSmall: string } | undefined, defaultAvailabilitySchedule: { __typename: 'PrivateSessionAvailabilitySchedule', id: string, schedule: Array<{ __typename: 'PrivateSessionAvailabilityScheduleDay', dayOfWeek: number, timeSchedule: Array<{ __typename: 'PrivateSessionAvailabilityScheduleTime', validFrom: any, validUntil: any }> }> } | undefined }> } } };

export type GetTeacherAppointmentQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  teacherIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
}>;


export type GetTeacherAppointmentQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, appointmentsV2: { __typename: 'AppointmentConnection', nodes: Array<{ __typename: 'Appointment', id: string }> } } } };

export type UpdateDefaultTeacherAvailabilityMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  trainerId: Scalars['ID']['input'];
  schedule: Array<SavePrivateSessionAvailabilityScheduleDayArgs> | SavePrivateSessionAvailabilityScheduleDayArgs;
}>;


export type UpdateDefaultTeacherAvailabilityMutation = { saveDefaultTeacherAvailabilitySchedule: { __typename: 'ExpectedErrors' } | { __typename: 'PrivateSessionAvailabilitySchedule', id: string } };

export type UpdateDefaultTeacherAvailabilitiesMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  trainerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  schedule: Array<SavePrivateSessionAvailabilityScheduleDayArgs> | SavePrivateSessionAvailabilityScheduleDayArgs;
}>;


export type UpdateDefaultTeacherAvailabilitiesMutation = { saveDefaultTeacherAvailabilitySchedules: { __typename: 'ExpectedErrors' } | { __typename: 'PrivateSessionAvailabilityScheduleList', nodes: Array<{ __typename: 'PrivateSessionAvailabilitySchedule', id: string }> } };

export type DeleteDefaultTeacherAvailabilitiesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteDefaultTeacherAvailabilitiesMutation = { deleteDefaultTeacherAvailabilitySchedules: boolean };

export type GetTeacherAvailabilityExceptionsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  isManualEntry?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTeacherAvailabilityExceptionsQuery = { venueByShortId: { __typename: 'Venue', id: string, viewerTeacher: { __typename: 'Teacher', id: string, daySpecificAvailability: { __typename: 'TeacherDaySpecificAvailabilityConnection', nodes: Array<{ __typename: 'TeacherDaySpecificAvailability', id: string, type: TrainerDaySpecificAvailabilityType, viewType: TrainerDaySpecificAvailabilityViewType, dateFrom: any, dateTo: any, title: string | undefined, calendarIntegrationId: string | undefined, timeSlots: Array<{ __typename: 'TeacherDaySpecificAvailabilityTime', dayOfWeek: number | undefined, validFrom: any, validUntil: any }>, recurringSettings: { __typename: 'TeacherDaySpecificAvailabilityRecurringSettings', dayOfMonth: number | undefined, daysOfWeek: Array<number> | undefined, frequency: RecurringFrequency | undefined, recurrenceType: RecurrenceType | undefined, interval: number | undefined, maxOccurrences: number | undefined, untilDate: any | undefined, recurrenceRule: string | undefined, exceptionDates: Array<any> } | undefined }> } } | undefined } };

export type GetTargetTeacherAvailabilityExceptionsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  teacherUuid: Scalars['String']['input'];
  isManualEntry?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type GetTargetTeacherAvailabilityExceptionsQuery = { venueByShortId: { __typename: 'Venue', id: string, teachers: { __typename: 'TeacherConnection', nodes: Array<{ __typename: 'Teacher', id: string, daySpecificAvailability: { __typename: 'TeacherDaySpecificAvailabilityConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined }, nodes: Array<{ __typename: 'TeacherDaySpecificAvailability', id: string, type: TrainerDaySpecificAvailabilityType, viewType: TrainerDaySpecificAvailabilityViewType, dateFrom: any, dateTo: any, title: string | undefined, calendarIntegrationId: string | undefined, timeSlots: Array<{ __typename: 'TeacherDaySpecificAvailabilityTime', dayOfWeek: number | undefined, validFrom: any, validUntil: any }>, recurringSettings: { __typename: 'TeacherDaySpecificAvailabilityRecurringSettings', dayOfMonth: number | undefined, daysOfWeek: Array<number> | undefined, frequency: RecurringFrequency | undefined, recurrenceType: RecurrenceType | undefined, interval: number | undefined, maxOccurrences: number | undefined, untilDate: any | undefined, recurrenceRule: string | undefined, exceptionDates: Array<any> } | undefined }> } }> } } };

export type SaveTeacherDaySpecificAvailabilityMutationVariables = Exact<{
  trainerId: Scalars['ID']['input'];
  availability: Array<SaveTeacherDaySpecificAvailabilityEntryArgs> | SaveTeacherDaySpecificAvailabilityEntryArgs;
  venueShortId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveTeacherDaySpecificAvailabilityMutation = { saveTeacherDaySpecificAvailability: { __typename: 'ExpectedErrors' } | { __typename: 'TeacherDaySpecificAvailabilityList', nodes: Array<{ __typename: 'TeacherDaySpecificAvailability', id: string }> } };

export type SaveTeacherDaySpecificAvailabilitiesMutationVariables = Exact<{
  entries: Array<SaveTeacherDaySpecificAvailabilityForTrainerInput> | SaveTeacherDaySpecificAvailabilityForTrainerInput;
  venueShortId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveTeacherDaySpecificAvailabilitiesMutation = { saveTeacherDaySpecificAvailabilities: { __typename: 'ExpectedErrors' } | { __typename: 'TeacherDaySpecificAvailabilityByTrainerList', nodes: Array<{ __typename: 'TeacherDaySpecificAvailabilityByTrainer', trainerId: string, nodes: Array<{ __typename: 'TeacherDaySpecificAvailability', id: string }> }> } };

export type DeleteTeacherDaySpecificAvailabilityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  venueShortId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteTeacherDaySpecificAvailabilityMutation = { deleteTeacherDaySpecificAvailability: boolean };

export type GetTeacherCalendarIntegrationsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type GetTeacherCalendarIntegrationsQuery = { venueByShortId: { __typename: 'Venue', id: string, viewerTeacher: { __typename: 'Teacher', id: string, calendarIntegrations: Array<{ __typename: 'TeacherCalendarIntegration', id: string, name: string, type: string, lastSuccessfulSyncAt: string | undefined, lastError: string | undefined, lastWarning: string | undefined }> } | undefined } };

export type GetTargetTeacherCalendarIntegrationsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  teacherUuid: Scalars['String']['input'];
}>;


export type GetTargetTeacherCalendarIntegrationsQuery = { venueByShortId: { __typename: 'Venue', id: string, teachers: { __typename: 'TeacherConnection', nodes: Array<{ __typename: 'Teacher', id: string, calendarIntegrations: Array<{ __typename: 'TeacherCalendarIntegration', id: string, name: string, type: string, lastSuccessfulSyncAt: string | undefined, lastAttemptedSyncAt: string | undefined, lastFullSyncAt: string | undefined, lastError: string | undefined, lastWarning: string | undefined }> }> } } };

export type CreateTeacherCalendarIntegrationMutationVariables = Exact<{
  url: Scalars['URL']['input'];
}>;


export type CreateTeacherCalendarIntegrationMutation = { createTeacherCalendarIntegration: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } | { __typename: 'TeacherCalendarIntegration', id: string, name: string, type: string, lastSuccessfulSyncAt: string | undefined, lastError: string | undefined, lastWarning: string | undefined } };

export type SyncTeacherCalendarIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SyncTeacherCalendarIntegrationMutation = { syncTeacherCalendarIntegration: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } | { __typename: 'TeacherCalendarIntegration', id: string, name: string, type: string, lastSuccessfulSyncAt: string | undefined, lastError: string | undefined, lastWarning: string | undefined } };

export type DeleteTeacherCalendarIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTeacherCalendarIntegrationMutation = { deleteTeacherCalendarIntegration: boolean };

export type CreateCustomerGroupsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type CreateCustomerGroupsQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', customerGroups: Array<{ __typename: 'CustomerGroup', id: string, name: string | undefined, color: string | undefined, groupPresetType: GroupPresetType | undefined }> } } };

export type CreateCustomerTagsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type CreateCustomerTagsQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, tags: { __typename: 'TagConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'Tag', id: string, name: string, color: string }> } } } };

export type PrivateSessionTeacherFilterOptionsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type PrivateSessionTeacherFilterOptionsQuery = { venueByShortId: { __typename: 'Venue', id: string, teachers: { __typename: 'TeacherConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'Teacher', id: string, nickname: string, profilePicture: { __typename: 'Picture', xSmall: string } | undefined }> } } };

export type PrivateSessionsSheetAppointmentByIdQueryVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type PrivateSessionsSheetAppointmentByIdQuery = { appointmentById: { __typename: 'Appointment', id: string, start: string, end: string, name: string, internalNote: string | undefined, location: { __typename: 'Location', id: string }, room: { __typename: 'Resource', id: string, name: string } | undefined, currentTeacher: { __typename: 'Teacher', id: string, nickname: string, firstname: string | undefined, lastname: string | undefined, profilePicture: { __typename: 'Picture', small: string } | undefined, contactDetails: { __typename: 'ContactDetails', email: string | undefined, phoneNumber: string | undefined } | undefined } | undefined, recurringSettings: { __typename: 'RecurringSettings', dayOfMonth: number | undefined, daysOfWeek: Array<number> | undefined, frequency: RecurringFrequency, recurrenceType: RecurrenceType, id: string, interval: number, seriesEndDate: string | undefined, seriesEndOccurrenceCount: number | undefined, recurrenceRule: string | undefined, recurrenceExceptionDates: Array<any> } | undefined, activity: { __typename: 'Activity', id: string, activityGroup: { __typename: 'ActivityGroup', id: string, color: string } } | undefined, participants: { __typename: 'CustomerConnection', nodes: Array<{ __typename: 'Customer', id: string, firstname: string | undefined, lastname: string | undefined, profilePicture: { __typename: 'Picture', small: string } | undefined }> } } };

export type PrivateSessionsSheetRecurringChangeCountQueryVariables = Exact<{
  appointmentId: Scalars['String']['input'];
  recurrenceSettings?: InputMaybe<UpdateRecurringAppointmentSettingsInput>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PrivateSessionsSheetRecurringChangeCountQuery = { updatePrivateSessionCount: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } | { __typename: 'UpdatePrivateSessionCountResponse', cancelledCount: number } };

export type PrivateSessionsSheetUpdatePrivateSessionMutationVariables = Exact<{
  appointmentId: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  recurrenceSettings?: InputMaybe<UpdateRecurringAppointmentSettingsInput>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  isParticipantNotificationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  participantCustomerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PrivateSessionsSheetUpdatePrivateSessionMutation = { updatePrivateSession: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } | { __typename: 'UpdatePrivateSessionResult', privateSession: { __typename: 'PrivateSession', id: string } | undefined, recurringSettings: { __typename: 'RecurringSettings', id: string } | undefined, notNotifiableParticipants: Array<{ __typename: 'Customer', id: string, firstname: string | undefined, lastname: string | undefined, phoneNumber: string | undefined, profilePicture: { __typename: 'Picture', small: string } | undefined }> } };

export type CancelRecurringPrivateSessionMutationVariables = Exact<{
  recurringAppointmentId: Scalars['String']['input'];
  appointmentId: Scalars['String']['input'];
  showCancelledInCalendar: Scalars['Boolean']['input'];
  cancellationMessage?: InputMaybe<Scalars['String']['input']>;
  isParticipantNotificationEnabled: Scalars['Boolean']['input'];
}>;


export type CancelRecurringPrivateSessionMutation = { cancelRecurringPrivateSession: { __typename: 'CancelRecurringPrivateSessionResult', failedAppointmentIds: Array<string>, cancelledAppointments: Array<{ __typename: 'Appointment', id: string }> } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, path: string | undefined, message: string }> } };

export type HidePrivateSessionFromCalendarMutationVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type HidePrivateSessionFromCalendarMutation = { hidePrivateSessionFromCalendar: { __typename: 'Appointment', id: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, path: string | undefined, message: string }> } };

export type HideRecurringPrivateSessionFromCalendarMutationVariables = Exact<{
  recurringAppointmentId: Scalars['String']['input'];
  appointmentId: Scalars['String']['input'];
}>;


export type HideRecurringPrivateSessionFromCalendarMutation = { hideRecurringPrivateSessionFromCalendar: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, path: string | undefined, message: string }> } | { __typename: 'HideRecurringPrivateSessionFromCalendarResult', failedAppointmentIds: Array<string>, hiddenAppointments: Array<{ __typename: 'Appointment', id: string }> } };

export type SubstitutionsMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type SubstitutionsMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string } };

export type GetAppointmentsForSubstitutionsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
}>;


export type GetAppointmentsForSubstitutionsQuery = { venueByShortId: { __typename: 'Venue', company: { __typename: 'Company', id: string, appointmentsCountV2: number, appointmentsV2: { __typename: 'AppointmentConnection', nodes: Array<{ __typename: 'Appointment', end: string, start: string, id: string, name: string, venue: { __typename: 'Venue', id: string, name: string }, currentTeacher: { __typename: 'Teacher', nickname: string, profilePicture: { __typename: 'Picture', small: string } | undefined } | undefined }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, startCursor: any | undefined, endCursor: any | undefined } } } } };

export type SubstitutionRequestAppointmentsQueryVariables = Exact<{
  requestId: Scalars['String']['input'];
  venueShortId: Scalars['String']['input'];
}>;


export type SubstitutionRequestAppointmentsQuery = { substitutionRequestAppointments: Array<{ __typename: 'Appointment', id: string, name: string, start: string, end: string, venue: { __typename: 'Venue', id: string, shortId: string, name: string }, currentTeacher: { __typename: 'Teacher', nickname: string, profilePicture: { __typename: 'Picture', small: string } | undefined } | undefined }> };

export type CreateSubstitutionRequestMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  venueShortId: Scalars['String']['input'];
  selectedAppointmentIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  deselectedAppointmentIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isSelectAllChecked?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
}>;


export type CreateSubstitutionRequestMutation = { createSubstitutionRequestV2: { __typename: 'SubstitutionRequest', id: string } };

export type AcceptSubstitutionRequestMutationVariables = Exact<{
  substitutionRequestId: Scalars['String']['input'];
  appointmentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AcceptSubstitutionRequestMutation = { acceptSubstitutionRequest: { __typename: 'SubstitutionRequestResult', errorType: SubstitutionErrorType | undefined, success: boolean, failedAppointments: Array<{ __typename: 'AppointmentSubstitutionFailedResult', appointmentId: string, errorType: SubstitutionErrorType }> | undefined, successfulAppointments: Array<{ __typename: 'AppointmentSubstitutionAcceptedResult', appointmentId: string }> | undefined } };

export type DeclineSubstitutionRequestMutationVariables = Exact<{
  substitutionRequestId: Scalars['String']['input'];
}>;


export type DeclineSubstitutionRequestMutation = { declineSubstitutionRequest: { __typename: 'SubstitutionRequestResult', errorType: SubstitutionErrorType | undefined, success: boolean, failedAppointments: Array<{ __typename: 'AppointmentSubstitutionFailedResult', appointmentId: string, errorType: SubstitutionErrorType }> | undefined, successfulAppointments: Array<{ __typename: 'AppointmentSubstitutionAcceptedResult', appointmentId: string }> | undefined } };

export type GetAppointmentsForSubstitutionsSummaryQueryVariables = Exact<{
  appointmentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetAppointmentsForSubstitutionsSummaryQuery = { appointmentsPreview: Array<{ __typename: 'Appointment', id: string, name: string, start: string, end: string, venue: { __typename: 'Venue', name: string, id: string, shortId: string } }> };

export type GetAppointmentsForSubstitutionsSummaryV2QueryVariables = Exact<{
  appointmentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetAppointmentsForSubstitutionsSummaryV2Query = { appointmentsPreview: Array<{ __typename: 'Appointment', id: string, name: string, start: string, end: string, venue: { __typename: 'Venue', name: string, id: string, shortId: string }, location: { __typename: 'Location', id: string, street: string | undefined, detail: string | undefined, zip: string | undefined, city: string | undefined } }> };

export type GetSubstitutionRequestQueryVariables = Exact<{
  substitutionRequestId: Scalars['String']['input'];
  substitutionStatus?: InputMaybe<SubstitutionStatus>;
  venueShortId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSubstitutionRequestQuery = { substitutionRequestAppointments: Array<{ __typename: 'Appointment', id: string, name: string, start: string, end: string, venue: { __typename: 'Venue', name: string, id: string } }> };

export type SubstitutionRequestsMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type SubstitutionRequestsMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string }, me: { __typename: 'Me', firstname: string } };

export type VenueDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type VenueDataQuery = { venueByShortId: { __typename: 'Venue', viewerRole: Role | undefined, company: { __typename: 'Company', id: string, venues: Array<{ __typename: 'Venue', id: string, name: string, shortId: string, viewerRole: Role | undefined }> } } };

export type SubstitutionFilterTeachersQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  venueIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SubstitutionFilterTeachersQuery = { venueByShortId: { __typename: 'Venue', company: { __typename: 'Company', id: string, teachers: { __typename: 'TeacherConnection', nodes: Array<{ __typename: 'Teacher', id: string, nickname: string }> } } } };

export type SubstitutionRequestsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  range?: InputMaybe<SubstitutionFilterRange>;
  sort?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status?: InputMaybe<SubstitutionStatus>;
  venueIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  submittedForTeacherIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  includeNoTeacherAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  skipOpenCount: Scalars['Boolean']['input'];
  skipCompletedCount: Scalars['Boolean']['input'];
  skipTotalCount: Scalars['Boolean']['input'];
}>;


export type SubstitutionRequestsQuery = { venueByShortId: { __typename: 'Venue', company: { __typename: 'Company', id: string, openSubstitutionsCount?: number, completedSubstitutionsCount?: number, totalSubstitutionCount?: number, substitutionsV2: { __typename: 'SubstitutionConnection', nodes: Array<{ __typename: 'Substitution', createdAt: string, id: string, reason: string, appointment: { __typename: 'Appointment', id: string, name: string, end: string, start: string, isCancelled: boolean, activity: { __typename: 'Activity', id: string, internalType: string } | undefined, venue: { __typename: 'Venue', id: string, name: string, shortId: string } }, createdBy: { __typename: 'Teacher', id: string, nickname: string, profilePicture: { __typename: 'Picture', small: string } | undefined } | undefined, declined: Array<{ __typename: 'Teacher', id: string, nickname: string, profilePicture: { __typename: 'Picture', small: string } | undefined }> | undefined, substitute: { __typename: 'Teacher', id: string, nickname: string, profilePicture: { __typename: 'Picture', small: string } | undefined } | undefined }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined } } } } };

export type CreateSubstitutionRequestFromExistingMutationVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  selectedSubstitutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  deselectedSubstitutionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isSelectAllChecked?: InputMaybe<Scalars['Boolean']['input']>;
  venueIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  submittedForTeacherIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  includeNoTeacherAssigned?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateSubstitutionRequestFromExistingMutation = { createSubstitutionRequestFromExisting: { __typename: 'SubstitutionRequest', id: string } };

export type AnalyticsVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type AnalyticsVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string, type: VenueType | undefined, company: { __typename: 'Company', id: string, isLtd: boolean } } };

export type AnalyticsQuicksightAnalyticsDashboardsQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type AnalyticsQuicksightAnalyticsDashboardsQuery = { me: { __typename: 'Me', quicksightAnalyticsDashboards: Array<{ __typename: 'QuicksightAnalyticsDashboard', id: string, name: string, description: string, isDefault: boolean, state: QuicksightAnalyticsDashboardState }> } };

export type AnalyticsQuicksightAnalyticsDashboardQueryVariables = Exact<{
  dashboardId: Scalars['String']['input'];
}>;


export type AnalyticsQuicksightAnalyticsDashboardQuery = { quicksightAnalyticsDashboard: { __typename: 'QuicksightAnalyticsDashboard', id: string, name: string, isDefault: boolean, state: QuicksightAnalyticsDashboardState, description: string } };

export type AnalyticsGenerateQuicksightAnalyticsEmbedUrlMutationVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  dashboardId: Scalars['String']['input'];
}>;


export type AnalyticsGenerateQuicksightAnalyticsEmbedUrlMutation = { generateQuicksightAnalyticsEmbedUrl: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } | { __typename: 'GenerateQuicksightAnalyticsEmbedUrl', embedUrl: string } };

export type AverageKpIsVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
  analyzedVenueShortIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  years: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
}>;


export type AverageKpIsVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, featurePreviews: Array<{ __typename: 'FeaturePreview', name: string }>, currency: { __typename: 'Currency', code: string }, company: { __typename: 'Company', id: string, bookingCount: { __typename: 'AnalyticsResult', total: Array<{ __typename: 'TotalValue', total: number, year: number }> }, customerCount: { __typename: 'AnalyticsResult', total: Array<{ __typename: 'TotalValue', total: number, year: number }> }, revenue: { __typename: 'AnalyticsResult', total: Array<{ __typename: 'TotalValue', total: number, year: number }> } } } };

export type UtilizationKpiVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
  analyzedVenueShortIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  years: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
}>;


export type UtilizationKpiVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, utilization: { __typename: 'Utilization', total: Array<{ __typename: 'YearlyUtilization', year: number, maxParticipations: number, participations: number }> } } } };

export type VenueSelectorMeQueryVariables = Exact<{ [key: string]: never; }>;


export type VenueSelectorMeQuery = { me: { __typename: 'Me', id: string, accessibleVenues: Array<{ __typename: 'Venue', id: string, shortId: string, name: string, viewerRole: Role | undefined, company: { __typename: 'Company', id: string } }> } };

export type YearlyBookingDevelopmentChartVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
  analyzedVenueShortIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  years: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
  granularity: AnalyticsGranularity;
  bookingCountSegment?: InputMaybe<BookingCountSegment>;
}>;


export type YearlyBookingDevelopmentChartVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, bookingCount: { __typename: 'AnalyticsResult', total: Array<{ __typename: 'TotalValue', total: number, year: number }>, timespanValues: Array<{ __typename: 'TimespanValue', value: number, timespan: { __typename: 'Timespan', from: string, until: string } }> } } } };

export type YearlyBookingDevelopmentChartExportMutationVariables = Exact<{
  venueShortIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  timespans: Array<TimespanInput> | TimespanInput;
  exportType: ExportType;
  loggedInVenueShortId: Scalars['String']['input'];
}>;


export type YearlyBookingDevelopmentChartExportMutation = { export: boolean };

export type YearlyCustomerDevelopmentChartVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
  analyzedVenueShortIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  years: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
  granularity: AnalyticsGranularity;
}>;


export type YearlyCustomerDevelopmentChartVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, customerCount: { __typename: 'AnalyticsResult', total: Array<{ __typename: 'TotalValue', total: number, year: number }>, timespanValues: Array<{ __typename: 'TimespanValue', value: number, timespan: { __typename: 'Timespan', from: string, until: string } }> } } } };

export type YearlyCustomerDevelopmentChartExportMutationVariables = Exact<{
  venueShortIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  timespans: Array<TimespanInput> | TimespanInput;
  exportType: ExportType;
  loggedInVenueShortId: Scalars['String']['input'];
}>;


export type YearlyCustomerDevelopmentChartExportMutation = { export: boolean };

export type YearlyMembershipDevelopmentChartVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
  analyzedVenueShortIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  years: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
  assignedMembershipSegment: AssignedMembershipSegment;
  granularity: AnalyticsGranularity;
}>;


export type YearlyMembershipDevelopmentChartVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, type: VenueType | undefined, company: { __typename: 'Company', id: string, membershipCount: { __typename: 'AnalyticsResult', total: Array<{ __typename: 'TotalValue', total: number, year: number }>, timespanValues: Array<{ __typename: 'TimespanValue', value: number, timespan: { __typename: 'Timespan', from: string, until: string } }> } } } };

export type YearlyMembershipDevelopmentChartExportMutationVariables = Exact<{
  venueShortIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  timespans: Array<TimespanInput> | TimespanInput;
  exportType: ExportType;
  loggedInVenueShortId: Scalars['String']['input'];
}>;


export type YearlyMembershipDevelopmentChartExportMutation = { export: boolean };

export type YearlyRevenueChartVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
  analyzedVenueShortIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  years: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
  granularity: AnalyticsGranularity;
  revenueSegment: RevenueSegment;
}>;


export type YearlyRevenueChartVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string, currency: { __typename: 'Currency', code: string }, company: { __typename: 'Company', id: string, revenue: { __typename: 'AnalyticsResult', total: Array<{ __typename: 'TotalValue', total: number, year: number }>, timespanValues: Array<{ __typename: 'TimespanValue', value: number, timespan: { __typename: 'Timespan', from: string, until: string } }> } } } };

export type YearlyRevenueChartExportMutationVariables = Exact<{
  venueShortIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  timespans: Array<TimespanInput> | TimespanInput;
  exportType: ExportType;
  loggedInVenueShortId: Scalars['String']['input'];
}>;


export type YearlyRevenueChartExportMutation = { export: boolean };

export type ActivityReportExportMeQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivityReportExportMeQuery = { me: { __typename: 'Me', id: string, email: string, accessibleVenues: Array<{ __typename: 'Venue', id: string, shortId: string, viewerRole: Role | undefined, company: { __typename: 'Company', id: string } }> } };

export type ActivityReportExportVenueQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type ActivityReportExportVenueQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string } } };

export type ActivityReportExportMutationVariables = Exact<{
  venueShortIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  timespans: Array<TimespanInput> | TimespanInput;
  exportType: ExportType;
  loggedInVenueShortId: Scalars['String']['input'];
}>;


export type ActivityReportExportMutation = { export: boolean };

export type CustomerReportExportMeQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerReportExportMeQuery = { me: { __typename: 'Me', id: string, email: string, accessibleVenues: Array<{ __typename: 'Venue', id: string, shortId: string, viewerRole: Role | undefined, company: { __typename: 'Company', id: string } }> } };

export type CustomerReportExportVenueQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type CustomerReportExportVenueQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string } } };

export type CustomerReportExportMutationVariables = Exact<{
  venueShortIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  timespans: Array<TimespanInput> | TimespanInput;
  exportType: ExportType;
  loggedInVenueShortId: Scalars['String']['input'];
}>;


export type CustomerReportExportMutation = { export: boolean };

export type FinancialReportExportMeQueryVariables = Exact<{ [key: string]: never; }>;


export type FinancialReportExportMeQuery = { me: { __typename: 'Me', id: string, email: string, accessibleVenues: Array<{ __typename: 'Venue', id: string, shortId: string, viewerRole: Role | undefined, company: { __typename: 'Company', id: string } }> } };

export type FinancialReportExportVenueQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type FinancialReportExportVenueQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string } } };

export type FinancialReportExportMutationVariables = Exact<{
  venueShortIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  timespans: Array<TimespanInput> | TimespanInput;
  exportType: ExportType;
  loggedInVenueShortId: Scalars['String']['input'];
}>;


export type FinancialReportExportMutation = { export: boolean };

export type ReportsVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type ReportsVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string, viewerRole: Role | undefined, activeEventSettings: Array<string>, venueExtensions: Array<{ __typename: 'VenueExtension', id: string, extension: { __typename: 'Extension', id: string, name: ExtensionName } }> } };

export type BillingCommunicationMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type BillingCommunicationMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string } };

export type BillingCommunicationVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type BillingCommunicationVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, venueExtensions: Array<{ __typename: 'VenueExtension', activationDate: string | undefined, issuingVenue: { __typename: 'Venue', id: string, shortId: string } | undefined, priceCap: { __typename: 'MonetaryValue', value: number } | undefined, extension: { __typename: 'Extension', id: string, name: ExtensionName } }>, currency: { __typename: 'Currency', code: string }, company: { __typename: 'Company', id: string, uniqueContactableCustomersCount: number, viewerIsCompanyAdmin: boolean, city: { __typename: 'City', country: string } } } };

export type ContractInformationMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type ContractInformationMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string } };

export type ContractInformationVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type ContractInformationVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string, contractInformation: { __typename: 'ContractInformation', contractStartDate: string, contractEndDate: string, paymentFrequency: BillingSubscriptionInterval, specialTerminationDate: string | undefined, regularCancellationDeadline: string, autoRenewalPeriodMonths: number, nextContractEndDate: string, specialCancellationPeriodMonths: number | undefined, noticePeriodDays: number, customMinValidUntil: string | undefined } | undefined, company: { __typename: 'Company', id: string, contractFileUrl: string | undefined, viewerIsCompanyAdmin: boolean, city: { __typename: 'City', country: string } } } };

export type PayoutVenueMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type PayoutVenueMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string } };

export type PayoutVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type PayoutVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string, company: { __typename: 'Company', id: string, city: { __typename: 'City', country: string } }, currency: { __typename: 'Currency', code: string }, stripeConnectedAccount: { __typename: 'StripeConnectedAccount', canAcceptPayments: boolean, canReceivePayouts: boolean, isVerified: boolean, bankAccount: { __typename: 'StripeExternalAccount', id: string, last4: string | undefined, bankName: string | undefined, accountHolder: string | undefined } | undefined, balance: { __typename: 'StripeBalance', available: Array<{ __typename: 'MonetaryValue', value: number, currency: string }>, pending: Array<{ __typename: 'MonetaryValue', value: number, currency: string }> }, inTransit: Array<{ __typename: 'MonetaryValue', value: number, currency: string }>, persons: Array<{ __typename: 'StripePerson', id: string, firstName: string | undefined, lastName: string | undefined, roles: Array<StripePersonRole>, title: string | undefined, isVerified: boolean }>, payoutSettings: { __typename: 'StripePayoutSettings', frequency: StripePayoutFrequency, executionDay: number } | undefined } | undefined } };

export type FetchStripePayoutsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type FetchStripePayoutsQuery = { venueByShortId: { __typename: 'Venue', id: string, stripePayouts: { __typename: 'StripePayoutConnection', nodes: Array<{ __typename: 'StripePayout', id: string, initiatedAt: string, status: StripePayoutStatus, type: StripePayoutType, amount: { __typename: 'MonetaryValue', value: number, currency: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined } } | undefined } };

export type FetchStripePayoutConfirmationQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  payoutId: Scalars['String']['input'];
}>;


export type FetchStripePayoutConfirmationQuery = { venueByShortId: { __typename: 'Venue', id: string, stripePayoutConfirmation: { __typename: 'StripePayoutConfirmation', fileName: string, pdfBase64: string } | undefined } };

export type SetStripePayoutSettingsMutationVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  frequency: StripePayoutFrequency;
  executionDay: Scalars['Int']['input'];
}>;


export type SetStripePayoutSettingsMutation = { setStripePayoutSettings: { __typename: 'StripePayoutSettings', frequency: StripePayoutFrequency, executionDay: number } };

export type FetchInvoicesQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  hasEInvoiceSubmission?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FetchInvoicesQuery = { venueByShortId: { __typename: 'Venue', currency: { __typename: 'Currency', code: string }, invoices: { __typename: 'InvoiceConnection', nodes: Array<{ __typename: 'Invoice', id: string, numberFormatted: string | undefined, issuedAt: string | undefined, type: InvoiceType, amount: number, recipient: { __typename: 'InvoiceRecipient', name: string } | undefined, eInvoiceSubmissions: Array<{ __typename: 'EInvoiceSubmission', status: EInvoiceSubmissionStatus }> }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, startCursor: any | undefined, endCursor: any | undefined } } } };

export type TechnicalEventLogQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type TechnicalEventLogQuery = { venueByShortId: { __typename: 'Venue', technicalEventLogs: { __typename: 'TechnicalEventLogConnection', nodes: Array<{ __typename: 'TechnicalEventLog', id: string, number: number, code: number, description: string | undefined, createdAt: string, information: string | undefined, signature: string | undefined, invokedByUser: { __typename: 'User', firstname: string | undefined, lastname: string | undefined } | undefined }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: any | undefined, startCursor: any | undefined } } } };

export type VerifyTechnicalEventLogSignatureIntegrityMutationVariables = Exact<{
  eventLogId: Scalars['String']['input'];
  venueShortId: Scalars['String']['input'];
}>;


export type VerifyTechnicalEventLogSignatureIntegrityMutation = { verifyTechnicalEventLogSignatureIntegrity: boolean };

export type ExportTechnicalEventLogMutationVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
}>;


export type ExportTechnicalEventLogMutation = { exportTechnicalEventLog: boolean };

export type CourtCalendarSportsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type CourtCalendarSportsQuery = { venueByShortId: { __typename: 'Venue', id: string, sports: { __typename: 'SportConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'Sport', id: string, name: string }> } } };

export type CourtCalendarCourtsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type CourtCalendarCourtsQuery = { venueByShortId: { __typename: 'Venue', id: string, timeZone: string, courts: { __typename: 'CourtConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'Court', id: string, name: string, sport: { __typename: 'Sport', id: string, name: string }, rentalRules: { __typename: 'CourtRentalRules', availability: { __typename: 'AvailabilityRule', id: string, schedule: Array<{ __typename: 'AvailabilityRuleScheduleEntry', dayOfWeek: number, openingHours: { __typename: 'AvailabilityRuleTimeRange', from: any, until: any } }> } | undefined, price: { __typename: 'PriceRule', id: string, price: { __typename: 'Price', value: number, currency: { __typename: 'Currency', code: string } }, tagPrices: Array<{ __typename: 'PriceRuleTagPrice', tags: { __typename: 'PriceRuleTagCondition', match: PriceRuleTagMatch, items: Array<{ __typename: 'PriceRuleTag', id: string, name: string }> }, price: { __typename: 'Price', value: number, currency: { __typename: 'Currency', code: string } } }>, timeBoundRules: Array<{ __typename: 'PriceRuleTimeBoundRule', window: { __typename: 'PriceRuleWindow', daysOfWeek: Array<number> | undefined, dates: { __typename: 'PriceRuleDateRange', from: any, until: any } | undefined, time: { __typename: 'PriceRuleTimeRange', from: string, until: string } | undefined }, price: { __typename: 'Price', value: number, currency: { __typename: 'Currency', code: string } }, tagPrices: Array<{ __typename: 'PriceRuleTagPrice', tags: { __typename: 'PriceRuleTagCondition', match: PriceRuleTagMatch, items: Array<{ __typename: 'PriceRuleTag', id: string, name: string }> }, price: { __typename: 'Price', value: number, currency: { __typename: 'Currency', code: string } } }> }> } | undefined, slot: { __typename: 'SlotRule', id: string, minDurationInMinutes: number, maxDurationInMinutes: number, minExtensionInMinutes: number, startsOnInMinutes: number, areGapsForbidden: boolean } | undefined, eligibility: { __typename: 'EligibilityRule', id: string } | undefined, cancellation: { __typename: 'CancellationRule', id: string } | undefined } }> } } };

export type CreateReservationMutationVariables = Exact<{
  courtId: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
  customerId?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  payment?: InputMaybe<ReservationPaymentInput>;
}>;


export type CreateReservationMutation = { createReservation: { __typename: 'Appointment', id: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string, path: string | undefined }> } | { __typename: 'RentalViolations', violations: Array<{ __typename: 'RentalViolation', aspect: RentalRuleType, code: RentalViolationCode }> } };

export type ReservationCustomerTagsQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type ReservationCustomerTagsQuery = { customer: { __typename: 'Customer', id: string, tags: { __typename: 'CustomerTagConnection', nodes: Array<{ __typename: 'CustomerTag', id: string, name: string }> } } };

export type CourtCalendarReservationsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  start?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  types?: InputMaybe<Array<ActivityType> | ActivityType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type CourtCalendarReservationsQuery = { venueByShortId: { __typename: 'Venue', id: string, timeZone: string, appointments: { __typename: 'AppointmentConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'Appointment', id: string, start: string, end: string, createdAt: string, isCancelled: boolean, activity: { __typename: 'Activity', id: string, name: string } | undefined, room: { __typename: 'Resource', id: string, name: string, description: string | undefined } | undefined, location: { __typename: 'Location', id: string, address: string }, participations: { __typename: 'AppointmentParticipationConnection', nodes: Array<{ __typename: 'AppointmentParticipation', id: string, price: { __typename: 'Price', value: number, currency: { __typename: 'Currency', code: string } } | undefined }> }, participants: { __typename: 'CustomerConnection', nodes: Array<{ __typename: 'Customer', id: string, firstname: string | undefined, lastname: string | undefined, profilePicture: { __typename: 'Picture', small: string } | undefined }> } }> } } };

export type CourtCalendarVenuePaymentOptionsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type CourtCalendarVenuePaymentOptionsQuery = { venueByShortId: { __typename: 'Venue', id: string, paymentOptions: Array<{ __typename: 'VenuePaymentOption', id: string, name: string }> } };

export type GetCourtQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  courtId: Scalars['String']['input'];
}>;


export type GetCourtQuery = { venueByShortId: { __typename: 'Venue', id: string, court: { __typename: 'Court', id: string, name: string, description: string | undefined, environment: Environment, surface: { __typename: 'Surface', id: string, name: string } | undefined, sport: { __typename: 'Sport', id: string, name: string }, size: { __typename: 'Size', id: string, name: string } | undefined, rentalRules: { __typename: 'CourtRentalRules', availability: { __typename: 'AvailabilityRule', id: string } | undefined, slot: { __typename: 'SlotRule', id: string } | undefined, price: { __typename: 'PriceRule', id: string } | undefined, eligibility: { __typename: 'EligibilityRule', id: string } | undefined, cancellation: { __typename: 'CancellationRule', id: string } | undefined } } | undefined } };

export type CourtsVenueCurrencyQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type CourtsVenueCurrencyQuery = { venueByShortId: { __typename: 'Venue', id: string, currency: { __typename: 'Currency', id: string, symbol: string } } };

export type CourtsVenueIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type CourtsVenueIdQuery = { venueByShortId: { __typename: 'Venue', id: string } };

export type CourtsVenueOpeningHoursQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type CourtsVenueOpeningHoursQuery = { venueByShortId: { __typename: 'Venue', id: string, openingHours: Array<{ __typename: 'OpeningHoursPeriod', weekdays: Array<Weekday>, start: any, end: any }> } };

export type SaveCourtsMutationVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  courts: Array<SaveCourtInput> | SaveCourtInput;
  availabilityRuleId?: InputMaybe<Scalars['ID']['input']>;
  slotRuleId?: InputMaybe<Scalars['ID']['input']>;
  priceRuleId?: InputMaybe<Scalars['ID']['input']>;
  eligibilityRuleId?: InputMaybe<Scalars['ID']['input']>;
  cancellationRuleId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SaveCourtsMutation = { saveCourts: { __typename: 'Courts', courts: Array<{ __typename: 'Court', id: string, name: string }> } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string, path: string | undefined }> } };

export type MakeCourtUnavailableMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MakeCourtUnavailableMutation = { makeCourtUnavailable: boolean };

export type GetCourtsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type GetCourtsQuery = { venueByShortId: { __typename: 'Venue', id: string, courts: { __typename: 'CourtConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'Court', id: string, name: string, environment: Environment, surface: { __typename: 'Surface', id: string, name: string } | undefined, sport: { __typename: 'Sport', id: string, name: string }, size: { __typename: 'Size', id: string, name: string } | undefined, rentalRules: { __typename: 'CourtRentalRules', availability: { __typename: 'AvailabilityRule', id: string } | undefined, price: { __typename: 'PriceRule', id: string } | undefined, slot: { __typename: 'SlotRule', id: string } | undefined, eligibility: { __typename: 'EligibilityRule', id: string } | undefined, cancellation: { __typename: 'CancellationRule', id: string } | undefined } }> } } };

export type GetVenueRentalRulesForNewCourtQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type GetVenueRentalRulesForNewCourtQuery = { venueByShortId: { __typename: 'Venue', id: string, rentalRules: { __typename: 'VenueRentalRules', availability: Array<{ __typename: 'AvailabilityRule', id: string, name: string, schedule: Array<{ __typename: 'AvailabilityRuleScheduleEntry', dayOfWeek: number, openingHours: { __typename: 'AvailabilityRuleTimeRange', from: any, until: any } }> }>, slot: Array<{ __typename: 'SlotRule', id: string, name: string, minDurationInMinutes: number, maxDurationInMinutes: number, minExtensionInMinutes: number, startsOnInMinutes: number }>, price: Array<{ __typename: 'PriceRule', id: string, name: string, price: { __typename: 'Price', value: number, currency: { __typename: 'Currency', code: string } }, tagPrices: Array<{ __typename: 'PriceRuleTagPrice', price: { __typename: 'Price', value: number } }>, timeBoundRules: Array<{ __typename: 'PriceRuleTimeBoundRule', label: string | undefined, tagPrices: Array<{ __typename: 'PriceRuleTagPrice', price: { __typename: 'Price', value: number } }> }> }>, eligibility: Array<{ __typename: 'EligibilityRule', id: string, name: string, audience: EligibilityRuleAudience, registration: { __typename: 'EligibilityRuleRegistrationWindow', start: { __typename: 'EligibilityRuleRegistrationOffset', value: number, unit: EligibilityRuleRegistrationUnit }, end: { __typename: 'EligibilityRuleRegistrationOffset', value: number, unit: EligibilityRuleRegistrationUnit } } }>, cancellation: Array<{ __typename: 'CancellationRule', id: string, name: string, hoursBeforeStart: number }> } } };

export type GetVenueSportsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type GetVenueSportsQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, sports: { __typename: 'SportConnection', nodes: Array<{ __typename: 'Sport', id: string, name: string, courtSizes: Array<{ __typename: 'Size', id: string, name: string }>, courtSurfaces: Array<{ __typename: 'Surface', id: string, name: string }> }> } } } };

export type ArchiveRentalRuleMutationVariables = Exact<{
  venueId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  aspect: RentalRuleType;
}>;


export type ArchiveRentalRuleMutation = { archiveRentalRule: { __typename: 'ArchivedRentalRule', id: string, name: string, aspect: RentalRuleType } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string, path: string | undefined }> } };

export type GetVenueRentalRulesQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type GetVenueRentalRulesQuery = { venueByShortId: { __typename: 'Venue', id: string, timeZone: string, rentalRules: { __typename: 'VenueRentalRules', availability: Array<{ __typename: 'AvailabilityRule', id: string, name: string, updatedAt: string, assignedCourts: Array<{ __typename: 'Court', id: string }>, schedule: Array<{ __typename: 'AvailabilityRuleScheduleEntry', dayOfWeek: number, openingHours: { __typename: 'AvailabilityRuleTimeRange', from: any, until: any } }> }>, slot: Array<{ __typename: 'SlotRule', id: string, name: string, updatedAt: string, minDurationInMinutes: number, maxDurationInMinutes: number, minExtensionInMinutes: number, startsOnInMinutes: number, areGapsForbidden: boolean, assignedCourts: Array<{ __typename: 'Court', id: string }> }>, price: Array<{ __typename: 'PriceRule', id: string, name: string, updatedAt: string, assignedCourts: Array<{ __typename: 'Court', id: string }>, price: { __typename: 'Price', value: number, currency: { __typename: 'Currency', symbol: string } }, tagPrices: Array<{ __typename: 'PriceRuleTagPrice', price: { __typename: 'Price', value: number }, tags: { __typename: 'PriceRuleTagCondition', match: PriceRuleTagMatch, items: Array<{ __typename: 'PriceRuleTag', id: string }> } }>, timeBoundRules: Array<{ __typename: 'PriceRuleTimeBoundRule', label: string | undefined, price: { __typename: 'Price', value: number }, tagPrices: Array<{ __typename: 'PriceRuleTagPrice', price: { __typename: 'Price', value: number }, tags: { __typename: 'PriceRuleTagCondition', match: PriceRuleTagMatch, items: Array<{ __typename: 'PriceRuleTag', id: string }> } }>, window: { __typename: 'PriceRuleWindow', daysOfWeek: Array<number> | undefined, dates: { __typename: 'PriceRuleDateRange', from: any, until: any } | undefined, time: { __typename: 'PriceRuleTimeRange', from: string, until: string } | undefined } }> }>, eligibility: Array<{ __typename: 'EligibilityRule', id: string, name: string, updatedAt: string, audience: EligibilityRuleAudience, assignedCourts: Array<{ __typename: 'Court', id: string }>, registration: { __typename: 'EligibilityRuleRegistrationWindow', start: { __typename: 'EligibilityRuleRegistrationOffset', value: number, unit: EligibilityRuleRegistrationUnit }, end: { __typename: 'EligibilityRuleRegistrationOffset', value: number, unit: EligibilityRuleRegistrationUnit } }, conditions: Array<{ __typename: 'EligibilityRuleCondition', match: EligibilityRuleTagMatch, tags: Array<{ __typename: 'EligibilityRuleTag', id: string, name: string }> }> }>, cancellation: Array<{ __typename: 'CancellationRule', id: string, name: string, updatedAt: string, hoursBeforeStart: number, assignedCourts: Array<{ __typename: 'Court', id: string }> }> } } };

export type SaveAvailabilityRuleMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  venueId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  schedule: Array<AvailabilityRuleScheduleEntryInput> | AvailabilityRuleScheduleEntryInput;
}>;


export type SaveAvailabilityRuleMutation = { saveAvailabilityRule: { __typename: 'AvailabilityRule', id: string, name: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string, path: string | undefined }> } };

export type SaveEligibilityRuleMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  venueId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  audience: EligibilityRuleAudience;
  registration?: InputMaybe<EligibilityRuleRegistrationInput>;
}>;


export type SaveEligibilityRuleMutation = { saveEligibilityRule: { __typename: 'EligibilityRule', id: string, name: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string, path: string | undefined }> } };

export type SavePriceRuleMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  venueId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  value: Scalars['Int']['input'];
  tagPrices?: InputMaybe<Array<PriceRuleTagPriceInput> | PriceRuleTagPriceInput>;
  timeBoundRules?: InputMaybe<Array<PriceRuleTimeBoundRuleInput> | PriceRuleTimeBoundRuleInput>;
}>;


export type SavePriceRuleMutation = { savePriceRule: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string, path: string | undefined }> } | { __typename: 'PriceRule', id: string, name: string } };

export type SaveCancellationRuleMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  venueId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  hoursBeforeStart: Scalars['Int']['input'];
}>;


export type SaveCancellationRuleMutation = { saveCancellationRule: { __typename: 'CancellationRule', id: string, name: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string, path: string | undefined }> } };

export type SaveSlotRuleMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  venueId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  minDurationInMinutes: Scalars['Int']['input'];
  maxDurationInMinutes: Scalars['Int']['input'];
  minExtensionInMinutes: Scalars['Int']['input'];
  startsOnInMinutes: Scalars['Int']['input'];
  areGapsForbidden: Scalars['Boolean']['input'];
}>;


export type SaveSlotRuleMutation = { saveSlotRule: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string, path: string | undefined }> } | { __typename: 'SlotRule', id: string, name: string } };

export type AddPhoneCallMutationVariables = Exact<{
  createdAt: Scalars['DateTime']['input'];
  html: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  unreachable: Scalars['Boolean']['input'];
}>;


export type AddPhoneCallMutation = { addPhoneCall: { __typename: 'PhoneCall', id: string } };

export type AddNoteMutationVariables = Exact<{
  createdAt: Scalars['DateTime']['input'];
  html: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
}>;


export type AddNoteMutation = { addNote: { __typename: 'Note', id: string } };

export type CommunicationHistoryQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
  communicationsPageSize?: Scalars['Int']['input'];
  communicationsAfterCursor?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type CommunicationHistoryQuery = { customer: { __typename: 'Customer', id: string, firstname: string | undefined, communications: { __typename: 'CommunicationConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined }, edges: Array<{ __typename: 'CommunicationEdge', node: { __typename: 'Email', id: string, createdAt: string, subject: string, deliveryStatus: DeliveryStatus | undefined, lastDeliveryError: string | undefined, html: string | undefined, deliveryEvents: Array<{ __typename: 'EmailDeliveryEvent', timestamp: string, type: string }>, executedBy: { __typename: 'User', firstname: string | undefined, lastname: string | undefined } | undefined } | { __typename: 'Note', id: string, createdAt: string, updatedAt: string, html: string | undefined, createdBy: { __typename: 'User', firstname: string | undefined, lastname: string | undefined } } | { __typename: 'PhoneCall', id: string, createdAt: string, updatedAt: string, html: string | undefined, unreachable: boolean, createdBy: { __typename: 'User', firstname: string | undefined, lastname: string | undefined } } }> } } };

export type CustomerProfileHeaderQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type CustomerProfileHeaderQuery = { customer: { __typename: 'Customer', id: string, firstname: string | undefined, lastname: string | undefined, email: string | undefined, phoneNumber: string | undefined, lastParticipatedAt: string | undefined, totalParticipationCount: number | undefined, profilePicture: { __typename: 'Picture', small: string } | undefined } };

export type RemovePhoneCallMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemovePhoneCallMutation = { removePhoneCall: boolean };

export type RemoveNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveNoteMutation = { removeNote: boolean };

export type CreateTagMutationVariables = Exact<{
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateTagMutation = { createTag: { __typename: 'Tag', id: string, name: string } };

export type GetTagsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTagsQuery = { venueByShortId: { __typename: 'Venue', company: { __typename: 'Company', id: string, tags: { __typename: 'TagConnection', nodes: Array<{ __typename: 'Tag', id: string, name: string }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } } };

export type DeleteTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  companyId: Scalars['String']['input'];
}>;


export type DeleteTagMutation = { deleteTag: { __typename: 'DeleteTagResult', result: boolean } };

export type UpdateTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
}>;


export type UpdateTagMutation = { updateTag: { __typename: 'Tag', id: string, name: string, color: string, description: string | undefined, customerCount: number } };

export type FetchTagsQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchTagsQuery = { venueByShortId: { __typename: 'Venue', company: { __typename: 'Company', id: string, tagsCount: number, tags: { __typename: 'TagConnection', nodes: Array<{ __typename: 'Tag', id: string, name: string, description: string | undefined, color: string, customerCount: number }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, startCursor: any | undefined, endCursor: any | undefined } } } } };

export type TagsMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type TagsMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string } };

export type UseCommunicationExtensionHelperQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type UseCommunicationExtensionHelperQuery = { venueByShortId: { __typename: 'Venue', id: string, currency: { __typename: 'Currency', code: string }, venueExtensions: Array<{ __typename: 'VenueExtension', activationDate: string | undefined, priceCap: { __typename: 'MonetaryValue', value: number, currency: string } | undefined, issuingVenue: { __typename: 'Venue', id: string, shortId: string } | undefined, extension: { __typename: 'Extension', id: string, name: ExtensionName } }> } };

export type AutomationIdMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  automationId: Scalars['ID']['input'];
}>;


export type AutomationIdMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string }, autoCommunication: { __typename: 'AutoCommunication', id: string, name: string | undefined } };

export type AutomationIdPageQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  automationId: Scalars['ID']['input'];
}>;


export type AutomationIdPageQuery = { venueByShortId: { __typename: 'Venue', id: string, type: VenueType | undefined, bookingSetting: { __typename: 'BookingSetting', notificationReplyTo: string | undefined } }, autoCommunication: { __typename: 'AutoCommunication', id: string, name: string | undefined, state: AutoCommunicationState, description: string | undefined, trigger: string | undefined, audience: string | undefined, content: string | undefined, scheduleAt: string | undefined, recipientsCount: number } };

export type AutomationsListMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type AutomationsListMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string } };

export type AutomationsListPageQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type AutomationsListPageQuery = { venueByShortId: { __typename: 'Venue', id: string, timeZone: string, company: { __typename: 'Company', autoCommunicationsCount: { __typename: 'AutoCommunicationCounts', active: number, archived: number, draft: number, inactive: number }, autoCommunications: { __typename: 'AutoCommunicationConnection', pageInfo: { __typename: 'PageInfo', startCursor: any | undefined, endCursor: any | undefined, hasPreviousPage: boolean, hasNextPage: boolean }, nodes: Array<{ __typename: 'AutoCommunication', id: string, name: string | undefined, description: string | undefined, state: AutoCommunicationState }> } } } };

export type AppliedFiltersDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type AppliedFiltersDataQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', aggregators: Array<{ __typename: 'Aggregator', id: string, name: string }>, customerGroups: Array<{ __typename: 'CustomerGroup', id: string, name: string | undefined }>, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string } }> } } } };

export type AppliedFiltersProductsQueryVariables = Exact<{
  productIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AppliedFiltersProductsQuery = { products: Array<{ __typename: 'Product', id: string, name: string }> };

export type AppliedFiltersActivitiesQueryVariables = Exact<{
  activityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AppliedFiltersActivitiesQuery = { activities: Array<{ __typename: 'Activity', id: string, name: string }> };

export type AutomationActivityVisitTriggerActivitiesQueryVariables = Exact<{
  activityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AutomationActivityVisitTriggerActivitiesQuery = { activities: Array<{ __typename: 'Activity', id: string, name: string }> };

export type AutomationPurchaseTriggerProductsQueryVariables = Exact<{
  productIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AutomationPurchaseTriggerProductsQuery = { products: Array<{ __typename: 'Product', id: string, name: string }> };

export type CurrentAudienceCountQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['String']['input']>;
}>;


export type CurrentAudienceCountQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', customersV3Count: number } } };

export type AutomationContentActivityQueryVariables = Exact<{
  activityId: Scalars['String']['input'];
}>;


export type AutomationContentActivityQuery = { activities: Array<{ __typename: 'Activity', id: string, name: string, description: string | undefined }> };

export type SoftDeleteAutomationOptionMutationVariables = Exact<{
  automationId: Scalars['ID']['input'];
}>;


export type SoftDeleteAutomationOptionMutation = { softDeleteAutoCommunication: boolean };

export type DuplicateAutomationOptionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DuplicateAutomationOptionMutation = { duplicateAutoCommunication: { __typename: 'AutoCommunication', id: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } };

export type SaveAutomationMutationVariables = Exact<{
  audience?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  trigger?: InputMaybe<Scalars['String']['input']>;
  scheduleAt?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
}>;


export type SaveAutomationMutation = { saveAutoCommunication: { __typename: 'AutoCommunication', id: string, state: AutoCommunicationState, name: string | undefined, description: string | undefined, trigger: string | undefined, scheduleAt: string | undefined, audience: string | undefined, content: string | undefined } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string, path: string | undefined }> } };

export type ActivateAutomationMutationVariables = Exact<{
  automationId: Scalars['ID']['input'];
}>;


export type ActivateAutomationMutation = { activateAutoCommunication: { __typename: 'AutoCommunication', id: string, state: AutoCommunicationState } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string, path: string | undefined }> } };

export type DeactivateAutomationMutationVariables = Exact<{
  automationId: Scalars['ID']['input'];
}>;


export type DeactivateAutomationMutation = { deactivateAutoCommunication: { __typename: 'AutoCommunication', id: string, state: AutoCommunicationState } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string, path: string | undefined }> } };

export type DuplicateAutomationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DuplicateAutomationMutation = { duplicateAutoCommunication: { __typename: 'AutoCommunication', id: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string, path: string | undefined }> } };

export type SoftDeleteAutomationMutationVariables = Exact<{
  automationId: Scalars['ID']['input'];
}>;


export type SoftDeleteAutomationMutation = { softDeleteAutoCommunication: boolean };

export type AutomationNewMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type AutomationNewMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string } };

export type AutomationNewPageQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type AutomationNewPageQuery = { venueByShortId: { __typename: 'Venue', id: string, type: VenueType | undefined, bookingSetting: { __typename: 'BookingSetting', notificationReplyTo: string | undefined } } };

export type CommunicationEmailBodyQueryVariables = Exact<{
  emailCampaignId: Scalars['ID']['input'];
}>;


export type CommunicationEmailBodyQuery = { emailCampaign: { __typename: 'EmailCampaign', id: string, body: string | undefined, editorType: EditorType } };

export type CommunicationSubjectQueryVariables = Exact<{
  emailCampaignId: Scalars['ID']['input'];
}>;


export type CommunicationSubjectQuery = { emailCampaign: { __typename: 'EmailCampaign', id: string, subject: string | undefined } };

export type CommunicationOverviewMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  emailCampaignId: Scalars['ID']['input'];
}>;


export type CommunicationOverviewMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string }, emailCampaign: { __typename: 'EmailCampaign', id: string, subject: string | undefined } };

export type CommunicationProductsQueryVariables = Exact<{
  productIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CommunicationProductsQuery = { products: Array<{ __typename: 'Product', id: string, name: string }> };

export type CommunicationActivitiesQueryVariables = Exact<{
  activityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CommunicationActivitiesQuery = { activities: Array<{ __typename: 'Activity', id: string, name: string }> };

export type CommunicationBaseDataQueryVariables = Exact<{
  emailCampaignId: Scalars['ID']['input'];
  venueShortId: Scalars['String']['input'];
}>;


export type CommunicationBaseDataQuery = { venueByShortId: { __typename: 'Venue', timeZone: string, company: { __typename: 'Company', id: string, aggregators: Array<{ __typename: 'Aggregator', id: string, name: string }>, customerGroups: Array<{ __typename: 'CustomerGroup', id: string, name: string | undefined }>, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string } }> } } }, emailCampaign: { __typename: 'EmailCampaign', recipientCount: number, sentAt: string | undefined, state: EmailCampaignState | undefined, filters: string | undefined, replyTo: { __typename: 'SenderDetails', address: string | undefined }, from: { __typename: 'SenderDetails', address: string | undefined }, sendingGroup: { __typename: 'SendingGroup', totalEmails: number, sentCount: number, deliveredCount: number, bouncedCount: number, openedCount: number, clickedCount: number, unsubscribedCount: number } | undefined } };

export type CommunicationIdMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  emailCampaignId: Scalars['ID']['input'];
}>;


export type CommunicationIdMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string }, emailCampaign: { __typename: 'EmailCampaign', id: string, subject: string | undefined } };

export type CommunicationIdCustomersCountQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunicationIdCustomersCountQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', customersV3Count: number } } };

export type CommunicationIdProductsQueryVariables = Exact<{
  productIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CommunicationIdProductsQuery = { products: Array<{ __typename: 'Product', id: string, name: string }> };

export type CommunicationIdActivitiesQueryVariables = Exact<{
  activityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CommunicationIdActivitiesQuery = { activities: Array<{ __typename: 'Activity', id: string, name: string }> };

export type CommunicationIdPageQueryVariables = Exact<{
  emailCampaignId: Scalars['ID']['input'];
  venueShortId: Scalars['String']['input'];
}>;


export type CommunicationIdPageQuery = { venueByShortId: { __typename: 'Venue', id: string, venueExtensions: Array<{ __typename: 'VenueExtension', extension: { __typename: 'Extension', id: string, name: ExtensionName } }>, company: { __typename: 'Company', aggregators: Array<{ __typename: 'Aggregator', id: string, name: string }>, customerGroups: Array<{ __typename: 'CustomerGroup', id: string, name: string | undefined }>, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string } }> } } }, emailCampaign: { __typename: 'EmailCampaign', id: string, subject: string | undefined, body: string | undefined, editorType: EditorType, editorContent: string | undefined, renderedContent: string | undefined, recipientCount: number, filters: string | undefined, replyTo: { __typename: 'SenderDetails', address: string | undefined } } };

export type RecipientsEditPageMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type RecipientsEditPageMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string } };

export type RecipientsEditPageQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  emailCampaignId: Scalars['ID']['input'];
}>;


export type RecipientsEditPageQuery = { venueByShortId: { __typename: 'Venue', id: string, type: VenueType | undefined }, emailCampaign: { __typename: 'EmailCampaign', id: string, recipientCount: number, filters: string | undefined } };

export type RecipientsEditCustomersQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type RecipientsEditCustomersQuery = { venueByShortId: { __typename: 'Venue', company: { __typename: 'Company', id: string, customersV3: { __typename: 'CustomersV3Response', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined }, nodes: Array<{ __typename: 'CustomerV3', id: string, communicationSettings: { __typename: 'CustomerCommunicationSettings', commercialEnabled: boolean, notificationsEnabled: boolean, hasValidEmail: boolean, hasTempEmail: boolean } }> } } } };

export type CommunicationsMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type CommunicationsMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string } };

export type CommunicationsTotalCountQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type CommunicationsTotalCountQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', emailCampaignsCount: number } } };

export type CommunicationsVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type CommunicationsVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, timeZone: string, company: { __typename: 'Company', emailCampaigns: { __typename: 'EmailCampaignConnection', pageInfo: { __typename: 'PageInfo', startCursor: any | undefined, endCursor: any | undefined, hasPreviousPage: boolean, hasNextPage: boolean }, nodes: Array<{ __typename: 'EmailCampaign', id: string, subject: string | undefined, sentAt: string | undefined, state: EmailCampaignState | undefined, sendingGroup: { __typename: 'SendingGroup', id: string, totalEmails: number, sentCount: number, deliveredCount: number, openedCount: number, clickedCount: number } | undefined }> } } } };

export type ResendCommunicationMutationVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  communicationId: Scalars['String']['input'];
}>;


export type ResendCommunicationMutation = { resendCommunication: boolean };

export type CommunicationCustomersCountEmailCampaignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CommunicationCustomersCountEmailCampaignQuery = { emailCampaign: { __typename: 'EmailCampaign', recipientCount: number, filters: string | undefined } };

export type CommunicationIdCustomersCountVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunicationIdCustomersCountVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', customersV3Count: number } } };

export type CommunicationRecipientCountEmailCampaignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CommunicationRecipientCountEmailCampaignQuery = { emailCampaign: { __typename: 'EmailCampaign', recipientCount: number } };

export type DeleteEmailOptionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEmailOptionMutation = { deleteEmailCampaign: boolean };

export type DuplicateEmailOptionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
}>;


export type DuplicateEmailOptionMutation = { duplicateEmailCampaignAsDraft: { __typename: 'EmailCampaign', id: string } };

export type SendTestEmailButtonMeQueryVariables = Exact<{ [key: string]: never; }>;


export type SendTestEmailButtonMeQuery = { me: { __typename: 'Me', id: string, email: string } };

export type NewVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, bookingSetting: { __typename: 'BookingSetting', notificationReplyTo: string | undefined }, venueExtensions: Array<{ __typename: 'VenueExtension', extension: { __typename: 'Extension', id: string, name: ExtensionName } }>, company: { __typename: 'Company', customersV3Count: number, aggregators: Array<{ __typename: 'Aggregator', id: string, name: string }>, customerGroups: Array<{ __typename: 'CustomerGroup', id: string, name: string | undefined }>, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string } }> } } } };

export type NewVenueByShortIdProductsQueryVariables = Exact<{
  productIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type NewVenueByShortIdProductsQuery = { products: Array<{ __typename: 'Product', id: string, name: string }> };

export type NewVenueByShortIdActivitiesQueryVariables = Exact<{
  activityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type NewVenueByShortIdActivitiesQuery = { activities: Array<{ __typename: 'Activity', id: string, name: string }> };

export type RecipientsNewPageMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type RecipientsNewPageMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string } };

export type RecipientsNewPageQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type RecipientsNewPageQuery = { venueByShortId: { __typename: 'Venue', id: string, type: VenueType | undefined } };

export type AiTemplateGeneratorGenerateTemplateMutationVariables = Exact<{
  prompt: Scalars['String']['input'];
  venueShortId: Scalars['String']['input'];
  additionalContext?: InputMaybe<Scalars['String']['input']>;
}>;


export type AiTemplateGeneratorGenerateTemplateMutation = { generateUnlayerTemplate: { __typename: 'UnlayerTemplateOutput', template: any | undefined, context: string | undefined, isBlocked: boolean } };

export type AiTextGeneratorGenerateEmailMutationVariables = Exact<{
  prompt: Scalars['String']['input'];
  venueShortId: Scalars['String']['input'];
  additionalContext?: InputMaybe<Scalars['String']['input']>;
}>;


export type AiTextGeneratorGenerateEmailMutation = { generateVenueCommunication: { __typename: 'RichTextOutput', text: string, html: string, context: string | undefined, isBlocked: boolean } };

export type DesignEditorMeQueryVariables = Exact<{ [key: string]: never; }>;


export type DesignEditorMeQuery = { me: { __typename: 'Me', isEversportsAdmin: boolean } };

export type EditRecipientsVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditRecipientsVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', customersV3: { __typename: 'CustomersV3Response', pageInfo: { __typename: 'PageInfo', startCursor: any | undefined, endCursor: any | undefined, hasNextPage: boolean }, nodes: Array<{ __typename: 'CustomerV3', id: string, firstname: string | undefined, lastname: string | undefined, email: string | undefined, lastParticipatedAt: string | undefined, communicationSettings: { __typename: 'CustomerCommunicationSettings', commercialEnabled: boolean, notificationsEnabled: boolean, hasValidEmail: boolean, hasTempEmail: boolean, contactable: boolean | undefined } }> } } } };

export type EditRecipientsContactableCountQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditRecipientsContactableCountQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', customersV3Count: number } } };

export type EditRecipientsTotalCountQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditRecipientsTotalCountQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', customersV3Count: number } } };

export type ActivityFilterRuleActivityQueryVariables = Exact<{
  activityId: Scalars['String']['input'];
}>;


export type ActivityFilterRuleActivityQuery = { activities: Array<{ __typename: 'Activity', id: string, name: string }> };

export type UseActivityPaginatedQueryVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<ActivityType> | ActivityType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UseActivityPaginatedQueryVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, activities: { __typename: 'ActivityConnection', pageInfo: { __typename: 'PageInfo', startCursor: any | undefined, endCursor: any | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename: 'Activity', id: string, name: string, isActive: boolean, type: ActivityType, activityGroup: { __typename: 'ActivityGroup', id: string, venue: { __typename: 'Venue', id: string, name: string } } }> } } } };

export type AggregatorFilterRuleVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type AggregatorFilterRuleVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', aggregators: Array<{ __typename: 'Aggregator', id: string, name: string }> } } };

export type CustomerGroupFilterRuleVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type CustomerGroupFilterRuleVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', customerGroups: Array<{ __typename: 'CustomerGroup', id: string, name: string | undefined }> } } };

export type PurchasedProductFilterRuleProductQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type PurchasedProductFilterRuleProductQuery = { products: Array<{ __typename: 'Product', id: string, name: string }> };

export type IsTaggedFilterRuleVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  tagIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type IsTaggedFilterRuleVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, color: string } }> } } } };

export type GetExamplePromptsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetExamplePromptsQuery = { getCustomerFiltersFromTextExamplePrompts: Array<string> };

export type GenerateFiltersFromTextMutationVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  input: Scalars['String']['input'];
}>;


export type GenerateFiltersFromTextMutation = { generateCustomerFiltersFromText: { __typename: 'TextToCustomerFiltersResponse', aiWarnings: Array<string>, reason: TextToFiltersReason | undefined, suggestion: string | undefined, filters: Array<{ __typename: 'FilterWithConfidence', filter: any, confidence: number }>, validation: { __typename: 'ValidationResult', errors: Array<{ __typename: 'ValidationError', filterId: string, filterType: string, ruleType: string, message: string, severity: ValidationSeverity }>, warnings: Array<{ __typename: 'ValidationError', filterId: string, filterType: string, ruleType: string, message: string, severity: ValidationSeverity }> }, unmatchedTerms: Array<{ __typename: 'UnmatchedTerm', term: string, similarEntities: Array<string> }>, assumptions: Array<{ __typename: 'TextToFiltersAssumption', field: string, value: string, note: string }>, adjustments: Array<{ __typename: 'TextToFiltersAdjustment', kind: TextToFiltersAdjustmentKind, filterType: string, ruleType: string, entityNames: Array<string> | undefined, productType: string | undefined, count: number | undefined }> } };

export type UseProductPaginatedQueryVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  productTypes?: InputMaybe<Array<ProductType> | ProductType>;
  states?: InputMaybe<Array<ProductState> | ProductState>;
  productGroups?: InputMaybe<Array<ProductGroupFilterInput> | ProductGroupFilterInput>;
  productIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UseProductPaginatedQueryVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, products: { __typename: 'ProductConnection', pageInfo: { __typename: 'PageInfo', startCursor: any | undefined, endCursor: any | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename: 'Product', id: string, name: string, state: ProductState, type: ProductType, productGroup: string | undefined, participationRules: Array<{ __typename: 'ProductParticipationRule', id: string, name: string, cycleUnit: ProductParticipationRuleCycleUnit | undefined, cycleValue: number | undefined }> }> } } } };

export type UseProductCountQueryQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  productTypes?: InputMaybe<Array<ProductType> | ProductType>;
  states?: InputMaybe<Array<ProductState> | ProductState>;
  productGroups?: InputMaybe<Array<ProductGroupFilterInput> | ProductGroupFilterInput>;
  productIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UseProductCountQueryQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, productsCount: number } } };

export type SurveyLinkMeQueryVariables = Exact<{ [key: string]: never; }>;


export type SurveyLinkMeQuery = { me: { __typename: 'Me', id: string, locale: string | undefined } };

export type AssignTagsMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  tagIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  selectedCustomerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  deselectedCustomerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isSelectAllChecked?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
}>;


export type AssignTagsMutation = { assignTagsV2: { __typename: 'AssignTagResult', result: boolean } };

export type ContactsVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactsVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', customersV3: { __typename: 'CustomersV3Response', pageInfo: { __typename: 'PageInfo', startCursor: any | undefined, endCursor: any | undefined, hasNextPage: boolean }, nodes: Array<{ __typename: 'CustomerV3', id: string, firstname: string | undefined, lastname: string | undefined, email: string | undefined, lastParticipatedAt: string | undefined, communicationSettings: { __typename: 'CustomerCommunicationSettings', commercialEnabled: boolean, notificationsEnabled: boolean, hasValidEmail: boolean, hasTempEmail: boolean, contactable: boolean | undefined } }> } } } };

export type ContactsTotalCountQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactsTotalCountQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', customersV3Count: number } } };

export type ContactsContactableCountQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactsContactableCountQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', customersV3Count: number } } };

export type ContactsPageQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type ContactsPageQuery = { venueByShortId: { __typename: 'Venue', id: string, type: VenueType | undefined, venueExtensions: Array<{ __typename: 'VenueExtension', id: string, extension: { __typename: 'Extension', id: string, name: ExtensionName } }> } };

export type ContactsMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type ContactsMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string } };

export type FriendReferralMetaDataQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type FriendReferralMetaDataQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string, currency: { __typename: 'Currency', symbol: string } } };

export type FriendReferralConfigQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type FriendReferralConfigQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, referralConfig: { __typename: 'CompanyReferralConfig', isActive: boolean, newCustomerRewardType: NewCustomerRewardType, newCustomerDiscountType: DiscountType | undefined, newCustomerDiscountValue: number | undefined, referrerRewardType: ReferrerRewardType, referrerDiscountType: DiscountType | undefined, referrerDiscountValue: number | undefined, referrerMessage: string | undefined } | undefined } } };

export type SaveCompanyReferralConfigMutationVariables = Exact<{
  isActive: Scalars['Boolean']['input'];
  newCustomerRewardType: NewCustomerRewardType;
  newCustomerDiscountType?: InputMaybe<DiscountType>;
  newCustomerDiscountValue?: InputMaybe<Scalars['Float']['input']>;
  referrerRewardType: ReferrerRewardType;
  referrerDiscountType?: InputMaybe<DiscountType>;
  referrerDiscountValue?: InputMaybe<Scalars['Float']['input']>;
  referrerMessage?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveCompanyReferralConfigMutation = { saveCompanyReferralConfig: { __typename: 'CompanyReferralConfig', isActive: boolean } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } };

export type UseEmailActionsSendEmailCampaignToMeMutationVariables = Exact<{
  venueId: Scalars['ID']['input'];
  message: Message;
  editorType: EditorType;
}>;


export type UseEmailActionsSendEmailCampaignToMeMutation = { sendEmailCampaignToMe: boolean };

export type UseEmailActionsSendDraftEmailToCustomersMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type UseEmailActionsSendDraftEmailToCustomersMutation = { sendEmailCampaign: boolean };

export type UseEmailActionsCreateEmailCampaignMutationVariables = Exact<{
  venueId: Scalars['ID']['input'];
  message: DraftMessage;
  editorContent?: InputMaybe<Scalars['String']['input']>;
  editorType: EditorType;
  filters?: InputMaybe<Scalars['String']['input']>;
}>;


export type UseEmailActionsCreateEmailCampaignMutation = { saveEmailCampaign: { __typename: 'EmailCampaign', id: string } | { __typename: 'ExpectedErrors' } };

export type UseEmailActionsUpdateEmailCampaignMutationVariables = Exact<{
  venueId: Scalars['ID']['input'];
  campaignId: Scalars['ID']['input'];
  message: DraftMessage;
  editorContent?: InputMaybe<Scalars['String']['input']>;
  editorType: EditorType;
  filters?: InputMaybe<Scalars['String']['input']>;
}>;


export type UseEmailActionsUpdateEmailCampaignMutation = { saveEmailCampaign: { __typename: 'EmailCampaign', id: string, subject: string | undefined, body: string | undefined, editorType: EditorType, editorContent: string | undefined, renderedContent: string | undefined, recipientCount: number, filters: string | undefined, replyTo: { __typename: 'SenderDetails', address: string | undefined } } | { __typename: 'ExpectedErrors' } };

export type MarketingTabsVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type MarketingTabsVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, type: VenueType | undefined } };

export type CompanyIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type CompanyIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string } } };

export type AggregatorsInfoQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AggregatorsInfoQuery = { company: { __typename: 'Company', aggregators: Array<{ __typename: 'Aggregator', id: string, name: string, venues: Array<{ __typename: 'Venue', id: string, name: string, locations: { __typename: 'LocationConnection', nodes: Array<{ __typename: 'Location', id: string, name: string, address: string, hasAppointments: boolean }> } }> }> } };

export type BrandedAppVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type BrandedAppVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, widgets: Array<{ __typename: 'CompanyWidgetActivities', id: string, name: string } | { __typename: 'CompanyWidgetActivitySchedule', id: string, name: string } | { __typename: 'CompanyWidgetNewsletter', id: string, name: string } | { __typename: 'CompanyWidgetOverview', id: string, name: string } | { __typename: 'CompanyWidgetPrices', id: string, name: string } | { __typename: 'CompanyWidgetVideos', id: string, name: string } | { __typename: 'CompanyWidgetVouchers', id: string, name: string }>, venues: Array<{ __typename: 'Venue', id: string, name: string }>, brandedApp: { __typename: 'CompanyBrandedApp', id: string, backgroundColor: string, cardBackgroundColor: string, cardTextColor: string, fontFamily: string | undefined, primaryColor: string, secondaryColor: string | undefined, textColor: string, invoicingVenue: { __typename: 'Venue', id: string }, widgets: Array<{ __typename: 'CompanyWidgetActivities', id: string, name: string } | { __typename: 'CompanyWidgetActivitySchedule', id: string, name: string } | { __typename: 'CompanyWidgetNewsletter', id: string, name: string } | { __typename: 'CompanyWidgetOverview', id: string, name: string } | { __typename: 'CompanyWidgetPrices', id: string, name: string } | { __typename: 'CompanyWidgetVideos', id: string, name: string } | { __typename: 'CompanyWidgetVouchers', id: string, name: string }> } | undefined } } };

export type SaveCreateCompanyBrandedAppMutationVariables = Exact<{
  backgroundColor: Scalars['String']['input'];
  cardBackgroundColor: Scalars['String']['input'];
  cardTextColor: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  companyWidgetIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  invoicingVenueId: Scalars['ID']['input'];
  primaryColor: Scalars['String']['input'];
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  textColor: Scalars['String']['input'];
}>;


export type SaveCreateCompanyBrandedAppMutation = { createCompanyBrandedApp: { __typename: 'CompanyBrandedApp', id: string, backgroundColor: string, cardBackgroundColor: string, cardTextColor: string, fontFamily: string | undefined, primaryColor: string, secondaryColor: string | undefined, textColor: string, invoicingVenue: { __typename: 'Venue', id: string }, widgets: Array<{ __typename: 'CompanyWidgetActivities', id: string, name: string } | { __typename: 'CompanyWidgetActivitySchedule', id: string, name: string } | { __typename: 'CompanyWidgetNewsletter', id: string, name: string } | { __typename: 'CompanyWidgetOverview', id: string, name: string } | { __typename: 'CompanyWidgetPrices', id: string, name: string } | { __typename: 'CompanyWidgetVideos', id: string, name: string } | { __typename: 'CompanyWidgetVouchers', id: string, name: string }> } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } };

export type SaveUpdateCompanyBrandedAppMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  backgroundColor: Scalars['String']['input'];
  cardBackgroundColor: Scalars['String']['input'];
  cardTextColor: Scalars['String']['input'];
  companyWidgetIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  invoicingVenueId: Scalars['ID']['input'];
  primaryColor: Scalars['String']['input'];
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  textColor: Scalars['String']['input'];
}>;


export type SaveUpdateCompanyBrandedAppMutation = { updateCompanyBrandedApp: { __typename: 'CompanyBrandedApp', id: string, backgroundColor: string, cardBackgroundColor: string, cardTextColor: string, fontFamily: string | undefined, primaryColor: string, secondaryColor: string | undefined, textColor: string, invoicingVenue: { __typename: 'Venue', id: string }, widgets: Array<{ __typename: 'CompanyWidgetActivities', id: string, name: string } | { __typename: 'CompanyWidgetActivitySchedule', id: string, name: string } | { __typename: 'CompanyWidgetNewsletter', id: string, name: string } | { __typename: 'CompanyWidgetOverview', id: string, name: string } | { __typename: 'CompanyWidgetPrices', id: string, name: string } | { __typename: 'CompanyWidgetVideos', id: string, name: string } | { __typename: 'CompanyWidgetVouchers', id: string, name: string }> } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } };

export type ExtensionVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type ExtensionVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, viewerRole: Role | undefined, venueExtensions: Array<{ __typename: 'VenueExtension', id: string, extension: { __typename: 'Extension', id: string, label: string, name: ExtensionName, priceType: string } }> } };

export type FloorPlanSpotsColorsQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type FloorPlanSpotsColorsQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, widgetBrandSettings: { __typename: 'CompanyWidgetBrandSettings', id: string, floorPlanBackgroundColor: string | undefined, spotBookableBackgroundColor: string | undefined, spotBookableTextColor: string | undefined, spotNonBookableBackgroundColor: string | undefined, spotNonBookableTextColor: string | undefined } | undefined } } };

export type UpsertFloorPlanColorsMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  floorPlanBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  spotBookableBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  spotBookableTextColor?: InputMaybe<Scalars['String']['input']>;
  spotNonBookableBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  spotNonBookableTextColor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertFloorPlanColorsMutation = { upsertCompanyWidgetBrandSettings: { __typename: 'CompanyWidgetBrandSettings', id: string, floorPlanBackgroundColor: string | undefined, spotBookableBackgroundColor: string | undefined, spotBookableTextColor: string | undefined, spotNonBookableBackgroundColor: string | undefined, spotNonBookableTextColor: string | undefined } };

export type GoogleAdsConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GoogleAdsConfigurationQuery = { googleAdsConfiguration: { __typename: 'GoogleAdsConfiguration', isAccountConnected: boolean, googleAdsAccountId: string | undefined, conversionActionId: string | undefined, expiresAt: string | undefined } };

export type SaveGoogleAdsConfigurationMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
  googleAdsAccountId: Scalars['String']['input'];
  conversionActionId: Scalars['String']['input'];
}>;


export type SaveGoogleAdsConfigurationMutation = { saveGoogleAdsConfiguration: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, path: string | undefined, message: string }> } | { __typename: 'GoogleAdsConfiguration', isAccountConnected: boolean, googleAdsAccountId: string | undefined, conversionActionId: string | undefined, expiresAt: string | undefined } };

export type CreateCompanyRepresentativeMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  location: CreateLocationArgs;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  type: CompanyRepresentativeType;
}>;


export type CreateCompanyRepresentativeMutation = { createCompanyRepresentative: { __typename: 'CompanyRepresentative', id: string, legalName: string, type: CompanyRepresentativeType, taxNumber: string | undefined, location: { __typename: 'Location', id: string, name: string, address: string, street: string | undefined, detail: string | undefined, zip: string | undefined, city: string | undefined, countryISO: string | undefined, municipality: string | undefined } } };

export type GetCompanyRepresentativesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetCompanyRepresentativesQuery = { company: { __typename: 'Company', id: string, name: string, address: { __typename: 'Address', street: string | undefined, detail: string | undefined, zip: string | undefined, city: string | undefined, countryISO: string | undefined, municipality: string | undefined }, representatives: { __typename: 'CompanyRepresentativeConnection', nodes: Array<{ __typename: 'CompanyRepresentative', id: string, legalName: string, type: CompanyRepresentativeType, taxNumber: string | undefined, location: { __typename: 'Location', id: string, name: string, street: string | undefined, detail: string | undefined, zip: string | undefined, city: string | undefined, countryISO: string | undefined, municipality: string | undefined } }> } } };

export type UpdateCompanyRepresentativeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  legalName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<UpdateLocationArgs>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CompanyRepresentativeType>;
}>;


export type UpdateCompanyRepresentativeMutation = { updateCompanyRepresentative: { __typename: 'CompanyRepresentative', id: string, legalName: string, type: CompanyRepresentativeType, taxNumber: string | undefined, location: { __typename: 'Location', id: string, name: string, address: string, street: string | undefined, detail: string | undefined, zip: string | undefined, city: string | undefined, countryISO: string | undefined, municipality: string | undefined } } };

export type GenerateTaxAgreementMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GenerateTaxAgreementMutation = { generateTaxAgreement: { __typename: 'GenerateTaxAgreementResult', pdfBase64: string, success: boolean } };

export type UploadSignedTaxAgreementMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  signedPdfBase64: Scalars['String']['input'];
}>;


export type UploadSignedTaxAgreementMutation = { uploadSignedTaxAgreement: { __typename: 'UploadSignedTaxAgreementResult', success: boolean, message: string | undefined } };

export type GetCompanyTaxInformationQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetCompanyTaxInformationQuery = { company: { __typename: 'Company', id: string, name: string, taxInformation: { __typename: 'GenericTaxInformation' } | { __typename: 'SpanishTaxInformation', tin: string | undefined, taxTerritory: SpainTaxTerritory, taxRegion: SpainTaxRegion | undefined, fiscalizationSoftwareInformation: { __typename: 'FiscalizationSoftwareInformation', name: string, license: string, version: string, responsibilityDeclaration: string | undefined, softwareCompany: { __typename: 'SoftwareCompany', tin: string, legalName: string, registered: boolean } } } } };

export type UpdateCompanyMunicipalityMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  municipality: Scalars['String']['input'];
}>;


export type UpdateCompanyMunicipalityMutation = { updateCompanyMunicipality: boolean };

export type GetBookkeepingAccountsQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type GetBookkeepingAccountsQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, bookkeepingAccounts: Array<{ __typename: 'BookkeepingAccount', id: string, name: string }> } } };

export type CreatePenaltyRuleMutationVariables = Exact<{
  name: Scalars['String']['input'];
  type: PenaltyRuleType;
  status: PenaltyRuleStatus;
  isApplicableToAllProducts: Scalars['Boolean']['input'];
  productIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  emailSubject: Scalars['String']['input'];
  emailBody: Scalars['String']['input'];
  fee?: InputMaybe<Scalars['Float']['input']>;
  feeBookkeepingAccountId?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CreatePenaltyRuleMutation = { createPenaltyRule: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string, path: string | undefined }> } | { __typename: 'PenaltyRule', id: string, name: string, type: PenaltyRuleType, status: PenaltyRuleStatus, isApplicableToAllProducts: boolean, productIds: Array<string>, emailSubject: string, emailBody: string, fee: number | undefined, feeBookkeepingAccountId: number | undefined, penaltiesCount: number } };

export type UpdatePenaltyRuleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type: PenaltyRuleType;
  status: PenaltyRuleStatus;
  isApplicableToAllProducts: Scalars['Boolean']['input'];
  productIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  emailSubject: Scalars['String']['input'];
  emailBody: Scalars['String']['input'];
  fee?: InputMaybe<Scalars['Float']['input']>;
  feeBookkeepingAccountId?: InputMaybe<Scalars['Float']['input']>;
}>;


export type UpdatePenaltyRuleMutation = { updatePenaltyRule: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string, path: string | undefined }> } | { __typename: 'PenaltyRule', id: string, name: string, type: PenaltyRuleType, status: PenaltyRuleStatus, isApplicableToAllProducts: boolean, productIds: Array<string>, emailSubject: string, emailBody: string, fee: number | undefined, feeBookkeepingAccountId: number | undefined, penaltiesCount: number } };

export type GetVenueCurrencyQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type GetVenueCurrencyQuery = { venueByShortId: { __typename: 'Venue', id: string, currency: { __typename: 'Currency', code: string } } };

export type FetchPenaltyRulesQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type FetchPenaltyRulesQuery = { venueByShortId: { __typename: 'Venue', company: { __typename: 'Company', id: string, penaltyRulesCount: number, penaltyRules: { __typename: 'PenaltyRuleConnection', nodes: Array<{ __typename: 'PenaltyRule', id: string, name: string, type: PenaltyRuleType, status: PenaltyRuleStatus, isApplicableToAllProducts: boolean, productIds: Array<string> }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined } } } } };

export type FetchPenaltyRuleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FetchPenaltyRuleQuery = { penaltyRule: { __typename: 'PenaltyRule', id: string, name: string, type: PenaltyRuleType, status: PenaltyRuleStatus, isApplicableToAllProducts: boolean, productIds: Array<string>, emailSubject: string, emailBody: string, fee: number | undefined, feeBookkeepingAccountId: number | undefined, penaltiesCount: number } };

export type DeactivatePenaltyRuleMutationVariables = Exact<{
  penaltyRuleUuid: Scalars['String']['input'];
}>;


export type DeactivatePenaltyRuleMutation = { deactivatePenaltyRule: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string, path: string | undefined }> } | { __typename: 'PenaltyRule', status: PenaltyRuleStatus } };

export type ActivatePenaltyRuleMutationVariables = Exact<{
  penaltyRuleUuid: Scalars['String']['input'];
}>;


export type ActivatePenaltyRuleMutation = { activatePenaltyRule: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string, path: string | undefined }> } | { __typename: 'PenaltyRule', status: PenaltyRuleStatus } };

export type PrivateSessionSettingsQueryQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type PrivateSessionSettingsQueryQuery = { venueByShortId: { __typename: 'Venue', id: string, bookingSetting: { __typename: 'BookingSetting', notificationReplyTo: string | undefined, notificationReceiver: string | undefined }, privateSessionSettings: { __typename: 'PrivateSessionSettings', id: string, isSelfManagingAllowed: boolean, notificationEmail: string | undefined, defaultAvailabilitySchedule: { __typename: 'PrivateSessionAvailabilitySchedule', id: string, schedule: Array<{ __typename: 'PrivateSessionAvailabilityScheduleDay', dayOfWeek: number, timeSchedule: Array<{ __typename: 'PrivateSessionAvailabilityScheduleTime', validUntil: any, validFrom: any }> }> } | undefined } | undefined } };

export type SavePrivateSessionSettingsMutationVariables = Exact<{
  venueId: Scalars['String']['input'];
  isSelfManagingAllowed: Scalars['Boolean']['input'];
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type SavePrivateSessionSettingsMutation = { savePrivateSessionSettings: { __typename: 'PrivateSessionSettings', id: string, isSelfManagingAllowed: boolean, notificationEmail: string | undefined } };

export type SaveDefaultAvailabilityScheduleMutationVariables = Exact<{
  venueId: Scalars['ID']['input'];
  schedule: Array<SavePrivateSessionAvailabilityScheduleDayArgs> | SavePrivateSessionAvailabilityScheduleDayArgs;
}>;


export type SaveDefaultAvailabilityScheduleMutation = { saveDefaultPrivateSessionAvailabilitySchedule: { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } | { __typename: 'PrivateSessionAvailabilitySchedule', id: string, schedule: Array<{ __typename: 'PrivateSessionAvailabilityScheduleDay', dayOfWeek: number, timeSchedule: Array<{ __typename: 'PrivateSessionAvailabilityScheduleTime', validFrom: any, validUntil: any }> }> } };

export type DateSpecificAvailabilityQueryQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type DateSpecificAvailabilityQueryQuery = { venueByShortId: { __typename: 'Venue', id: string, privateSessionSettings: { __typename: 'PrivateSessionSettings', defaultDaySpecificAvailability: { __typename: 'PrivateSessionDaySpecificAvailabilityConnection', nodes: Array<{ __typename: 'PrivateSessionDaySpecificAvailability', id: string, dateFrom: any, timeSlots: Array<{ __typename: 'PrivateSessionDaySpecificAvailabilityTime', validFrom: any, validUntil: any }> }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, startCursor: any | undefined, endCursor: any | undefined } } } | undefined } };

export type DeletePrivateSessionDaySpecificAvailabilityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePrivateSessionDaySpecificAvailabilityMutation = { deletePrivateSessionDaySpecificAvailability: boolean };

export type SavePrivateSessionDaySpecificAvailabilityMutationVariables = Exact<{
  venueId: Scalars['ID']['input'];
  availability: Array<SavePrivateSessionDaySpecificAvailabilityDateEntryArgs> | SavePrivateSessionDaySpecificAvailabilityDateEntryArgs;
}>;


export type SavePrivateSessionDaySpecificAvailabilityMutation = { savePrivateSessionDaySpecificAvailability: { __typename: 'ExpectedErrors' } | { __typename: 'PrivateSessionDaySpecificAvailabilityList', nodes: Array<{ __typename: 'PrivateSessionDaySpecificAvailability', id: string, dateFrom: any, timeSlots: Array<{ __typename: 'PrivateSessionDaySpecificAvailabilityTime', validFrom: any, validUntil: any }> }> } };

export type GetFloorPlansQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type GetFloorPlansQuery = { venueByShortId: { __typename: 'Venue', id: string, floorPlans: Array<{ __typename: 'FloorPlan', id: string }>, floorPlanConnection: { __typename: 'FloorPlanConnection', edges: Array<{ __typename: 'FloorPlanEdge', cursor: any, node: { __typename: 'FloorPlan', id: string, name: string, numberOfAssignedFloorPlans: number } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'FloorPlan', id: string, name: string, numberOfAssignedFloorPlans: number }> } } };

export type SubstitutionExtensionSettingsQueryQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type SubstitutionExtensionSettingsQueryQuery = { company: { __typename: 'Company', id: string, venues: Array<{ __typename: 'Venue', name: string, shortId: string }>, settings: { __typename: 'Settings', id: string, substitutionNotification: { __typename: 'SubstitutionNotification', email: string | undefined, successfullySubstituted: boolean, successfullyCreated: boolean, customerNotificationEnabled: boolean, customerNotificationEmailTemplate: string | undefined } | undefined } } };

export type SaveSubstitutionNotificationSettingsMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  successfullySubstituted: Scalars['Boolean']['input'];
  successfullyCreated: Scalars['Boolean']['input'];
  customerNotificationEnabled: Scalars['Boolean']['input'];
  customerNotificationEmailTemplate?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveSubstitutionNotificationSettingsMutation = { saveSubstitutionNotificationSettings: { __typename: 'SubstitutionNotification', email: string | undefined, successfullySubstituted: boolean, successfullyCreated: boolean, customerNotificationEnabled: boolean, customerNotificationEmailTemplate: string | undefined } };

export type VenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type VenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string, internalType: VenueInternalsType | undefined } };

export type GetFloorPlanQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type GetFloorPlanQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string, floorPlans: Array<{ __typename: 'FloorPlan', id: string, name: string, numberOfAssignedFloorPlans: number, spots: Array<{ __typename: 'BookableSpot', id: string, x: number, y: number, label: string, bookableIcon: BookableSpotIconType | undefined, floorPlanId: string, isAvailable: boolean, isPriority: boolean } | { __typename: 'NonBookableSpot', id: string, x: number, y: number, label: string, nonBookableIcon: NonBookableItemIconType, floorPlanId: string }> }> } };

export type UpdateFloorPlanMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  venueId: Scalars['String']['input'];
}>;


export type UpdateFloorPlanMutation = { updateFloorPlan: { __typename: 'FloorPlan', id: string, name: string } };

export type CreateFloorPlanMutationVariables = Exact<{
  name: Scalars['String']['input'];
  venueId: Scalars['String']['input'];
}>;


export type CreateFloorPlanMutation = { createFloorPlan: { __typename: 'FloorPlan', id: string } };

export type ArchiveFloorPlanMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveFloorPlanMutation = { archiveFloorPlan: boolean };

export type SyncBookableSpotsMutationVariables = Exact<{
  floorPlanId: Scalars['String']['input'];
  syncBookableSpots: Array<SyncBookableSpotInput> | SyncBookableSpotInput;
}>;


export type SyncBookableSpotsMutation = { syncBookableSpots: Array<{ __typename: 'BookableSpot', bookableIcon: BookableSpotIconType | undefined, floorPlanId: string, id: string, isAvailable: boolean, isPriority: boolean, label: string, x: number, y: number }> };

export type SyncNonBookableSpotsMutationVariables = Exact<{
  floorPlanId: Scalars['String']['input'];
  syncNonBookableSpots: Array<SyncNonBookableSpotInput> | SyncNonBookableSpotInput;
}>;


export type SyncNonBookableSpotsMutation = { syncNonBookableSpots: Array<{ __typename: 'NonBookableSpot', nonBookableIcon: NonBookableItemIconType, floorPlanId: string, id: string, label: string, x: number, y: number }> };

export type PublishFloorPlanMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PublishFloorPlanMutation = { publishFloorPlan: boolean };

export type SpotBookingNewQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type SpotBookingNewQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string, internalType: VenueInternalsType | undefined } };

export type ImportsVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type ImportsVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string, type: VenueType | undefined, importToken: { __typename: 'VenueImportToken', token: string } | undefined, latestRun: { __typename: 'VenueImportRun', state: ImportRunState } | undefined, latestUpload: { __typename: 'VenueImportUpload', id: string, state: ImportUploadState } | undefined, company: { __typename: 'Company', id: string }, internals: { __typename: 'VenueInternals', previousSoftware: PreviousSoftware | undefined } | undefined } };

export type ImportsVenueResultsByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type ImportsVenueResultsByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, latestRun: { __typename: 'VenueImportRun', errors: Record<string, unknown> | undefined, result: Record<string, unknown> | undefined } | undefined } };

export type ImportsMeQueryVariables = Exact<{ [key: string]: never; }>;


export type ImportsMeQuery = { me: { __typename: 'Me', isEversportsAdmin: boolean } };

export type GenerateTokenMutationVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type GenerateTokenMutation = { generateToken: { __typename: 'VenueImportToken', token: string } };

export type StartImportMutationVariables = Exact<{
  shortId: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
}>;


export type StartImportMutation = { startImport: { __typename: 'VenueImportRun', state: ImportRunState } };

export type CashRegisterAccessUsersQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type CashRegisterAccessUsersQuery = { venueByShortId: { __typename: 'Venue', id: string, cashRegisterUsers: Array<{ __typename: 'CashRegisterUser', id: string, firstname: string | undefined, lastname: string | undefined, role: Role }> } };

export type SoftwareVersionQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type SoftwareVersionQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, settings: { __typename: 'Settings', id: string, softwareVersion: { __typename: 'SoftwareVersion', versionName: string } | undefined } } } };

export type FetchTaxArchivesQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type FetchTaxArchivesQuery = { venueByShortId: { __typename: 'Venue', id: string, taxArchives: { __typename: 'TaxArchiveConnection', nodes: Array<{ __typename: 'TaxArchive', id: string, name: string, fromDate: string, toDate: string, createdAt: string, downloadUrl: string | undefined }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined } } } };

export type CreatePeriodMutationVariables = Exact<{
  seasonId: Scalars['ID']['input'];
  properties: PeriodInput;
  courtGroupId: Scalars['ID']['input'];
}>;


export type CreatePeriodMutation = { createPeriod: { __typename: 'Period', id: string, name: string, start: any, end: any, interval: number, intervalType: IntervalType, weekdays: Array<Weekday>, rates: Array<{ __typename: 'Rate', id: string, consumerType: ConsumerType, bookingType: BookingType, price: number, minUnits: number | undefined, maxUnits: number | undefined, customerGroup: { __typename: 'CustomerGroup', id: string, name: string | undefined } | undefined }> } | { __typename: 'PeriodValidation', isValid: boolean, errors: Array<PeriodValidationError>, overlapsWith: Array<{ __typename: 'Period', id: string, name: string }>, rateValidations: Array<{ __typename: 'RateValidation', errors: Array<RateValidationError>, isValid: boolean, alsoUsedIn: Array<{ __typename: 'Period', id: string, name: string }> }> } };

export type UpdatePeriodMutationVariables = Exact<{
  periodId: Scalars['ID']['input'];
  properties: PeriodInput;
  courtGroupId: Scalars['ID']['input'];
}>;


export type UpdatePeriodMutation = { updatePeriod: { __typename: 'Period', id: string } | { __typename: 'PeriodValidation', isValid: boolean, errors: Array<PeriodValidationError>, overlapsWith: Array<{ __typename: 'Period', id: string, name: string }>, rateValidations: Array<{ __typename: 'RateValidation', errors: Array<RateValidationError>, isValid: boolean, alsoUsedIn: Array<{ __typename: 'Period', id: string, name: string }> }> } };

export type RemovePeriodMutationVariables = Exact<{
  periodId: Scalars['ID']['input'];
  courtGroupId: Scalars['ID']['input'];
}>;


export type RemovePeriodMutation = { removePeriod: boolean };

export type SeasonIdVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
  courtGroupId: Scalars['ID']['input'];
}>;


export type SeasonIdVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string }, courtGroup: { __typename: 'CourtGroup', id: string, name: string } };

export type SeasonIdPageQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
  courtGroupId: Scalars['ID']['input'];
  seasonId: Scalars['ID']['input'];
}>;


export type SeasonIdPageQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', customerGroups: Array<{ __typename: 'CustomerGroup', id: string, name: string | undefined, groupPresetType: GroupPresetType | undefined }> } }, courtGroupSeason: { __typename: 'Season', id: string, name: string, periods: Array<{ __typename: 'Period', id: string, name: string, start: any, end: any, interval: number, intervalType: IntervalType, weekdays: Array<Weekday>, rates: Array<{ __typename: 'Rate', id: string, consumerType: ConsumerType, bookingType: BookingType, price: number, minUnits: number | undefined, maxUnits: number | undefined, customerGroup: { __typename: 'CustomerGroup', id: string, name: string | undefined } | undefined }> }> } };

export type RatesVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type RatesVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string } };

export type RatesCourtGroupsQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type RatesCourtGroupsQuery = { venueByShortId: { __typename: 'Venue', id: string, courtGroups: Array<{ __typename: 'CourtGroup', id: string, name: string, courts: Array<{ __typename: 'Resource', id: string }> }> } };

export type RatesCourtGroupSeasonsQueryVariables = Exact<{
  courtGroupId: Scalars['ID']['input'];
}>;


export type RatesCourtGroupSeasonsQuery = { courtGroup: { __typename: 'CourtGroup', id: string, courts: Array<{ __typename: 'Resource', id: string, name: string }>, seasons: Array<{ __typename: 'ValidatedSeason', id: string, name: string, start: any, end: any, validation: { __typename: 'SeasonValidation', alsoUsedIn: Array<{ __typename: 'CourtGroup', id: string, name: string }>, overrides: Array<{ __typename: 'Season', id: string, name: string }> } }> } };

export type UpdateSeasonMutationVariables = Exact<{
  seasonId: Scalars['ID']['input'];
  courtGroupId: Scalars['ID']['input'];
  properties: SeasonInput;
}>;


export type UpdateSeasonMutation = { updateSeason: { __typename: 'Season', id: string, name: string, start: any, end: any } | { __typename: 'SeasonValidation', isValid: boolean, alsoUsedIn: Array<{ __typename: 'CourtGroup', id: string, name: string }>, conflictsIn: Array<{ __typename: 'CourtGroup', id: string, name: string }>, overlaps: Array<{ __typename: 'Season', id: string, name: string, end: any, start: any }>, overrides: Array<{ __typename: 'Season', id: string, name: string }> } };

export type RemoveSeasonMutationVariables = Exact<{
  seasonId: Scalars['ID']['input'];
  courtGroupId: Scalars['ID']['input'];
}>;


export type RemoveSeasonMutation = { removeSeason: boolean };

export type CreateSeasonMutationVariables = Exact<{
  courtGroupId: Scalars['ID']['input'];
  properties: SeasonInput;
}>;


export type CreateSeasonMutation = { createSeason: { __typename: 'Season', id: string, name: string, end: any, start: any } | { __typename: 'SeasonValidation', isValid: boolean, alsoUsedIn: Array<{ __typename: 'CourtGroup', id: string, name: string }>, conflictsIn: Array<{ __typename: 'CourtGroup', id: string, name: string }>, overlaps: Array<{ __typename: 'Season', id: string, name: string, end: any, start: any }>, overrides: Array<{ __typename: 'Season', id: string, name: string }> } };

export type VenueVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type VenueVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string } };

export type WidgetListVenueQueryVariables = Exact<{
  venueId: Scalars['String']['input'];
}>;


export type WidgetListVenueQuery = { venue: { __typename: 'Venue', id: string, name: string, company: { __typename: 'Company', id: string, marketplaceHostname: string, venues: Array<{ __typename: 'Venue', id: string, name: string }>, widgets: Array<{ __typename: 'CompanyWidgetActivities', id: string, name: string, isInOverviewWidget: boolean, widgetPageURL: string, isDeletable: boolean } | { __typename: 'CompanyWidgetActivitySchedule', id: string, name: string, isInOverviewWidget: boolean, widgetPageURL: string, isDeletable: boolean } | { __typename: 'CompanyWidgetNewsletter', id: string, name: string, isInOverviewWidget: boolean, widgetPageURL: string, isDeletable: boolean } | { __typename: 'CompanyWidgetOverview', id: string, name: string, isInOverviewWidget: boolean, widgetPageURL: string, isDeletable: boolean } | { __typename: 'CompanyWidgetPrices', id: string, name: string, isInOverviewWidget: boolean, widgetPageURL: string, isDeletable: boolean } | { __typename: 'CompanyWidgetVideos', id: string, name: string, isInOverviewWidget: boolean, widgetPageURL: string, isDeletable: boolean } | { __typename: 'CompanyWidgetVouchers', id: string, name: string, isInOverviewWidget: boolean, widgetPageURL: string, isDeletable: boolean }>, companyWidgetOverview: Array<{ __typename: 'CompanyWidgetActivities' } | { __typename: 'CompanyWidgetActivitySchedule' } | { __typename: 'CompanyWidgetNewsletter' } | { __typename: 'CompanyWidgetOverview', id: string, name: string, widgets: Array<{ __typename: 'CompanyWidgetActivities', id: string, name: string } | { __typename: 'CompanyWidgetActivitySchedule', id: string, name: string } | { __typename: 'CompanyWidgetNewsletter', id: string, name: string } | { __typename: 'CompanyWidgetOverview', id: string, name: string } | { __typename: 'CompanyWidgetPrices', id: string, name: string } | { __typename: 'CompanyWidgetVideos', id: string, name: string } | { __typename: 'CompanyWidgetVouchers', id: string, name: string }> } | { __typename: 'CompanyWidgetPrices' } | { __typename: 'CompanyWidgetVideos' } | { __typename: 'CompanyWidgetVouchers' }> } } };

export type WidgetEditCompanyWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  shortId: Scalars['String']['input'];
}>;


export type WidgetEditCompanyWidgetQuery = { companyWidget: { __typename: 'CompanyWidgetActivities' } | { __typename: 'CompanyWidgetActivitySchedule' } | { __typename: 'CompanyWidgetNewsletter' } | { __typename: 'CompanyWidgetOverview' } | { __typename: 'CompanyWidgetPrices' } | { __typename: 'CompanyWidgetVideos' } | { __typename: 'CompanyWidgetVouchers' }, venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, venues: Array<{ __typename: 'Venue', id: string, name: string }> } } };

export type BrandSettingsQueryQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type BrandSettingsQueryQuery = { company: { __typename: 'Company', id: string, name: string, widgetBrandSettings: { __typename: 'CompanyWidgetBrandSettings', backgroundColor: string, cardBackgroundColor: string, cardTextColor: string, displayName: string | undefined, floorPlanBackgroundColor: string | undefined, fontFamily: string | undefined, id: string, primaryColor: string, spotBookableBackgroundColor: string | undefined, spotBookableTextColor: string | undefined, spotNonBookableBackgroundColor: string | undefined, spotNonBookableTextColor: string | undefined, textColor: string, logo: { __typename: 'Picture', id: string, small: string, medium: string, large: string } | undefined } | undefined } };

export type CreateCompanyWidgetBrandSettingsMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  backgroundColor: Scalars['String']['input'];
  cardBackgroundColor: Scalars['String']['input'];
  textColor: Scalars['String']['input'];
  cardTextColor: Scalars['String']['input'];
  primaryColor: Scalars['String']['input'];
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  logoFile?: InputMaybe<LogoFileInput>;
}>;


export type CreateCompanyWidgetBrandSettingsMutation = { createCompanyWidgetBrandSettings: { __typename: 'CompanyWidgetBrandSettings', id: string, displayName: string | undefined, backgroundColor: string, cardBackgroundColor: string, textColor: string, cardTextColor: string, primaryColor: string, fontFamily: string | undefined, logo: { __typename: 'Picture', id: string, small: string, medium: string, large: string } | undefined } };

export type UpdateCompanyWidgetBrandSettingsMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  cardBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
  cardTextColor?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  logoFile?: InputMaybe<LogoFileInput>;
  removeLogo?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateCompanyWidgetBrandSettingsMutation = { updateCompanyWidgetBrandSettings: { __typename: 'CompanyWidgetBrandSettings', id: string, displayName: string | undefined, backgroundColor: string, cardBackgroundColor: string, textColor: string, cardTextColor: string, primaryColor: string, fontFamily: string | undefined, logo: { __typename: 'Picture', id: string, small: string, medium: string, large: string } | undefined } };

export type ActivitiesVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type ActivitiesVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, activeActivityTypes: Array<ActivityType>, widgetBrandSettings: { __typename: 'CompanyWidgetBrandSettings', id: string, backgroundColor: string, cardBackgroundColor: string, cardTextColor: string, displayName: string | undefined, fontFamily: string | undefined, primaryColor: string, textColor: string } | undefined }, venueExtensions: Array<{ __typename: 'VenueExtension', id: string, extension: { __typename: 'Extension', id: string, name: ExtensionName } }> } };

export type ActivitiesCompanyWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActivitiesCompanyWidgetQuery = { companyWidget: { __typename: 'CompanyWidgetActivities', id: string, name: string, colorBackground: string | undefined, colorBackgroundCard: string | undefined, colorButton: string | undefined, colorFont: string | undefined, colorFontCard: string | undefined, colorHeading: string | undefined, fontFamily: string | undefined, isOnlyWidgetOfThisType: boolean, activityTypes: Array<ActivityType>, isMyBookingsLinkVisible: boolean, defaultStartDate: string | undefined, defaultEndDate: string | undefined, isActivityGroupFilterHidden: boolean, isTrainerFilterHidden: boolean, isDateFilterHidden: boolean, isVenueFilterHidden: boolean, defaultVenues: { __typename: 'VenueConnection', nodes: Array<{ __typename: 'Venue', id: string }> } } | { __typename: 'CompanyWidgetActivitySchedule' } | { __typename: 'CompanyWidgetNewsletter' } | { __typename: 'CompanyWidgetOverview' } | { __typename: 'CompanyWidgetPrices' } | { __typename: 'CompanyWidgetVideos' } | { __typename: 'CompanyWidgetVouchers' } };

export type ActivityWidgetTrainersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type ActivityWidgetTrainersQuery = { companyWidget: { __typename: 'CompanyWidgetActivities', id: string, trainers: { __typename: 'TeacherConnection', nodes: Array<{ __typename: 'Teacher', id: string }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } | { __typename: 'CompanyWidgetActivitySchedule' } | { __typename: 'CompanyWidgetNewsletter' } | { __typename: 'CompanyWidgetOverview' } | { __typename: 'CompanyWidgetPrices' } | { __typename: 'CompanyWidgetVideos' } | { __typename: 'CompanyWidgetVouchers' } };

export type ActivityWidgetActivityGroupsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type ActivityWidgetActivityGroupsQuery = { companyWidget: { __typename: 'CompanyWidgetActivities', id: string, activityGroups: { __typename: 'ActivityGroupConnection', nodes: Array<{ __typename: 'ActivityGroup', id: string }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } | { __typename: 'CompanyWidgetActivitySchedule' } | { __typename: 'CompanyWidgetNewsletter' } | { __typename: 'CompanyWidgetOverview' } | { __typename: 'CompanyWidgetPrices' } | { __typename: 'CompanyWidgetVideos' } | { __typename: 'CompanyWidgetVouchers' } };

export type SaveCreateCompanyWidgetActivitiesMutationVariables = Exact<{
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBackgroundCard?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  colorHeading?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  activityTypes: Array<ActivityType> | ActivityType;
  activityGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  trainerIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  defaultVenueIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  defaultStart?: InputMaybe<Scalars['DateTime']['input']>;
  defaultEnd?: InputMaybe<Scalars['DateTime']['input']>;
  isMyBookingsLinkVisible: Scalars['Boolean']['input'];
  isActivityGroupFilterHidden: Scalars['Boolean']['input'];
  isTrainerFilterHidden: Scalars['Boolean']['input'];
  isDateFilterHidden: Scalars['Boolean']['input'];
  isVenueFilterHidden: Scalars['Boolean']['input'];
}>;


export type SaveCreateCompanyWidgetActivitiesMutation = { createCompanyWidgetActivities: { __typename: 'CompanyWidgetActivities', id: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } };

export type SaveUpdateCompanyWidgetActivitiesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBackgroundCard?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  colorHeading?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  activityTypes: Array<ActivityType> | ActivityType;
  activityGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  trainerIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  defaultVenueIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  defaultStart?: InputMaybe<Scalars['DateTime']['input']>;
  defaultEnd?: InputMaybe<Scalars['DateTime']['input']>;
  isMyBookingsLinkVisible: Scalars['Boolean']['input'];
  isActivityGroupFilterHidden: Scalars['Boolean']['input'];
  isTrainerFilterHidden: Scalars['Boolean']['input'];
  isDateFilterHidden: Scalars['Boolean']['input'];
  isVenueFilterHidden: Scalars['Boolean']['input'];
}>;


export type SaveUpdateCompanyWidgetActivitiesMutation = { updateCompanyWidgetActivities: { __typename: 'CompanyWidgetActivities', id: string, name: string, colorBackground: string | undefined, colorBackgroundCard: string | undefined, colorButton: string | undefined, colorFont: string | undefined, colorFontCard: string | undefined, colorHeading: string | undefined, fontFamily: string | undefined, activityTypes: Array<ActivityType>, isMyBookingsLinkVisible: boolean, defaultStartDate: string | undefined, defaultEndDate: string | undefined, isActivityGroupFilterHidden: boolean, isDateFilterHidden: boolean, isVenueFilterHidden: boolean, defaultVenues: { __typename: 'VenueConnection', nodes: Array<{ __typename: 'Venue', id: string }> } } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } };

export type ActivityScheduleVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type ActivityScheduleVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, widgetBrandSettings: { __typename: 'CompanyWidgetBrandSettings', backgroundColor: string, cardBackgroundColor: string, cardTextColor: string, displayName: string | undefined, fontFamily: string | undefined, primaryColor: string, textColor: string } | undefined } } };

export type ActivityScheduleCompanyWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActivityScheduleCompanyWidgetQuery = { companyWidget: { __typename: 'CompanyWidgetActivities' } | { __typename: 'CompanyWidgetActivitySchedule', id: string, name: string, colorBackground: string | undefined, colorButton: string | undefined, colorFont: string | undefined, colorFontCard: string | undefined, fontFamily: string | undefined, isOnlyWidgetOfThisType: boolean, groupSchedule: boolean, showLevel: boolean, showResource: boolean, showTrainer: boolean, showCompactViewMobile: boolean | undefined, spotLimitDisplayType: SpotLimitDisplayType | undefined, isMyBookingsLinkVisible: boolean, isActivityGroupFilterHidden: boolean, isSportFilterHidden: boolean, isTeacherFilterHidden: boolean, isVenueFilterHidden: boolean } | { __typename: 'CompanyWidgetNewsletter' } | { __typename: 'CompanyWidgetOverview' } | { __typename: 'CompanyWidgetPrices' } | { __typename: 'CompanyWidgetVideos' } | { __typename: 'CompanyWidgetVouchers' } };

export type ActivityScheduleCreateCompanyWidgetActivityScheduleMutationVariables = Exact<{
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  defaultActivityGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  defaultSportIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  defaultTeacherIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  defaultVenueIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  groupSchedule: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  showLevel: Scalars['Boolean']['input'];
  showResource: Scalars['Boolean']['input'];
  showTrainer: Scalars['Boolean']['input'];
  showCompactViewMobile: Scalars['Boolean']['input'];
  spotLimitDisplayType?: InputMaybe<SpotLimitDisplayType>;
  isMyBookingsLinkVisible: Scalars['Boolean']['input'];
  isActivityGroupFilterHidden: Scalars['Boolean']['input'];
  isSportFilterHidden: Scalars['Boolean']['input'];
  isTeacherFilterHidden: Scalars['Boolean']['input'];
  isVenueFilterHidden: Scalars['Boolean']['input'];
}>;


export type ActivityScheduleCreateCompanyWidgetActivityScheduleMutation = { createCompanyWidgetActivitySchedule: { __typename: 'CompanyWidgetActivitySchedule', id: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } };

export type ActivityScheduleUpdateCompanyWidgetActivityScheduleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  defaultActivityGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  defaultSportIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  defaultTeacherIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  defaultVenueIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  groupSchedule: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  showLevel: Scalars['Boolean']['input'];
  showResource: Scalars['Boolean']['input'];
  showTrainer: Scalars['Boolean']['input'];
  showCompactViewMobile: Scalars['Boolean']['input'];
  spotLimitDisplayType?: InputMaybe<SpotLimitDisplayType>;
  isMyBookingsLinkVisible: Scalars['Boolean']['input'];
  isActivityGroupFilterHidden: Scalars['Boolean']['input'];
  isSportFilterHidden: Scalars['Boolean']['input'];
  isTeacherFilterHidden: Scalars['Boolean']['input'];
  isVenueFilterHidden: Scalars['Boolean']['input'];
}>;


export type ActivityScheduleUpdateCompanyWidgetActivityScheduleMutation = { updateCompanyWidgetActivitySchedule: { __typename: 'CompanyWidgetActivitySchedule', id: string, name: string, colorBackground: string | undefined, colorButton: string | undefined, colorFont: string | undefined, colorFontCard: string | undefined, fontFamily: string | undefined, groupSchedule: boolean, showLevel: boolean, showResource: boolean, showTrainer: boolean, showCompactViewMobile: boolean | undefined, spotLimitDisplayType: SpotLimitDisplayType | undefined, isMyBookingsLinkVisible: boolean, isActivityGroupFilterHidden: boolean, isSportFilterHidden: boolean, isTeacherFilterHidden: boolean, isVenueFilterHidden: boolean } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } };

export type FilterOptionsCompanyVenuesQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type FilterOptionsCompanyVenuesQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, venues: Array<{ __typename: 'Venue', id: string, name: string }> } } };

export type CompanyTeachersQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  venueIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type CompanyTeachersQuery = { company: { __typename: 'Company', id: string, teachers: { __typename: 'TeacherConnection', nodes: Array<{ __typename: 'Teacher', id: string, name: string }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } };

export type CompanyActivityGroupsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  venueIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type CompanyActivityGroupsQuery = { company: { __typename: 'Company', id: string, activityGroups: { __typename: 'ActivityGroupConnection', nodes: Array<{ __typename: 'ActivityGroup', id: string, name: string, venue: { __typename: 'Venue', id: string, name: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } };

export type CompanySportsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
  venueIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type CompanySportsQuery = { company: { __typename: 'Company', id: string, sports: { __typename: 'SportConnection', nodes: Array<{ __typename: 'Sport', id: string, name: string }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } };

export type DefaultTeachersCompanyWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type DefaultTeachersCompanyWidgetQuery = { companyWidget: { __typename: 'CompanyWidgetActivities' } | { __typename: 'CompanyWidgetActivitySchedule', id: string, defaultTeachers: { __typename: 'TeacherConnection', nodes: Array<{ __typename: 'Teacher', id: string, nickname: string }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } | undefined } | { __typename: 'CompanyWidgetNewsletter' } | { __typename: 'CompanyWidgetOverview' } | { __typename: 'CompanyWidgetPrices' } | { __typename: 'CompanyWidgetVideos' } | { __typename: 'CompanyWidgetVouchers' } };

export type DefaultActivityGroupsCompanyWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type DefaultActivityGroupsCompanyWidgetQuery = { companyWidget: { __typename: 'CompanyWidgetActivities' } | { __typename: 'CompanyWidgetActivitySchedule', id: string, defaultActivityGroups: { __typename: 'ActivityGroupConnection', nodes: Array<{ __typename: 'ActivityGroup', id: string, name: string, venue: { __typename: 'Venue', id: string, name: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } | undefined } | { __typename: 'CompanyWidgetNewsletter' } | { __typename: 'CompanyWidgetOverview' } | { __typename: 'CompanyWidgetPrices' } | { __typename: 'CompanyWidgetVideos' } | { __typename: 'CompanyWidgetVouchers' } };

export type DefaultSportsCompanyWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type DefaultSportsCompanyWidgetQuery = { companyWidget: { __typename: 'CompanyWidgetActivities' } | { __typename: 'CompanyWidgetActivitySchedule', id: string, defaultSports: { __typename: 'SportConnection', nodes: Array<{ __typename: 'Sport', id: string, name: string }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } | undefined } | { __typename: 'CompanyWidgetNewsletter' } | { __typename: 'CompanyWidgetOverview' } | { __typename: 'CompanyWidgetPrices' } | { __typename: 'CompanyWidgetVideos' } | { __typename: 'CompanyWidgetVouchers' } };

export type DefaultVenuesCompanyWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type DefaultVenuesCompanyWidgetQuery = { companyWidget: { __typename: 'CompanyWidgetActivities' } | { __typename: 'CompanyWidgetActivitySchedule', id: string, defaultVenues: { __typename: 'VenueConnection', nodes: Array<{ __typename: 'Venue', id: string, name: string }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } | undefined } | { __typename: 'CompanyWidgetNewsletter' } | { __typename: 'CompanyWidgetOverview' } | { __typename: 'CompanyWidgetPrices' } | { __typename: 'CompanyWidgetVideos' } | { __typename: 'CompanyWidgetVouchers' } };

export type NewsletterVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type NewsletterVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, widgetBrandSettings: { __typename: 'CompanyWidgetBrandSettings', backgroundColor: string, cardBackgroundColor: string, cardTextColor: string, displayName: string | undefined, fontFamily: string | undefined, primaryColor: string, textColor: string } | undefined, venues: Array<{ __typename: 'Venue', id: string, website: string | undefined }> } } };

export type NewsletterCompanyWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NewsletterCompanyWidgetQuery = { companyWidget: { __typename: 'CompanyWidgetActivities' } | { __typename: 'CompanyWidgetActivitySchedule' } | { __typename: 'CompanyWidgetNewsletter', id: string, name: string, title: string | undefined, description: string | undefined, colorBackground: string | undefined, colorFont: string | undefined, colorButton: string | undefined, fontFamily: string | undefined, isDeletable: boolean, allowedDomains: Array<string> | undefined } | { __typename: 'CompanyWidgetOverview' } | { __typename: 'CompanyWidgetPrices' } | { __typename: 'CompanyWidgetVideos' } | { __typename: 'CompanyWidgetVouchers' } };

export type SaveCreateCompanyWidgetNewsletterMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  allowedDomains?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SaveCreateCompanyWidgetNewsletterMutation = { createCompanyWidgetNewsletter: { __typename: 'CompanyWidgetNewsletter', id: string } | { __typename: 'ExpectedErrors' } };

export type SaveUpdateCompanyWidgetNewsletterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  allowedDomains?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SaveUpdateCompanyWidgetNewsletterMutation = { updateCompanyWidgetNewsletter: { __typename: 'CompanyWidgetNewsletter', id: string } | { __typename: 'ExpectedErrors' } };

export type PricesVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type PricesVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, widgetBrandSettings: { __typename: 'CompanyWidgetBrandSettings', backgroundColor: string, cardBackgroundColor: string, cardTextColor: string, displayName: string | undefined, fontFamily: string | undefined, primaryColor: string, textColor: string } | undefined, productGroups: { __typename: 'ProductGroupConnection', nodes: Array<{ __typename: 'ProductGroup', id: string, name: string, priority: number }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } } };

export type PricesCompanyWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type PricesCompanyWidgetQuery = { companyWidget: { __typename: 'CompanyWidgetActivities' } | { __typename: 'CompanyWidgetActivitySchedule' } | { __typename: 'CompanyWidgetNewsletter' } | { __typename: 'CompanyWidgetOverview' } | { __typename: 'CompanyWidgetPrices', id: string, name: string, colorBackground: string | undefined, colorBackgroundCard: string | undefined, colorButton: string | undefined, colorFont: string | undefined, colorFontCard: string | undefined, colorHeading: string | undefined, fontFamily: string | undefined, isOnlyWidgetOfThisType: boolean, isMyProductsLinkVisible: boolean, invoicingVenue: { __typename: 'Venue', id: string }, productGroups: { __typename: 'ProductGroupConnection', nodes: Array<{ __typename: 'ProductGroup', id: string, name: string, priority: number }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } | undefined } | { __typename: 'CompanyWidgetVideos' } | { __typename: 'CompanyWidgetVouchers' } };

export type PricesSaveCreateCompanyWidgetPricesMutationVariables = Exact<{
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBackgroundCard?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  colorHeading?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  invoicingVenueId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  productGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  isMyProductsLinkVisible: Scalars['Boolean']['input'];
}>;


export type PricesSaveCreateCompanyWidgetPricesMutation = { createCompanyWidgetPrices: { __typename: 'CompanyWidgetPrices', id: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } };

export type PricesSaveUpdateCompanyWidgetPricesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBackgroundCard?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  colorHeading?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  invoicingVenueId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  productGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  isMyProductsLinkVisible: Scalars['Boolean']['input'];
}>;


export type PricesSaveUpdateCompanyWidgetPricesMutation = { updateCompanyWidgetPrices: { __typename: 'CompanyWidgetPrices', name: string, colorBackground: string | undefined, colorBackgroundCard: string | undefined, colorButton: string | undefined, colorFont: string | undefined, colorFontCard: string | undefined, colorHeading: string | undefined, fontFamily: string | undefined, isMyProductsLinkVisible: boolean, invoicingVenue: { __typename: 'Venue', id: string }, productGroups: { __typename: 'ProductGroupConnection', nodes: Array<{ __typename: 'ProductGroup', id: string, name: string, priority: number }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } | undefined } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } };

export type RecordingCategoriesVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type RecordingCategoriesVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, widgetBrandSettings: { __typename: 'CompanyWidgetBrandSettings', backgroundColor: string, cardBackgroundColor: string, cardTextColor: string, displayName: string | undefined, fontFamily: string | undefined, primaryColor: string, textColor: string } | undefined, recordingCategories: { __typename: 'RecordingCategoryConnection', nodes: Array<{ __typename: 'RecordingCategory', id: string, name: string, venue: { __typename: 'Venue', id: string, name: string } }> } } } };

export type VideosCompanyWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type VideosCompanyWidgetQuery = { companyWidget: { __typename: 'CompanyWidgetActivities' } | { __typename: 'CompanyWidgetActivitySchedule' } | { __typename: 'CompanyWidgetNewsletter' } | { __typename: 'CompanyWidgetOverview' } | { __typename: 'CompanyWidgetPrices' } | { __typename: 'CompanyWidgetVideos', id: string, name: string, colorBackground: string | undefined, colorBackgroundCard: string | undefined, colorButton: string | undefined, colorFont: string | undefined, colorFontCard: string | undefined, colorHeading: string | undefined, fontFamily: string | undefined, isOnlyWidgetOfThisType: boolean, isMyVideosLinkVisible: boolean, defaultLanguages: Array<RecordingSupportedLanguage>, defaultLevels: Array<RecordingDifficultyLevel>, isDurationFilterHidden: boolean, isLanguageFilterHidden: boolean, isLevelFilterHidden: boolean, isSportFilterHidden: boolean, isTeacherFilterHidden: boolean, isVenueFilterHidden: boolean, recordingCategories: { __typename: 'RecordingCategoryConnection', nodes: Array<{ __typename: 'RecordingCategory', id: string }> }, defaultVenues: { __typename: 'VenueConnection', nodes: Array<{ __typename: 'Venue', id: string }> } } | { __typename: 'CompanyWidgetVouchers' } };

export type SaveCreateCompanyWidgetVideosMutationVariables = Exact<{
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBackgroundCard?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  colorHeading?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  defaultVenueIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  defaultTeacherIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  defaultSportIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  defaultLanguages?: InputMaybe<Array<RecordingSupportedLanguage> | RecordingSupportedLanguage>;
  defaultLevels?: InputMaybe<Array<RecordingDifficultyLevel> | RecordingDifficultyLevel>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recordingCategoryIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  isMyVideosLinkVisible: Scalars['Boolean']['input'];
  isDurationFilterHidden: Scalars['Boolean']['input'];
  isLanguageFilterHidden: Scalars['Boolean']['input'];
  isLevelFilterHidden: Scalars['Boolean']['input'];
  isSportFilterHidden: Scalars['Boolean']['input'];
  isTeacherFilterHidden: Scalars['Boolean']['input'];
  isVenueFilterHidden: Scalars['Boolean']['input'];
}>;


export type SaveCreateCompanyWidgetVideosMutation = { createCompanyWidgetVideos: { __typename: 'CompanyWidgetVideos', id: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } };

export type SaveUpdateCompanyWidgetVideosMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBackgroundCard?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  colorHeading?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  defaultVenueIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  defaultTeacherIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  defaultSportIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  defaultLanguages?: InputMaybe<Array<RecordingSupportedLanguage> | RecordingSupportedLanguage>;
  defaultLevels?: InputMaybe<Array<RecordingDifficultyLevel> | RecordingDifficultyLevel>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recordingCategoryIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  isMyVideosLinkVisible: Scalars['Boolean']['input'];
  isDurationFilterHidden: Scalars['Boolean']['input'];
  isLanguageFilterHidden: Scalars['Boolean']['input'];
  isLevelFilterHidden: Scalars['Boolean']['input'];
  isSportFilterHidden: Scalars['Boolean']['input'];
  isTeacherFilterHidden: Scalars['Boolean']['input'];
  isVenueFilterHidden: Scalars['Boolean']['input'];
}>;


export type SaveUpdateCompanyWidgetVideosMutation = { updateCompanyWidgetVideos: { __typename: 'CompanyWidgetVideos', id: string, name: string, colorBackground: string | undefined, colorBackgroundCard: string | undefined, colorButton: string | undefined, colorFont: string | undefined, colorFontCard: string | undefined, colorHeading: string | undefined, fontFamily: string | undefined, isMyVideosLinkVisible: boolean, defaultLanguages: Array<RecordingSupportedLanguage>, defaultLevels: Array<RecordingDifficultyLevel>, isDurationFilterHidden: boolean, isLanguageFilterHidden: boolean, isLevelFilterHidden: boolean, isSportFilterHidden: boolean, isTeacherFilterHidden: boolean, isVenueFilterHidden: boolean, recordingCategories: { __typename: 'RecordingCategoryConnection', nodes: Array<{ __typename: 'RecordingCategory', id: string, name: string, venue: { __typename: 'Venue', id: string, name: string } }> }, defaultVenues: { __typename: 'VenueConnection', nodes: Array<{ __typename: 'Venue', id: string }> } } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', id: string, message: string }> } };

export type VouchersVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type VouchersVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, widgetBrandSettings: { __typename: 'CompanyWidgetBrandSettings', backgroundColor: string, cardBackgroundColor: string, cardTextColor: string, displayName: string | undefined, fontFamily: string | undefined, primaryColor: string, textColor: string } | undefined } } };

export type VouchersCompanyWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type VouchersCompanyWidgetQuery = { companyWidget: { __typename: 'CompanyWidgetActivities' } | { __typename: 'CompanyWidgetActivitySchedule' } | { __typename: 'CompanyWidgetNewsletter' } | { __typename: 'CompanyWidgetOverview' } | { __typename: 'CompanyWidgetPrices' } | { __typename: 'CompanyWidgetVideos' } | { __typename: 'CompanyWidgetVouchers', id: string, name: string, colorBackground: string | undefined, colorButton: string | undefined, colorFontCard: string | undefined, colorBackgroundCard: string | undefined, fontFamily: string | undefined, isOnlyWidgetOfThisType: boolean, invoicingVenueId: number, isDeletable: boolean, invoicingVenue: { __typename: 'Venue', id: string } } };

export type CreateCompanyWidgetVouchersMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  invoicingVenueId: Scalars['ID']['input'];
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBackgroundCard?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCompanyWidgetVouchersMutation = { createCompanyWidgetVouchers: { __typename: 'CompanyWidgetVouchers', id: string } | { __typename: 'ExpectedErrors' } };

export type UpdateCompanyWidgetVouchersMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  invoicingVenueId: Scalars['ID']['input'];
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBackgroundCard?: InputMaybe<Scalars['String']['input']>;
  colorButton?: InputMaybe<Scalars['String']['input']>;
  colorFontCard?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCompanyWidgetVouchersMutation = { updateCompanyWidgetVouchers: { __typename: 'CompanyWidgetVouchers', id: string } | { __typename: 'ExpectedErrors' } };

export type DeleteWidgetDeleteCompanyWidgetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWidgetDeleteCompanyWidgetMutation = { deleteCompanyWidget: boolean };

export type ImageUploadVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type ImageUploadVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string } };

export type WidgetOverviewActionAssignWidgetToOverviewMutationVariables = Exact<{
  widgetId: Scalars['ID']['input'];
}>;


export type WidgetOverviewActionAssignWidgetToOverviewMutation = { assignWidgetToOverview: { __typename: 'CompanyWidgetOverview', id: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } };

export type WidgetOverviewActionUnassignWidgetFromOverviewMutationVariables = Exact<{
  widgetId: Scalars['ID']['input'];
}>;


export type WidgetOverviewActionUnassignWidgetFromOverviewMutation = { unassignWidgetFromOverview: { __typename: 'CompanyWidgetOverview', id: string } | { __typename: 'ExpectedErrors', errors: Array<{ __typename: 'ExpectedError', message: string }> } };

export type UseCompanySportsPaginatedQueryVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UseCompanySportsPaginatedQueryVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, sports: { __typename: 'SportConnection', pageInfo: { __typename: 'PageInfo', startCursor: any | undefined, endCursor: any | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename: 'Sport', id: string, name: string }> } } } };

export type UseCompanyTeachersPaginatedQueryVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UseCompanyTeachersPaginatedQueryVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, teachers: { __typename: 'TeacherConnection', pageInfo: { __typename: 'PageInfo', startCursor: any | undefined, endCursor: any | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename: 'Teacher', id: string, name: string }> } } } };

export type UseDefaultSportsCompanyPaginatedQueryCompanyWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UseDefaultSportsCompanyPaginatedQueryCompanyWidgetQuery = { companyWidget: { __typename: 'CompanyWidgetActivities' } | { __typename: 'CompanyWidgetActivitySchedule' } | { __typename: 'CompanyWidgetNewsletter' } | { __typename: 'CompanyWidgetOverview' } | { __typename: 'CompanyWidgetPrices' } | { __typename: 'CompanyWidgetVideos', id: string, defaultSports: { __typename: 'SportConnection', nodes: Array<{ __typename: 'Sport', id: string, name: string }>, pageInfo: { __typename: 'PageInfo', startCursor: any | undefined, endCursor: any | undefined, hasNextPage: boolean, hasPreviousPage: boolean } } | undefined } | { __typename: 'CompanyWidgetVouchers' } };

export type UseDefaultTeachersCompanyPaginatedQueryCompanyWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UseDefaultTeachersCompanyPaginatedQueryCompanyWidgetQuery = { companyWidget: { __typename: 'CompanyWidgetActivities' } | { __typename: 'CompanyWidgetActivitySchedule' } | { __typename: 'CompanyWidgetNewsletter' } | { __typename: 'CompanyWidgetOverview' } | { __typename: 'CompanyWidgetPrices' } | { __typename: 'CompanyWidgetVideos', id: string, defaultTeachers: { __typename: 'TeacherConnection', nodes: Array<{ __typename: 'Teacher', id: string, name: string }>, pageInfo: { __typename: 'PageInfo', startCursor: any | undefined, endCursor: any | undefined, hasNextPage: boolean, hasPreviousPage: boolean } } | undefined } | { __typename: 'CompanyWidgetVouchers' } };

export type WidgetCreateVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type WidgetCreateVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, venues: Array<{ __typename: 'Venue', id: string, name: string }> } } };

export type PublicAppointmentsQueryVariables = Exact<{
  requestId: Scalars['ID']['input'];
}>;


export type PublicAppointmentsQuery = { publicAppointments: Array<{ __typename: 'PublicAppointment', id: string, name: string, start: string, end: string, venue: { __typename: 'PublicVenue', id: string, shortId: string, name: string } }> };

export type VenueByIdQueryVariables = Exact<{
  venueId: Scalars['String']['input'];
}>;


export type VenueByIdQuery = { venue: { __typename: 'Venue', id: string, shortId: string } };

export type RequestFileUploadMutationVariables = Exact<{
  filename: Scalars['String']['input'];
  venueId: Scalars['String']['input'];
  fileType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestFileUploadMutation = { requestFileUpload: { __typename: 'FileUploadRequest', url: string, key: string, fields: Record<string, unknown> } };

export type ConfirmFileUploadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  venueId: Scalars['String']['input'];
  fileType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfirmFileUploadMutation = { confirmFileUpload: { __typename: 'File', id: string, filename: string, mimeType: string, path: string, url: { __typename: 'Document', url: string } | { __typename: 'Picture', xSmall: string } } };

export type AmplitudePageLoggerVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type AmplitudePageLoggerVenueByShortIdQuery = { me: { __typename: 'Me', id: string, isTrainer: boolean }, session: { __typename: 'Session', isAmplitudeTrackingEnabled: boolean } | undefined, venueByShortId: { __typename: 'Venue', id: string, viewerRole: Role | undefined } };

export type HubspotScriptMeQueryVariables = Exact<{ [key: string]: never; }>;


export type HubspotScriptMeQuery = { me: { __typename: 'Me', id: string, hubspotToken: string | undefined, firstname: string, lastname: string, email: string } };

export type MiddlewareSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type MiddlewareSessionQuery = { session: { __typename: 'Session', isLoggedIn: boolean, requiredAction: RequiredSessionAction | undefined, language: string | undefined, currentOrganization: { __typename: 'Organization', id: string, resources: Array<{ __typename: 'OrganizationResource', identifier: string }> } | undefined, mfa: { __typename: 'Mfa', verified: boolean } | undefined } | undefined };

export type DeleteSubstitutionMutationVariables = Exact<{
  substitutionId: Scalars['String']['input'];
}>;


export type DeleteSubstitutionMutation = { deleteSubstitution: { __typename: 'DeleteSubstitutionResult', success: boolean, errorType: DeleteSubstitutionErrorType | undefined } };

export type CheckAppointmentConflictsV2QueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  startTime: Scalars['DateTime']['input'];
  endTime: Scalars['DateTime']['input'];
  roomId?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  recurrenceSettings?: InputMaybe<UpdateRecurringAppointmentSettingsInput>;
  excludeAppointmentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckAppointmentConflictsV2Query = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string, conflictingAppointmentsV2: { __typename: 'AppointmentConflictResult', hasConflicts: boolean, conflicts: Array<{ __typename: 'ConflictDetail', conflictType: ConflictType, appointment: { __typename: 'Appointment', id: string, name: string, start: string, end: string, venue: { __typename: 'Venue', id: string, shortId: string, name: string } } }> } } } };

export type CustomerSearchQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
  searchTerm: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type CustomerSearchQuery = { venueByShortId: { __typename: 'Venue', id: string, customerSearch: { __typename: 'CustomerSearchResultConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: any | undefined, endCursor: any | undefined }, nodes: Array<{ __typename: 'CustomerSearchResult', matchedField: CustomerSearchField, customer: { __typename: 'Customer', id: string, firstname: string | undefined, lastname: string | undefined, email: string | undefined, phoneNumber: string | undefined, customerNumber: string | undefined, communicationSettings: { __typename: 'CustomerCommunicationSettings', hasTempEmail: boolean }, profilePicture: { __typename: 'Picture', small: string } | undefined } }> } } };

export type FriendReferralReportExportMeQueryVariables = Exact<{ [key: string]: never; }>;


export type FriendReferralReportExportMeQuery = { me: { __typename: 'Me', id: string, email: string, accessibleVenues: Array<{ __typename: 'Venue', id: string, shortId: string, viewerRole: Role | undefined, company: { __typename: 'Company', id: string } }> } };

export type FriendReferralReportExportVenueQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type FriendReferralReportExportVenueQuery = { venueByShortId: { __typename: 'Venue', id: string, company: { __typename: 'Company', id: string } } };

export type FriendReferralReportExportMutationVariables = Exact<{
  venueShortIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  timespans: Array<TimespanInput> | TimespanInput;
  exportType: ExportType;
  loggedInVenueShortId: Scalars['String']['input'];
}>;


export type FriendReferralReportExportMutation = { export: boolean };

export type HeaderVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type HeaderVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, viewerRole: Role | undefined, wallet: { __typename: 'Wallet', pspId: string } | undefined } };

export type UserMenuMeQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMenuMeQuery = { me: { __typename: 'Me', id: string, firstname: string, lastname: string, isTrainer: boolean, profilePicture: { __typename: 'Picture', small: string } | undefined }, session: { __typename: 'Session', mfa: { __typename: 'Mfa', verified: boolean } | undefined } | undefined };

export type UserMenuVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type UserMenuVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, viewerRole: Role | undefined, type: VenueType | undefined, venueExtensions: Array<{ __typename: 'VenueExtension', id: string, extension: { __typename: 'Extension', id: string, name: ExtensionName } }>, wallet: { __typename: 'Wallet', state: WalletVerificationState, pspId: string } | undefined, featurePreviews: Array<{ __typename: 'FeaturePreview', name: string }> } };

export type VenueSwitcherMeQueryVariables = Exact<{ [key: string]: never; }>;


export type VenueSwitcherMeQuery = { me: { __typename: 'Me', id: string, accessibleVenues: Array<{ __typename: 'Venue', id: string, name: string, shortId: string }> } };

export type VenueSwitcherVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type VenueSwitcherVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, name: string, shortId: string } };

export type NavigationMeQueryVariables = Exact<{ [key: string]: never; }>;


export type NavigationMeQuery = { me: { __typename: 'Me', id: string, isTrainer: boolean }, session: { __typename: 'Session', mfa: { __typename: 'Mfa', verified: boolean } | undefined } | undefined };

export type NavigationVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type NavigationVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, viewerRole: Role | undefined, type: VenueType | undefined, bookingRequestsCount: number, venueExtensions: Array<{ __typename: 'VenueExtension', id: string, extension: { __typename: 'Extension', id: string, name: ExtensionName } }>, wallet: { __typename: 'Wallet', state: WalletVerificationState, pspId: string } | undefined, featurePreviews: Array<{ __typename: 'FeaturePreview', name: string }> } };

export type FetchAllTagsQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchAllTagsQuery = { venueByShortId: { __typename: 'Venue', company: { __typename: 'Company', id: string, tags: { __typename: 'TagConnection', nodes: Array<{ __typename: 'Tag', id: string, name: string, color: string }> } } } };

export type VenueExtensionGuardVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type VenueExtensionGuardVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, type: VenueType | undefined, venueExtensions: Array<{ __typename: 'VenueExtension', id: string, extension: { __typename: 'Extension', id: string, name: ExtensionName } }> } };

export type ViewerRoleGuardVenueByShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type ViewerRoleGuardVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, viewerRole: Role | undefined, internalType: VenueInternalsType | undefined, company: { __typename: 'Company', city: { __typename: 'City', country: string } }, venueExtensions: Array<{ __typename: 'VenueExtension', id: string, extension: { __typename: 'Extension', id: string, name: ExtensionName } }> } };

export type FeaturePreviewsVenueByShortIdQueryVariables = Exact<{
  venueShortId: Scalars['String']['input'];
}>;


export type FeaturePreviewsVenueByShortIdQuery = { venueByShortId: { __typename: 'Venue', id: string, featurePreviews: Array<{ __typename: 'FeaturePreview', id: string, name: string }> } };


export const RecoverAccountAccessDocument = gql`
    mutation RecoverAccountAccess($recoveryCode: String!) {
  recoverMfa(recoveryCode: $recoveryCode) {
    ... on Session {
      __typename
      requiredAction
    }
  }
}
    `;
export const VerifyOtpTokenDocument = gql`
    mutation VerifyOTPToken($token: String!, $trustDevice: Boolean!) {
  verifyMfa(token: $token, trustDevice: $trustDevice) {
    ... on Session {
      __typename
      requiredAction
      mfa {
        verified
      }
    }
  }
}
    `;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: String!) {
  requestPasswordReset(email: $email)
}
    `;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    ... on Session {
      __typename
      mfa {
        verified
      }
      requiredAction
      requiresMfa
    }
  }
}
    `;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export const MaskeradeDocument = gql`
    mutation Maskerade($email: String!) {
  maskerade(email: $email) {
    ... on Session {
      __typename
    }
  }
}
    `;
export const PasswordResetDocument = gql`
    mutation PasswordReset($token: String!, $password: String!) {
  resetPassword(token: $token, password: $password)
}
    `;
export const ChangeOrganizationDocument = gql`
    mutation ChangeOrganization($resourceIdentifier: String!, $password: String!) {
  changeOrganization(resourceIdentifier: $resourceIdentifier, password: $password) {
    ... on Session {
      __typename
      isLoggedIn
    }
  }
}
    `;
export const SetupMfaSessionDocument = gql`
    query SetupMFASession {
  session {
    requiredAction
  }
}
    `;
export const SetupMfaDocument = gql`
    mutation SetupMFA {
  setupMfa {
    ... on Session {
      __typename
      requiredAction
      mfaSetup {
        secretUri
        recoveryCodes
      }
    }
  }
}
    `;
export const VerifyMfaTokenDocument = gql`
    mutation VerifyMFAToken($token: String!) {
  verifyMfa(token: $token) {
    ... on Session {
      __typename
      requiredAction
      mfa {
        verified
      }
    }
  }
}
    `;
export const VenueSwitcherDocument = gql`
    query VenueSwitcher {
  session {
    requiredAction
    accessibleResources {
      identifier
      name
      description
      image {
        id
        xSmall
      }
    }
  }
}
    `;
export const VenueLandingPageDocument = gql`
    query VenueLandingPage($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    shortId
    viewerRole
    venueExtensions {
      extension {
        id
        name
      }
    }
  }
}
    `;
export const VenueLandingPageSessionDocument = gql`
    query VenueLandingPageSession {
  session {
    requiredAction
    isLoggedIn
    currentOrganization {
      id
      resources {
        identifier
      }
    }
  }
}
    `;
export const SetOrganizationDocument = gql`
    mutation SetOrganization($resourceIdentifier: String!) {
  setOrganization(resourceIdentifier: $resourceIdentifier) {
    ... on Session {
      __typename
      isLoggedIn
    }
  }
}
    `;
export const GetAssignedFloorPlanDocument = gql`
    query GetAssignedFloorPlan($appointmentId: String!) {
  appointmentById(id: $appointmentId) {
    id
    name
    currentTeacher {
      id
      nickname
      profilePicture {
        id
        xSmall
      }
    }
    venue {
      id
      internalType
    }
    assignedFloorPlan {
      id
      name
      totalBookableSpotsCount
      assignedSpotsCount
      spots {
        ... on AssignedBookableSpot {
          __typename
          id
          x
          y
          label
          bookableIcon
          isAvailable
          isPriority
          customer {
            id
            firstname
            lastname
            profilePicture {
              id
              xSmall
            }
          }
        }
        ... on AssignedNonBookableSpot {
          __typename
          id
          x
          y
          label
          nonBookableIcon
        }
      }
    }
  }
}
    `;
export const CancelAppointmentDocument = gql`
    mutation CancelAppointment($appointmentId: String!, $showCancelledInCalendar: Boolean!, $cancellationMessage: String, $isParticipantNotificationEnabled: Boolean!) {
  cancelAppointment(
    appointmentId: $appointmentId
    showCancelledInCalendar: $showCancelledInCalendar
    cancellationMessage: $cancellationMessage
    isParticipantNotificationEnabled: $isParticipantNotificationEnabled
  ) {
    __typename
    ... on Appointment {
      id
      participants(first: 50, states: [Accepted, Pending, Cancelled]) {
        nodes {
          id
          firstname
          lastname
          email
          phoneNumber
          profilePicture {
            small
          }
        }
      }
    }
    ... on ExpectedErrors {
      errors {
        id
        path
        message
      }
    }
  }
}
    `;
export const PrivateSessionBannerVisibilityDocument = gql`
    query PrivateSessionBannerVisibility($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    bookablePrivateSessions: activities(
      first: 1
      types: [ACTIVITY_TYPE_PRIVATE]
      visibility: BOOKABLE
    ) {
      nodes {
        id
      }
    }
    company {
      id
      widgets(types: COMPANY_WIDGET_TYPE_ACTIVITIES) {
        __typename
        ... on CompanyWidgetActivities {
          id
          activityTypes
        }
      }
    }
  }
}
    `;
export const GetPrivateSessionsDocument = gql`
    query GetPrivateSessions($venueShortId: String!, $first: Int, $last: Int, $before: Cursor, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    internalType
    activities(
      isActive: true
      types: [ACTIVITY_TYPE_PRIVATE]
      first: $first
      after: $after
      last: $last
      before: $before
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
        defaultDuration
        visibility
        hasTeachersWithoutBookableAvailability
        activityGroup {
          id
          name
        }
        settings {
          bookingType
        }
        resources(types: [TRAINER], first: 50) {
          nodes {
            __typename
            ... on Teacher {
              id
              nickname
              availabilityStatus
              profilePicture {
                xSmall
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const SaveRoomSharingRuleDocument = gql`
    mutation SaveRoomSharingRule($roomId: ID!, $maxPrivateSessions: Int!, $maxPrivateSessionsWithGroup: Int) {
  saveRoomAvailabilityRule(
    roomId: $roomId
    maxPrivateSessions: $maxPrivateSessions
    maxPrivateSessionsWithGroup: $maxPrivateSessionsWithGroup
  ) {
    ... on RoomAvailabilityRule {
      maxPrivateSessions
      maxPrivateSessionsWithGroup
    }
  }
}
    `;
export const DeleteRoomSharingRuleDocument = gql`
    mutation DeleteRoomSharingRule($roomId: ID!) {
  deleteRoomAvailabilityRule(roomId: $roomId) {
    ... on RoomAvailabilityRule {
      id
    }
  }
}
    `;
export const PrivateSessionOffersUsingRoomDocument = gql`
    query PrivateSessionOffersUsingRoom($venueShortId: String!, $roomId: String!, $first: Int, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    activities(
      isActive: true
      types: [ACTIVITY_TYPE_PRIVATE]
      roomId: $roomId
      first: $first
      after: $after
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
        defaultDuration
      }
    }
  }
}
    `;
export const RoomsWithRulesDocument = gql`
    query RoomsWithRules($venueShortId: String!, $first: Int, $after: Cursor, $last: Int, $before: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    roomsWithAvailabilityRule(
      first: $first
      after: $after
      last: $last
      before: $before
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
        availabilityRule {
          id
          maxPrivateSessions
          maxPrivateSessionsWithGroup
        }
      }
    }
  }
}
    `;
export const PrivateSessionsEditMetaDataDocument = gql`
    query PrivateSessionsEditMetaData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
}
    `;
export const PrivateSessionsEditVenueDataDocument = gql`
    query PrivateSessionsEditVenueData($venueShortId: String!, $first: Int, $after: Cursor, $id: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    shortId
    internalType
    roomCount
    teacherCount
    sports {
      nodes {
        id
        name
      }
    }
    locations {
      nodes {
        id
        name
        street
        city
        zip
        detail
      }
    }
    activity(id: $id) {
      id
      name
      availabilitySchedule {
        id
        schedule {
          dayOfWeek
          timeSchedule {
            validFrom
            validUntil
          }
        }
      }
      defaultDuration
      internalType
      isActive
      isTemplate
      description
      visibility
      settings {
        bookingType
        isBookingRequestSelfManagingAllowed
        appointmentStartTime
        bufferTimeInMinutes
        paymentOption
        location {
          id
        }
      }
      maxParticipants
      registrationStart
      registrationStartUnit
      registrationEnd
      registrationEndUnit
      type
      sport {
        id
        name
      }
      activityGroup {
        id
        name
        color
      }
      cancelPeriod
      cancellationConditions
      cancelPeriodUnit
      participationValue
      products(first: $first, after: $after) {
        nodes {
          id
          participationRules {
            id
            activities(ids: [$id]) {
              id
            }
          }
        }
      }
      picture {
        id
        mimeType
        xSmall
        size
        name
      }
      resources(first: $first, after: $after) {
        nodes {
          __typename
          ... on Resource {
            id
            name
          }
          ... on Teacher {
            id
            nickname
          }
        }
      }
      roomSharingConfig {
        roomId
        isRoomSharingAllowed
      }
    }
    activityGroups(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
        color
      }
    }
  }
}
    `;
export const UpdatePrivateSessionOfferDocument = gql`
    mutation UpdatePrivateSessionOffer($activityId: String!, $locationId: String!, $name: String!, $sportId: String!, $activityGroupId: String!, $durationInMinutes: Int!, $maxParticipants: Int!, $roomIds: PaginationSelectionInput!, $teacherIds: PaginationSelectionInput!, $description: String!, $imageId: String!, $isTemplate: Boolean, $productIds: ProductPaginationSelectionInput!, $creditType: CreditType!, $creditsUsedPerAppointment: Int, $cancellationRule: CancellationRuleInput!, $visibility: ActivityVisibility!, $bookingType: ActivityBookingType!, $registrationStart: Int, $registrationStartUnit: ActivityTimespanUnit, $registrationEnd: Int, $registrationEndUnit: ActivityTimespanUnit, $appointmentStartTime: ActivityAppointmentStartTime!, $bufferTimeInMinutes: Int!, $paymentOption: ActivityPaymentOption, $isBookingRequestSelfManagingAllowed: Boolean, $schedule: [PrivateSessionAvailabilityScheduleDayInput!], $roomSharingConfig: [RoomSharingConfigInput!], $productParticipationRules: [ProductParticipationRuleInput!]) {
  updatePrivateSessionOffer(
    activityId: $activityId
    locationId: $locationId
    name: $name
    sportId: $sportId
    activityGroupId: $activityGroupId
    durationInMinutes: $durationInMinutes
    maxParticipants: $maxParticipants
    roomIds: $roomIds
    teacherIds: $teacherIds
    description: $description
    imageId: $imageId
    isTemplate: $isTemplate
    productIds: $productIds
    creditType: $creditType
    creditsUsedPerAppointment: $creditsUsedPerAppointment
    cancellationRule: $cancellationRule
    visibility: $visibility
    bookingType: $bookingType
    registrationStart: $registrationStart
    registrationStartUnit: $registrationStartUnit
    registrationEnd: $registrationEnd
    registrationEndUnit: $registrationEndUnit
    appointmentStartTime: $appointmentStartTime
    bufferTimeInMinutes: $bufferTimeInMinutes
    paymentOption: $paymentOption
    isBookingRequestSelfManagingAllowed: $isBookingRequestSelfManagingAllowed
    schedule: $schedule
    roomSharingConfig: $roomSharingConfig
    productParticipationRules: $productParticipationRules
  ) {
    ... on Activity {
      id
      type
      sport {
        id
        name
      }
      name
      description
      defaultDuration
      maxParticipants
      participationValue
      cancelPeriod
      cancelPeriodUnit
      cancellationConditions
      activityGroup {
        id
        name
        color
      }
      picture {
        id
        mimeType
        xSmall
        size
        name
      }
    }
    ... on ExpectedErrors {
      errors {
        id
        path
        message
      }
    }
  }
}
    `;
export const PrivateSessionsMetaDataDocument = gql`
    query PrivateSessionsMetaData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
}
    `;
export const PrivateSessionsCityDocument = gql`
    query PrivateSessionsCity($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
      city {
        id
        country
      }
    }
  }
}
    `;
export const PrivateSessionsTeachersDocument = gql`
    query PrivateSessionsTeachers($venueShortId: String!, $first: Int, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    teachers(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        nickname
      }
    }
  }
}
    `;
export const PrivateSessionsRoomsDocument = gql`
    query PrivateSessionsRooms($venueShortId: String!, $first: Int, $after: Cursor, $excludeRoomsWithRule: Boolean) {
  venueByShortId(shortId: $venueShortId) {
    id
    roomsV2(
      first: $first
      after: $after
      excludeRoomsWithRule: $excludeRoomsWithRule
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
        availabilityRule {
          maxPrivateSessions
          maxPrivateSessionsWithGroup
        }
      }
    }
  }
}
    `;
export const PrivateSessionsTeachersWithAvailabilityDocument = gql`
    query PrivateSessionsTeachersWithAvailability($venueShortId: String!, $first: Int, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    teachers(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        nickname
        availabilityStatus
        profilePicture {
          xSmall
        }
      }
    }
  }
}
    `;
export const PrivateSessionsProductGroupsDocument = gql`
    query PrivateSessionsProductGroups($venueShortId: String!, $first: Int, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
      productGroups(first: $first, after: $after) {
        nodes {
          id
          name
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const PrivateSessionOfferTemplatesDocument = gql`
    query PrivateSessionOfferTemplates($venueShortId: String!, $first: Int, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    shortId
    internalType
    sports {
      nodes {
        id
        name
      }
    }
    locations {
      nodes {
        id
        name
        street
        city
        zip
        detail
      }
    }
    activityGroups(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
        color
      }
    }
    privateSessionOfferTemplates(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
        defaultDuration
        maxParticipants
        description
        participationValue
        cancelPeriod
        cancelPeriodUnit
        cancellationConditions
        visibility
        registrationStart
        registrationStartUnit
        registrationEnd
        registrationEndUnit
        availabilitySchedule {
          id
          schedule {
            dayOfWeek
            timeSchedule {
              validFrom
              validUntil
            }
          }
        }
        settings {
          bookingType
          isBookingRequestSelfManagingAllowed
          appointmentStartTime
          bufferTimeInMinutes
          paymentOption
          location {
            id
          }
        }
        sport {
          id
          name
        }
        activityGroup {
          id
          name
          color
        }
        picture {
          id
          mimeType
          xSmall
          size
          name
        }
        roomSharingConfig {
          roomId
          isRoomSharingAllowed
        }
        products(first: $first, after: $after) {
          nodes {
            id
            participationRules {
              id
              activities {
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const PrivateSessionOfferTemplateResourcesDocument = gql`
    query PrivateSessionOfferTemplateResources($venueShortId: String!, $activityId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    roomCount
    teacherCount
    activity(id: $activityId) {
      id
      resources {
        nodes {
          __typename
          ... on Resource {
            id
          }
          ... on Teacher {
            id
          }
        }
      }
    }
  }
}
    `;
export const DefaultPrivateSessionPaymentOptionDocument = gql`
    query DefaultPrivateSessionPaymentOption($venueId: String!) {
  defaultPrivateSessionPaymentOption(venueId: $venueId)
}
    `;
export const CreatePrivateSessionOfferDocument = gql`
    mutation CreatePrivateSessionOffer($venueId: String!, $locationId: String!, $name: String!, $sportId: String!, $activityGroupId: String!, $durationInMinutes: Int!, $maxParticipants: Int!, $roomIds: PaginationSelectionInput!, $teacherIds: PaginationSelectionInput!, $description: String!, $imageId: String!, $productIds: ProductPaginationSelectionInput!, $creditType: CreditType!, $creditsUsedPerAppointment: Int, $cancellationRule: CancellationRuleInput!, $isTemplate: Boolean, $visibility: ActivityVisibility!, $bookingType: ActivityBookingType!, $registrationStart: Int, $registrationStartUnit: ActivityTimespanUnit, $registrationEnd: Int, $registrationEndUnit: ActivityTimespanUnit, $appointmentStartTime: ActivityAppointmentStartTime!, $bufferTimeInMinutes: Int!, $paymentOption: ActivityPaymentOption, $isBookingRequestSelfManagingAllowed: Boolean, $schedule: [PrivateSessionAvailabilityScheduleDayInput!], $roomSharingConfig: [RoomSharingConfigInput!], $productParticipationRules: [ProductParticipationRuleInput!]) {
  createPrivateSessionOffer(
    venueId: $venueId
    locationId: $locationId
    name: $name
    sportId: $sportId
    activityGroupId: $activityGroupId
    durationInMinutes: $durationInMinutes
    maxParticipants: $maxParticipants
    roomIds: $roomIds
    teacherIds: $teacherIds
    description: $description
    imageId: $imageId
    productIds: $productIds
    creditType: $creditType
    creditsUsedPerAppointment: $creditsUsedPerAppointment
    cancellationRule: $cancellationRule
    isTemplate: $isTemplate
    visibility: $visibility
    bookingType: $bookingType
    registrationStart: $registrationStart
    registrationStartUnit: $registrationStartUnit
    registrationEnd: $registrationEnd
    registrationEndUnit: $registrationEndUnit
    appointmentStartTime: $appointmentStartTime
    bufferTimeInMinutes: $bufferTimeInMinutes
    paymentOption: $paymentOption
    isBookingRequestSelfManagingAllowed: $isBookingRequestSelfManagingAllowed
    schedule: $schedule
    roomSharingConfig: $roomSharingConfig
    productParticipationRules: $productParticipationRules
  ) {
    ... on Activity {
      id
      type
      sport {
        id
        name
      }
      name
    }
    ... on ExpectedErrors {
      errors {
        id
        path
        message
      }
    }
  }
}
    `;
export const ArchiveActivityDocument = gql`
    mutation ArchiveActivity($id: String!) {
  archiveActivity(id: $id) {
    ... on Activity {
      id
      name
    }
    ... on ExpectedErrors {
      errors {
        id
        path
        message
      }
    }
  }
}
    `;
export const CreateActivityGroupDocument = gql`
    mutation CreateActivityGroup($venueId: String!, $name: String!, $color: String!) {
  createActivityGroup(venueId: $venueId, name: $name, color: $color) {
    id
    name
    color
  }
}
    `;
export const BookingAvailabilityDocument = gql`
    query BookingAvailability($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    privateSessionSettings {
      defaultAvailabilitySchedule {
        id
        schedule {
          dayOfWeek
          timeSchedule {
            validUntil
            validFrom
          }
        }
      }
    }
    venueExtensions {
      id
      extension {
        name
      }
    }
  }
}
    `;
export const ProductsWithParticipationRulesDocument = gql`
    query ProductsWithParticipationRules($venueShortId: String!, $searchTerm: String, $productTypes: [ProductType!], $states: [ProductState!], $productGroups: [ProductGroupFilterInput!], $first: Int, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
      products(
        venueShortId: $venueShortId
        searchTerm: $searchTerm
        productTypes: $productTypes
        states: $states
        productGroups: $productGroups
        hasActivityBasedParticipationRules: true
        first: $first
        after: $after
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        nodes {
          id
          name
          state
          type
          productGroup
          participationRules {
            id
            name
            cycleUnit
            cycleValue
            maxPerCycle
          }
        }
      }
    }
  }
}
    `;
export const PrivateSessionsVenueDataDocument = gql`
    query PrivateSessionsVenueData($venueShortId: String!, $first: Int, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    activityGroups(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
        color
      }
    }
  }
}
    `;
export const GetPrivateSessionOffersForCreateDocument = gql`
    query GetPrivateSessionOffersForCreate($venueShortId: String!, $first: Int, $allowedTeacherIds: [String!]) {
  venueByShortId(shortId: $venueShortId) {
    id
    internalType
    activities(
      types: [ACTIVITY_TYPE_PRIVATE]
      isActive: true
      first: $first
      allowedTeacherIds: $allowedTeacherIds
    ) {
      nodes {
        id
        name
        defaultDuration
        maxParticipants
        settings {
          location {
            id
          }
        }
        activityGroup {
          id
          name
          color
        }
      }
    }
    locations(first: $first) {
      nodes {
        id
        name
        street
        city
        zip
        detail
      }
    }
  }
}
    `;
export const GetPrivateSessionsVenueByShortIdDocument = gql`
    query GetPrivateSessionsVenueByShortId($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    internalType
  }
}
    `;
export const GetPrivateSessionOfferResourcesDocument = gql`
    query GetPrivateSessionOfferResources($activityIds: [String!]!, $first: Int) {
  activities(ids: $activityIds) {
    id
    resources(first: $first) {
      nodes {
        __typename
        ... on Resource {
          id
          name
        }
        ... on Teacher {
          id
          nickname
          firstname
          lastname
          contactDetails {
            email
            phoneNumber
          }
          profilePicture {
            small
          }
        }
      }
    }
  }
}
    `;
export const CreatePrivateSessionDocument = gql`
    mutation CreatePrivateSession($locationId: String!, $privateSessionOfferId: String!, $resourceId: String, $startsAt: DateTime!, $teacherId: String, $internalNote: String, $participantCustomerIds: [String!]) {
  createPrivateSession(
    locationId: $locationId
    privateSessionOfferId: $privateSessionOfferId
    resourceId: $resourceId
    startsAt: $startsAt
    teacherId: $teacherId
    internalNote: $internalNote
    participantCustomerIds: $participantCustomerIds
  ) {
    ... on PrivateSession {
      id
      startsAt
    }
    ... on ExpectedErrors {
      errors {
        id
        message
        path
      }
    }
  }
}
    `;
export const GetPrivateSessionVenueSettingsDocument = gql`
    query GetPrivateSessionVenueSettings($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
    internalType
    viewerRole
    viewerTeacher {
      id
      active
    }
    schedulerSettings {
      id
      start
      end
      defaultView
    }
    privateSessionSettings {
      id
      isSelfManagingAllowed
      hasFullViewAccess
    }
    venueExtensions {
      extension {
        name
      }
    }
    bookingRequestsCount(status: [REQUESTED])
  }
}
    `;
export const GetPrivateSessionViewerContextDocument = gql`
    query GetPrivateSessionViewerContext($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    viewerRole
    viewerTeacher {
      id
    }
  }
}
    `;
export const GetPrivateSessionCalendarAppointmentsDocument = gql`
    query GetPrivateSessionCalendarAppointments($venueShortId: String!, $endDate: DateTime, $startDate: DateTime, $first: Int, $after: Cursor, $before: Cursor, $last: Int) {
  venueByShortId(shortId: $venueShortId) {
    id
    appointments(
      first: $first
      after: $after
      before: $before
      last: $last
      end: $endDate
      start: $startDate
      isActive: true
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
      nodes {
        id
        name
        start
        end
        isCancelled
        recurringSettings {
          id
        }
        room {
          id
          name
        }
        activity {
          id
          type
          internalType
          activityGroup {
            id
            color
          }
        }
        participants(first: 10) {
          nodes {
            id
            firstname
            lastname
          }
        }
        currentTeacher {
          id
          nickname
          firstname
          lastname
        }
      }
    }
  }
}
    `;
export const GetPrivateSessionAppointmentDetailDocument = gql`
    query GetPrivateSessionAppointmentDetail($appointmentId: String!) {
  appointmentById(id: $appointmentId) {
    id
    internalNote
    recurringSettings {
      id
      frequency
      recurrenceType
      interval
      daysOfWeek
      dayOfMonth
      seriesEndDate
      seriesEndOccurrenceCount
      recurrenceRule
      recurrenceExceptionDates
    }
    location {
      address
    }
    currentTeacher {
      profilePicture {
        small
      }
      contactDetails {
        email
        phoneNumber
      }
    }
    participants(first: 10) {
      nodes {
        id
        firstname
        lastname
        email
        phoneNumber
        profilePicture {
          small
        }
      }
    }
  }
}
    `;
export const GetPrivateSessionBookingRequestsDocument = gql`
    query GetPrivateSessionBookingRequests($venueShortId: String!, $endDate: DateTime, $startDate: DateTime, $first: Int, $after: Cursor, $before: Cursor, $last: Int) {
  venueByShortId(shortId: $venueShortId) {
    id
    bookingRequests(
      after: $after
      before: $before
      end: $endDate
      first: $first
      last: $last
      start: $startDate
      status: [REQUESTED]
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
      nodes {
        id
        name
        start
        end
        declineIndicator
        requestedAt
        requestedBy {
          id
          firstname
          lastname
          profilePicture {
            small
          }
          email
          phoneNumber
        }
        location {
          id
          address
        }
        resource {
          id
          name
        }
        suggestedResource {
          id
          name
        }
        activity {
          id
          roomCount: resourceCount(types: [ROOM])
          trainerCount: resourceCount(types: [TRAINER])
          defaultDuration
          activityGroup {
            id
            color
          }
        }
        teacher {
          id
          nickname
          firstname
          lastname
          contactDetails {
            email
            phoneNumber
          }
          profilePicture {
            small
          }
        }
        suggestedTeacher {
          id
          nickname
          firstname
          lastname
          contactDetails {
            email
            phoneNumber
          }
          profilePicture {
            small
          }
        }
      }
    }
  }
}
    `;
export const CreateRecurringAppointmentDocument = gql`
    mutation CreateRecurringAppointment($privateSessionOfferId: String!, $locationId: String!, $resourceId: String, $teacherId: String, $startsAt: DateTime!, $duration: Int!, $frequency: RecurringFrequency!, $interval: Int!, $seriesEndDate: DateTime, $occurrenceCount: Int, $daysOfWeek: [Int!], $dayOfMonth: Int, $internalNote: String, $participantCustomerIds: [String!]) {
  createRecurringAppointment(
    privateSessionOfferId: $privateSessionOfferId
    locationId: $locationId
    resourceId: $resourceId
    teacherId: $teacherId
    startsAt: $startsAt
    duration: $duration
    frequency: $frequency
    interval: $interval
    seriesEndDate: $seriesEndDate
    occurrenceCount: $occurrenceCount
    daysOfWeek: $daysOfWeek
    dayOfMonth: $dayOfMonth
    internalNote: $internalNote
    participantCustomerIds: $participantCustomerIds
  ) {
    ... on RecurringSettings {
      id
      frequency
      interval
      daysOfWeek
      dayOfMonth
      seriesEndDate
      actualOccurrenceCount
    }
    ... on ExpectedErrors {
      errors {
        id
        message
        path
      }
    }
  }
}
    `;
export const DeclineBookingRequestDocument = gql`
    mutation DeclineBookingRequest($bookingRequestId: ID!, $reason: String, $answeredAsAdmin: Boolean!) {
  declineBookingRequest(
    id: $bookingRequestId
    reason: $reason
    answeredAsAdmin: $answeredAsAdmin
  ) {
    ... on BookingRequest {
      id
    }
  }
}
    `;
export const GetBookingRequestByIdDocument = gql`
    query GetBookingRequestById($id: ID!) {
  bookingRequest(id: $id) {
    id
    name
    start
    end
    status
    internalNote
    teacher {
      id
      nickname
      firstname
      lastname
      contactDetails {
        email
        phoneNumber
      }
      profilePicture {
        small
      }
    }
    resource {
      id
      name
    }
    requestedBy {
      id
      firstname
      lastname
      email
      phoneNumber
      profilePicture {
        small
      }
    }
  }
}
    `;
export const GetBookingRequestStatusByIdDocument = gql`
    query GetBookingRequestStatusById($id: ID!) {
  bookingRequest(id: $id) {
    id
    status
  }
}
    `;
export const AcceptBookingRequestDocument = gql`
    mutation AcceptBookingRequest($id: ID!, $teacherId: ID, $roomId: ID, $start: DateTime, $answeredAsAdmin: Boolean!, $internalNote: String) {
  acceptBookingRequest(
    id: $id
    teacherId: $teacherId
    roomId: $roomId
    start: $start
    answeredAsAdmin: $answeredAsAdmin
    internalNote: $internalNote
  ) {
    __typename
    ... on BookingRequest {
      id
      status
    }
    ... on ExpectedErrors {
      errors {
        id
      }
    }
  }
}
    `;
export const GetPrivateSessionsForDragEventDocument = gql`
    query GetPrivateSessionsForDragEvent($venueShortId: String!, $endDate: DateTime!, $startDate: DateTime!, $teacherId: String, $roomId: String, $excludeAppointmentId: String) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
      conflictingAppointmentsV2(
        startTime: $startDate
        endTime: $endDate
        roomId: $roomId
        teacherId: $teacherId
        excludeAppointmentId: $excludeAppointmentId
      ) {
        hasConflicts
      }
    }
    appointments(first: 50, end: $endDate, start: $startDate, isActive: true) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
      nodes {
        id
        name
        start
        end
        participants(first: 10) {
          nodes {
            id
            firstname
            lastname
            phoneNumber
            profilePicture {
              small
            }
          }
        }
        currentTeacher {
          id
          nickname
          firstname
          lastname
          profilePicture {
            small
          }
          contactDetails {
            email
            phoneNumber
          }
        }
      }
    }
  }
}
    `;
export const GetViewerIdDocument = gql`
    query GetViewerId {
  me {
    id
  }
}
    `;
export const GetMyAvailabilitySettingsDocument = gql`
    query GetMyAvailabilitySettings($venueShortId: String!) {
  me {
    isEversportsAdmin
  }
  venueByShortId(shortId: $venueShortId) {
    id
    internalType
    viewerRole
    viewerTeacher {
      id
      active
    }
  }
}
    `;
export const GetDefaultTeacherAvailabilityDocument = gql`
    query GetDefaultTeacherAvailability($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
    }
    viewerTeacher {
      id
      nickname
      defaultAvailabilitySchedule {
        id
        schedule {
          dayOfWeek
          timeSchedule {
            validFrom
            validUntil
          }
        }
      }
    }
  }
}
    `;
export const GetTargetTeacherAvailabilityDocument = gql`
    query GetTargetTeacherAvailability($venueShortId: String!, $teacherUuids: [String!]!, $first: Int!) {
  venueByShortId(shortId: $venueShortId) {
    id
    internalType
    company {
      id
    }
    teachers(uuids: $teacherUuids, first: $first) {
      nodes {
        id
        nickname
        availabilityStatus
        profilePicture {
          xSmall
        }
        defaultAvailabilitySchedule {
          id
          schedule {
            dayOfWeek
            timeSchedule {
              validFrom
              validUntil
            }
          }
        }
      }
    }
  }
}
    `;
export const GetTeacherAppointmentDocument = gql`
    query GetTeacherAppointment($venueShortId: String!, $teacherIds: [String!]!, $start: DateTime!, $end: DateTime!) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
      appointmentsV2(
        venueShortId: $venueShortId
        trainerIds: $teacherIds
        start: $start
        end: $end
        isCancelled: false
        first: 1
      ) {
        nodes {
          id
        }
      }
    }
  }
}
    `;
export const UpdateDefaultTeacherAvailabilityDocument = gql`
    mutation UpdateDefaultTeacherAvailability($companyId: ID!, $trainerId: ID!, $schedule: [SavePrivateSessionAvailabilityScheduleDayArgs!]!) {
  saveDefaultTeacherAvailabilitySchedule(
    schedule: $schedule
    companyId: $companyId
    trainerId: $trainerId
  ) {
    ... on PrivateSessionAvailabilitySchedule {
      id
    }
  }
}
    `;
export const UpdateDefaultTeacherAvailabilitiesDocument = gql`
    mutation UpdateDefaultTeacherAvailabilities($companyId: ID!, $trainerIds: [ID!]!, $schedule: [SavePrivateSessionAvailabilityScheduleDayArgs!]!) {
  saveDefaultTeacherAvailabilitySchedules(
    schedule: $schedule
    companyId: $companyId
    trainerIds: $trainerIds
  ) {
    ... on PrivateSessionAvailabilityScheduleList {
      nodes {
        id
      }
    }
  }
}
    `;
export const DeleteDefaultTeacherAvailabilitiesDocument = gql`
    mutation DeleteDefaultTeacherAvailabilities($ids: [ID!]!) {
  deleteDefaultTeacherAvailabilitySchedules(ids: $ids)
}
    `;
export const GetTeacherAvailabilityExceptionsDocument = gql`
    query GetTeacherAvailabilityExceptions($venueShortId: String!, $isManualEntry: Boolean) {
  venueByShortId(shortId: $venueShortId) {
    id
    viewerTeacher {
      id
      daySpecificAvailability(first: 50, isManualEntry: $isManualEntry) {
        nodes {
          id
          type
          viewType
          dateFrom
          dateTo
          title
          calendarIntegrationId
          timeSlots {
            dayOfWeek
            validFrom
            validUntil
          }
          recurringSettings {
            dayOfMonth
            daysOfWeek
            frequency
            recurrenceType
            interval
            maxOccurrences
            untilDate
            recurrenceRule
            exceptionDates
          }
        }
      }
    }
  }
}
    `;
export const GetTargetTeacherAvailabilityExceptionsDocument = gql`
    query GetTargetTeacherAvailabilityExceptions($venueShortId: String!, $teacherUuid: String!, $isManualEntry: Boolean, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    teachers(uuid: $teacherUuid, first: 1) {
      nodes {
        id
        daySpecificAvailability(
          first: 50
          after: $after
          venueShortId: $venueShortId
          isManualEntry: $isManualEntry
        ) {
          pageInfo {
            hasNextPage
            endCursor
          }
          nodes {
            id
            type
            viewType
            dateFrom
            dateTo
            title
            calendarIntegrationId
            timeSlots {
              dayOfWeek
              validFrom
              validUntil
            }
            recurringSettings {
              dayOfMonth
              daysOfWeek
              frequency
              recurrenceType
              interval
              maxOccurrences
              untilDate
              recurrenceRule
              exceptionDates
            }
          }
        }
      }
    }
  }
}
    `;
export const SaveTeacherDaySpecificAvailabilityDocument = gql`
    mutation SaveTeacherDaySpecificAvailability($trainerId: ID!, $availability: [SaveTeacherDaySpecificAvailabilityEntryArgs!]!, $venueShortId: String) {
  saveTeacherDaySpecificAvailability(
    trainerId: $trainerId
    availability: $availability
    venueShortId: $venueShortId
  ) {
    __typename
    ... on TeacherDaySpecificAvailabilityList {
      nodes {
        id
      }
    }
  }
}
    `;
export const SaveTeacherDaySpecificAvailabilitiesDocument = gql`
    mutation SaveTeacherDaySpecificAvailabilities($entries: [SaveTeacherDaySpecificAvailabilityForTrainerInput!]!, $venueShortId: String) {
  saveTeacherDaySpecificAvailabilities(
    entries: $entries
    venueShortId: $venueShortId
  ) {
    __typename
    ... on TeacherDaySpecificAvailabilityByTrainerList {
      nodes {
        trainerId
        nodes {
          id
        }
      }
    }
  }
}
    `;
export const DeleteTeacherDaySpecificAvailabilityDocument = gql`
    mutation DeleteTeacherDaySpecificAvailability($id: ID!, $venueShortId: String) {
  deleteTeacherDaySpecificAvailability(id: $id, venueShortId: $venueShortId)
}
    `;
export const GetTeacherCalendarIntegrationsDocument = gql`
    query GetTeacherCalendarIntegrations($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    viewerTeacher {
      id
      calendarIntegrations {
        id
        name
        type
        lastSuccessfulSyncAt
        lastError
        lastWarning
      }
    }
  }
}
    `;
export const GetTargetTeacherCalendarIntegrationsDocument = gql`
    query GetTargetTeacherCalendarIntegrations($venueShortId: String!, $teacherUuid: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    teachers(uuid: $teacherUuid, first: 1) {
      nodes {
        id
        calendarIntegrations {
          id
          name
          type
          lastSuccessfulSyncAt
          lastAttemptedSyncAt
          lastFullSyncAt
          lastError
          lastWarning
        }
      }
    }
  }
}
    `;
export const CreateTeacherCalendarIntegrationDocument = gql`
    mutation CreateTeacherCalendarIntegration($url: URL!) {
  createTeacherCalendarIntegration(url: $url) {
    __typename
    ... on TeacherCalendarIntegration {
      id
      name
      type
      lastSuccessfulSyncAt
      lastError
      lastWarning
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export const SyncTeacherCalendarIntegrationDocument = gql`
    mutation SyncTeacherCalendarIntegration($id: ID!) {
  syncTeacherCalendarIntegration(id: $id) {
    __typename
    ... on TeacherCalendarIntegration {
      id
      name
      type
      lastSuccessfulSyncAt
      lastError
      lastWarning
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export const DeleteTeacherCalendarIntegrationDocument = gql`
    mutation DeleteTeacherCalendarIntegration($id: ID!) {
  deleteTeacherCalendarIntegration(id: $id)
}
    `;
export const CreateCustomerGroupsDocument = gql`
    query CreateCustomerGroups($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      customerGroups {
        id
        name
        color
        groupPresetType
      }
    }
  }
}
    `;
export const CreateCustomerTagsDocument = gql`
    query CreateCustomerTags($venueShortId: String!, $searchTerm: String, $first: Int, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
      tags(searchTerm: $searchTerm, first: $first, after: $after) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        nodes {
          id
          name
          color
        }
      }
    }
  }
}
    `;
export const PrivateSessionTeacherFilterOptionsDocument = gql`
    query PrivateSessionTeacherFilterOptions($venueShortId: String!, $first: Int, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    teachers(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        nickname
        profilePicture {
          xSmall
        }
      }
    }
  }
}
    `;
export const PrivateSessionsSheetAppointmentByIdDocument = gql`
    query PrivateSessionsSheetAppointmentById($appointmentId: String!) {
  appointmentById(id: $appointmentId) {
    id
    start
    end
    name
    internalNote
    location {
      id
    }
    room {
      id
      name
    }
    currentTeacher {
      id
      nickname
      firstname
      lastname
      profilePicture {
        small
      }
      contactDetails {
        email
        phoneNumber
      }
    }
    recurringSettings {
      dayOfMonth
      daysOfWeek
      frequency
      recurrenceType
      id
      interval
      seriesEndDate
      seriesEndOccurrenceCount
      recurrenceRule
      recurrenceExceptionDates
    }
    activity {
      id
      activityGroup {
        id
        color
      }
    }
    participants(first: 50) {
      nodes {
        id
        firstname
        lastname
        profilePicture {
          small
        }
      }
    }
  }
}
    `;
export const PrivateSessionsSheetRecurringChangeCountDocument = gql`
    query PrivateSessionsSheetRecurringChangeCount($appointmentId: String!, $recurrenceSettings: UpdateRecurringAppointmentSettingsInput, $startsAt: DateTime, $duration: Int) {
  updatePrivateSessionCount(
    appointmentId: $appointmentId
    startsAt: $startsAt
    duration: $duration
    recurrenceSettings: $recurrenceSettings
  ) {
    __typename
    ... on UpdatePrivateSessionCountResponse {
      cancelledCount
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export const PrivateSessionsSheetUpdatePrivateSessionDocument = gql`
    mutation PrivateSessionsSheetUpdatePrivateSession($appointmentId: String!, $duration: Int, $locationId: String, $recurrenceSettings: UpdateRecurringAppointmentSettingsInput, $resourceId: String, $startsAt: DateTime, $teacherId: String, $message: String, $isParticipantNotificationEnabled: Boolean, $internalNote: String, $participantCustomerIds: [String!]) {
  updatePrivateSession(
    appointmentId: $appointmentId
    duration: $duration
    locationId: $locationId
    recurrenceSettings: $recurrenceSettings
    resourceId: $resourceId
    startsAt: $startsAt
    teacherId: $teacherId
    updateSettings: {message: $message, isParticipantNotificationEnabled: $isParticipantNotificationEnabled}
    internalNote: $internalNote
    participantCustomerIds: $participantCustomerIds
  ) {
    __typename
    ... on ExpectedErrors {
      errors {
        message
      }
    }
    ... on UpdatePrivateSessionResult {
      privateSession {
        id
      }
      recurringSettings {
        id
      }
      notNotifiableParticipants {
        id
        firstname
        lastname
        phoneNumber
        profilePicture {
          small
        }
      }
    }
  }
}
    `;
export const CancelRecurringPrivateSessionDocument = gql`
    mutation CancelRecurringPrivateSession($recurringAppointmentId: String!, $appointmentId: String!, $showCancelledInCalendar: Boolean!, $cancellationMessage: String, $isParticipantNotificationEnabled: Boolean!) {
  cancelRecurringPrivateSession(
    recurringAppointmentId: $recurringAppointmentId
    appointmentId: $appointmentId
    showCancelledInCalendar: $showCancelledInCalendar
    cancellationMessage: $cancellationMessage
    isParticipantNotificationEnabled: $isParticipantNotificationEnabled
  ) {
    ... on CancelRecurringPrivateSessionResult {
      __typename
      cancelledAppointments {
        id
      }
      failedAppointmentIds
    }
    ... on ExpectedErrors {
      __typename
      errors {
        id
        path
        message
      }
    }
  }
}
    `;
export const HidePrivateSessionFromCalendarDocument = gql`
    mutation HidePrivateSessionFromCalendar($appointmentId: String!) {
  hidePrivateSessionFromCalendar(appointmentId: $appointmentId) {
    ... on Appointment {
      id
    }
    ... on ExpectedErrors {
      errors {
        id
        path
        message
      }
    }
  }
}
    `;
export const HideRecurringPrivateSessionFromCalendarDocument = gql`
    mutation HideRecurringPrivateSessionFromCalendar($recurringAppointmentId: String!, $appointmentId: String!) {
  hideRecurringPrivateSessionFromCalendar(
    recurringAppointmentId: $recurringAppointmentId
    appointmentId: $appointmentId
  ) {
    ... on HideRecurringPrivateSessionFromCalendarResult {
      hiddenAppointments {
        id
      }
      failedAppointmentIds
    }
    ... on ExpectedErrors {
      errors {
        id
        path
        message
      }
    }
  }
}
    `;
export const SubstitutionsMetaDataDocument = gql`
    query SubstitutionsMetaData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
}
    `;
export const GetAppointmentsForSubstitutionsDocument = gql`
    query GetAppointmentsForSubstitutions($venueShortId: String!, $first: Int, $last: Int, $before: Cursor, $after: Cursor, $start: DateTime!, $end: DateTime!) {
  venueByShortId(shortId: $venueShortId) {
    company {
      id
      appointmentsCountV2(
        venueShortId: $venueShortId
        start: $start
        end: $end
        isCancelled: false
      )
      appointmentsV2(
        venueShortId: $venueShortId
        first: $first
        after: $after
        start: $start
        end: $end
        last: $last
        before: $before
        isCancelled: false
      ) {
        nodes {
          end
          start
          id
          name
          venue {
            id
            name
          }
          currentTeacher {
            nickname
            profilePicture {
              small
            }
          }
        }
        pageInfo {
          hasNextPage
          startCursor
          endCursor
        }
      }
    }
  }
}
    `;
export const SubstitutionRequestAppointmentsDocument = gql`
    query SubstitutionRequestAppointments($requestId: String!, $venueShortId: String!) {
  substitutionRequestAppointments(
    substitutionRequestId: $requestId
    venueShortId: $venueShortId
  ) {
    __typename
    id
    name
    start
    end
    venue {
      __typename
      id
      shortId
      name
    }
    currentTeacher {
      nickname
      profilePicture {
        small
      }
    }
  }
}
    `;
export const CreateSubstitutionRequestDocument = gql`
    mutation CreateSubstitutionRequest($companyId: ID!, $venueShortId: String!, $selectedAppointmentIds: [String!], $deselectedAppointmentIds: [String!], $isSelectAllChecked: Boolean, $reason: String!, $start: DateTime!, $end: DateTime!) {
  createSubstitutionRequestV2(
    venueShortId: $venueShortId
    companyId: $companyId
    selectedAppointmentIds: $selectedAppointmentIds
    deselectedAppointmentIds: $deselectedAppointmentIds
    isSelectAllChecked: $isSelectAllChecked
    reason: $reason
    start: $start
    end: $end
    hasCancelledAppointments: false
  ) {
    id
  }
}
    `;
export const AcceptSubstitutionRequestDocument = gql`
    mutation AcceptSubstitutionRequest($substitutionRequestId: String!, $appointmentIds: [String!]!) {
  acceptSubstitutionRequest(
    substitutionRequestId: $substitutionRequestId
    appointmentIds: $appointmentIds
  ) {
    errorType
    success
    failedAppointments {
      appointmentId
      errorType
    }
    successfulAppointments {
      appointmentId
    }
  }
}
    `;
export const DeclineSubstitutionRequestDocument = gql`
    mutation DeclineSubstitutionRequest($substitutionRequestId: String!) {
  declineSubstitutionRequest(substitutionRequestId: $substitutionRequestId) {
    errorType
    success
    failedAppointments {
      appointmentId
      errorType
    }
    successfulAppointments {
      appointmentId
    }
  }
}
    `;
export const GetAppointmentsForSubstitutionsSummaryDocument = gql`
    query GetAppointmentsForSubstitutionsSummary($appointmentIds: [String!]!) {
  appointmentsPreview(appointmentIds: $appointmentIds) {
    id
    venue {
      name
      id
      shortId
    }
    name
    start
    end
  }
}
    `;
export const GetAppointmentsForSubstitutionsSummaryV2Document = gql`
    query GetAppointmentsForSubstitutionsSummaryV2($appointmentIds: [String!]!) {
  appointmentsPreview(appointmentIds: $appointmentIds) {
    id
    venue {
      name
      id
      shortId
    }
    location {
      id
      street
      detail
      zip
      city
    }
    name
    start
    end
  }
}
    `;
export const GetSubstitutionRequestDocument = gql`
    query GetSubstitutionRequest($substitutionRequestId: String!, $substitutionStatus: SubstitutionStatus, $venueShortId: String) {
  substitutionRequestAppointments(
    substitutionRequestId: $substitutionRequestId
    substitutionStatus: $substitutionStatus
    venueShortId: $venueShortId
  ) {
    id
    name
    start
    end
    venue {
      name
      id
    }
  }
}
    `;
export const SubstitutionRequestsMetaDataDocument = gql`
    query SubstitutionRequestsMetaData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
  me {
    firstname
  }
}
    `;
export const VenueDataDocument = gql`
    query VenueData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    viewerRole
    company {
      id
      venues {
        id
        name
        shortId
        viewerRole
      }
    }
  }
}
    `;
export const SubstitutionFilterTeachersDocument = gql`
    query SubstitutionFilterTeachers($venueShortId: String!, $venueIds: [String!]) {
  venueByShortId(shortId: $venueShortId) {
    company {
      id
      teachers(first: 50, venueIds: $venueIds) {
        nodes {
          id
          nickname
        }
      }
    }
  }
}
    `;
export const SubstitutionRequestsDocument = gql`
    query SubstitutionRequests($venueShortId: String!, $first: Int, $after: Cursor, $last: Int, $before: Cursor, $range: SubstitutionFilterRange, $sort: [String!], $status: SubstitutionStatus, $venueIds: [String!], $submittedForTeacherIds: [String!], $includeNoTeacherAssigned: Boolean, $skipOpenCount: Boolean!, $skipCompletedCount: Boolean!, $skipTotalCount: Boolean!) {
  venueByShortId(shortId: $venueShortId) {
    company {
      id
      openSubstitutionsCount: substitutionsCount(
        venueShortId: $venueShortId
        status: OPEN
        range: $range
        venueIds: $venueIds
        submittedForTeacherIds: $submittedForTeacherIds
        includeNoTeacherAssigned: $includeNoTeacherAssigned
      ) @skip(if: $skipOpenCount)
      completedSubstitutionsCount: substitutionsCount(
        venueShortId: $venueShortId
        status: COMPLETED
        range: $range
        venueIds: $venueIds
        submittedForTeacherIds: $submittedForTeacherIds
        includeNoTeacherAssigned: $includeNoTeacherAssigned
      ) @skip(if: $skipCompletedCount)
      totalSubstitutionCount: substitutionsCount(
        venueShortId: $venueShortId
        range: $range
        venueIds: $venueIds
        submittedForTeacherIds: $submittedForTeacherIds
        includeNoTeacherAssigned: $includeNoTeacherAssigned
      ) @skip(if: $skipTotalCount)
      substitutionsV2(
        venueShortId: $venueShortId
        first: $first
        after: $after
        last: $last
        before: $before
        range: $range
        sort: $sort
        status: $status
        venueIds: $venueIds
        submittedForTeacherIds: $submittedForTeacherIds
        includeNoTeacherAssigned: $includeNoTeacherAssigned
      ) {
        nodes {
          appointment {
            id
            name
            end
            start
            isCancelled
            activity {
              id
              internalType
            }
            venue {
              id
              name
              shortId
            }
          }
          createdAt
          createdBy {
            id
            nickname
            profilePicture {
              small
            }
          }
          declined {
            id
            nickname
            profilePicture {
              small
            }
          }
          id
          reason
          substitute {
            id
            nickname
            profilePicture {
              small
            }
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
      }
    }
  }
}
    `;
export const CreateSubstitutionRequestFromExistingDocument = gql`
    mutation CreateSubstitutionRequestFromExisting($venueShortId: String!, $selectedSubstitutionIds: [String!], $deselectedSubstitutionIds: [String!], $isSelectAllChecked: Boolean, $venueIds: [String!], $submittedForTeacherIds: [String!], $includeNoTeacherAssigned: Boolean) {
  createSubstitutionRequestFromExisting(
    venueShortId: $venueShortId
    selectedSubstitutionIds: $selectedSubstitutionIds
    deselectedSubstitutionIds: $deselectedSubstitutionIds
    isSelectAllChecked: $isSelectAllChecked
    venueIds: $venueIds
    submittedForTeacherIds: $submittedForTeacherIds
    includeNoTeacherAssigned: $includeNoTeacherAssigned
  ) {
    id
  }
}
    `;
export const AnalyticsVenueByShortIdDocument = gql`
    query AnalyticsVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    name
    type
    company {
      id
      isLtd
    }
  }
}
    `;
export const AnalyticsQuicksightAnalyticsDashboardsDocument = gql`
    query AnalyticsQuicksightAnalyticsDashboards($shortId: String!) {
  me {
    quicksightAnalyticsDashboards(shortId: $shortId) {
      id
      name
      description
      isDefault
      state
    }
  }
}
    `;
export const AnalyticsQuicksightAnalyticsDashboardDocument = gql`
    query AnalyticsQuicksightAnalyticsDashboard($dashboardId: String!) {
  quicksightAnalyticsDashboard(dashboardId: $dashboardId) {
    id
    name
    isDefault
    state
    description
  }
}
    `;
export const AnalyticsGenerateQuicksightAnalyticsEmbedUrlDocument = gql`
    mutation AnalyticsGenerateQuicksightAnalyticsEmbedUrl($venueShortId: String!, $dashboardId: String!) {
  generateQuicksightAnalyticsEmbedUrl(
    venueShortId: $venueShortId
    dashboardId: $dashboardId
  ) {
    __typename
    ... on GenerateQuicksightAnalyticsEmbedUrl {
      embedUrl
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export const AverageKpIsVenueByShortIdDocument = gql`
    query AverageKPIsVenueByShortId($shortId: String!, $analyzedVenueShortIds: [String!]!, $years: [Float!]!) {
  venueByShortId(shortId: $shortId) {
    id
    featurePreviews(enabled: true) {
      name
    }
    currency {
      code
    }
    company {
      id
      bookingCount(
        granularity: MONTHLY
        years: $years
        venueShortIds: $analyzedVenueShortIds
      ) {
        total {
          total
          year
        }
      }
      customerCount(
        granularity: MONTHLY
        years: $years
        venueShortIds: $analyzedVenueShortIds
      ) {
        total {
          total
          year
        }
      }
      revenue(
        granularity: MONTHLY
        years: $years
        venueShortIds: $analyzedVenueShortIds
      ) {
        total {
          total
          year
        }
      }
    }
  }
}
    `;
export const UtilizationKpiVenueByShortIdDocument = gql`
    query UtilizationKPIVenueByShortId($shortId: String!, $analyzedVenueShortIds: [String!]!, $years: [Float!]!) {
  venueByShortId(shortId: $shortId) {
    id
    company {
      id
      utilization(
        granularity: MONTHLY
        years: $years
        venueShortIds: $analyzedVenueShortIds
      ) {
        total {
          year
          maxParticipations
          participations
        }
      }
    }
  }
}
    `;
export const VenueSelectorMeDocument = gql`
    query VenueSelectorMe {
  me {
    id
    accessibleVenues {
      id
      shortId
      name
      viewerRole
      company {
        id
      }
    }
  }
}
    `;
export const YearlyBookingDevelopmentChartVenueByShortIdDocument = gql`
    query YearlyBookingDevelopmentChartVenueByShortId($shortId: String!, $analyzedVenueShortIds: [String!]!, $years: [Float!]!, $granularity: AnalyticsGranularity!, $bookingCountSegment: BookingCountSegment) {
  venueByShortId(shortId: $shortId) {
    id
    company {
      id
      bookingCount(
        granularity: $granularity
        years: $years
        venueShortIds: $analyzedVenueShortIds
        bookingCountSegment: $bookingCountSegment
      ) {
        total {
          total
          year
        }
        timespanValues {
          timespan {
            from
            until
          }
          value
        }
      }
    }
  }
}
    `;
export const YearlyBookingDevelopmentChartExportDocument = gql`
    mutation YearlyBookingDevelopmentChartExport($venueShortIds: [String!]!, $timespans: [TimespanInput!]!, $exportType: ExportType!, $loggedInVenueShortId: String!) {
  export(
    venueShortIds: $venueShortIds
    timespans: $timespans
    exportType: $exportType
    loggedInVenueShortId: $loggedInVenueShortId
  )
}
    `;
export const YearlyCustomerDevelopmentChartVenueByShortIdDocument = gql`
    query YearlyCustomerDevelopmentChartVenueByShortId($shortId: String!, $analyzedVenueShortIds: [String!]!, $years: [Float!]!, $granularity: AnalyticsGranularity!) {
  venueByShortId(shortId: $shortId) {
    id
    company {
      id
      customerCount(
        granularity: $granularity
        years: $years
        venueShortIds: $analyzedVenueShortIds
      ) {
        total {
          total
          year
        }
        timespanValues {
          timespan {
            from
            until
          }
          value
        }
      }
    }
  }
}
    `;
export const YearlyCustomerDevelopmentChartExportDocument = gql`
    mutation YearlyCustomerDevelopmentChartExport($venueShortIds: [String!]!, $timespans: [TimespanInput!]!, $exportType: ExportType!, $loggedInVenueShortId: String!) {
  export(
    venueShortIds: $venueShortIds
    timespans: $timespans
    exportType: $exportType
    loggedInVenueShortId: $loggedInVenueShortId
  )
}
    `;
export const YearlyMembershipDevelopmentChartVenueByShortIdDocument = gql`
    query YearlyMembershipDevelopmentChartVenueByShortId($shortId: String!, $analyzedVenueShortIds: [String!]!, $years: [Float!]!, $assignedMembershipSegment: AssignedMembershipSegment!, $granularity: AnalyticsGranularity!) {
  venueByShortId(shortId: $shortId) {
    id
    type
    company {
      id
      membershipCount(
        granularity: $granularity
        years: $years
        assignedMembershipSegment: $assignedMembershipSegment
        venueShortIds: $analyzedVenueShortIds
      ) {
        total {
          total
          year
        }
        timespanValues {
          timespan {
            from
            until
          }
          value
        }
      }
    }
  }
}
    `;
export const YearlyMembershipDevelopmentChartExportDocument = gql`
    mutation YearlyMembershipDevelopmentChartExport($venueShortIds: [String!]!, $timespans: [TimespanInput!]!, $exportType: ExportType!, $loggedInVenueShortId: String!) {
  export(
    venueShortIds: $venueShortIds
    timespans: $timespans
    exportType: $exportType
    loggedInVenueShortId: $loggedInVenueShortId
  )
}
    `;
export const YearlyRevenueChartVenueByShortIdDocument = gql`
    query YearlyRevenueChartVenueByShortId($shortId: String!, $analyzedVenueShortIds: [String!]!, $years: [Float!]!, $granularity: AnalyticsGranularity!, $revenueSegment: RevenueSegment!) {
  venueByShortId(shortId: $shortId) {
    id
    name
    currency {
      code
    }
    company {
      id
      revenue(
        granularity: $granularity
        years: $years
        venueShortIds: $analyzedVenueShortIds
        revenueSegment: $revenueSegment
      ) {
        total {
          total
          year
        }
        timespanValues {
          timespan {
            from
            until
          }
          value
        }
      }
    }
  }
}
    `;
export const YearlyRevenueChartExportDocument = gql`
    mutation YearlyRevenueChartExport($venueShortIds: [String!]!, $timespans: [TimespanInput!]!, $exportType: ExportType!, $loggedInVenueShortId: String!) {
  export(
    venueShortIds: $venueShortIds
    timespans: $timespans
    exportType: $exportType
    loggedInVenueShortId: $loggedInVenueShortId
  )
}
    `;
export const ActivityReportExportMeDocument = gql`
    query ActivityReportExportMe {
  me {
    id
    email
    accessibleVenues {
      id
      shortId
      viewerRole
      company {
        id
      }
    }
  }
}
    `;
export const ActivityReportExportVenueDocument = gql`
    query ActivityReportExportVenue($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
    }
  }
}
    `;
export const ActivityReportExportDocument = gql`
    mutation ActivityReportExport($venueShortIds: [String!]!, $timespans: [TimespanInput!]!, $exportType: ExportType!, $loggedInVenueShortId: String!) {
  export(
    venueShortIds: $venueShortIds
    timespans: $timespans
    exportType: $exportType
    loggedInVenueShortId: $loggedInVenueShortId
  )
}
    `;
export const CustomerReportExportMeDocument = gql`
    query CustomerReportExportMe {
  me {
    id
    email
    accessibleVenues {
      id
      shortId
      viewerRole
      company {
        id
      }
    }
  }
}
    `;
export const CustomerReportExportVenueDocument = gql`
    query CustomerReportExportVenue($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
    }
  }
}
    `;
export const CustomerReportExportDocument = gql`
    mutation CustomerReportExport($venueShortIds: [String!]!, $timespans: [TimespanInput!]!, $exportType: ExportType!, $loggedInVenueShortId: String!) {
  export(
    venueShortIds: $venueShortIds
    timespans: $timespans
    exportType: $exportType
    loggedInVenueShortId: $loggedInVenueShortId
  )
}
    `;
export const FinancialReportExportMeDocument = gql`
    query FinancialReportExportMe {
  me {
    id
    email
    accessibleVenues {
      id
      shortId
      viewerRole
      company {
        id
      }
    }
  }
}
    `;
export const FinancialReportExportVenueDocument = gql`
    query FinancialReportExportVenue($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
    }
  }
}
    `;
export const FinancialReportExportDocument = gql`
    mutation FinancialReportExport($venueShortIds: [String!]!, $timespans: [TimespanInput!]!, $exportType: ExportType!, $loggedInVenueShortId: String!) {
  export(
    venueShortIds: $venueShortIds
    timespans: $timespans
    exportType: $exportType
    loggedInVenueShortId: $loggedInVenueShortId
  )
}
    `;
export const ReportsVenueByShortIdDocument = gql`
    query ReportsVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    name
    viewerRole
    venueExtensions {
      id
      extension {
        id
        name
      }
    }
    activeEventSettings
  }
}
    `;
export const BillingCommunicationMetaDataDocument = gql`
    query BillingCommunicationMetaData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
}
    `;
export const BillingCommunicationVenueByShortIdDocument = gql`
    query BillingCommunicationVenueByShortId($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    venueExtensions {
      activationDate
      issuingVenue {
        id
        shortId
      }
      priceCap {
        value
      }
      extension {
        id
        name
      }
    }
    currency {
      code
    }
    company {
      id
      uniqueContactableCustomersCount
      viewerIsCompanyAdmin
      city {
        country
      }
    }
  }
}
    `;
export const ContractInformationMetaDataDocument = gql`
    query ContractInformationMetaData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
}
    `;
export const ContractInformationVenueByShortIdDocument = gql`
    query ContractInformationVenueByShortId($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
    contractInformation {
      contractStartDate
      contractEndDate
      paymentFrequency
      specialTerminationDate
      regularCancellationDeadline
      autoRenewalPeriodMonths
      nextContractEndDate
      specialCancellationPeriodMonths
      noticePeriodDays
      customMinValidUntil
    }
    company {
      id
      contractFileUrl
      viewerIsCompanyAdmin
      city {
        country
      }
    }
  }
}
    `;
export const PayoutVenueMetaDataDocument = gql`
    query PayoutVenueMetaData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
}
    `;
export const PayoutVenueByShortIdDocument = gql`
    query PayoutVenueByShortId($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
    company {
      id
      city {
        country
      }
    }
    currency {
      code
    }
    stripeConnectedAccount {
      canAcceptPayments
      canReceivePayouts
      isVerified
      bankAccount {
        id
        last4
        bankName
        accountHolder
      }
      balance {
        available {
          value
          currency
        }
        pending {
          value
          currency
        }
      }
      inTransit {
        value
        currency
      }
      persons {
        id
        firstName
        lastName
        roles
        title
        isVerified
      }
      payoutSettings {
        frequency
        executionDay
      }
    }
  }
}
    `;
export const FetchStripePayoutsDocument = gql`
    query FetchStripePayouts($venueShortId: String!, $first: Int, $after: Cursor, $last: Int, $before: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    stripePayouts(first: $first, after: $after, last: $last, before: $before) {
      nodes {
        id
        initiatedAt
        status
        type
        amount {
          value
          currency
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
    `;
export const FetchStripePayoutConfirmationDocument = gql`
    query FetchStripePayoutConfirmation($venueShortId: String!, $payoutId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    stripePayoutConfirmation(payoutId: $payoutId) {
      fileName
      pdfBase64
    }
  }
}
    `;
export const SetStripePayoutSettingsDocument = gql`
    mutation SetStripePayoutSettings($venueShortId: String!, $frequency: StripePayoutFrequency!, $executionDay: Int!) {
  setStripePayoutSettings(
    venueShortId: $venueShortId
    frequency: $frequency
    executionDay: $executionDay
  ) {
    frequency
    executionDay
  }
}
    `;
export const FetchInvoicesDocument = gql`
    query FetchInvoices($shortId: String!, $first: Int, $after: Cursor, $last: Int, $before: Cursor, $hasEInvoiceSubmission: Boolean) {
  venueByShortId(shortId: $shortId) {
    currency {
      code
    }
    invoices(
      first: $first
      after: $after
      last: $last
      before: $before
      hasEInvoiceSubmission: $hasEInvoiceSubmission
    ) {
      nodes {
        id
        numberFormatted
        issuedAt
        type
        amount
        recipient {
          name
        }
        eInvoiceSubmissions {
          status
        }
      }
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
}
    `;
export const TechnicalEventLogDocument = gql`
    query TechnicalEventLog($venueShortId: String!, $fromDate: DateTime!, $toDate: DateTime!, $first: Int, $after: Cursor, $last: Int, $before: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    technicalEventLogs(
      fromDate: $fromDate
      toDate: $toDate
      first: $first
      after: $after
      last: $last
      before: $before
    ) {
      nodes {
        id
        number
        code
        description
        invokedByUser {
          firstname
          lastname
        }
        createdAt
        information
        signature
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
}
    `;
export const VerifyTechnicalEventLogSignatureIntegrityDocument = gql`
    mutation VerifyTechnicalEventLogSignatureIntegrity($eventLogId: String!, $venueShortId: String!) {
  verifyTechnicalEventLogSignatureIntegrity(
    eventLogId: $eventLogId
    venueShortId: $venueShortId
  )
}
    `;
export const ExportTechnicalEventLogDocument = gql`
    mutation ExportTechnicalEventLog($venueShortId: String!, $fromDate: DateTime!, $toDate: DateTime!) {
  exportTechnicalEventLog(
    venueShortId: $venueShortId
    fromDate: $fromDate
    toDate: $toDate
  )
}
    `;
export const CourtCalendarSportsDocument = gql`
    query CourtCalendarSports($venueShortId: String!, $first: Int, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    sports(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
      }
    }
  }
}
    `;
export const CourtCalendarCourtsDocument = gql`
    query CourtCalendarCourts($venueShortId: String!, $first: Int, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    timeZone
    courts(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
        sport {
          id
          name
        }
        rentalRules {
          availability {
            id
            schedule {
              dayOfWeek
              openingHours {
                from
                until
              }
            }
          }
          price {
            id
            price {
              value
              currency {
                code
              }
            }
            tagPrices {
              tags {
                match
                items {
                  id
                  name
                }
              }
              price {
                value
                currency {
                  code
                }
              }
            }
            timeBoundRules {
              window {
                dates {
                  from
                  until
                }
                daysOfWeek
                time {
                  from
                  until
                }
              }
              price {
                value
                currency {
                  code
                }
              }
              tagPrices {
                tags {
                  match
                  items {
                    id
                    name
                  }
                }
                price {
                  value
                  currency {
                    code
                  }
                }
              }
            }
          }
          slot {
            id
            minDurationInMinutes
            maxDurationInMinutes
            minExtensionInMinutes
            startsOnInMinutes
            areGapsForbidden
          }
          eligibility {
            id
          }
          cancellation {
            id
          }
        }
      }
    }
  }
}
    `;
export const CreateReservationDocument = gql`
    mutation CreateReservation($courtId: ID!, $start: DateTime!, $end: DateTime!, $customerId: ID, $price: Int, $payment: ReservationPaymentInput) {
  createReservation(
    courtId: $courtId
    start: $start
    end: $end
    customerId: $customerId
    price: $price
    payment: $payment
  ) {
    __typename
    ... on Appointment {
      id
    }
    ... on RentalViolations {
      violations {
        aspect
        code
      }
    }
    ... on ExpectedErrors {
      errors {
        id
        message
        path
      }
    }
  }
}
    `;
export const ReservationCustomerTagsDocument = gql`
    query ReservationCustomerTags($customerId: String!) {
  customer(customerId: $customerId) {
    id
    tags(first: 50) {
      nodes {
        id
        name
      }
    }
  }
}
    `;
export const CourtCalendarReservationsDocument = gql`
    query CourtCalendarReservations($venueShortId: String!, $start: DateTime, $end: DateTime, $types: [ActivityType!], $first: Int, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    timeZone
    appointments(
      start: $start
      end: $end
      isActive: true
      types: $types
      first: $first
      after: $after
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        start
        end
        createdAt
        isCancelled
        activity {
          id
          name
        }
        room {
          id
          name
          description
        }
        location {
          id
          address
        }
        participations(first: 50) {
          nodes {
            id
            price {
              value
              currency {
                code
              }
            }
          }
        }
        participants(first: 10) {
          nodes {
            id
            firstname
            lastname
            profilePicture {
              small
            }
          }
        }
      }
    }
  }
}
    `;
export const CourtCalendarVenuePaymentOptionsDocument = gql`
    query CourtCalendarVenuePaymentOptions($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    paymentOptions {
      id
      name
    }
  }
}
    `;
export const GetCourtDocument = gql`
    query GetCourt($venueShortId: String!, $courtId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    court(id: $courtId) {
      id
      name
      description
      surface {
        id
        name
      }
      environment
      sport {
        id
        name
      }
      size {
        id
        name
      }
      rentalRules {
        availability {
          id
        }
        slot {
          id
        }
        price {
          id
        }
        eligibility {
          id
        }
        cancellation {
          id
        }
      }
    }
  }
}
    `;
export const CourtsVenueCurrencyDocument = gql`
    query CourtsVenueCurrency($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    currency {
      id
      symbol
    }
  }
}
    `;
export const CourtsVenueIdDocument = gql`
    query CourtsVenueId($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
  }
}
    `;
export const CourtsVenueOpeningHoursDocument = gql`
    query CourtsVenueOpeningHours($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    openingHours {
      weekdays
      start
      end
    }
  }
}
    `;
export const SaveCourtsDocument = gql`
    mutation SaveCourts($venueShortId: String!, $courts: [SaveCourtInput!]!, $availabilityRuleId: ID, $slotRuleId: ID, $priceRuleId: ID, $eligibilityRuleId: ID, $cancellationRuleId: ID) {
  saveCourts(
    venueShortId: $venueShortId
    courts: $courts
    availabilityRuleId: $availabilityRuleId
    slotRuleId: $slotRuleId
    priceRuleId: $priceRuleId
    eligibilityRuleId: $eligibilityRuleId
    cancellationRuleId: $cancellationRuleId
  ) {
    __typename
    ... on Courts {
      courts {
        id
        name
      }
    }
    ... on ExpectedErrors {
      errors {
        message
        path
      }
    }
  }
}
    `;
export const MakeCourtUnavailableDocument = gql`
    mutation MakeCourtUnavailable($id: String!) {
  makeCourtUnavailable(id: $id)
}
    `;
export const GetCourtsDocument = gql`
    query GetCourts($venueShortId: String!, $first: Int, $last: Int, $before: Cursor, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    courts(first: $first, after: $after, last: $last, before: $before) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
        surface {
          id
          name
        }
        environment
        sport {
          id
          name
        }
        size {
          id
          name
        }
        rentalRules {
          availability {
            id
          }
          price {
            id
          }
          slot {
            id
          }
          eligibility {
            id
          }
          cancellation {
            id
          }
        }
      }
    }
  }
}
    `;
export const GetVenueRentalRulesForNewCourtDocument = gql`
    query GetVenueRentalRulesForNewCourt($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    rentalRules {
      availability {
        id
        name
        schedule {
          dayOfWeek
          openingHours {
            from
            until
          }
        }
      }
      slot {
        id
        name
        minDurationInMinutes
        maxDurationInMinutes
        minExtensionInMinutes
        startsOnInMinutes
      }
      price {
        id
        name
        price {
          value
          currency {
            code
          }
        }
        tagPrices {
          price {
            value
          }
        }
        timeBoundRules {
          label
          tagPrices {
            price {
              value
            }
          }
        }
      }
      eligibility {
        id
        name
        audience
        registration {
          start {
            value
            unit
          }
          end {
            value
            unit
          }
        }
      }
      cancellation {
        id
        name
        hoursBeforeStart
      }
    }
  }
}
    `;
export const GetVenueSportsDocument = gql`
    query GetVenueSports($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
      sports {
        nodes {
          id
          name
          courtSizes {
            id
            name
          }
          courtSurfaces {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const ArchiveRentalRuleDocument = gql`
    mutation ArchiveRentalRule($venueId: ID!, $id: ID!, $aspect: RentalRuleType!) {
  archiveRentalRule(venueId: $venueId, id: $id, aspect: $aspect) {
    __typename
    ... on ArchivedRentalRule {
      id
      name
      aspect
    }
    ... on ExpectedErrors {
      errors {
        message
        path
      }
    }
  }
}
    `;
export const GetVenueRentalRulesDocument = gql`
    query GetVenueRentalRules($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    timeZone
    rentalRules {
      availability {
        id
        name
        assignedCourts {
          id
        }
        updatedAt
        schedule {
          dayOfWeek
          openingHours {
            from
            until
          }
        }
      }
      slot {
        id
        name
        assignedCourts {
          id
        }
        updatedAt
        minDurationInMinutes
        maxDurationInMinutes
        minExtensionInMinutes
        startsOnInMinutes
        areGapsForbidden
      }
      price {
        id
        name
        assignedCourts {
          id
        }
        updatedAt
        price {
          value
          currency {
            symbol
          }
        }
        tagPrices {
          price {
            value
          }
          tags {
            match
            items {
              id
            }
          }
        }
        timeBoundRules {
          label
          price {
            value
          }
          tagPrices {
            price {
              value
            }
            tags {
              match
              items {
                id
              }
            }
          }
          window {
            dates {
              from
              until
            }
            daysOfWeek
            time {
              from
              until
            }
          }
        }
      }
      eligibility {
        id
        name
        assignedCourts {
          id
        }
        updatedAt
        audience
        registration {
          start {
            value
            unit
          }
          end {
            value
            unit
          }
        }
        conditions {
          match
          tags {
            id
            name
          }
        }
      }
      cancellation {
        id
        name
        assignedCourts {
          id
        }
        updatedAt
        hoursBeforeStart
      }
    }
  }
}
    `;
export const SaveAvailabilityRuleDocument = gql`
    mutation SaveAvailabilityRule($id: ID, $venueId: ID!, $name: String!, $schedule: [AvailabilityRuleScheduleEntryInput!]!) {
  saveAvailabilityRule(
    id: $id
    venueId: $venueId
    name: $name
    schedule: $schedule
  ) {
    __typename
    ... on AvailabilityRule {
      id
      name
    }
    ... on ExpectedErrors {
      errors {
        message
        path
      }
    }
  }
}
    `;
export const SaveEligibilityRuleDocument = gql`
    mutation SaveEligibilityRule($id: ID, $venueId: ID!, $name: String!, $audience: EligibilityRuleAudience!, $registration: EligibilityRuleRegistrationInput) {
  saveEligibilityRule(
    id: $id
    venueId: $venueId
    name: $name
    audience: $audience
    registration: $registration
  ) {
    __typename
    ... on EligibilityRule {
      id
      name
    }
    ... on ExpectedErrors {
      errors {
        message
        path
      }
    }
  }
}
    `;
export const SavePriceRuleDocument = gql`
    mutation SavePriceRule($id: ID, $venueId: ID!, $name: String!, $value: Int!, $tagPrices: [PriceRuleTagPriceInput!], $timeBoundRules: [PriceRuleTimeBoundRuleInput!]) {
  savePriceRule(
    id: $id
    venueId: $venueId
    name: $name
    value: $value
    tagPrices: $tagPrices
    timeBoundRules: $timeBoundRules
  ) {
    __typename
    ... on PriceRule {
      id
      name
    }
    ... on ExpectedErrors {
      errors {
        message
        path
      }
    }
  }
}
    `;
export const SaveCancellationRuleDocument = gql`
    mutation SaveCancellationRule($id: ID, $venueId: ID!, $name: String!, $hoursBeforeStart: Int!) {
  saveCancellationRule(
    id: $id
    venueId: $venueId
    name: $name
    hoursBeforeStart: $hoursBeforeStart
  ) {
    __typename
    ... on CancellationRule {
      id
      name
    }
    ... on ExpectedErrors {
      errors {
        message
        path
      }
    }
  }
}
    `;
export const SaveSlotRuleDocument = gql`
    mutation SaveSlotRule($id: ID, $venueId: ID!, $name: String!, $minDurationInMinutes: Int!, $maxDurationInMinutes: Int!, $minExtensionInMinutes: Int!, $startsOnInMinutes: Int!, $areGapsForbidden: Boolean!) {
  saveSlotRule(
    id: $id
    venueId: $venueId
    name: $name
    minDurationInMinutes: $minDurationInMinutes
    maxDurationInMinutes: $maxDurationInMinutes
    minExtensionInMinutes: $minExtensionInMinutes
    startsOnInMinutes: $startsOnInMinutes
    areGapsForbidden: $areGapsForbidden
  ) {
    __typename
    ... on SlotRule {
      id
      name
    }
    ... on ExpectedErrors {
      errors {
        message
        path
      }
    }
  }
}
    `;
export const AddPhoneCallDocument = gql`
    mutation AddPhoneCall($createdAt: DateTime!, $html: String!, $customerId: ID!, $unreachable: Boolean!) {
  addPhoneCall(
    createdAt: $createdAt
    html: $html
    customerId: $customerId
    unreachable: $unreachable
  ) {
    __typename
    id
  }
}
    `;
export const AddNoteDocument = gql`
    mutation AddNote($createdAt: DateTime!, $html: String!, $customerId: ID!) {
  addNote(createdAt: $createdAt, html: $html, customerId: $customerId) {
    __typename
    id
  }
}
    `;
export const CommunicationHistoryDocument = gql`
    query CommunicationHistory($customerId: String!, $communicationsPageSize: Int! = 20, $communicationsAfterCursor: Cursor = null) {
  customer(customerId: $customerId) {
    id
    firstname
    communications(
      first: $communicationsPageSize
      after: $communicationsAfterCursor
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ... on Note {
            __typename
            id
            createdAt
            createdBy {
              firstname
              lastname
            }
            updatedAt
            html
          }
          ... on PhoneCall {
            __typename
            id
            createdAt
            createdBy {
              firstname
              lastname
            }
            updatedAt
            html
            unreachable
          }
          ... on Email {
            __typename
            id
            createdAt
            subject
            deliveryStatus
            deliveryEvents {
              timestamp
              type
            }
            lastDeliveryError
            html
            executedBy {
              firstname
              lastname
            }
          }
        }
      }
    }
  }
}
    `;
export const CustomerProfileHeaderDocument = gql`
    query CustomerProfileHeader($customerId: String!) {
  customer(customerId: $customerId) {
    id
    firstname
    lastname
    email
    profilePicture {
      small
    }
    phoneNumber
    lastParticipatedAt
    totalParticipationCount
  }
}
    `;
export const RemovePhoneCallDocument = gql`
    mutation RemovePhoneCall($id: ID!) {
  removePhoneCall(id: $id)
}
    `;
export const RemoveNoteDocument = gql`
    mutation RemoveNote($id: ID!) {
  removeNote(id: $id)
}
    `;
export const CreateTagDocument = gql`
    mutation CreateTag($color: String!, $name: String!, $companyId: String!, $description: String) {
  createTag(
    color: $color
    name: $name
    companyId: $companyId
    description: $description
  ) {
    id
    name
  }
}
    `;
export const GetTagsDocument = gql`
    query GetTags($venueShortId: String!, $searchTerm: String) {
  venueByShortId(shortId: $venueShortId) {
    company {
      id
      tags(first: 10, searchTerm: $searchTerm) {
        nodes {
          id
          name
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const DeleteTagDocument = gql`
    mutation DeleteTag($id: ID!, $companyId: String!) {
  deleteTag(id: $id, companyId: $companyId) {
    result
  }
}
    `;
export const UpdateTagDocument = gql`
    mutation UpdateTag($id: ID!, $name: String!, $color: String!, $description: String, $companyId: String!) {
  updateTag(
    id: $id
    name: $name
    color: $color
    description: $description
    companyId: $companyId
  ) {
    id
    name
    color
    description
    customerCount
  }
}
    `;
export const FetchTagsDocument = gql`
    query FetchTags($shortId: String!, $first: Int, $after: Cursor, $last: Int, $before: Cursor, $searchTerm: String) {
  venueByShortId(shortId: $shortId) {
    company {
      id
      tagsCount
      tags(
        first: $first
        after: $after
        last: $last
        before: $before
        searchTerm: $searchTerm
      ) {
        nodes {
          id
          name
          description
          color
          customerCount
        }
        pageInfo {
          hasNextPage
          startCursor
          endCursor
        }
      }
    }
  }
}
    `;
export const TagsMetaDataDocument = gql`
    query TagsMetaData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
}
    `;
export const UseCommunicationExtensionHelperDocument = gql`
    query UseCommunicationExtensionHelper($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    currency {
      code
    }
    venueExtensions {
      activationDate
      priceCap {
        value
        currency
      }
      issuingVenue {
        id
        shortId
      }
      extension {
        id
        name
      }
    }
  }
}
    `;
export const AutomationIdMetaDataDocument = gql`
    query AutomationIdMetaData($venueShortId: String!, $automationId: ID!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
  autoCommunication(id: $automationId) {
    id
    name
  }
}
    `;
export const AutomationIdPageDocument = gql`
    query AutomationIdPage($venueShortId: String!, $automationId: ID!) {
  venueByShortId(shortId: $venueShortId) {
    id
    type
    bookingSetting {
      notificationReplyTo
    }
  }
  autoCommunication(id: $automationId) {
    id
    name
    state
    description
    trigger
    audience
    content
    scheduleAt
    recipientsCount
  }
}
    `;
export const AutomationsListMetaDataDocument = gql`
    query AutomationsListMetaData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
}
    `;
export const AutomationsListPageDocument = gql`
    query AutomationsListPage($venueShortId: String!, $first: Int, $last: Int, $before: Cursor, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    timeZone
    company {
      autoCommunicationsCount {
        active
        archived
        draft
        inactive
      }
      autoCommunications(first: $first, after: $after, last: $last, before: $before) {
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
        nodes {
          id
          name
          description
          state
        }
      }
    }
  }
}
    `;
export const AppliedFiltersDataDocument = gql`
    query AppliedFiltersData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      aggregators {
        id
        name
      }
      customerGroups {
        id
        name
      }
      tags(first: 50) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const AppliedFiltersProductsDocument = gql`
    query AppliedFiltersProducts($productIds: [String!]!) {
  products(ids: $productIds) {
    id
    name
  }
}
    `;
export const AppliedFiltersActivitiesDocument = gql`
    query AppliedFiltersActivities($activityIds: [String!]!) {
  activities(ids: $activityIds) {
    id
    name
  }
}
    `;
export const AutomationActivityVisitTriggerActivitiesDocument = gql`
    query AutomationActivityVisitTriggerActivities($activityIds: [String!]!) {
  activities(ids: $activityIds) {
    id
    name
  }
}
    `;
export const AutomationPurchaseTriggerProductsDocument = gql`
    query AutomationPurchaseTriggerProducts($productIds: [String!]!) {
  products(ids: $productIds) {
    id
    name
  }
}
    `;
export const CurrentAudienceCountDocument = gql`
    query CurrentAudienceCount($venueShortId: String!, $filters: String) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      customersV3Count(filters: $filters)
    }
  }
}
    `;
export const AutomationContentActivityDocument = gql`
    query AutomationContentActivity($activityId: String!) {
  activities(ids: [$activityId]) {
    id
    name
    description
  }
}
    `;
export const SoftDeleteAutomationOptionDocument = gql`
    mutation SoftDeleteAutomationOption($automationId: ID!) {
  softDeleteAutoCommunication(id: $automationId)
}
    `;
export const DuplicateAutomationOptionDocument = gql`
    mutation DuplicateAutomationOption($id: ID!) {
  duplicateAutoCommunication(id: $id) {
    ... on AutoCommunication {
      id
    }
    ... on ExpectedErrors {
      errors {
        ... on ExpectedError {
          message
        }
      }
    }
  }
}
    `;
export const SaveAutomationDocument = gql`
    mutation SaveAutomation($audience: String, $content: String, $description: String, $id: ID, $name: String!, $trigger: String, $scheduleAt: String, $venueId: ID!) {
  saveAutoCommunication(
    id: $id
    name: $name
    description: $description
    trigger: $trigger
    scheduleAt: $scheduleAt
    audience: $audience
    content: $content
    venueId: $venueId
  ) {
    ... on AutoCommunication {
      __typename
      id
      state
      name
      description
      trigger
      scheduleAt
      audience
      content
    }
    ... on ExpectedErrors {
      errors {
        id
        message
        path
      }
    }
  }
}
    `;
export const ActivateAutomationDocument = gql`
    mutation ActivateAutomation($automationId: ID!) {
  activateAutoCommunication(id: $automationId) {
    ... on AutoCommunication {
      __typename
      id
      state
    }
    ... on ExpectedErrors {
      errors {
        id
        message
        path
      }
    }
  }
}
    `;
export const DeactivateAutomationDocument = gql`
    mutation DeactivateAutomation($automationId: ID!) {
  deactivateAutoCommunication(id: $automationId) {
    ... on AutoCommunication {
      __typename
      id
      state
    }
    ... on ExpectedErrors {
      errors {
        id
        message
        path
      }
    }
  }
}
    `;
export const DuplicateAutomationDocument = gql`
    mutation DuplicateAutomation($id: ID!) {
  duplicateAutoCommunication(id: $id) {
    ... on AutoCommunication {
      __typename
      id
    }
    ... on ExpectedErrors {
      errors {
        id
        message
        path
      }
    }
  }
}
    `;
export const SoftDeleteAutomationDocument = gql`
    mutation SoftDeleteAutomation($automationId: ID!) {
  softDeleteAutoCommunication(id: $automationId)
}
    `;
export const AutomationNewMetaDataDocument = gql`
    query AutomationNewMetaData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
}
    `;
export const AutomationNewPageDocument = gql`
    query AutomationNewPage($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    type
    bookingSetting {
      notificationReplyTo
    }
  }
}
    `;
export const CommunicationEmailBodyDocument = gql`
    query CommunicationEmailBody($emailCampaignId: ID!) {
  emailCampaign(id: $emailCampaignId) {
    id
    body
    editorType
  }
}
    `;
export const CommunicationSubjectDocument = gql`
    query CommunicationSubject($emailCampaignId: ID!) {
  emailCampaign(id: $emailCampaignId) {
    id
    subject
  }
}
    `;
export const CommunicationOverviewMetaDataDocument = gql`
    query CommunicationOverviewMetaData($venueShortId: String!, $emailCampaignId: ID!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
  emailCampaign(id: $emailCampaignId) {
    id
    subject
  }
}
    `;
export const CommunicationProductsDocument = gql`
    query CommunicationProducts($productIds: [String!]!) {
  products(ids: $productIds) {
    id
    name
  }
}
    `;
export const CommunicationActivitiesDocument = gql`
    query CommunicationActivities($activityIds: [String!]!) {
  activities(ids: $activityIds) {
    id
    name
  }
}
    `;
export const CommunicationBaseDataDocument = gql`
    query CommunicationBaseData($emailCampaignId: ID!, $venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    timeZone
    company {
      id
      aggregators {
        id
        name
      }
      customerGroups {
        id
        name
      }
      tags(first: 50) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
  emailCampaign(id: $emailCampaignId) {
    replyTo {
      address
    }
    recipientCount
    sentAt
    state
    from {
      address
    }
    sendingGroup {
      totalEmails
      sentCount
      deliveredCount
      bouncedCount
      openedCount
      clickedCount
      unsubscribedCount
    }
    filters
  }
}
    `;
export const CommunicationIdMetaDataDocument = gql`
    query CommunicationIdMetaData($venueShortId: String!, $emailCampaignId: ID!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
  emailCampaign(id: $emailCampaignId) {
    id
    subject
  }
}
    `;
export const CommunicationIdCustomersCountDocument = gql`
    query CommunicationIdCustomersCount($venueShortId: String!, $filters: String) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      customersV3Count(filters: $filters)
    }
  }
}
    `;
export const CommunicationIdProductsDocument = gql`
    query CommunicationIdProducts($productIds: [String!]!) {
  products(ids: $productIds) {
    id
    name
  }
}
    `;
export const CommunicationIdActivitiesDocument = gql`
    query CommunicationIdActivities($activityIds: [String!]!) {
  activities(ids: $activityIds) {
    id
    name
  }
}
    `;
export const CommunicationIdPageDocument = gql`
    query CommunicationIdPage($emailCampaignId: ID!, $venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    venueExtensions {
      extension {
        id
        name
      }
    }
    company {
      aggregators {
        id
        name
      }
      customerGroups {
        id
        name
      }
      tags(first: 50) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
  emailCampaign(id: $emailCampaignId) {
    id
    subject
    replyTo {
      address
    }
    body
    editorType
    editorContent
    renderedContent
    recipientCount
    filters
  }
}
    `;
export const RecipientsEditPageMetaDataDocument = gql`
    query RecipientsEditPageMetaData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
}
    `;
export const RecipientsEditPageDocument = gql`
    query RecipientsEditPage($venueShortId: String!, $emailCampaignId: ID!) {
  venueByShortId(shortId: $venueShortId) {
    id
    type
  }
  emailCampaign(id: $emailCampaignId) {
    id
    recipientCount
    filters
  }
}
    `;
export const RecipientsEditCustomersDocument = gql`
    query RecipientsEditCustomers($venueShortId: String!, $filters: String, $first: Int, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    company {
      id
      customersV3(filters: $filters, first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          id
          communicationSettings {
            commercialEnabled
            notificationsEnabled
            hasValidEmail
            hasTempEmail
          }
        }
      }
    }
  }
}
    `;
export const CommunicationsMetaDataDocument = gql`
    query CommunicationsMetaData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
}
    `;
export const CommunicationsTotalCountDocument = gql`
    query CommunicationsTotalCount($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      emailCampaignsCount
    }
  }
}
    `;
export const CommunicationsVenueByShortIdDocument = gql`
    query CommunicationsVenueByShortId($venueShortId: String!, $first: Int, $last: Int, $before: Cursor, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    timeZone
    company {
      emailCampaigns(first: $first, after: $after, last: $last, before: $before) {
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
        nodes {
          id
          subject
          sentAt
          state
          sendingGroup {
            id
            totalEmails
            sentCount
            deliveredCount
            openedCount
            clickedCount
          }
        }
      }
    }
  }
}
    `;
export const ResendCommunicationDocument = gql`
    mutation ResendCommunication($venueShortId: String!, $communicationId: String!) {
  resendCommunication(
    communicationId: $communicationId
    venueShortId: $venueShortId
  )
}
    `;
export const CommunicationCustomersCountEmailCampaignDocument = gql`
    query CommunicationCustomersCountEmailCampaign($id: ID!) {
  emailCampaign(id: $id) {
    recipientCount
    filters
  }
}
    `;
export const CommunicationIdCustomersCountVenueByShortIdDocument = gql`
    query CommunicationIdCustomersCountVenueByShortId($venueShortId: String!, $filters: String) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      customersV3Count(filters: $filters)
    }
  }
}
    `;
export const CommunicationRecipientCountEmailCampaignDocument = gql`
    query CommunicationRecipientCountEmailCampaign($id: ID!) {
  emailCampaign(id: $id) {
    recipientCount
  }
}
    `;
export const DeleteEmailOptionDocument = gql`
    mutation DeleteEmailOption($id: ID!) {
  deleteEmailCampaign(id: $id)
}
    `;
export const DuplicateEmailOptionDocument = gql`
    mutation DuplicateEmailOption($id: ID!, $subject: String!) {
  duplicateEmailCampaignAsDraft(id: $id, subject: $subject) {
    id
  }
}
    `;
export const SendTestEmailButtonMeDocument = gql`
    query SendTestEmailButtonMe {
  me {
    id
    email
  }
}
    `;
export const NewVenueByShortIdDocument = gql`
    query NewVenueByShortId($venueShortId: String!, $filters: String) {
  venueByShortId(shortId: $venueShortId) {
    id
    bookingSetting {
      notificationReplyTo
    }
    venueExtensions {
      extension {
        id
        name
      }
    }
    company {
      customersV3Count(filters: $filters)
      aggregators {
        id
        name
      }
      customerGroups {
        id
        name
      }
      tags(first: 50) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const NewVenueByShortIdProductsDocument = gql`
    query NewVenueByShortIdProducts($productIds: [String!]!) {
  products(ids: $productIds) {
    id
    name
  }
}
    `;
export const NewVenueByShortIdActivitiesDocument = gql`
    query NewVenueByShortIdActivities($activityIds: [String!]!) {
  activities(ids: $activityIds) {
    id
    name
  }
}
    `;
export const RecipientsNewPageMetaDataDocument = gql`
    query RecipientsNewPageMetaData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
}
    `;
export const RecipientsNewPageDocument = gql`
    query RecipientsNewPage($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    type
  }
}
    `;
export const AiTemplateGeneratorGenerateTemplateDocument = gql`
    mutation AITemplateGeneratorGenerateTemplate($prompt: String!, $venueShortId: String!, $additionalContext: String) {
  generateUnlayerTemplate(
    prompt: $prompt
    venueShortId: $venueShortId
    additionalContext: $additionalContext
  ) {
    template
    context
    isBlocked
  }
}
    `;
export const AiTextGeneratorGenerateEmailDocument = gql`
    mutation AITextGeneratorGenerateEmail($prompt: String!, $venueShortId: String!, $additionalContext: String) {
  generateVenueCommunication(
    prompt: $prompt
    venueShortId: $venueShortId
    additionalContext: $additionalContext
  ) {
    text
    html
    context
    isBlocked
  }
}
    `;
export const DesignEditorMeDocument = gql`
    query DesignEditorMe {
  me {
    isEversportsAdmin
  }
}
    `;
export const EditRecipientsVenueByShortIdDocument = gql`
    query EditRecipientsVenueByShortId($venueShortId: String!, $first: Int, $last: Int, $after: Cursor, $before: Cursor, $filters: String) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      customersV3(
        first: $first
        last: $last
        after: $after
        before: $before
        filters: $filters
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
        }
        nodes {
          id
          firstname
          lastname
          email
          lastParticipatedAt
          communicationSettings {
            commercialEnabled
            notificationsEnabled
            hasValidEmail
            hasTempEmail
            contactable
          }
        }
      }
    }
  }
}
    `;
export const EditRecipientsContactableCountDocument = gql`
    query EditRecipientsContactableCount($venueShortId: String!, $filters: String) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      customersV3Count(filters: $filters)
    }
  }
}
    `;
export const EditRecipientsTotalCountDocument = gql`
    query EditRecipientsTotalCount($venueShortId: String!, $filters: String) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      customersV3Count(filters: $filters)
    }
  }
}
    `;
export const ActivityFilterRuleActivityDocument = gql`
    query ActivityFilterRuleActivity($activityId: String!) {
  activities(ids: [$activityId]) {
    id
    name
  }
}
    `;
export const UseActivityPaginatedQueryVenueByShortIdDocument = gql`
    query UseActivityPaginatedQueryVenueByShortId($venueShortId: String!, $searchTerm: String, $first: Int, $before: Cursor, $after: Cursor, $last: Int, $types: [ActivityType!], $isActive: Boolean) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
      activities(
        searchTerm: $searchTerm
        first: $first
        before: $before
        after: $after
        last: $last
        types: $types
        isActive: $isActive
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        nodes {
          id
          name
          isActive
          type
          activityGroup {
            id
            venue {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
export const AggregatorFilterRuleVenueByShortIdDocument = gql`
    query AggregatorFilterRuleVenueByShortId($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      aggregators {
        id
        name
      }
    }
  }
}
    `;
export const CustomerGroupFilterRuleVenueByShortIdDocument = gql`
    query CustomerGroupFilterRuleVenueByShortId($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      customerGroups {
        id
        name
      }
    }
  }
}
    `;
export const PurchasedProductFilterRuleProductDocument = gql`
    query PurchasedProductFilterRuleProduct($productId: String!) {
  products(ids: [$productId]) {
    id
    name
  }
}
    `;
export const IsTaggedFilterRuleVenueByShortIdDocument = gql`
    query IsTaggedFilterRuleVenueByShortId($venueShortId: String!, $tagIds: [String!]) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      tags(ids: $tagIds, first: 50) {
        edges {
          node {
            id
            name
            color
          }
        }
      }
    }
  }
}
    `;
export const GetExamplePromptsDocument = gql`
    query GetExamplePrompts($venueShortId: String!, $count: Int) {
  getCustomerFiltersFromTextExamplePrompts(
    venueShortId: $venueShortId
    count: $count
  )
}
    `;
export const GenerateFiltersFromTextDocument = gql`
    mutation GenerateFiltersFromText($venueShortId: String!, $input: String!) {
  generateCustomerFiltersFromText(venueShortId: $venueShortId, input: $input) {
    filters {
      filter
      confidence
    }
    validation {
      errors {
        filterId
        filterType
        ruleType
        message
        severity
      }
      warnings {
        filterId
        filterType
        ruleType
        message
        severity
      }
    }
    unmatchedTerms {
      term
      similarEntities
    }
    aiWarnings
    assumptions {
      field
      value
      note
    }
    adjustments {
      kind
      filterType
      ruleType
      entityNames
      productType
      count
    }
    reason
    suggestion
  }
}
    `;
export const UseProductPaginatedQueryVenueByShortIdDocument = gql`
    query UseProductPaginatedQueryVenueByShortId($venueShortId: String!, $searchTerm: String, $first: Int, $before: Cursor, $after: Cursor, $last: Int, $productTypes: [ProductType!], $states: [ProductState!], $productGroups: [ProductGroupFilterInput!], $productIds: [String!]) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
      products(
        venueShortId: $venueShortId
        searchTerm: $searchTerm
        first: $first
        before: $before
        after: $after
        last: $last
        productTypes: $productTypes
        states: $states
        productGroups: $productGroups
        ids: $productIds
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        nodes {
          id
          name
          state
          type
          productGroup
          participationRules {
            id
            name
            cycleUnit
            cycleValue
          }
        }
      }
    }
  }
}
    `;
export const UseProductCountQueryDocument = gql`
    query UseProductCountQuery($venueShortId: String!, $searchTerm: String, $productTypes: [ProductType!], $states: [ProductState!], $productGroups: [ProductGroupFilterInput!], $productIds: [String!]) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
      productsCount(
        venueShortId: $venueShortId
        searchTerm: $searchTerm
        productTypes: $productTypes
        states: $states
        productGroups: $productGroups
        ids: $productIds
      )
    }
  }
}
    `;
export const SurveyLinkMeDocument = gql`
    query SurveyLinkMe {
  me {
    id
    locale
  }
}
    `;
export const AssignTagsDocument = gql`
    mutation AssignTags($companyId: String!, $tagIds: [String!]!, $selectedCustomerIds: [String!], $deselectedCustomerIds: [String!], $isSelectAllChecked: Boolean, $filters: String) {
  assignTagsV2(
    companyId: $companyId
    tagIds: $tagIds
    selectedCustomerIds: $selectedCustomerIds
    deselectedCustomerIds: $deselectedCustomerIds
    isSelectAllChecked: $isSelectAllChecked
    filters: $filters
  ) {
    result
  }
}
    `;
export const ContactsVenueByShortIdDocument = gql`
    query ContactsVenueByShortId($venueShortId: String!, $first: Int, $last: Int, $after: Cursor, $before: Cursor, $filters: String) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      customersV3(
        first: $first
        last: $last
        after: $after
        before: $before
        filters: $filters
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
        }
        nodes {
          id
          firstname
          lastname
          email
          lastParticipatedAt
          communicationSettings {
            commercialEnabled
            notificationsEnabled
            hasValidEmail
            hasTempEmail
            contactable
          }
        }
      }
    }
  }
}
    `;
export const ContactsTotalCountDocument = gql`
    query ContactsTotalCount($venueShortId: String!, $filters: String) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      customersV3Count(filters: $filters)
    }
  }
}
    `;
export const ContactsContactableCountDocument = gql`
    query ContactsContactableCount($venueShortId: String!, $filters: String) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      customersV3Count(filters: $filters)
    }
  }
}
    `;
export const ContactsPageDocument = gql`
    query ContactsPage($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    type
    venueExtensions {
      id
      extension {
        id
        name
      }
    }
  }
}
    `;
export const ContactsMetaDataDocument = gql`
    query ContactsMetaData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
  }
}
    `;
export const FriendReferralMetaDataDocument = gql`
    query FriendReferralMetaData($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
    currency {
      symbol
    }
  }
}
    `;
export const FriendReferralConfigDocument = gql`
    query FriendReferralConfig($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
      referralConfig {
        isActive
        newCustomerRewardType
        newCustomerDiscountType
        newCustomerDiscountValue
        referrerRewardType
        referrerDiscountType
        referrerDiscountValue
        referrerMessage
      }
    }
  }
}
    `;
export const SaveCompanyReferralConfigDocument = gql`
    mutation SaveCompanyReferralConfig($isActive: Boolean!, $newCustomerRewardType: NewCustomerRewardType!, $newCustomerDiscountType: DiscountType, $newCustomerDiscountValue: Float, $referrerRewardType: ReferrerRewardType!, $referrerDiscountType: DiscountType, $referrerDiscountValue: Float, $referrerMessage: String) {
  saveCompanyReferralConfig(
    isActive: $isActive
    newCustomerRewardType: $newCustomerRewardType
    newCustomerDiscountType: $newCustomerDiscountType
    newCustomerDiscountValue: $newCustomerDiscountValue
    referrerRewardType: $referrerRewardType
    referrerDiscountType: $referrerDiscountType
    referrerDiscountValue: $referrerDiscountValue
    referrerMessage: $referrerMessage
  ) {
    __typename
    ... on CompanyReferralConfig {
      isActive
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export const UseEmailActionsSendEmailCampaignToMeDocument = gql`
    mutation UseEmailActionsSendEmailCampaignToMe($venueId: ID!, $message: Message!, $editorType: EditorType!) {
  sendEmailCampaignToMe(
    venueId: $venueId
    message: $message
    editorType: $editorType
  )
}
    `;
export const UseEmailActionsSendDraftEmailToCustomersDocument = gql`
    mutation UseEmailActionsSendDraftEmailToCustomers($campaignId: ID!) {
  sendEmailCampaign(id: $campaignId)
}
    `;
export const UseEmailActionsCreateEmailCampaignDocument = gql`
    mutation UseEmailActionsCreateEmailCampaign($venueId: ID!, $message: DraftMessage!, $editorContent: String, $editorType: EditorType!, $filters: String) {
  saveEmailCampaign(
    venueId: $venueId
    message: $message
    editorContent: $editorContent
    editorType: $editorType
    filters: $filters
  ) {
    __typename
    ... on EmailCampaign {
      id
    }
  }
}
    `;
export const UseEmailActionsUpdateEmailCampaignDocument = gql`
    mutation UseEmailActionsUpdateEmailCampaign($venueId: ID!, $campaignId: ID!, $message: DraftMessage!, $editorContent: String, $editorType: EditorType!, $filters: String) {
  saveEmailCampaign(
    venueId: $venueId
    id: $campaignId
    message: $message
    editorContent: $editorContent
    editorType: $editorType
    filters: $filters
  ) {
    __typename
    ... on EmailCampaign {
      id
      subject
      replyTo {
        address
      }
      body
      editorType
      editorContent
      renderedContent
      recipientCount
      filters
    }
  }
}
    `;
export const MarketingTabsVenueByShortIdDocument = gql`
    query MarketingTabsVenueByShortId($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    type
  }
}
    `;
export const CompanyIdDocument = gql`
    query CompanyId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    company {
      id
    }
  }
}
    `;
export const AggregatorsInfoDocument = gql`
    query AggregatorsInfo($id: String!) {
  company(id: $id) {
    aggregators {
      id
      name
      venues(companyId: $id) {
        id
        name
        locations {
          nodes {
            id
            name
            address
            hasAppointments
          }
        }
      }
    }
  }
}
    `;
export const BrandedAppVenueByShortIdDocument = gql`
    query BrandedAppVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    company {
      id
      widgets {
        __typename
        ... on CompanyWidgetInterface {
          id
          name
        }
      }
      venues(onlyActive: true) {
        id
        name
      }
      brandedApp {
        id
        backgroundColor
        cardBackgroundColor
        cardTextColor
        fontFamily
        invoicingVenue {
          id
        }
        primaryColor
        secondaryColor
        textColor
        widgets {
          __typename
          ... on CompanyWidgetInterface {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const SaveCreateCompanyBrandedAppDocument = gql`
    mutation SaveCreateCompanyBrandedApp($backgroundColor: String!, $cardBackgroundColor: String!, $cardTextColor: String!, $companyId: ID!, $companyWidgetIds: [ID!]!, $fontFamily: String, $invoicingVenueId: ID!, $primaryColor: String!, $secondaryColor: String, $textColor: String!) {
  createCompanyBrandedApp(
    backgroundColor: $backgroundColor
    cardBackgroundColor: $cardBackgroundColor
    cardTextColor: $cardTextColor
    companyId: $companyId
    companyWidgetIds: $companyWidgetIds
    invoicingVenueId: $invoicingVenueId
    fontFamily: $fontFamily
    primaryColor: $primaryColor
    secondaryColor: $secondaryColor
    textColor: $textColor
  ) {
    __typename
    ... on CompanyBrandedApp {
      id
      backgroundColor
      cardBackgroundColor
      cardTextColor
      fontFamily
      primaryColor
      secondaryColor
      textColor
      invoicingVenue {
        id
      }
      widgets {
        ... on CompanyWidgetInterface {
          id
          name
          __typename
        }
      }
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export const SaveUpdateCompanyBrandedAppDocument = gql`
    mutation SaveUpdateCompanyBrandedApp($id: ID!, $backgroundColor: String!, $cardBackgroundColor: String!, $cardTextColor: String!, $companyWidgetIds: [ID!]!, $fontFamily: String, $invoicingVenueId: ID!, $primaryColor: String!, $secondaryColor: String, $textColor: String!) {
  updateCompanyBrandedApp(
    id: $id
    backgroundColor: $backgroundColor
    cardBackgroundColor: $cardBackgroundColor
    cardTextColor: $cardTextColor
    companyWidgetIds: $companyWidgetIds
    invoicingVenueId: $invoicingVenueId
    fontFamily: $fontFamily
    primaryColor: $primaryColor
    secondaryColor: $secondaryColor
    textColor: $textColor
  ) {
    __typename
    ... on CompanyBrandedApp {
      id
      backgroundColor
      cardBackgroundColor
      cardTextColor
      fontFamily
      primaryColor
      secondaryColor
      textColor
      invoicingVenue {
        id
      }
      widgets {
        ... on CompanyWidgetInterface {
          id
          name
          __typename
        }
      }
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export const ExtensionVenueByShortIdDocument = gql`
    query ExtensionVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    viewerRole
    venueExtensions {
      id
      extension {
        id
        label
        name
        priceType
      }
    }
  }
}
    `;
export const FloorPlanSpotsColorsDocument = gql`
    query FloorPlanSpotsColors($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    company {
      id
      widgetBrandSettings {
        id
        floorPlanBackgroundColor
        spotBookableBackgroundColor
        spotBookableTextColor
        spotNonBookableBackgroundColor
        spotNonBookableTextColor
      }
    }
  }
}
    `;
export const UpsertFloorPlanColorsDocument = gql`
    mutation UpsertFloorPlanColors($companyId: ID!, $floorPlanBackgroundColor: String, $spotBookableBackgroundColor: String, $spotBookableTextColor: String, $spotNonBookableBackgroundColor: String, $spotNonBookableTextColor: String) {
  upsertCompanyWidgetBrandSettings(
    companyId: $companyId
    floorPlanBackgroundColor: $floorPlanBackgroundColor
    spotBookableBackgroundColor: $spotBookableBackgroundColor
    spotBookableTextColor: $spotBookableTextColor
    spotNonBookableBackgroundColor: $spotNonBookableBackgroundColor
    spotNonBookableTextColor: $spotNonBookableTextColor
  ) {
    id
    floorPlanBackgroundColor
    spotBookableBackgroundColor
    spotBookableTextColor
    spotNonBookableBackgroundColor
    spotNonBookableTextColor
  }
}
    `;
export const GoogleAdsConfigurationDocument = gql`
    query GoogleAdsConfiguration {
  googleAdsConfiguration {
    isAccountConnected
    googleAdsAccountId
    conversionActionId
    expiresAt
  }
}
    `;
export const SaveGoogleAdsConfigurationDocument = gql`
    mutation SaveGoogleAdsConfiguration($token: String, $googleAdsAccountId: String!, $conversionActionId: String!) {
  saveGoogleAdsConfiguration(
    token: $token
    googleAdsAccountId: $googleAdsAccountId
    conversionActionId: $conversionActionId
  ) {
    __typename
    ... on GoogleAdsConfiguration {
      isAccountConnected
      googleAdsAccountId
      conversionActionId
      expiresAt
    }
    ... on ExpectedErrors {
      errors {
        id
        path
        message
      }
    }
  }
}
    `;
export const CreateCompanyRepresentativeDocument = gql`
    mutation CreateCompanyRepresentative($companyId: String!, $legalName: String!, $location: CreateLocationArgs!, $taxNumber: String, $type: CompanyRepresentativeType!) {
  createCompanyRepresentative(
    companyId: $companyId
    legalName: $legalName
    location: $location
    taxNumber: $taxNumber
    type: $type
  ) {
    id
    legalName
    type
    taxNumber
    location {
      id
      name
      address
      street
      detail
      zip
      city
      countryISO
      municipality
    }
  }
}
    `;
export const GetCompanyRepresentativesDocument = gql`
    query GetCompanyRepresentatives($companyId: String!) {
  company(id: $companyId) {
    id
    name
    address {
      street
      detail
      zip
      city
      countryISO
      municipality
    }
    representatives(types: [LEGAL], first: 1) {
      nodes {
        id
        legalName
        type
        taxNumber
        location {
          id
          name
          street
          detail
          zip
          city
          countryISO
          municipality
        }
      }
    }
  }
}
    `;
export const UpdateCompanyRepresentativeDocument = gql`
    mutation UpdateCompanyRepresentative($id: String!, $legalName: String, $location: UpdateLocationArgs, $taxNumber: String, $type: CompanyRepresentativeType) {
  updateCompanyRepresentative(
    id: $id
    legalName: $legalName
    location: $location
    taxNumber: $taxNumber
    type: $type
  ) {
    id
    legalName
    type
    taxNumber
    location {
      id
      name
      address
      street
      detail
      zip
      city
      countryISO
      municipality
    }
  }
}
    `;
export const GenerateTaxAgreementDocument = gql`
    mutation GenerateTaxAgreement($companyId: String!) {
  generateTaxAgreement(companyId: $companyId) {
    pdfBase64
    success
  }
}
    `;
export const UploadSignedTaxAgreementDocument = gql`
    mutation UploadSignedTaxAgreement($companyId: String!, $signedPdfBase64: String!) {
  uploadSignedTaxAgreement(
    companyId: $companyId
    signedPdfBase64: $signedPdfBase64
  ) {
    success
    message
  }
}
    `;
export const GetCompanyTaxInformationDocument = gql`
    query GetCompanyTaxInformation($companyId: String!) {
  company(id: $companyId) {
    id
    name
    taxInformation {
      ... on SpanishTaxInformation {
        __typename
        tin
        taxTerritory
        taxRegion
        fiscalizationSoftwareInformation {
          name
          license
          softwareCompany {
            tin
            legalName
            registered
          }
          version
          responsibilityDeclaration
        }
      }
    }
  }
}
    `;
export const UpdateCompanyMunicipalityDocument = gql`
    mutation UpdateCompanyMunicipality($companyId: String!, $municipality: String!) {
  updateCompanyMunicipality(companyId: $companyId, municipality: $municipality)
}
    `;
export const GetBookkeepingAccountsDocument = gql`
    query GetBookkeepingAccounts($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
      bookkeepingAccounts {
        id
        name
      }
    }
  }
}
    `;
export const CreatePenaltyRuleDocument = gql`
    mutation CreatePenaltyRule($name: String!, $type: PenaltyRuleType!, $status: PenaltyRuleStatus!, $isApplicableToAllProducts: Boolean!, $productIds: [String!]!, $emailSubject: String!, $emailBody: String!, $fee: Float, $feeBookkeepingAccountId: Float) {
  createPenaltyRule(
    name: $name
    type: $type
    status: $status
    isApplicableToAllProducts: $isApplicableToAllProducts
    productIds: $productIds
    emailSubject: $emailSubject
    emailBody: $emailBody
    fee: $fee
    feeBookkeepingAccountId: $feeBookkeepingAccountId
  ) {
    ... on PenaltyRule {
      __typename
      id
      name
      type
      status
      isApplicableToAllProducts
      productIds
      emailSubject
      emailBody
      fee
      feeBookkeepingAccountId
      penaltiesCount
    }
    ... on ExpectedErrors {
      __typename
      errors {
        id
        message
        path
      }
    }
  }
}
    `;
export const UpdatePenaltyRuleDocument = gql`
    mutation UpdatePenaltyRule($id: ID!, $name: String!, $type: PenaltyRuleType!, $status: PenaltyRuleStatus!, $isApplicableToAllProducts: Boolean!, $productIds: [String!]!, $emailSubject: String!, $emailBody: String!, $fee: Float, $feeBookkeepingAccountId: Float) {
  updatePenaltyRule(
    id: $id
    name: $name
    type: $type
    status: $status
    isApplicableToAllProducts: $isApplicableToAllProducts
    productIds: $productIds
    emailSubject: $emailSubject
    emailBody: $emailBody
    fee: $fee
    feeBookkeepingAccountId: $feeBookkeepingAccountId
  ) {
    ... on PenaltyRule {
      __typename
      id
      name
      type
      status
      isApplicableToAllProducts
      productIds
      emailSubject
      emailBody
      fee
      feeBookkeepingAccountId
      penaltiesCount
    }
    ... on ExpectedErrors {
      __typename
      errors {
        id
        message
        path
      }
    }
  }
}
    `;
export const GetVenueCurrencyDocument = gql`
    query GetVenueCurrency($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    currency {
      code
    }
  }
}
    `;
export const FetchPenaltyRulesDocument = gql`
    query FetchPenaltyRules($shortId: String!, $first: Int, $after: Cursor, $last: Int, $before: Cursor) {
  venueByShortId(shortId: $shortId) {
    company {
      id
      penaltyRulesCount
      penaltyRules(first: $first, after: $after, last: $last, before: $before) {
        nodes {
          id
          name
          type
          status
          isApplicableToAllProducts
          productIds
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
      }
    }
  }
}
    `;
export const FetchPenaltyRuleDocument = gql`
    query FetchPenaltyRule($id: ID!) {
  penaltyRule(id: $id) {
    id
    name
    type
    status
    isApplicableToAllProducts
    productIds
    emailSubject
    emailBody
    fee
    feeBookkeepingAccountId
    penaltiesCount
  }
}
    `;
export const DeactivatePenaltyRuleDocument = gql`
    mutation DeactivatePenaltyRule($penaltyRuleUuid: String!) {
  deactivatePenaltyRule(id: $penaltyRuleUuid) {
    ... on PenaltyRule {
      __typename
      status
    }
    ... on ExpectedErrors {
      __typename
      errors {
        id
        message
        path
      }
    }
  }
}
    `;
export const ActivatePenaltyRuleDocument = gql`
    mutation ActivatePenaltyRule($penaltyRuleUuid: String!) {
  activatePenaltyRule(id: $penaltyRuleUuid) {
    ... on PenaltyRule {
      __typename
      status
    }
    ... on ExpectedErrors {
      __typename
      errors {
        id
        message
        path
      }
    }
  }
}
    `;
export const PrivateSessionSettingsQueryDocument = gql`
    query PrivateSessionSettingsQuery($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    bookingSetting {
      notificationReplyTo
      notificationReceiver
    }
    privateSessionSettings {
      id
      isSelfManagingAllowed
      notificationEmail
      defaultAvailabilitySchedule {
        id
        schedule {
          dayOfWeek
          timeSchedule {
            validUntil
            validFrom
          }
        }
      }
    }
  }
}
    `;
export const SavePrivateSessionSettingsDocument = gql`
    mutation SavePrivateSessionSettings($venueId: String!, $isSelfManagingAllowed: Boolean!, $notificationEmail: String) {
  savePrivateSessionSettings(
    venueId: $venueId
    isSelfManagingAllowed: $isSelfManagingAllowed
    notificationEmail: $notificationEmail
  ) {
    id
    isSelfManagingAllowed
    notificationEmail
  }
}
    `;
export const SaveDefaultAvailabilityScheduleDocument = gql`
    mutation SaveDefaultAvailabilitySchedule($venueId: ID!, $schedule: [SavePrivateSessionAvailabilityScheduleDayArgs!]!) {
  saveDefaultPrivateSessionAvailabilitySchedule(
    venueId: $venueId
    schedule: $schedule
  ) {
    ... on PrivateSessionAvailabilitySchedule {
      id
      schedule {
        dayOfWeek
        timeSchedule {
          validFrom
          validUntil
        }
      }
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export const DateSpecificAvailabilityQueryDocument = gql`
    query DateSpecificAvailabilityQuery($venueShortId: String!, $first: Int, $after: Cursor, $last: Int, $before: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    privateSessionSettings {
      defaultDaySpecificAvailability(
        first: $first
        after: $after
        last: $last
        before: $before
      ) {
        nodes {
          id
          dateFrom
          timeSlots {
            validFrom
            validUntil
          }
        }
        pageInfo {
          hasNextPage
          startCursor
          endCursor
        }
      }
    }
  }
}
    `;
export const DeletePrivateSessionDaySpecificAvailabilityDocument = gql`
    mutation DeletePrivateSessionDaySpecificAvailability($id: ID!) {
  deletePrivateSessionDaySpecificAvailability(id: $id)
}
    `;
export const SavePrivateSessionDaySpecificAvailabilityDocument = gql`
    mutation SavePrivateSessionDaySpecificAvailability($venueId: ID!, $availability: [SavePrivateSessionDaySpecificAvailabilityDateEntryArgs!]!) {
  savePrivateSessionDaySpecificAvailability(
    venueId: $venueId
    availability: $availability
  ) {
    ... on PrivateSessionDaySpecificAvailabilityList {
      nodes {
        id
        dateFrom
        timeSlots {
          validFrom
          validUntil
        }
      }
    }
  }
}
    `;
export const GetFloorPlansDocument = gql`
    query GetFloorPlans($venueShortId: String!, $first: Int, $after: Cursor, $last: Int, $before: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    floorPlans {
      id
    }
    floorPlanConnection(first: $first, after: $after, last: $last, before: $before) {
      edges {
        node {
          id
          name
          numberOfAssignedFloorPlans
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
        numberOfAssignedFloorPlans
      }
    }
  }
}
    `;
export const SubstitutionExtensionSettingsQueryDocument = gql`
    query SubstitutionExtensionSettingsQuery($companyId: String!) {
  company(id: $companyId) {
    id
    venues {
      name
      shortId
    }
    settings {
      id
      substitutionNotification {
        email
        successfullySubstituted
        successfullyCreated
        customerNotificationEnabled
        customerNotificationEmailTemplate
      }
    }
  }
}
    `;
export const SaveSubstitutionNotificationSettingsDocument = gql`
    mutation SaveSubstitutionNotificationSettings($companyId: String!, $email: String, $successfullySubstituted: Boolean!, $successfullyCreated: Boolean!, $customerNotificationEnabled: Boolean!, $customerNotificationEmailTemplate: String) {
  saveSubstitutionNotificationSettings(
    companyId: $companyId
    email: $email
    successfullySubstituted: $successfullySubstituted
    successfullyCreated: $successfullyCreated
    customerNotificationEnabled: $customerNotificationEnabled
    customerNotificationEmailTemplate: $customerNotificationEmailTemplate
  ) {
    email
    successfullySubstituted
    successfullyCreated
    customerNotificationEnabled
    customerNotificationEmailTemplate
  }
}
    `;
export const VenueByShortIdDocument = gql`
    query VenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    name
    internalType
  }
}
    `;
export const GetFloorPlanDocument = gql`
    query GetFloorPlan($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    name
    floorPlans {
      id
      name
      numberOfAssignedFloorPlans
      spots {
        ... on BookableSpot {
          __typename
          id
          x
          y
          label
          bookableIcon
          floorPlanId
          isAvailable
          isPriority
        }
        ... on NonBookableSpot {
          __typename
          id
          x
          y
          label
          nonBookableIcon
          floorPlanId
        }
      }
    }
  }
}
    `;
export const UpdateFloorPlanDocument = gql`
    mutation UpdateFloorPlan($id: ID!, $name: String!, $venueId: String!) {
  updateFloorPlan(id: $id, name: $name, venueId: $venueId) {
    id
    name
  }
}
    `;
export const CreateFloorPlanDocument = gql`
    mutation CreateFloorPlan($name: String!, $venueId: String!) {
  createFloorPlan(name: $name, venueId: $venueId) {
    id
  }
}
    `;
export const ArchiveFloorPlanDocument = gql`
    mutation ArchiveFloorPlan($id: ID!) {
  archiveFloorPlan(id: $id)
}
    `;
export const SyncBookableSpotsDocument = gql`
    mutation SyncBookableSpots($floorPlanId: String!, $syncBookableSpots: [SyncBookableSpotInput!]!) {
  syncBookableSpots(
    floorPlanId: $floorPlanId
    syncBookableSpots: $syncBookableSpots
  ) {
    bookableIcon
    floorPlanId
    id
    isAvailable
    isPriority
    label
    x
    y
  }
}
    `;
export const SyncNonBookableSpotsDocument = gql`
    mutation SyncNonBookableSpots($floorPlanId: String!, $syncNonBookableSpots: [SyncNonBookableSpotInput!]!) {
  syncNonBookableSpots(
    floorPlanId: $floorPlanId
    syncNonBookableSpots: $syncNonBookableSpots
  ) {
    nonBookableIcon
    floorPlanId
    id
    label
    x
    y
  }
}
    `;
export const PublishFloorPlanDocument = gql`
    mutation PublishFloorPlan($id: ID!) {
  publishFloorPlan(id: $id)
}
    `;
export const SpotBookingNewDocument = gql`
    query SpotBookingNew($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    name
    internalType
  }
}
    `;
export const ImportsVenueByShortIdDocument = gql`
    query ImportsVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    name
    type
    importToken {
      token
    }
    latestRun {
      state
    }
    latestUpload {
      id
      state
    }
    company {
      id
    }
    internals {
      previousSoftware
    }
  }
}
    `;
export const ImportsVenueResultsByShortIdDocument = gql`
    query ImportsVenueResultsByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    latestRun {
      errors
      result
    }
  }
}
    `;
export const ImportsMeDocument = gql`
    query ImportsMe {
  me {
    isEversportsAdmin
  }
}
    `;
export const GenerateTokenDocument = gql`
    mutation GenerateToken($shortId: String!) {
  generateToken(venueShortId: $shortId) {
    token
  }
}
    `;
export const StartImportDocument = gql`
    mutation StartImport($shortId: String!, $uploadId: String!) {
  startImport(venueShortId: $shortId, uploadId: $uploadId) {
    state
  }
}
    `;
export const CashRegisterAccessUsersDocument = gql`
    query CashRegisterAccessUsers($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    cashRegisterUsers {
      id
      firstname
      lastname
      role
    }
  }
}
    `;
export const SoftwareVersionDocument = gql`
    query SoftwareVersion($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    company {
      id
      settings {
        id
        softwareVersion {
          versionName
        }
      }
    }
  }
}
    `;
export const FetchTaxArchivesDocument = gql`
    query FetchTaxArchives($venueShortId: String!, $first: Int, $after: Cursor, $last: Int, $before: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    taxArchives(first: $first, after: $after, last: $last, before: $before) {
      nodes {
        id
        name
        fromDate
        toDate
        createdAt
        downloadUrl
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
    `;
export const CreatePeriodDocument = gql`
    mutation CreatePeriod($seasonId: ID!, $properties: PeriodInput!, $courtGroupId: ID!) {
  createPeriod(
    seasonId: $seasonId
    courtGroupId: $courtGroupId
    properties: $properties
  ) {
    ... on Period {
      __typename
      id
      name
      start
      end
      interval
      intervalType
      weekdays
      rates(courtGroupId: $courtGroupId) {
        id
        consumerType
        bookingType
        customerGroup {
          id
          name
        }
        price
        minUnits
        maxUnits
      }
    }
    ... on PeriodValidation {
      __typename
      isValid
      errors
      overlapsWith {
        id
        name
      }
      rateValidations {
        errors
        isValid
        alsoUsedIn {
          id
          name
        }
      }
    }
  }
}
    `;
export const UpdatePeriodDocument = gql`
    mutation UpdatePeriod($periodId: ID!, $properties: PeriodInput!, $courtGroupId: ID!) {
  updatePeriod(
    periodId: $periodId
    courtGroupId: $courtGroupId
    properties: $properties
  ) {
    ... on Period {
      __typename
      id
    }
    ... on PeriodValidation {
      __typename
      isValid
      errors
      overlapsWith {
        id
        name
      }
      rateValidations {
        errors
        isValid
        alsoUsedIn {
          id
          name
        }
      }
    }
  }
}
    `;
export const RemovePeriodDocument = gql`
    mutation RemovePeriod($periodId: ID!, $courtGroupId: ID!) {
  removePeriod(periodId: $periodId, courtGroupId: $courtGroupId)
}
    `;
export const SeasonIdVenueByShortIdDocument = gql`
    query SeasonIdVenueByShortId($shortId: String!, $courtGroupId: ID!) {
  venueByShortId(shortId: $shortId) {
    id
    name
  }
  courtGroup(courtGroupId: $courtGroupId) {
    id
    name
  }
}
    `;
export const SeasonIdPageDocument = gql`
    query SeasonIdPage($shortId: String!, $courtGroupId: ID!, $seasonId: ID!) {
  venueByShortId(shortId: $shortId) {
    id
    company {
      customerGroups {
        id
        name
        groupPresetType
      }
    }
  }
  courtGroupSeason(courtGroupId: $courtGroupId, seasonId: $seasonId) {
    id
    name
    periods(courtGroupId: $courtGroupId) {
      id
      name
      start
      end
      interval
      intervalType
      weekdays
      rates(courtGroupId: $courtGroupId) {
        id
        consumerType
        bookingType
        customerGroup {
          id
          name
        }
        price
        minUnits
        maxUnits
      }
    }
  }
}
    `;
export const RatesVenueByShortIdDocument = gql`
    query RatesVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    name
  }
}
    `;
export const RatesCourtGroupsDocument = gql`
    query RatesCourtGroups($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    courtGroups {
      id
      name
      courts {
        id
      }
    }
  }
}
    `;
export const RatesCourtGroupSeasonsDocument = gql`
    query RatesCourtGroupSeasons($courtGroupId: ID!) {
  courtGroup(courtGroupId: $courtGroupId) {
    id
    courts {
      id
      name
    }
    seasons {
      id
      name
      start
      end
      validation {
        alsoUsedIn {
          id
          name
        }
        overrides {
          id
          name
        }
      }
    }
  }
}
    `;
export const UpdateSeasonDocument = gql`
    mutation UpdateSeason($seasonId: ID!, $courtGroupId: ID!, $properties: SeasonInput!) {
  updateSeason(
    seasonId: $seasonId
    courtGroupId: $courtGroupId
    properties: $properties
  ) {
    __typename
    ... on SeasonValidation {
      isValid
      alsoUsedIn {
        id
        name
      }
      conflictsIn {
        id
        name
      }
      overlaps {
        id
        name
        end
        start
      }
      overrides {
        id
        name
      }
    }
    ... on Season {
      id
      name
      start
      end
    }
  }
}
    `;
export const RemoveSeasonDocument = gql`
    mutation RemoveSeason($seasonId: ID!, $courtGroupId: ID!) {
  removeSeason(seasonId: $seasonId, courtGroupId: $courtGroupId)
}
    `;
export const CreateSeasonDocument = gql`
    mutation CreateSeason($courtGroupId: ID!, $properties: SeasonInput!) {
  createSeason(courtGroupId: $courtGroupId, properties: $properties) {
    __typename
    ... on Season {
      id
      name
      end
      start
    }
    ... on SeasonValidation {
      isValid
      alsoUsedIn {
        id
        name
      }
      conflictsIn {
        id
        name
      }
      overlaps {
        id
        name
        end
        start
      }
      overrides {
        id
        name
      }
    }
  }
}
    `;
export const VenueVenueByShortIdDocument = gql`
    query VenueVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    name
  }
}
    `;
export const WidgetListVenueDocument = gql`
    query WidgetListVenue($venueId: String!) {
  venue(id: $venueId) {
    id
    name
    company {
      id
      marketplaceHostname
      venues(onlyActive: true) {
        id
        name
      }
      widgets(
        types: [COMPANY_WIDGET_TYPE_ACTIVITY_SCHEDULE, COMPANY_WIDGET_TYPE_PRICES, COMPANY_WIDGET_TYPE_VOUCHERS, COMPANY_WIDGET_TYPE_ACTIVITIES, COMPANY_WIDGET_TYPE_VIDEOS, COMPANY_WIDGET_TYPE_NEWSLETTER]
      ) {
        ... on CompanyWidgetInterface {
          id
          name
          isInOverviewWidget
          widgetPageURL(venueId: $venueId)
          isDeletable
          __typename
        }
      }
      companyWidgetOverview: widgets(types: [COMPANY_WIDGET_TYPE_OVERVIEW]) {
        ... on CompanyWidgetOverview {
          id
          name
          widgets {
            ... on CompanyWidgetInterface {
              id
              name
              __typename
            }
          }
        }
      }
    }
  }
}
    `;
export const WidgetEditCompanyWidgetDocument = gql`
    query WidgetEditCompanyWidget($id: ID!, $shortId: String!) {
  companyWidget(id: $id) {
    __typename
  }
  venueByShortId(shortId: $shortId) {
    id
    company {
      id
      venues(onlyActive: true) {
        id
        name
      }
    }
  }
}
    `;
export const BrandSettingsQueryDocument = gql`
    query BrandSettingsQuery($companyId: String!) {
  company(id: $companyId) {
    id
    name
    widgetBrandSettings {
      backgroundColor
      cardBackgroundColor
      cardTextColor
      displayName
      floorPlanBackgroundColor
      fontFamily
      id
      logo {
        id
        small
        medium
        large
      }
      primaryColor
      spotBookableBackgroundColor
      spotBookableTextColor
      spotNonBookableBackgroundColor
      spotNonBookableTextColor
      textColor
    }
  }
}
    `;
export const CreateCompanyWidgetBrandSettingsDocument = gql`
    mutation CreateCompanyWidgetBrandSettings($companyId: String!, $displayName: String, $backgroundColor: String!, $cardBackgroundColor: String!, $textColor: String!, $cardTextColor: String!, $primaryColor: String!, $fontFamily: String, $logoFile: LogoFileInput) {
  createCompanyWidgetBrandSettings(
    companyId: $companyId
    displayName: $displayName
    backgroundColor: $backgroundColor
    cardBackgroundColor: $cardBackgroundColor
    textColor: $textColor
    cardTextColor: $cardTextColor
    primaryColor: $primaryColor
    fontFamily: $fontFamily
    logoFile: $logoFile
  ) {
    id
    displayName
    backgroundColor
    cardBackgroundColor
    textColor
    cardTextColor
    primaryColor
    fontFamily
    logo {
      id
      small
      medium
      large
    }
  }
}
    `;
export const UpdateCompanyWidgetBrandSettingsDocument = gql`
    mutation UpdateCompanyWidgetBrandSettings($uuid: String!, $displayName: String, $backgroundColor: String, $cardBackgroundColor: String, $textColor: String, $cardTextColor: String, $primaryColor: String, $fontFamily: String, $logoFile: LogoFileInput, $removeLogo: Boolean) {
  updateCompanyWidgetBrandSettings(
    uuid: $uuid
    displayName: $displayName
    backgroundColor: $backgroundColor
    cardBackgroundColor: $cardBackgroundColor
    textColor: $textColor
    cardTextColor: $cardTextColor
    primaryColor: $primaryColor
    fontFamily: $fontFamily
    logoFile: $logoFile
    removeLogo: $removeLogo
  ) {
    id
    displayName
    backgroundColor
    cardBackgroundColor
    textColor
    cardTextColor
    primaryColor
    fontFamily
    logo {
      id
      small
      medium
      large
    }
  }
}
    `;
export const ActivitiesVenueByShortIdDocument = gql`
    query ActivitiesVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    company {
      id
      activeActivityTypes
      widgetBrandSettings {
        id
        backgroundColor
        cardBackgroundColor
        cardTextColor
        displayName
        fontFamily
        primaryColor
        textColor
      }
    }
    venueExtensions {
      id
      extension {
        id
        name
      }
    }
  }
}
    `;
export const ActivitiesCompanyWidgetDocument = gql`
    query ActivitiesCompanyWidget($id: ID!) {
  companyWidget(id: $id) {
    __typename
    ... on CompanyWidgetActivities {
      id
      name
      colorBackground
      colorBackgroundCard
      colorButton
      colorFont
      colorFontCard
      colorHeading
      fontFamily
      isOnlyWidgetOfThisType
      activityTypes
      isMyBookingsLinkVisible
      defaultStartDate
      defaultEndDate
      defaultVenues(first: 50) {
        nodes {
          id
        }
      }
      isActivityGroupFilterHidden
      isTrainerFilterHidden
      isDateFilterHidden
      isVenueFilterHidden
    }
  }
}
    `;
export const ActivityWidgetTrainersDocument = gql`
    query ActivityWidgetTrainers($id: ID!, $first: Int, $after: Cursor) {
  companyWidget(id: $id) {
    __typename
    ... on CompanyWidgetActivities {
      id
      trainers(first: $first, after: $after) {
        nodes {
          id
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const ActivityWidgetActivityGroupsDocument = gql`
    query ActivityWidgetActivityGroups($id: ID!, $first: Int, $after: Cursor) {
  companyWidget(id: $id) {
    __typename
    ... on CompanyWidgetActivities {
      id
      activityGroups(first: $first, after: $after) {
        nodes {
          id
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const SaveCreateCompanyWidgetActivitiesDocument = gql`
    mutation SaveCreateCompanyWidgetActivities($colorBackground: String, $colorBackgroundCard: String, $colorButton: String, $colorFont: String, $colorFontCard: String, $colorHeading: String, $companyId: ID!, $fontFamily: String, $name: String!, $activityTypes: [ActivityType!]!, $activityGroupIds: [ID!], $trainerIds: [ID!], $defaultVenueIds: [ID!], $defaultStart: DateTime, $defaultEnd: DateTime, $isMyBookingsLinkVisible: Boolean!, $isActivityGroupFilterHidden: Boolean!, $isTrainerFilterHidden: Boolean!, $isDateFilterHidden: Boolean!, $isVenueFilterHidden: Boolean!) {
  createCompanyWidgetActivities(
    colorBackground: $colorBackground
    colorBackgroundCard: $colorBackgroundCard
    colorButton: $colorButton
    colorFontCard: $colorFontCard
    colorFont: $colorFont
    colorHeading: $colorHeading
    companyId: $companyId
    fontFamily: $fontFamily
    name: $name
    activityTypes: $activityTypes
    activityGroupIds: $activityGroupIds
    trainerIds: $trainerIds
    defaultVenueIds: $defaultVenueIds
    defaultStart: $defaultStart
    defaultEnd: $defaultEnd
    isMyBookingsLinkVisible: $isMyBookingsLinkVisible
    isActivityGroupFilterHidden: $isActivityGroupFilterHidden
    isTrainerFilterHidden: $isTrainerFilterHidden
    isDateFilterHidden: $isDateFilterHidden
    isVenueFilterHidden: $isVenueFilterHidden
  ) {
    __typename
    ... on CompanyWidgetActivities {
      id
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export const SaveUpdateCompanyWidgetActivitiesDocument = gql`
    mutation SaveUpdateCompanyWidgetActivities($id: ID!, $colorBackground: String, $colorBackgroundCard: String, $colorButton: String, $colorFont: String, $colorFontCard: String, $colorHeading: String, $companyId: ID!, $fontFamily: String, $name: String!, $activityTypes: [ActivityType!]!, $activityGroupIds: [ID!], $trainerIds: [ID!], $defaultVenueIds: [ID!], $defaultStart: DateTime, $defaultEnd: DateTime, $isMyBookingsLinkVisible: Boolean!, $isActivityGroupFilterHidden: Boolean!, $isTrainerFilterHidden: Boolean!, $isDateFilterHidden: Boolean!, $isVenueFilterHidden: Boolean!) {
  updateCompanyWidgetActivities(
    id: $id
    colorBackground: $colorBackground
    colorBackgroundCard: $colorBackgroundCard
    colorButton: $colorButton
    colorFontCard: $colorFontCard
    colorFont: $colorFont
    colorHeading: $colorHeading
    companyId: $companyId
    fontFamily: $fontFamily
    name: $name
    activityTypes: $activityTypes
    activityGroupIds: $activityGroupIds
    trainerIds: $trainerIds
    defaultVenueIds: $defaultVenueIds
    defaultStart: $defaultStart
    defaultEnd: $defaultEnd
    isMyBookingsLinkVisible: $isMyBookingsLinkVisible
    isActivityGroupFilterHidden: $isActivityGroupFilterHidden
    isTrainerFilterHidden: $isTrainerFilterHidden
    isDateFilterHidden: $isDateFilterHidden
    isVenueFilterHidden: $isVenueFilterHidden
  ) {
    __typename
    ... on CompanyWidgetActivities {
      id
      name
      colorBackground
      colorBackgroundCard
      colorButton
      colorFont
      colorFontCard
      colorHeading
      fontFamily
      activityTypes
      isMyBookingsLinkVisible
      defaultStartDate
      defaultEndDate
      defaultVenues(first: 50) {
        nodes {
          id
        }
      }
      isActivityGroupFilterHidden
      isDateFilterHidden
      isVenueFilterHidden
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export const ActivityScheduleVenueByShortIdDocument = gql`
    query ActivityScheduleVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    company {
      id
      widgetBrandSettings {
        backgroundColor
        cardBackgroundColor
        cardTextColor
        displayName
        fontFamily
        primaryColor
        textColor
      }
    }
  }
}
    `;
export const ActivityScheduleCompanyWidgetDocument = gql`
    query ActivityScheduleCompanyWidget($id: ID!) {
  companyWidget(id: $id) {
    __typename
    ... on CompanyWidgetActivitySchedule {
      id
      name
      colorBackground
      colorButton
      colorFont
      colorFontCard
      fontFamily
      isOnlyWidgetOfThisType
      groupSchedule
      showLevel
      showResource
      showTrainer
      showCompactViewMobile
      spotLimitDisplayType
      isMyBookingsLinkVisible
      isActivityGroupFilterHidden
      isSportFilterHidden
      isTeacherFilterHidden
      isVenueFilterHidden
    }
  }
}
    `;
export const ActivityScheduleCreateCompanyWidgetActivityScheduleDocument = gql`
    mutation ActivityScheduleCreateCompanyWidgetActivitySchedule($colorFontCard: String, $colorBackground: String, $colorButton: String, $colorFont: String, $companyId: ID!, $defaultActivityGroupIds: [ID!]!, $defaultSportIds: [ID!]!, $defaultTeacherIds: [ID!]!, $defaultVenueIds: [ID!]!, $fontFamily: String, $groupSchedule: Boolean!, $name: String!, $showLevel: Boolean!, $showResource: Boolean!, $showTrainer: Boolean!, $showCompactViewMobile: Boolean!, $spotLimitDisplayType: SpotLimitDisplayType, $isMyBookingsLinkVisible: Boolean!, $isActivityGroupFilterHidden: Boolean!, $isSportFilterHidden: Boolean!, $isTeacherFilterHidden: Boolean!, $isVenueFilterHidden: Boolean!) {
  createCompanyWidgetActivitySchedule(
    colorFontCard: $colorFontCard
    colorBackground: $colorBackground
    colorButton: $colorButton
    colorFont: $colorFont
    companyId: $companyId
    defaultActivityGroupIds: $defaultActivityGroupIds
    defaultSportIds: $defaultSportIds
    defaultTeacherIds: $defaultTeacherIds
    defaultVenueIds: $defaultVenueIds
    fontFamily: $fontFamily
    groupSchedule: $groupSchedule
    name: $name
    showLevel: $showLevel
    showResource: $showResource
    showTrainer: $showTrainer
    showCompactViewMobile: $showCompactViewMobile
    spotLimitDisplayType: $spotLimitDisplayType
    isMyBookingsLinkVisible: $isMyBookingsLinkVisible
    isActivityGroupFilterHidden: $isActivityGroupFilterHidden
    isSportFilterHidden: $isSportFilterHidden
    isTeacherFilterHidden: $isTeacherFilterHidden
    isVenueFilterHidden: $isVenueFilterHidden
  ) {
    __typename
    ... on CompanyWidgetActivitySchedule {
      id
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export const ActivityScheduleUpdateCompanyWidgetActivityScheduleDocument = gql`
    mutation ActivityScheduleUpdateCompanyWidgetActivitySchedule($id: ID!, $colorFontCard: String, $colorBackground: String, $colorButton: String, $colorFont: String, $companyId: String!, $defaultActivityGroupIds: [ID!]!, $defaultSportIds: [ID!]!, $defaultTeacherIds: [ID!]!, $defaultVenueIds: [ID!]!, $fontFamily: String, $groupSchedule: Boolean!, $name: String!, $showLevel: Boolean!, $showResource: Boolean!, $showTrainer: Boolean!, $showCompactViewMobile: Boolean!, $spotLimitDisplayType: SpotLimitDisplayType, $isMyBookingsLinkVisible: Boolean!, $isActivityGroupFilterHidden: Boolean!, $isSportFilterHidden: Boolean!, $isTeacherFilterHidden: Boolean!, $isVenueFilterHidden: Boolean!) {
  updateCompanyWidgetActivitySchedule(
    id: $id
    colorFontCard: $colorFontCard
    colorBackground: $colorBackground
    colorButton: $colorButton
    colorFont: $colorFont
    companyId: $companyId
    defaultActivityGroupIds: $defaultActivityGroupIds
    defaultSportIds: $defaultSportIds
    defaultTeacherIds: $defaultTeacherIds
    defaultVenueIds: $defaultVenueIds
    fontFamily: $fontFamily
    groupSchedule: $groupSchedule
    name: $name
    showLevel: $showLevel
    showResource: $showResource
    showTrainer: $showTrainer
    showCompactViewMobile: $showCompactViewMobile
    spotLimitDisplayType: $spotLimitDisplayType
    isMyBookingsLinkVisible: $isMyBookingsLinkVisible
    isActivityGroupFilterHidden: $isActivityGroupFilterHidden
    isSportFilterHidden: $isSportFilterHidden
    isTeacherFilterHidden: $isTeacherFilterHidden
    isVenueFilterHidden: $isVenueFilterHidden
  ) {
    __typename
    ... on CompanyWidgetActivitySchedule {
      id
      name
      colorBackground
      colorButton
      colorFont
      colorFontCard
      fontFamily
      groupSchedule
      showLevel
      showResource
      showTrainer
      showCompactViewMobile
      spotLimitDisplayType
      isMyBookingsLinkVisible
      isActivityGroupFilterHidden
      isSportFilterHidden
      isTeacherFilterHidden
      isVenueFilterHidden
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export const FilterOptionsCompanyVenuesDocument = gql`
    query FilterOptionsCompanyVenues($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    company {
      id
      venues(onlyActive: true) {
        id
        name
      }
    }
  }
}
    `;
export const CompanyTeachersDocument = gql`
    query CompanyTeachers($companyId: String!, $venueIds: [String!], $first: Int!, $after: Cursor) {
  company(id: $companyId) {
    id
    teachers(first: $first, after: $after, venueIds: $venueIds) {
      nodes {
        id
        name: nickname
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;
export const CompanyActivityGroupsDocument = gql`
    query CompanyActivityGroups($companyId: String!, $venueIds: [String!], $first: Int!, $after: Cursor) {
  company(id: $companyId) {
    id
    activityGroups(first: $first, after: $after, venueIds: $venueIds) {
      nodes {
        id
        name
        venue {
          id
          name
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;
export const CompanySportsDocument = gql`
    query CompanySports($companyId: String!, $venueIds: [String!], $first: Int!, $after: Cursor) {
  company(id: $companyId) {
    id
    sports(first: $first, after: $after, venueIds: $venueIds) {
      nodes {
        id
        name
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;
export const DefaultTeachersCompanyWidgetDocument = gql`
    query DefaultTeachersCompanyWidget($id: ID!, $first: Int, $after: Cursor) {
  companyWidget(id: $id) {
    __typename
    ... on CompanyWidgetActivitySchedule {
      id
      defaultTeachers(first: $first, after: $after) {
        nodes {
          id
          nickname
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const DefaultActivityGroupsCompanyWidgetDocument = gql`
    query DefaultActivityGroupsCompanyWidget($id: ID!, $first: Int, $after: Cursor) {
  companyWidget(id: $id) {
    __typename
    ... on CompanyWidgetActivitySchedule {
      id
      defaultActivityGroups(first: $first, after: $after) {
        nodes {
          id
          name
          venue {
            id
            name
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const DefaultSportsCompanyWidgetDocument = gql`
    query DefaultSportsCompanyWidget($id: ID!, $first: Int, $after: Cursor) {
  companyWidget(id: $id) {
    __typename
    ... on CompanyWidgetActivitySchedule {
      id
      defaultSports(first: $first, after: $after) {
        nodes {
          id
          name
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const DefaultVenuesCompanyWidgetDocument = gql`
    query DefaultVenuesCompanyWidget($id: ID!, $first: Int, $after: Cursor) {
  companyWidget(id: $id) {
    __typename
    ... on CompanyWidgetActivitySchedule {
      id
      defaultVenues(first: $first, after: $after) {
        nodes {
          id
          name
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const NewsletterVenueByShortIdDocument = gql`
    query NewsletterVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    company {
      id
      widgetBrandSettings {
        backgroundColor
        cardBackgroundColor
        cardTextColor
        displayName
        fontFamily
        primaryColor
        textColor
      }
      venues(onlyActive: true) {
        id
        website
      }
    }
  }
}
    `;
export const NewsletterCompanyWidgetDocument = gql`
    query NewsletterCompanyWidget($id: ID!) {
  companyWidget(id: $id) {
    __typename
    ... on CompanyWidgetNewsletter {
      id
      name
      title
      description
      colorBackground
      colorFont
      colorButton
      fontFamily
      isDeletable
      allowedDomains
    }
  }
}
    `;
export const SaveCreateCompanyWidgetNewsletterDocument = gql`
    mutation SaveCreateCompanyWidgetNewsletter($companyId: ID!, $name: String!, $title: String, $description: String, $colorBackground: String, $colorFont: String, $colorButton: String, $fontFamily: String, $allowedDomains: [String!]) {
  createCompanyWidgetNewsletter(
    companyId: $companyId
    name: $name
    title: $title
    description: $description
    colorBackground: $colorBackground
    colorFont: $colorFont
    colorButton: $colorButton
    fontFamily: $fontFamily
    allowedDomains: $allowedDomains
  ) {
    __typename
    ... on CompanyWidgetNewsletter {
      id
    }
  }
}
    `;
export const SaveUpdateCompanyWidgetNewsletterDocument = gql`
    mutation SaveUpdateCompanyWidgetNewsletter($id: ID!, $companyId: ID!, $name: String!, $title: String, $description: String, $colorBackground: String, $colorFont: String, $colorButton: String, $fontFamily: String, $allowedDomains: [String!]) {
  updateCompanyWidgetNewsletter(
    id: $id
    companyId: $companyId
    name: $name
    title: $title
    description: $description
    colorBackground: $colorBackground
    colorFont: $colorFont
    colorButton: $colorButton
    fontFamily: $fontFamily
    allowedDomains: $allowedDomains
  ) {
    __typename
    ... on CompanyWidgetNewsletter {
      id
    }
  }
}
    `;
export const PricesVenueByShortIdDocument = gql`
    query PricesVenueByShortId($shortId: String!, $after: Cursor) {
  venueByShortId(shortId: $shortId) {
    id
    company {
      id
      widgetBrandSettings {
        backgroundColor
        cardBackgroundColor
        cardTextColor
        displayName
        fontFamily
        primaryColor
        textColor
      }
      productGroups(first: 50, after: $after) {
        nodes {
          id
          name
          priority
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const PricesCompanyWidgetDocument = gql`
    query PricesCompanyWidget($id: ID!, $after: Cursor) {
  companyWidget(id: $id) {
    __typename
    ... on CompanyWidgetPrices {
      id
      name
      colorBackground
      colorBackgroundCard
      colorButton
      colorFont
      colorFontCard
      colorHeading
      fontFamily
      isOnlyWidgetOfThisType
      isMyProductsLinkVisible
      invoicingVenue {
        id
      }
      productGroups(first: 50, after: $after) {
        nodes {
          id
          name
          priority
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const PricesSaveCreateCompanyWidgetPricesDocument = gql`
    mutation PricesSaveCreateCompanyWidgetPrices($colorBackground: String, $colorBackgroundCard: String, $colorButton: String, $colorFont: String, $colorFontCard: String, $colorHeading: String, $companyId: ID!, $fontFamily: String, $invoicingVenueId: ID!, $name: String!, $productGroupIds: [ID!]!, $isMyProductsLinkVisible: Boolean!) {
  createCompanyWidgetPrices(
    colorBackground: $colorBackground
    colorBackgroundCard: $colorBackgroundCard
    colorButton: $colorButton
    colorFontCard: $colorFontCard
    colorFont: $colorFont
    colorHeading: $colorHeading
    companyId: $companyId
    fontFamily: $fontFamily
    invoicingVenueId: $invoicingVenueId
    name: $name
    productGroupIds: $productGroupIds
    isMyProductsLinkVisible: $isMyProductsLinkVisible
  ) {
    __typename
    ... on CompanyWidgetPrices {
      id
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export const PricesSaveUpdateCompanyWidgetPricesDocument = gql`
    mutation PricesSaveUpdateCompanyWidgetPrices($id: ID!, $colorBackground: String, $colorBackgroundCard: String, $colorButton: String, $colorFont: String, $colorFontCard: String, $colorHeading: String, $companyId: ID!, $fontFamily: String, $invoicingVenueId: ID!, $name: String!, $productGroupIds: [ID!]!, $isMyProductsLinkVisible: Boolean!) {
  updateCompanyWidgetPrices(
    id: $id
    colorBackground: $colorBackground
    colorBackgroundCard: $colorBackgroundCard
    colorButton: $colorButton
    colorFontCard: $colorFontCard
    colorFont: $colorFont
    colorHeading: $colorHeading
    companyId: $companyId
    fontFamily: $fontFamily
    invoicingVenueId: $invoicingVenueId
    name: $name
    productGroupIds: $productGroupIds
    isMyProductsLinkVisible: $isMyProductsLinkVisible
  ) {
    __typename
    ... on CompanyWidgetPrices {
      name
      colorBackground
      colorBackgroundCard
      colorButton
      colorFont
      colorFontCard
      colorHeading
      fontFamily
      isMyProductsLinkVisible
      invoicingVenue {
        id
      }
      productGroups(first: 50) {
        nodes {
          id
          name
          priority
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export const RecordingCategoriesVenueByShortIdDocument = gql`
    query RecordingCategoriesVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    company {
      id
      widgetBrandSettings {
        backgroundColor
        cardBackgroundColor
        cardTextColor
        displayName
        fontFamily
        primaryColor
        textColor
      }
      recordingCategories(first: 50) {
        nodes {
          id
          name
          venue {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const VideosCompanyWidgetDocument = gql`
    query VideosCompanyWidget($id: ID!) {
  companyWidget(id: $id) {
    __typename
    ... on CompanyWidgetVideos {
      id
      name
      colorBackground
      colorBackgroundCard
      colorButton
      colorFont
      colorFontCard
      colorHeading
      fontFamily
      isOnlyWidgetOfThisType
      isMyVideosLinkVisible
      recordingCategories(first: 50) {
        nodes {
          id
        }
      }
      defaultVenues(first: 50) {
        nodes {
          id
        }
      }
      defaultLanguages
      defaultLevels
      isDurationFilterHidden
      isLanguageFilterHidden
      isLevelFilterHidden
      isSportFilterHidden
      isTeacherFilterHidden
      isVenueFilterHidden
    }
  }
}
    `;
export const SaveCreateCompanyWidgetVideosDocument = gql`
    mutation SaveCreateCompanyWidgetVideos($colorBackground: String, $colorBackgroundCard: String, $colorButton: String, $colorFont: String, $colorFontCard: String, $colorHeading: String, $companyId: ID!, $defaultVenueIds: [ID!], $defaultTeacherIds: [ID!], $defaultSportIds: [ID!], $defaultLanguages: [RecordingSupportedLanguage!], $defaultLevels: [RecordingDifficultyLevel!], $fontFamily: String, $name: String!, $recordingCategoryIds: [ID!], $isMyVideosLinkVisible: Boolean!, $isDurationFilterHidden: Boolean!, $isLanguageFilterHidden: Boolean!, $isLevelFilterHidden: Boolean!, $isSportFilterHidden: Boolean!, $isTeacherFilterHidden: Boolean!, $isVenueFilterHidden: Boolean!) {
  createCompanyWidgetVideos(
    colorBackground: $colorBackground
    colorBackgroundCard: $colorBackgroundCard
    colorButton: $colorButton
    colorFontCard: $colorFontCard
    colorFont: $colorFont
    colorHeading: $colorHeading
    companyId: $companyId
    defaultVenueIds: $defaultVenueIds
    defaultTeacherIds: $defaultTeacherIds
    defaultSportIds: $defaultSportIds
    defaultLanguages: $defaultLanguages
    defaultLevels: $defaultLevels
    fontFamily: $fontFamily
    name: $name
    recordingCategoryIds: $recordingCategoryIds
    isMyVideosLinkVisible: $isMyVideosLinkVisible
    isDurationFilterHidden: $isDurationFilterHidden
    isLanguageFilterHidden: $isLanguageFilterHidden
    isLevelFilterHidden: $isLevelFilterHidden
    isSportFilterHidden: $isSportFilterHidden
    isTeacherFilterHidden: $isTeacherFilterHidden
    isVenueFilterHidden: $isVenueFilterHidden
  ) {
    __typename
    ... on CompanyWidgetVideos {
      id
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export const SaveUpdateCompanyWidgetVideosDocument = gql`
    mutation SaveUpdateCompanyWidgetVideos($id: ID!, $colorBackground: String, $colorBackgroundCard: String, $colorButton: String, $colorFont: String, $colorFontCard: String, $colorHeading: String, $companyId: ID!, $defaultVenueIds: [ID!], $defaultTeacherIds: [ID!], $defaultSportIds: [ID!], $defaultLanguages: [RecordingSupportedLanguage!], $defaultLevels: [RecordingDifficultyLevel!], $fontFamily: String, $name: String!, $recordingCategoryIds: [ID!], $isMyVideosLinkVisible: Boolean!, $isDurationFilterHidden: Boolean!, $isLanguageFilterHidden: Boolean!, $isLevelFilterHidden: Boolean!, $isSportFilterHidden: Boolean!, $isTeacherFilterHidden: Boolean!, $isVenueFilterHidden: Boolean!) {
  updateCompanyWidgetVideos(
    id: $id
    colorBackground: $colorBackground
    colorBackgroundCard: $colorBackgroundCard
    colorButton: $colorButton
    colorFontCard: $colorFontCard
    colorFont: $colorFont
    colorHeading: $colorHeading
    companyId: $companyId
    defaultVenueIds: $defaultVenueIds
    defaultTeacherIds: $defaultTeacherIds
    defaultSportIds: $defaultSportIds
    defaultLanguages: $defaultLanguages
    defaultLevels: $defaultLevels
    fontFamily: $fontFamily
    name: $name
    recordingCategoryIds: $recordingCategoryIds
    isMyVideosLinkVisible: $isMyVideosLinkVisible
    isDurationFilterHidden: $isDurationFilterHidden
    isLanguageFilterHidden: $isLanguageFilterHidden
    isLevelFilterHidden: $isLevelFilterHidden
    isSportFilterHidden: $isSportFilterHidden
    isTeacherFilterHidden: $isTeacherFilterHidden
    isVenueFilterHidden: $isVenueFilterHidden
  ) {
    __typename
    ... on CompanyWidgetVideos {
      id
      name
      colorBackground
      colorBackgroundCard
      colorButton
      colorFont
      colorFontCard
      colorHeading
      fontFamily
      isMyVideosLinkVisible
      recordingCategories(first: 50) {
        nodes {
          id
          name
          venue {
            id
            name
          }
        }
      }
      defaultVenues(first: 50) {
        nodes {
          id
        }
      }
      defaultLanguages
      defaultLevels
      isDurationFilterHidden
      isLanguageFilterHidden
      isLevelFilterHidden
      isSportFilterHidden
      isTeacherFilterHidden
      isVenueFilterHidden
    }
    ... on ExpectedErrors {
      errors {
        id
        message
      }
    }
  }
}
    `;
export const VouchersVenueByShortIdDocument = gql`
    query VouchersVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    company {
      id
      widgetBrandSettings {
        backgroundColor
        cardBackgroundColor
        cardTextColor
        displayName
        fontFamily
        primaryColor
        textColor
      }
    }
  }
}
    `;
export const VouchersCompanyWidgetDocument = gql`
    query VouchersCompanyWidget($id: ID!) {
  companyWidget(id: $id) {
    __typename
    ... on CompanyWidgetVouchers {
      id
      name
      colorBackground
      colorButton
      colorFontCard
      colorBackgroundCard
      fontFamily
      isOnlyWidgetOfThisType
      invoicingVenueId
      invoicingVenue {
        id
      }
      isDeletable
    }
  }
}
    `;
export const CreateCompanyWidgetVouchersDocument = gql`
    mutation CreateCompanyWidgetVouchers($companyId: ID!, $name: String!, $invoicingVenueId: ID!, $colorBackground: String, $colorBackgroundCard: String, $colorButton: String, $colorFontCard: String, $fontFamily: String) {
  createCompanyWidgetVouchers(
    companyId: $companyId
    name: $name
    invoicingVenueId: $invoicingVenueId
    colorBackground: $colorBackground
    colorBackgroundCard: $colorBackgroundCard
    colorButton: $colorButton
    colorFontCard: $colorFontCard
    fontFamily: $fontFamily
  ) {
    __typename
    ... on CompanyWidgetVouchers {
      id
    }
  }
}
    `;
export const UpdateCompanyWidgetVouchersDocument = gql`
    mutation UpdateCompanyWidgetVouchers($id: ID!, $companyId: ID!, $name: String!, $invoicingVenueId: ID!, $colorBackground: String, $colorBackgroundCard: String, $colorButton: String, $colorFontCard: String, $fontFamily: String) {
  updateCompanyWidgetVouchers(
    id: $id
    companyId: $companyId
    name: $name
    invoicingVenueId: $invoicingVenueId
    colorBackground: $colorBackground
    colorBackgroundCard: $colorBackgroundCard
    colorButton: $colorButton
    colorFontCard: $colorFontCard
    fontFamily: $fontFamily
  ) {
    __typename
    ... on CompanyWidgetVouchers {
      id
    }
  }
}
    `;
export const DeleteWidgetDeleteCompanyWidgetDocument = gql`
    mutation DeleteWidgetDeleteCompanyWidget($id: ID!) {
  deleteCompanyWidget(id: $id)
}
    `;
export const ImageUploadVenueByShortIdDocument = gql`
    query ImageUploadVenueByShortId($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
  }
}
    `;
export const WidgetOverviewActionAssignWidgetToOverviewDocument = gql`
    mutation WidgetOverviewActionAssignWidgetToOverview($widgetId: ID!) {
  assignWidgetToOverview(widgetId: $widgetId) {
    ... on CompanyWidgetOverview {
      id
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export const WidgetOverviewActionUnassignWidgetFromOverviewDocument = gql`
    mutation WidgetOverviewActionUnassignWidgetFromOverview($widgetId: ID!) {
  unassignWidgetFromOverview(widgetId: $widgetId) {
    ... on CompanyWidgetOverview {
      id
    }
    ... on ExpectedErrors {
      errors {
        message
      }
    }
  }
}
    `;
export const UseCompanySportsPaginatedQueryVenueByShortIdDocument = gql`
    query UseCompanySportsPaginatedQueryVenueByShortId($venueShortId: String!, $first: Int, $before: Cursor, $after: Cursor, $last: Int) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
      sports(first: $first, before: $before, after: $after, last: $last) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        nodes {
          id
          name
        }
      }
    }
  }
}
    `;
export const UseCompanyTeachersPaginatedQueryVenueByShortIdDocument = gql`
    query UseCompanyTeachersPaginatedQueryVenueByShortId($venueShortId: String!, $first: Int, $before: Cursor, $after: Cursor, $last: Int) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
      teachers(first: $first, before: $before, after: $after, last: $last) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        nodes {
          id
          name: nickname
        }
      }
    }
  }
}
    `;
export const UseDefaultSportsCompanyPaginatedQueryCompanyWidgetDocument = gql`
    query UseDefaultSportsCompanyPaginatedQueryCompanyWidget($id: ID!, $first: Int, $before: Cursor, $after: Cursor, $last: Int) {
  companyWidget(id: $id) {
    __typename
    ... on CompanyWidgetVideos {
      id
      defaultSports(first: $first, before: $before, after: $after, last: $last) {
        nodes {
          id
          name
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
}
    `;
export const UseDefaultTeachersCompanyPaginatedQueryCompanyWidgetDocument = gql`
    query UseDefaultTeachersCompanyPaginatedQueryCompanyWidget($id: ID!, $first: Int, $before: Cursor, $after: Cursor, $last: Int) {
  companyWidget(id: $id) {
    __typename
    ... on CompanyWidgetVideos {
      id
      defaultTeachers(first: $first, before: $before, after: $after, last: $last) {
        nodes {
          id
          name: nickname
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
}
    `;
export const WidgetCreateVenueByShortIdDocument = gql`
    query WidgetCreateVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    company {
      id
      venues(onlyActive: true) {
        id
        name
      }
    }
  }
}
    `;
export const PublicAppointmentsDocument = gql`
    query PublicAppointments($requestId: ID!) {
  publicAppointments(substitutionRequestId: $requestId) {
    __typename
    id
    name
    start
    end
    venue {
      __typename
      id
      shortId
      name
    }
  }
}
    `;
export const VenueByIdDocument = gql`
    query VenueById($venueId: String!) {
  venue(id: $venueId) {
    id
    shortId
  }
}
    `;
export const RequestFileUploadDocument = gql`
    mutation RequestFileUpload($filename: String!, $venueId: String!, $fileType: String, $description: String) {
  requestFileUpload(
    filename: $filename
    venueId: $venueId
    fileType: $fileType
    description: $description
  ) {
    url
    key
    fields
  }
}
    `;
export const ConfirmFileUploadDocument = gql`
    mutation ConfirmFileUpload($id: ID!, $key: String!, $filename: String!, $venueId: String!, $fileType: String, $description: String) {
  confirmFileUpload(
    id: $id
    key: $key
    filename: $filename
    venueId: $venueId
    fileType: $fileType
    description: $description
  ) {
    id
    filename
    mimeType
    path
    url {
      __typename
      ... on Picture {
        xSmall
      }
      ... on Document {
        url
      }
    }
  }
}
    `;
export const AmplitudePageLoggerVenueByShortIdDocument = gql`
    query AmplitudePageLoggerVenueByShortId($shortId: String!) {
  me {
    id
    isTrainer
  }
  session {
    isAmplitudeTrackingEnabled
  }
  venueByShortId(shortId: $shortId) {
    id
    viewerRole
  }
}
    `;
export const HubspotScriptMeDocument = gql`
    query HubspotScriptMe {
  me {
    id
    hubspotToken
    firstname
    lastname
    email
  }
}
    `;
export const MiddlewareSessionDocument = gql`
    query MiddlewareSession {
  session {
    isLoggedIn
    requiredAction
    currentOrganization {
      id
      resources {
        identifier
      }
    }
    language
    mfa {
      verified
    }
  }
}
    `;
export const DeleteSubstitutionDocument = gql`
    mutation DeleteSubstitution($substitutionId: String!) {
  deleteSubstitution(substitutionId: $substitutionId) {
    success
    errorType
  }
}
    `;
export const CheckAppointmentConflictsV2Document = gql`
    query CheckAppointmentConflictsV2($venueShortId: String!, $startTime: DateTime!, $endTime: DateTime!, $roomId: String, $teacherId: String, $recurrenceSettings: UpdateRecurringAppointmentSettingsInput, $excludeAppointmentId: String) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
      conflictingAppointmentsV2(
        startTime: $startTime
        endTime: $endTime
        roomId: $roomId
        teacherId: $teacherId
        recurrenceSettings: $recurrenceSettings
        excludeAppointmentId: $excludeAppointmentId
      ) {
        hasConflicts
        conflicts {
          conflictType
          appointment {
            id
            name
            start
            end
            venue {
              id
              shortId
              name
            }
          }
        }
      }
    }
  }
}
    `;
export const CustomerSearchDocument = gql`
    query CustomerSearch($venueShortId: String!, $searchTerm: String!, $first: Int, $after: Cursor) {
  venueByShortId(shortId: $venueShortId) {
    id
    customerSearch(searchTerm: $searchTerm, first: $first, after: $after) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        matchedField
        customer {
          id
          firstname
          lastname
          email
          phoneNumber
          customerNumber
          communicationSettings {
            hasTempEmail
          }
          profilePicture {
            small
          }
        }
      }
    }
  }
}
    `;
export const FriendReferralReportExportMeDocument = gql`
    query FriendReferralReportExportMe {
  me {
    id
    email
    accessibleVenues {
      id
      shortId
      viewerRole
      company {
        id
      }
    }
  }
}
    `;
export const FriendReferralReportExportVenueDocument = gql`
    query FriendReferralReportExportVenue($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    company {
      id
    }
  }
}
    `;
export const FriendReferralReportExportDocument = gql`
    mutation FriendReferralReportExport($venueShortIds: [String!]!, $timespans: [TimespanInput!]!, $exportType: ExportType!, $loggedInVenueShortId: String!) {
  export(
    venueShortIds: $venueShortIds
    timespans: $timespans
    exportType: $exportType
    loggedInVenueShortId: $loggedInVenueShortId
  )
}
    `;
export const HeaderVenueByShortIdDocument = gql`
    query HeaderVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    viewerRole
    wallet {
      pspId
    }
  }
}
    `;
export const UserMenuMeDocument = gql`
    query UserMenuMe {
  me {
    id
    firstname
    lastname
    isTrainer
    profilePicture {
      small
    }
  }
  session {
    mfa {
      verified
    }
  }
}
    `;
export const UserMenuVenueByShortIdDocument = gql`
    query UserMenuVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    viewerRole
    type
    venueExtensions {
      id
      extension {
        id
        name
      }
    }
    wallet {
      state
      pspId
    }
    featurePreviews(enabled: true) {
      name
    }
  }
}
    `;
export const VenueSwitcherMeDocument = gql`
    query VenueSwitcherMe {
  me {
    id
    accessibleVenues {
      id
      name
      shortId
    }
  }
}
    `;
export const VenueSwitcherVenueByShortIdDocument = gql`
    query VenueSwitcherVenueByShortId($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    name
    shortId
  }
}
    `;
export const NavigationMeDocument = gql`
    query NavigationMe {
  me {
    id
    isTrainer
  }
  session {
    mfa {
      verified
    }
  }
}
    `;
export const NavigationVenueByShortIdDocument = gql`
    query NavigationVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    viewerRole
    type
    venueExtensions {
      id
      extension {
        id
        name
      }
    }
    wallet {
      state
      pspId
    }
    featurePreviews(enabled: true) {
      name
    }
    bookingRequestsCount(status: [REQUESTED])
  }
}
    `;
export const FetchAllTagsDocument = gql`
    query FetchAllTags($shortId: String!, $searchTerm: String) {
  venueByShortId(shortId: $shortId) {
    company {
      id
      tags(first: 50, searchTerm: $searchTerm) {
        nodes {
          id
          name
          color
        }
      }
    }
  }
}
    `;
export const VenueExtensionGuardVenueByShortIdDocument = gql`
    query VenueExtensionGuardVenueByShortId($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    type
    venueExtensions {
      id
      extension {
        id
        name
      }
    }
  }
}
    `;
export const ViewerRoleGuardVenueByShortIdDocument = gql`
    query ViewerRoleGuardVenueByShortId($shortId: String!) {
  venueByShortId(shortId: $shortId) {
    id
    viewerRole
    internalType
    company {
      city {
        country
      }
    }
    venueExtensions {
      id
      extension {
        id
        name
      }
    }
  }
}
    `;
export const FeaturePreviewsVenueByShortIdDocument = gql`
    query FeaturePreviewsVenueByShortId($venueShortId: String!) {
  venueByShortId(shortId: $venueShortId) {
    id
    featurePreviews(public: true, enabled: true) {
      id
      name
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    RecoverAccountAccess(variables: RecoverAccountAccessMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecoverAccountAccessMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecoverAccountAccessMutation>(RecoverAccountAccessDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RecoverAccountAccess', 'mutation', variables);
    },
    VerifyOTPToken(variables: VerifyOtpTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerifyOtpTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifyOtpTokenMutation>(VerifyOtpTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VerifyOTPToken', 'mutation', variables);
    },
    RequestPasswordReset(variables: RequestPasswordResetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RequestPasswordResetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestPasswordResetMutation>(RequestPasswordResetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RequestPasswordReset', 'mutation', variables);
    },
    Login(variables: LoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginMutation>(LoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Login', 'mutation', variables);
    },
    Logout(variables?: LogoutMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LogoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LogoutMutation>(LogoutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Logout', 'mutation', variables);
    },
    Maskerade(variables: MaskeradeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MaskeradeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MaskeradeMutation>(MaskeradeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Maskerade', 'mutation', variables);
    },
    PasswordReset(variables: PasswordResetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PasswordResetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PasswordResetMutation>(PasswordResetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PasswordReset', 'mutation', variables);
    },
    ChangeOrganization(variables: ChangeOrganizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChangeOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeOrganizationMutation>(ChangeOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ChangeOrganization', 'mutation', variables);
    },
    SetupMFASession(variables?: SetupMfaSessionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetupMfaSessionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetupMfaSessionQuery>(SetupMfaSessionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetupMFASession', 'query', variables);
    },
    SetupMFA(variables?: SetupMfaMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetupMfaMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetupMfaMutation>(SetupMfaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetupMFA', 'mutation', variables);
    },
    VerifyMFAToken(variables: VerifyMfaTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerifyMfaTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifyMfaTokenMutation>(VerifyMfaTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VerifyMFAToken', 'mutation', variables);
    },
    VenueSwitcher(variables?: VenueSwitcherQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VenueSwitcherQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VenueSwitcherQuery>(VenueSwitcherDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VenueSwitcher', 'query', variables);
    },
    VenueLandingPage(variables: VenueLandingPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VenueLandingPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VenueLandingPageQuery>(VenueLandingPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VenueLandingPage', 'query', variables);
    },
    VenueLandingPageSession(variables?: VenueLandingPageSessionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VenueLandingPageSessionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VenueLandingPageSessionQuery>(VenueLandingPageSessionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VenueLandingPageSession', 'query', variables);
    },
    SetOrganization(variables: SetOrganizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetOrganizationMutation>(SetOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetOrganization', 'mutation', variables);
    },
    GetAssignedFloorPlan(variables: GetAssignedFloorPlanQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAssignedFloorPlanQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAssignedFloorPlanQuery>(GetAssignedFloorPlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAssignedFloorPlan', 'query', variables);
    },
    CancelAppointment(variables: CancelAppointmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CancelAppointmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelAppointmentMutation>(CancelAppointmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CancelAppointment', 'mutation', variables);
    },
    PrivateSessionBannerVisibility(variables: PrivateSessionBannerVisibilityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionBannerVisibilityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionBannerVisibilityQuery>(PrivateSessionBannerVisibilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionBannerVisibility', 'query', variables);
    },
    GetPrivateSessions(variables: GetPrivateSessionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPrivateSessionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPrivateSessionsQuery>(GetPrivateSessionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPrivateSessions', 'query', variables);
    },
    SaveRoomSharingRule(variables: SaveRoomSharingRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveRoomSharingRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveRoomSharingRuleMutation>(SaveRoomSharingRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveRoomSharingRule', 'mutation', variables);
    },
    DeleteRoomSharingRule(variables: DeleteRoomSharingRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteRoomSharingRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteRoomSharingRuleMutation>(DeleteRoomSharingRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteRoomSharingRule', 'mutation', variables);
    },
    PrivateSessionOffersUsingRoom(variables: PrivateSessionOffersUsingRoomQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionOffersUsingRoomQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionOffersUsingRoomQuery>(PrivateSessionOffersUsingRoomDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionOffersUsingRoom', 'query', variables);
    },
    RoomsWithRules(variables: RoomsWithRulesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoomsWithRulesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoomsWithRulesQuery>(RoomsWithRulesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RoomsWithRules', 'query', variables);
    },
    PrivateSessionsEditMetaData(variables: PrivateSessionsEditMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionsEditMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionsEditMetaDataQuery>(PrivateSessionsEditMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionsEditMetaData', 'query', variables);
    },
    PrivateSessionsEditVenueData(variables: PrivateSessionsEditVenueDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionsEditVenueDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionsEditVenueDataQuery>(PrivateSessionsEditVenueDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionsEditVenueData', 'query', variables);
    },
    UpdatePrivateSessionOffer(variables: UpdatePrivateSessionOfferMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePrivateSessionOfferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePrivateSessionOfferMutation>(UpdatePrivateSessionOfferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdatePrivateSessionOffer', 'mutation', variables);
    },
    PrivateSessionsMetaData(variables: PrivateSessionsMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionsMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionsMetaDataQuery>(PrivateSessionsMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionsMetaData', 'query', variables);
    },
    PrivateSessionsCity(variables: PrivateSessionsCityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionsCityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionsCityQuery>(PrivateSessionsCityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionsCity', 'query', variables);
    },
    PrivateSessionsTeachers(variables: PrivateSessionsTeachersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionsTeachersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionsTeachersQuery>(PrivateSessionsTeachersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionsTeachers', 'query', variables);
    },
    PrivateSessionsRooms(variables: PrivateSessionsRoomsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionsRoomsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionsRoomsQuery>(PrivateSessionsRoomsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionsRooms', 'query', variables);
    },
    PrivateSessionsTeachersWithAvailability(variables: PrivateSessionsTeachersWithAvailabilityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionsTeachersWithAvailabilityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionsTeachersWithAvailabilityQuery>(PrivateSessionsTeachersWithAvailabilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionsTeachersWithAvailability', 'query', variables);
    },
    PrivateSessionsProductGroups(variables: PrivateSessionsProductGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionsProductGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionsProductGroupsQuery>(PrivateSessionsProductGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionsProductGroups', 'query', variables);
    },
    PrivateSessionOfferTemplates(variables: PrivateSessionOfferTemplatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionOfferTemplatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionOfferTemplatesQuery>(PrivateSessionOfferTemplatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionOfferTemplates', 'query', variables);
    },
    PrivateSessionOfferTemplateResources(variables: PrivateSessionOfferTemplateResourcesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionOfferTemplateResourcesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionOfferTemplateResourcesQuery>(PrivateSessionOfferTemplateResourcesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionOfferTemplateResources', 'query', variables);
    },
    DefaultPrivateSessionPaymentOption(variables: DefaultPrivateSessionPaymentOptionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DefaultPrivateSessionPaymentOptionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DefaultPrivateSessionPaymentOptionQuery>(DefaultPrivateSessionPaymentOptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DefaultPrivateSessionPaymentOption', 'query', variables);
    },
    CreatePrivateSessionOffer(variables: CreatePrivateSessionOfferMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePrivateSessionOfferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePrivateSessionOfferMutation>(CreatePrivateSessionOfferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreatePrivateSessionOffer', 'mutation', variables);
    },
    ArchiveActivity(variables: ArchiveActivityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveActivityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveActivityMutation>(ArchiveActivityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchiveActivity', 'mutation', variables);
    },
    CreateActivityGroup(variables: CreateActivityGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateActivityGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateActivityGroupMutation>(CreateActivityGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateActivityGroup', 'mutation', variables);
    },
    BookingAvailability(variables: BookingAvailabilityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BookingAvailabilityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingAvailabilityQuery>(BookingAvailabilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BookingAvailability', 'query', variables);
    },
    ProductsWithParticipationRules(variables: ProductsWithParticipationRulesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductsWithParticipationRulesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductsWithParticipationRulesQuery>(ProductsWithParticipationRulesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProductsWithParticipationRules', 'query', variables);
    },
    PrivateSessionsVenueData(variables: PrivateSessionsVenueDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionsVenueDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionsVenueDataQuery>(PrivateSessionsVenueDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionsVenueData', 'query', variables);
    },
    GetPrivateSessionOffersForCreate(variables: GetPrivateSessionOffersForCreateQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPrivateSessionOffersForCreateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPrivateSessionOffersForCreateQuery>(GetPrivateSessionOffersForCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPrivateSessionOffersForCreate', 'query', variables);
    },
    GetPrivateSessionsVenueByShortId(variables: GetPrivateSessionsVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPrivateSessionsVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPrivateSessionsVenueByShortIdQuery>(GetPrivateSessionsVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPrivateSessionsVenueByShortId', 'query', variables);
    },
    GetPrivateSessionOfferResources(variables: GetPrivateSessionOfferResourcesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPrivateSessionOfferResourcesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPrivateSessionOfferResourcesQuery>(GetPrivateSessionOfferResourcesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPrivateSessionOfferResources', 'query', variables);
    },
    CreatePrivateSession(variables: CreatePrivateSessionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePrivateSessionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePrivateSessionMutation>(CreatePrivateSessionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreatePrivateSession', 'mutation', variables);
    },
    GetPrivateSessionVenueSettings(variables: GetPrivateSessionVenueSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPrivateSessionVenueSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPrivateSessionVenueSettingsQuery>(GetPrivateSessionVenueSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPrivateSessionVenueSettings', 'query', variables);
    },
    GetPrivateSessionViewerContext(variables: GetPrivateSessionViewerContextQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPrivateSessionViewerContextQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPrivateSessionViewerContextQuery>(GetPrivateSessionViewerContextDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPrivateSessionViewerContext', 'query', variables);
    },
    GetPrivateSessionCalendarAppointments(variables: GetPrivateSessionCalendarAppointmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPrivateSessionCalendarAppointmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPrivateSessionCalendarAppointmentsQuery>(GetPrivateSessionCalendarAppointmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPrivateSessionCalendarAppointments', 'query', variables);
    },
    GetPrivateSessionAppointmentDetail(variables: GetPrivateSessionAppointmentDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPrivateSessionAppointmentDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPrivateSessionAppointmentDetailQuery>(GetPrivateSessionAppointmentDetailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPrivateSessionAppointmentDetail', 'query', variables);
    },
    GetPrivateSessionBookingRequests(variables: GetPrivateSessionBookingRequestsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPrivateSessionBookingRequestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPrivateSessionBookingRequestsQuery>(GetPrivateSessionBookingRequestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPrivateSessionBookingRequests', 'query', variables);
    },
    CreateRecurringAppointment(variables: CreateRecurringAppointmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRecurringAppointmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRecurringAppointmentMutation>(CreateRecurringAppointmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateRecurringAppointment', 'mutation', variables);
    },
    DeclineBookingRequest(variables: DeclineBookingRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeclineBookingRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeclineBookingRequestMutation>(DeclineBookingRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeclineBookingRequest', 'mutation', variables);
    },
    GetBookingRequestById(variables: GetBookingRequestByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBookingRequestByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBookingRequestByIdQuery>(GetBookingRequestByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBookingRequestById', 'query', variables);
    },
    GetBookingRequestStatusById(variables: GetBookingRequestStatusByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBookingRequestStatusByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBookingRequestStatusByIdQuery>(GetBookingRequestStatusByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBookingRequestStatusById', 'query', variables);
    },
    AcceptBookingRequest(variables: AcceptBookingRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcceptBookingRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcceptBookingRequestMutation>(AcceptBookingRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AcceptBookingRequest', 'mutation', variables);
    },
    GetPrivateSessionsForDragEvent(variables: GetPrivateSessionsForDragEventQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPrivateSessionsForDragEventQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPrivateSessionsForDragEventQuery>(GetPrivateSessionsForDragEventDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPrivateSessionsForDragEvent', 'query', variables);
    },
    GetViewerId(variables?: GetViewerIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetViewerIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetViewerIdQuery>(GetViewerIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetViewerId', 'query', variables);
    },
    GetMyAvailabilitySettings(variables: GetMyAvailabilitySettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetMyAvailabilitySettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMyAvailabilitySettingsQuery>(GetMyAvailabilitySettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMyAvailabilitySettings', 'query', variables);
    },
    GetDefaultTeacherAvailability(variables: GetDefaultTeacherAvailabilityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetDefaultTeacherAvailabilityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDefaultTeacherAvailabilityQuery>(GetDefaultTeacherAvailabilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetDefaultTeacherAvailability', 'query', variables);
    },
    GetTargetTeacherAvailability(variables: GetTargetTeacherAvailabilityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTargetTeacherAvailabilityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTargetTeacherAvailabilityQuery>(GetTargetTeacherAvailabilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTargetTeacherAvailability', 'query', variables);
    },
    GetTeacherAppointment(variables: GetTeacherAppointmentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTeacherAppointmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTeacherAppointmentQuery>(GetTeacherAppointmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTeacherAppointment', 'query', variables);
    },
    UpdateDefaultTeacherAvailability(variables: UpdateDefaultTeacherAvailabilityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDefaultTeacherAvailabilityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDefaultTeacherAvailabilityMutation>(UpdateDefaultTeacherAvailabilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateDefaultTeacherAvailability', 'mutation', variables);
    },
    UpdateDefaultTeacherAvailabilities(variables: UpdateDefaultTeacherAvailabilitiesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDefaultTeacherAvailabilitiesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDefaultTeacherAvailabilitiesMutation>(UpdateDefaultTeacherAvailabilitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateDefaultTeacherAvailabilities', 'mutation', variables);
    },
    DeleteDefaultTeacherAvailabilities(variables: DeleteDefaultTeacherAvailabilitiesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteDefaultTeacherAvailabilitiesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteDefaultTeacherAvailabilitiesMutation>(DeleteDefaultTeacherAvailabilitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteDefaultTeacherAvailabilities', 'mutation', variables);
    },
    GetTeacherAvailabilityExceptions(variables: GetTeacherAvailabilityExceptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTeacherAvailabilityExceptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTeacherAvailabilityExceptionsQuery>(GetTeacherAvailabilityExceptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTeacherAvailabilityExceptions', 'query', variables);
    },
    GetTargetTeacherAvailabilityExceptions(variables: GetTargetTeacherAvailabilityExceptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTargetTeacherAvailabilityExceptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTargetTeacherAvailabilityExceptionsQuery>(GetTargetTeacherAvailabilityExceptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTargetTeacherAvailabilityExceptions', 'query', variables);
    },
    SaveTeacherDaySpecificAvailability(variables: SaveTeacherDaySpecificAvailabilityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveTeacherDaySpecificAvailabilityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveTeacherDaySpecificAvailabilityMutation>(SaveTeacherDaySpecificAvailabilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveTeacherDaySpecificAvailability', 'mutation', variables);
    },
    SaveTeacherDaySpecificAvailabilities(variables: SaveTeacherDaySpecificAvailabilitiesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveTeacherDaySpecificAvailabilitiesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveTeacherDaySpecificAvailabilitiesMutation>(SaveTeacherDaySpecificAvailabilitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveTeacherDaySpecificAvailabilities', 'mutation', variables);
    },
    DeleteTeacherDaySpecificAvailability(variables: DeleteTeacherDaySpecificAvailabilityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteTeacherDaySpecificAvailabilityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTeacherDaySpecificAvailabilityMutation>(DeleteTeacherDaySpecificAvailabilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteTeacherDaySpecificAvailability', 'mutation', variables);
    },
    GetTeacherCalendarIntegrations(variables: GetTeacherCalendarIntegrationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTeacherCalendarIntegrationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTeacherCalendarIntegrationsQuery>(GetTeacherCalendarIntegrationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTeacherCalendarIntegrations', 'query', variables);
    },
    GetTargetTeacherCalendarIntegrations(variables: GetTargetTeacherCalendarIntegrationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTargetTeacherCalendarIntegrationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTargetTeacherCalendarIntegrationsQuery>(GetTargetTeacherCalendarIntegrationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTargetTeacherCalendarIntegrations', 'query', variables);
    },
    CreateTeacherCalendarIntegration(variables: CreateTeacherCalendarIntegrationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTeacherCalendarIntegrationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTeacherCalendarIntegrationMutation>(CreateTeacherCalendarIntegrationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateTeacherCalendarIntegration', 'mutation', variables);
    },
    SyncTeacherCalendarIntegration(variables: SyncTeacherCalendarIntegrationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SyncTeacherCalendarIntegrationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SyncTeacherCalendarIntegrationMutation>(SyncTeacherCalendarIntegrationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SyncTeacherCalendarIntegration', 'mutation', variables);
    },
    DeleteTeacherCalendarIntegration(variables: DeleteTeacherCalendarIntegrationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteTeacherCalendarIntegrationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTeacherCalendarIntegrationMutation>(DeleteTeacherCalendarIntegrationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteTeacherCalendarIntegration', 'mutation', variables);
    },
    CreateCustomerGroups(variables: CreateCustomerGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCustomerGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCustomerGroupsQuery>(CreateCustomerGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateCustomerGroups', 'query', variables);
    },
    CreateCustomerTags(variables: CreateCustomerTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCustomerTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCustomerTagsQuery>(CreateCustomerTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateCustomerTags', 'query', variables);
    },
    PrivateSessionTeacherFilterOptions(variables: PrivateSessionTeacherFilterOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionTeacherFilterOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionTeacherFilterOptionsQuery>(PrivateSessionTeacherFilterOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionTeacherFilterOptions', 'query', variables);
    },
    PrivateSessionsSheetAppointmentById(variables: PrivateSessionsSheetAppointmentByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionsSheetAppointmentByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionsSheetAppointmentByIdQuery>(PrivateSessionsSheetAppointmentByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionsSheetAppointmentById', 'query', variables);
    },
    PrivateSessionsSheetRecurringChangeCount(variables: PrivateSessionsSheetRecurringChangeCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionsSheetRecurringChangeCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionsSheetRecurringChangeCountQuery>(PrivateSessionsSheetRecurringChangeCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionsSheetRecurringChangeCount', 'query', variables);
    },
    PrivateSessionsSheetUpdatePrivateSession(variables: PrivateSessionsSheetUpdatePrivateSessionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionsSheetUpdatePrivateSessionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionsSheetUpdatePrivateSessionMutation>(PrivateSessionsSheetUpdatePrivateSessionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionsSheetUpdatePrivateSession', 'mutation', variables);
    },
    CancelRecurringPrivateSession(variables: CancelRecurringPrivateSessionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CancelRecurringPrivateSessionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelRecurringPrivateSessionMutation>(CancelRecurringPrivateSessionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CancelRecurringPrivateSession', 'mutation', variables);
    },
    HidePrivateSessionFromCalendar(variables: HidePrivateSessionFromCalendarMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<HidePrivateSessionFromCalendarMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<HidePrivateSessionFromCalendarMutation>(HidePrivateSessionFromCalendarDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'HidePrivateSessionFromCalendar', 'mutation', variables);
    },
    HideRecurringPrivateSessionFromCalendar(variables: HideRecurringPrivateSessionFromCalendarMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<HideRecurringPrivateSessionFromCalendarMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<HideRecurringPrivateSessionFromCalendarMutation>(HideRecurringPrivateSessionFromCalendarDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'HideRecurringPrivateSessionFromCalendar', 'mutation', variables);
    },
    SubstitutionsMetaData(variables: SubstitutionsMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SubstitutionsMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubstitutionsMetaDataQuery>(SubstitutionsMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SubstitutionsMetaData', 'query', variables);
    },
    GetAppointmentsForSubstitutions(variables: GetAppointmentsForSubstitutionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAppointmentsForSubstitutionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAppointmentsForSubstitutionsQuery>(GetAppointmentsForSubstitutionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAppointmentsForSubstitutions', 'query', variables);
    },
    SubstitutionRequestAppointments(variables: SubstitutionRequestAppointmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SubstitutionRequestAppointmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubstitutionRequestAppointmentsQuery>(SubstitutionRequestAppointmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SubstitutionRequestAppointments', 'query', variables);
    },
    CreateSubstitutionRequest(variables: CreateSubstitutionRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSubstitutionRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSubstitutionRequestMutation>(CreateSubstitutionRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSubstitutionRequest', 'mutation', variables);
    },
    AcceptSubstitutionRequest(variables: AcceptSubstitutionRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcceptSubstitutionRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcceptSubstitutionRequestMutation>(AcceptSubstitutionRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AcceptSubstitutionRequest', 'mutation', variables);
    },
    DeclineSubstitutionRequest(variables: DeclineSubstitutionRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeclineSubstitutionRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeclineSubstitutionRequestMutation>(DeclineSubstitutionRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeclineSubstitutionRequest', 'mutation', variables);
    },
    GetAppointmentsForSubstitutionsSummary(variables: GetAppointmentsForSubstitutionsSummaryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAppointmentsForSubstitutionsSummaryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAppointmentsForSubstitutionsSummaryQuery>(GetAppointmentsForSubstitutionsSummaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAppointmentsForSubstitutionsSummary', 'query', variables);
    },
    GetAppointmentsForSubstitutionsSummaryV2(variables: GetAppointmentsForSubstitutionsSummaryV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAppointmentsForSubstitutionsSummaryV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAppointmentsForSubstitutionsSummaryV2Query>(GetAppointmentsForSubstitutionsSummaryV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAppointmentsForSubstitutionsSummaryV2', 'query', variables);
    },
    GetSubstitutionRequest(variables: GetSubstitutionRequestQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSubstitutionRequestQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSubstitutionRequestQuery>(GetSubstitutionRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSubstitutionRequest', 'query', variables);
    },
    SubstitutionRequestsMetaData(variables: SubstitutionRequestsMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SubstitutionRequestsMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubstitutionRequestsMetaDataQuery>(SubstitutionRequestsMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SubstitutionRequestsMetaData', 'query', variables);
    },
    VenueData(variables: VenueDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VenueDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VenueDataQuery>(VenueDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VenueData', 'query', variables);
    },
    SubstitutionFilterTeachers(variables: SubstitutionFilterTeachersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SubstitutionFilterTeachersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubstitutionFilterTeachersQuery>(SubstitutionFilterTeachersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SubstitutionFilterTeachers', 'query', variables);
    },
    SubstitutionRequests(variables: SubstitutionRequestsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SubstitutionRequestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubstitutionRequestsQuery>(SubstitutionRequestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SubstitutionRequests', 'query', variables);
    },
    CreateSubstitutionRequestFromExisting(variables: CreateSubstitutionRequestFromExistingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSubstitutionRequestFromExistingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSubstitutionRequestFromExistingMutation>(CreateSubstitutionRequestFromExistingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSubstitutionRequestFromExisting', 'mutation', variables);
    },
    AnalyticsVenueByShortId(variables: AnalyticsVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AnalyticsVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnalyticsVenueByShortIdQuery>(AnalyticsVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AnalyticsVenueByShortId', 'query', variables);
    },
    AnalyticsQuicksightAnalyticsDashboards(variables: AnalyticsQuicksightAnalyticsDashboardsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AnalyticsQuicksightAnalyticsDashboardsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnalyticsQuicksightAnalyticsDashboardsQuery>(AnalyticsQuicksightAnalyticsDashboardsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AnalyticsQuicksightAnalyticsDashboards', 'query', variables);
    },
    AnalyticsQuicksightAnalyticsDashboard(variables: AnalyticsQuicksightAnalyticsDashboardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AnalyticsQuicksightAnalyticsDashboardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnalyticsQuicksightAnalyticsDashboardQuery>(AnalyticsQuicksightAnalyticsDashboardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AnalyticsQuicksightAnalyticsDashboard', 'query', variables);
    },
    AnalyticsGenerateQuicksightAnalyticsEmbedUrl(variables: AnalyticsGenerateQuicksightAnalyticsEmbedUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AnalyticsGenerateQuicksightAnalyticsEmbedUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnalyticsGenerateQuicksightAnalyticsEmbedUrlMutation>(AnalyticsGenerateQuicksightAnalyticsEmbedUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AnalyticsGenerateQuicksightAnalyticsEmbedUrl', 'mutation', variables);
    },
    AverageKPIsVenueByShortId(variables: AverageKpIsVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AverageKpIsVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AverageKpIsVenueByShortIdQuery>(AverageKpIsVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AverageKPIsVenueByShortId', 'query', variables);
    },
    UtilizationKPIVenueByShortId(variables: UtilizationKpiVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UtilizationKpiVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UtilizationKpiVenueByShortIdQuery>(UtilizationKpiVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UtilizationKPIVenueByShortId', 'query', variables);
    },
    VenueSelectorMe(variables?: VenueSelectorMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VenueSelectorMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VenueSelectorMeQuery>(VenueSelectorMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VenueSelectorMe', 'query', variables);
    },
    YearlyBookingDevelopmentChartVenueByShortId(variables: YearlyBookingDevelopmentChartVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<YearlyBookingDevelopmentChartVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<YearlyBookingDevelopmentChartVenueByShortIdQuery>(YearlyBookingDevelopmentChartVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'YearlyBookingDevelopmentChartVenueByShortId', 'query', variables);
    },
    YearlyBookingDevelopmentChartExport(variables: YearlyBookingDevelopmentChartExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<YearlyBookingDevelopmentChartExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<YearlyBookingDevelopmentChartExportMutation>(YearlyBookingDevelopmentChartExportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'YearlyBookingDevelopmentChartExport', 'mutation', variables);
    },
    YearlyCustomerDevelopmentChartVenueByShortId(variables: YearlyCustomerDevelopmentChartVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<YearlyCustomerDevelopmentChartVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<YearlyCustomerDevelopmentChartVenueByShortIdQuery>(YearlyCustomerDevelopmentChartVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'YearlyCustomerDevelopmentChartVenueByShortId', 'query', variables);
    },
    YearlyCustomerDevelopmentChartExport(variables: YearlyCustomerDevelopmentChartExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<YearlyCustomerDevelopmentChartExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<YearlyCustomerDevelopmentChartExportMutation>(YearlyCustomerDevelopmentChartExportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'YearlyCustomerDevelopmentChartExport', 'mutation', variables);
    },
    YearlyMembershipDevelopmentChartVenueByShortId(variables: YearlyMembershipDevelopmentChartVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<YearlyMembershipDevelopmentChartVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<YearlyMembershipDevelopmentChartVenueByShortIdQuery>(YearlyMembershipDevelopmentChartVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'YearlyMembershipDevelopmentChartVenueByShortId', 'query', variables);
    },
    YearlyMembershipDevelopmentChartExport(variables: YearlyMembershipDevelopmentChartExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<YearlyMembershipDevelopmentChartExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<YearlyMembershipDevelopmentChartExportMutation>(YearlyMembershipDevelopmentChartExportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'YearlyMembershipDevelopmentChartExport', 'mutation', variables);
    },
    YearlyRevenueChartVenueByShortId(variables: YearlyRevenueChartVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<YearlyRevenueChartVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<YearlyRevenueChartVenueByShortIdQuery>(YearlyRevenueChartVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'YearlyRevenueChartVenueByShortId', 'query', variables);
    },
    YearlyRevenueChartExport(variables: YearlyRevenueChartExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<YearlyRevenueChartExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<YearlyRevenueChartExportMutation>(YearlyRevenueChartExportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'YearlyRevenueChartExport', 'mutation', variables);
    },
    ActivityReportExportMe(variables?: ActivityReportExportMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivityReportExportMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivityReportExportMeQuery>(ActivityReportExportMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivityReportExportMe', 'query', variables);
    },
    ActivityReportExportVenue(variables: ActivityReportExportVenueQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivityReportExportVenueQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivityReportExportVenueQuery>(ActivityReportExportVenueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivityReportExportVenue', 'query', variables);
    },
    ActivityReportExport(variables: ActivityReportExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivityReportExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivityReportExportMutation>(ActivityReportExportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivityReportExport', 'mutation', variables);
    },
    CustomerReportExportMe(variables?: CustomerReportExportMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerReportExportMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerReportExportMeQuery>(CustomerReportExportMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CustomerReportExportMe', 'query', variables);
    },
    CustomerReportExportVenue(variables: CustomerReportExportVenueQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerReportExportVenueQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerReportExportVenueQuery>(CustomerReportExportVenueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CustomerReportExportVenue', 'query', variables);
    },
    CustomerReportExport(variables: CustomerReportExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerReportExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerReportExportMutation>(CustomerReportExportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CustomerReportExport', 'mutation', variables);
    },
    FinancialReportExportMe(variables?: FinancialReportExportMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FinancialReportExportMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FinancialReportExportMeQuery>(FinancialReportExportMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FinancialReportExportMe', 'query', variables);
    },
    FinancialReportExportVenue(variables: FinancialReportExportVenueQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FinancialReportExportVenueQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FinancialReportExportVenueQuery>(FinancialReportExportVenueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FinancialReportExportVenue', 'query', variables);
    },
    FinancialReportExport(variables: FinancialReportExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FinancialReportExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FinancialReportExportMutation>(FinancialReportExportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FinancialReportExport', 'mutation', variables);
    },
    ReportsVenueByShortId(variables: ReportsVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReportsVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportsVenueByShortIdQuery>(ReportsVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ReportsVenueByShortId', 'query', variables);
    },
    BillingCommunicationMetaData(variables: BillingCommunicationMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BillingCommunicationMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BillingCommunicationMetaDataQuery>(BillingCommunicationMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BillingCommunicationMetaData', 'query', variables);
    },
    BillingCommunicationVenueByShortId(variables: BillingCommunicationVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BillingCommunicationVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BillingCommunicationVenueByShortIdQuery>(BillingCommunicationVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BillingCommunicationVenueByShortId', 'query', variables);
    },
    ContractInformationMetaData(variables: ContractInformationMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContractInformationMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContractInformationMetaDataQuery>(ContractInformationMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ContractInformationMetaData', 'query', variables);
    },
    ContractInformationVenueByShortId(variables: ContractInformationVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContractInformationVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContractInformationVenueByShortIdQuery>(ContractInformationVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ContractInformationVenueByShortId', 'query', variables);
    },
    PayoutVenueMetaData(variables: PayoutVenueMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PayoutVenueMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PayoutVenueMetaDataQuery>(PayoutVenueMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PayoutVenueMetaData', 'query', variables);
    },
    PayoutVenueByShortId(variables: PayoutVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PayoutVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PayoutVenueByShortIdQuery>(PayoutVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PayoutVenueByShortId', 'query', variables);
    },
    FetchStripePayouts(variables: FetchStripePayoutsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchStripePayoutsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchStripePayoutsQuery>(FetchStripePayoutsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchStripePayouts', 'query', variables);
    },
    FetchStripePayoutConfirmation(variables: FetchStripePayoutConfirmationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchStripePayoutConfirmationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchStripePayoutConfirmationQuery>(FetchStripePayoutConfirmationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchStripePayoutConfirmation', 'query', variables);
    },
    SetStripePayoutSettings(variables: SetStripePayoutSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetStripePayoutSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetStripePayoutSettingsMutation>(SetStripePayoutSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetStripePayoutSettings', 'mutation', variables);
    },
    FetchInvoices(variables: FetchInvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchInvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchInvoicesQuery>(FetchInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchInvoices', 'query', variables);
    },
    TechnicalEventLog(variables: TechnicalEventLogQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TechnicalEventLogQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TechnicalEventLogQuery>(TechnicalEventLogDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TechnicalEventLog', 'query', variables);
    },
    VerifyTechnicalEventLogSignatureIntegrity(variables: VerifyTechnicalEventLogSignatureIntegrityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerifyTechnicalEventLogSignatureIntegrityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifyTechnicalEventLogSignatureIntegrityMutation>(VerifyTechnicalEventLogSignatureIntegrityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VerifyTechnicalEventLogSignatureIntegrity', 'mutation', variables);
    },
    ExportTechnicalEventLog(variables: ExportTechnicalEventLogMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExportTechnicalEventLogMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExportTechnicalEventLogMutation>(ExportTechnicalEventLogDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ExportTechnicalEventLog', 'mutation', variables);
    },
    CourtCalendarSports(variables: CourtCalendarSportsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CourtCalendarSportsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CourtCalendarSportsQuery>(CourtCalendarSportsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CourtCalendarSports', 'query', variables);
    },
    CourtCalendarCourts(variables: CourtCalendarCourtsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CourtCalendarCourtsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CourtCalendarCourtsQuery>(CourtCalendarCourtsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CourtCalendarCourts', 'query', variables);
    },
    CreateReservation(variables: CreateReservationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateReservationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateReservationMutation>(CreateReservationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateReservation', 'mutation', variables);
    },
    ReservationCustomerTags(variables: ReservationCustomerTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReservationCustomerTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReservationCustomerTagsQuery>(ReservationCustomerTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ReservationCustomerTags', 'query', variables);
    },
    CourtCalendarReservations(variables: CourtCalendarReservationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CourtCalendarReservationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CourtCalendarReservationsQuery>(CourtCalendarReservationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CourtCalendarReservations', 'query', variables);
    },
    CourtCalendarVenuePaymentOptions(variables: CourtCalendarVenuePaymentOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CourtCalendarVenuePaymentOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CourtCalendarVenuePaymentOptionsQuery>(CourtCalendarVenuePaymentOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CourtCalendarVenuePaymentOptions', 'query', variables);
    },
    GetCourt(variables: GetCourtQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCourtQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCourtQuery>(GetCourtDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCourt', 'query', variables);
    },
    CourtsVenueCurrency(variables: CourtsVenueCurrencyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CourtsVenueCurrencyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CourtsVenueCurrencyQuery>(CourtsVenueCurrencyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CourtsVenueCurrency', 'query', variables);
    },
    CourtsVenueId(variables: CourtsVenueIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CourtsVenueIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CourtsVenueIdQuery>(CourtsVenueIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CourtsVenueId', 'query', variables);
    },
    CourtsVenueOpeningHours(variables: CourtsVenueOpeningHoursQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CourtsVenueOpeningHoursQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CourtsVenueOpeningHoursQuery>(CourtsVenueOpeningHoursDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CourtsVenueOpeningHours', 'query', variables);
    },
    SaveCourts(variables: SaveCourtsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveCourtsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveCourtsMutation>(SaveCourtsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveCourts', 'mutation', variables);
    },
    MakeCourtUnavailable(variables: MakeCourtUnavailableMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MakeCourtUnavailableMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MakeCourtUnavailableMutation>(MakeCourtUnavailableDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MakeCourtUnavailable', 'mutation', variables);
    },
    GetCourts(variables: GetCourtsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCourtsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCourtsQuery>(GetCourtsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCourts', 'query', variables);
    },
    GetVenueRentalRulesForNewCourt(variables: GetVenueRentalRulesForNewCourtQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetVenueRentalRulesForNewCourtQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetVenueRentalRulesForNewCourtQuery>(GetVenueRentalRulesForNewCourtDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetVenueRentalRulesForNewCourt', 'query', variables);
    },
    GetVenueSports(variables: GetVenueSportsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetVenueSportsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetVenueSportsQuery>(GetVenueSportsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetVenueSports', 'query', variables);
    },
    ArchiveRentalRule(variables: ArchiveRentalRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveRentalRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveRentalRuleMutation>(ArchiveRentalRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchiveRentalRule', 'mutation', variables);
    },
    GetVenueRentalRules(variables: GetVenueRentalRulesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetVenueRentalRulesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetVenueRentalRulesQuery>(GetVenueRentalRulesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetVenueRentalRules', 'query', variables);
    },
    SaveAvailabilityRule(variables: SaveAvailabilityRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveAvailabilityRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveAvailabilityRuleMutation>(SaveAvailabilityRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveAvailabilityRule', 'mutation', variables);
    },
    SaveEligibilityRule(variables: SaveEligibilityRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveEligibilityRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveEligibilityRuleMutation>(SaveEligibilityRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveEligibilityRule', 'mutation', variables);
    },
    SavePriceRule(variables: SavePriceRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SavePriceRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SavePriceRuleMutation>(SavePriceRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SavePriceRule', 'mutation', variables);
    },
    SaveCancellationRule(variables: SaveCancellationRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveCancellationRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveCancellationRuleMutation>(SaveCancellationRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveCancellationRule', 'mutation', variables);
    },
    SaveSlotRule(variables: SaveSlotRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveSlotRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveSlotRuleMutation>(SaveSlotRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveSlotRule', 'mutation', variables);
    },
    AddPhoneCall(variables: AddPhoneCallMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddPhoneCallMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddPhoneCallMutation>(AddPhoneCallDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddPhoneCall', 'mutation', variables);
    },
    AddNote(variables: AddNoteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddNoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddNoteMutation>(AddNoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddNote', 'mutation', variables);
    },
    CommunicationHistory(variables: CommunicationHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationHistoryQuery>(CommunicationHistoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationHistory', 'query', variables);
    },
    CustomerProfileHeader(variables: CustomerProfileHeaderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerProfileHeaderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerProfileHeaderQuery>(CustomerProfileHeaderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CustomerProfileHeader', 'query', variables);
    },
    RemovePhoneCall(variables: RemovePhoneCallMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemovePhoneCallMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemovePhoneCallMutation>(RemovePhoneCallDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemovePhoneCall', 'mutation', variables);
    },
    RemoveNote(variables: RemoveNoteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveNoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveNoteMutation>(RemoveNoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveNote', 'mutation', variables);
    },
    CreateTag(variables: CreateTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTagMutation>(CreateTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateTag', 'mutation', variables);
    },
    GetTags(variables: GetTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTagsQuery>(GetTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTags', 'query', variables);
    },
    DeleteTag(variables: DeleteTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTagMutation>(DeleteTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteTag', 'mutation', variables);
    },
    UpdateTag(variables: UpdateTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTagMutation>(UpdateTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateTag', 'mutation', variables);
    },
    FetchTags(variables: FetchTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchTagsQuery>(FetchTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchTags', 'query', variables);
    },
    TagsMetaData(variables: TagsMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TagsMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TagsMetaDataQuery>(TagsMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TagsMetaData', 'query', variables);
    },
    UseCommunicationExtensionHelper(variables: UseCommunicationExtensionHelperQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseCommunicationExtensionHelperQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseCommunicationExtensionHelperQuery>(UseCommunicationExtensionHelperDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UseCommunicationExtensionHelper', 'query', variables);
    },
    AutomationIdMetaData(variables: AutomationIdMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AutomationIdMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationIdMetaDataQuery>(AutomationIdMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AutomationIdMetaData', 'query', variables);
    },
    AutomationIdPage(variables: AutomationIdPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AutomationIdPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationIdPageQuery>(AutomationIdPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AutomationIdPage', 'query', variables);
    },
    AutomationsListMetaData(variables: AutomationsListMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AutomationsListMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationsListMetaDataQuery>(AutomationsListMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AutomationsListMetaData', 'query', variables);
    },
    AutomationsListPage(variables: AutomationsListPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AutomationsListPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationsListPageQuery>(AutomationsListPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AutomationsListPage', 'query', variables);
    },
    AppliedFiltersData(variables: AppliedFiltersDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AppliedFiltersDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppliedFiltersDataQuery>(AppliedFiltersDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AppliedFiltersData', 'query', variables);
    },
    AppliedFiltersProducts(variables: AppliedFiltersProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AppliedFiltersProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppliedFiltersProductsQuery>(AppliedFiltersProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AppliedFiltersProducts', 'query', variables);
    },
    AppliedFiltersActivities(variables: AppliedFiltersActivitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AppliedFiltersActivitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppliedFiltersActivitiesQuery>(AppliedFiltersActivitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AppliedFiltersActivities', 'query', variables);
    },
    AutomationActivityVisitTriggerActivities(variables: AutomationActivityVisitTriggerActivitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AutomationActivityVisitTriggerActivitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationActivityVisitTriggerActivitiesQuery>(AutomationActivityVisitTriggerActivitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AutomationActivityVisitTriggerActivities', 'query', variables);
    },
    AutomationPurchaseTriggerProducts(variables: AutomationPurchaseTriggerProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AutomationPurchaseTriggerProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationPurchaseTriggerProductsQuery>(AutomationPurchaseTriggerProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AutomationPurchaseTriggerProducts', 'query', variables);
    },
    CurrentAudienceCount(variables: CurrentAudienceCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CurrentAudienceCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentAudienceCountQuery>(CurrentAudienceCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CurrentAudienceCount', 'query', variables);
    },
    AutomationContentActivity(variables: AutomationContentActivityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AutomationContentActivityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationContentActivityQuery>(AutomationContentActivityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AutomationContentActivity', 'query', variables);
    },
    SoftDeleteAutomationOption(variables: SoftDeleteAutomationOptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SoftDeleteAutomationOptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SoftDeleteAutomationOptionMutation>(SoftDeleteAutomationOptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SoftDeleteAutomationOption', 'mutation', variables);
    },
    DuplicateAutomationOption(variables: DuplicateAutomationOptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DuplicateAutomationOptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DuplicateAutomationOptionMutation>(DuplicateAutomationOptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DuplicateAutomationOption', 'mutation', variables);
    },
    SaveAutomation(variables: SaveAutomationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveAutomationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveAutomationMutation>(SaveAutomationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveAutomation', 'mutation', variables);
    },
    ActivateAutomation(variables: ActivateAutomationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivateAutomationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivateAutomationMutation>(ActivateAutomationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivateAutomation', 'mutation', variables);
    },
    DeactivateAutomation(variables: DeactivateAutomationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeactivateAutomationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeactivateAutomationMutation>(DeactivateAutomationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeactivateAutomation', 'mutation', variables);
    },
    DuplicateAutomation(variables: DuplicateAutomationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DuplicateAutomationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DuplicateAutomationMutation>(DuplicateAutomationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DuplicateAutomation', 'mutation', variables);
    },
    SoftDeleteAutomation(variables: SoftDeleteAutomationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SoftDeleteAutomationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SoftDeleteAutomationMutation>(SoftDeleteAutomationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SoftDeleteAutomation', 'mutation', variables);
    },
    AutomationNewMetaData(variables: AutomationNewMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AutomationNewMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationNewMetaDataQuery>(AutomationNewMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AutomationNewMetaData', 'query', variables);
    },
    AutomationNewPage(variables: AutomationNewPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AutomationNewPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationNewPageQuery>(AutomationNewPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AutomationNewPage', 'query', variables);
    },
    CommunicationEmailBody(variables: CommunicationEmailBodyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationEmailBodyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationEmailBodyQuery>(CommunicationEmailBodyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationEmailBody', 'query', variables);
    },
    CommunicationSubject(variables: CommunicationSubjectQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationSubjectQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationSubjectQuery>(CommunicationSubjectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationSubject', 'query', variables);
    },
    CommunicationOverviewMetaData(variables: CommunicationOverviewMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationOverviewMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationOverviewMetaDataQuery>(CommunicationOverviewMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationOverviewMetaData', 'query', variables);
    },
    CommunicationProducts(variables: CommunicationProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationProductsQuery>(CommunicationProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationProducts', 'query', variables);
    },
    CommunicationActivities(variables: CommunicationActivitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationActivitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationActivitiesQuery>(CommunicationActivitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationActivities', 'query', variables);
    },
    CommunicationBaseData(variables: CommunicationBaseDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationBaseDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationBaseDataQuery>(CommunicationBaseDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationBaseData', 'query', variables);
    },
    CommunicationIdMetaData(variables: CommunicationIdMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationIdMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationIdMetaDataQuery>(CommunicationIdMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationIdMetaData', 'query', variables);
    },
    CommunicationIdCustomersCount(variables: CommunicationIdCustomersCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationIdCustomersCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationIdCustomersCountQuery>(CommunicationIdCustomersCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationIdCustomersCount', 'query', variables);
    },
    CommunicationIdProducts(variables: CommunicationIdProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationIdProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationIdProductsQuery>(CommunicationIdProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationIdProducts', 'query', variables);
    },
    CommunicationIdActivities(variables: CommunicationIdActivitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationIdActivitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationIdActivitiesQuery>(CommunicationIdActivitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationIdActivities', 'query', variables);
    },
    CommunicationIdPage(variables: CommunicationIdPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationIdPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationIdPageQuery>(CommunicationIdPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationIdPage', 'query', variables);
    },
    RecipientsEditPageMetaData(variables: RecipientsEditPageMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecipientsEditPageMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecipientsEditPageMetaDataQuery>(RecipientsEditPageMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RecipientsEditPageMetaData', 'query', variables);
    },
    RecipientsEditPage(variables: RecipientsEditPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecipientsEditPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecipientsEditPageQuery>(RecipientsEditPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RecipientsEditPage', 'query', variables);
    },
    RecipientsEditCustomers(variables: RecipientsEditCustomersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecipientsEditCustomersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecipientsEditCustomersQuery>(RecipientsEditCustomersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RecipientsEditCustomers', 'query', variables);
    },
    CommunicationsMetaData(variables: CommunicationsMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationsMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationsMetaDataQuery>(CommunicationsMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationsMetaData', 'query', variables);
    },
    CommunicationsTotalCount(variables: CommunicationsTotalCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationsTotalCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationsTotalCountQuery>(CommunicationsTotalCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationsTotalCount', 'query', variables);
    },
    CommunicationsVenueByShortId(variables: CommunicationsVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationsVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationsVenueByShortIdQuery>(CommunicationsVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationsVenueByShortId', 'query', variables);
    },
    ResendCommunication(variables: ResendCommunicationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ResendCommunicationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResendCommunicationMutation>(ResendCommunicationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ResendCommunication', 'mutation', variables);
    },
    CommunicationCustomersCountEmailCampaign(variables: CommunicationCustomersCountEmailCampaignQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationCustomersCountEmailCampaignQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationCustomersCountEmailCampaignQuery>(CommunicationCustomersCountEmailCampaignDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationCustomersCountEmailCampaign', 'query', variables);
    },
    CommunicationIdCustomersCountVenueByShortId(variables: CommunicationIdCustomersCountVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationIdCustomersCountVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationIdCustomersCountVenueByShortIdQuery>(CommunicationIdCustomersCountVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationIdCustomersCountVenueByShortId', 'query', variables);
    },
    CommunicationRecipientCountEmailCampaign(variables: CommunicationRecipientCountEmailCampaignQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunicationRecipientCountEmailCampaignQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunicationRecipientCountEmailCampaignQuery>(CommunicationRecipientCountEmailCampaignDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunicationRecipientCountEmailCampaign', 'query', variables);
    },
    DeleteEmailOption(variables: DeleteEmailOptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteEmailOptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteEmailOptionMutation>(DeleteEmailOptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteEmailOption', 'mutation', variables);
    },
    DuplicateEmailOption(variables: DuplicateEmailOptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DuplicateEmailOptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DuplicateEmailOptionMutation>(DuplicateEmailOptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DuplicateEmailOption', 'mutation', variables);
    },
    SendTestEmailButtonMe(variables?: SendTestEmailButtonMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendTestEmailButtonMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendTestEmailButtonMeQuery>(SendTestEmailButtonMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SendTestEmailButtonMe', 'query', variables);
    },
    NewVenueByShortId(variables: NewVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NewVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NewVenueByShortIdQuery>(NewVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NewVenueByShortId', 'query', variables);
    },
    NewVenueByShortIdProducts(variables: NewVenueByShortIdProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NewVenueByShortIdProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NewVenueByShortIdProductsQuery>(NewVenueByShortIdProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NewVenueByShortIdProducts', 'query', variables);
    },
    NewVenueByShortIdActivities(variables: NewVenueByShortIdActivitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NewVenueByShortIdActivitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NewVenueByShortIdActivitiesQuery>(NewVenueByShortIdActivitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NewVenueByShortIdActivities', 'query', variables);
    },
    RecipientsNewPageMetaData(variables: RecipientsNewPageMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecipientsNewPageMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecipientsNewPageMetaDataQuery>(RecipientsNewPageMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RecipientsNewPageMetaData', 'query', variables);
    },
    RecipientsNewPage(variables: RecipientsNewPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecipientsNewPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecipientsNewPageQuery>(RecipientsNewPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RecipientsNewPage', 'query', variables);
    },
    AITemplateGeneratorGenerateTemplate(variables: AiTemplateGeneratorGenerateTemplateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AiTemplateGeneratorGenerateTemplateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiTemplateGeneratorGenerateTemplateMutation>(AiTemplateGeneratorGenerateTemplateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AITemplateGeneratorGenerateTemplate', 'mutation', variables);
    },
    AITextGeneratorGenerateEmail(variables: AiTextGeneratorGenerateEmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AiTextGeneratorGenerateEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiTextGeneratorGenerateEmailMutation>(AiTextGeneratorGenerateEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AITextGeneratorGenerateEmail', 'mutation', variables);
    },
    DesignEditorMe(variables?: DesignEditorMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DesignEditorMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DesignEditorMeQuery>(DesignEditorMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DesignEditorMe', 'query', variables);
    },
    EditRecipientsVenueByShortId(variables: EditRecipientsVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditRecipientsVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditRecipientsVenueByShortIdQuery>(EditRecipientsVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EditRecipientsVenueByShortId', 'query', variables);
    },
    EditRecipientsContactableCount(variables: EditRecipientsContactableCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditRecipientsContactableCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditRecipientsContactableCountQuery>(EditRecipientsContactableCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EditRecipientsContactableCount', 'query', variables);
    },
    EditRecipientsTotalCount(variables: EditRecipientsTotalCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditRecipientsTotalCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditRecipientsTotalCountQuery>(EditRecipientsTotalCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EditRecipientsTotalCount', 'query', variables);
    },
    ActivityFilterRuleActivity(variables: ActivityFilterRuleActivityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivityFilterRuleActivityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivityFilterRuleActivityQuery>(ActivityFilterRuleActivityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivityFilterRuleActivity', 'query', variables);
    },
    UseActivityPaginatedQueryVenueByShortId(variables: UseActivityPaginatedQueryVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseActivityPaginatedQueryVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseActivityPaginatedQueryVenueByShortIdQuery>(UseActivityPaginatedQueryVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UseActivityPaginatedQueryVenueByShortId', 'query', variables);
    },
    AggregatorFilterRuleVenueByShortId(variables: AggregatorFilterRuleVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AggregatorFilterRuleVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AggregatorFilterRuleVenueByShortIdQuery>(AggregatorFilterRuleVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AggregatorFilterRuleVenueByShortId', 'query', variables);
    },
    CustomerGroupFilterRuleVenueByShortId(variables: CustomerGroupFilterRuleVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerGroupFilterRuleVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerGroupFilterRuleVenueByShortIdQuery>(CustomerGroupFilterRuleVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CustomerGroupFilterRuleVenueByShortId', 'query', variables);
    },
    PurchasedProductFilterRuleProduct(variables: PurchasedProductFilterRuleProductQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PurchasedProductFilterRuleProductQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PurchasedProductFilterRuleProductQuery>(PurchasedProductFilterRuleProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PurchasedProductFilterRuleProduct', 'query', variables);
    },
    IsTaggedFilterRuleVenueByShortId(variables: IsTaggedFilterRuleVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IsTaggedFilterRuleVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IsTaggedFilterRuleVenueByShortIdQuery>(IsTaggedFilterRuleVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'IsTaggedFilterRuleVenueByShortId', 'query', variables);
    },
    GetExamplePrompts(variables: GetExamplePromptsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetExamplePromptsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetExamplePromptsQuery>(GetExamplePromptsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetExamplePrompts', 'query', variables);
    },
    GenerateFiltersFromText(variables: GenerateFiltersFromTextMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateFiltersFromTextMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateFiltersFromTextMutation>(GenerateFiltersFromTextDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GenerateFiltersFromText', 'mutation', variables);
    },
    UseProductPaginatedQueryVenueByShortId(variables: UseProductPaginatedQueryVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseProductPaginatedQueryVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseProductPaginatedQueryVenueByShortIdQuery>(UseProductPaginatedQueryVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UseProductPaginatedQueryVenueByShortId', 'query', variables);
    },
    UseProductCountQuery(variables: UseProductCountQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseProductCountQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseProductCountQueryQuery>(UseProductCountQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UseProductCountQuery', 'query', variables);
    },
    SurveyLinkMe(variables?: SurveyLinkMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SurveyLinkMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SurveyLinkMeQuery>(SurveyLinkMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SurveyLinkMe', 'query', variables);
    },
    AssignTags(variables: AssignTagsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AssignTagsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssignTagsMutation>(AssignTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AssignTags', 'mutation', variables);
    },
    ContactsVenueByShortId(variables: ContactsVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsVenueByShortIdQuery>(ContactsVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ContactsVenueByShortId', 'query', variables);
    },
    ContactsTotalCount(variables: ContactsTotalCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsTotalCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsTotalCountQuery>(ContactsTotalCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ContactsTotalCount', 'query', variables);
    },
    ContactsContactableCount(variables: ContactsContactableCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsContactableCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsContactableCountQuery>(ContactsContactableCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ContactsContactableCount', 'query', variables);
    },
    ContactsPage(variables: ContactsPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsPageQuery>(ContactsPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ContactsPage', 'query', variables);
    },
    ContactsMetaData(variables: ContactsMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsMetaDataQuery>(ContactsMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ContactsMetaData', 'query', variables);
    },
    FriendReferralMetaData(variables: FriendReferralMetaDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FriendReferralMetaDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FriendReferralMetaDataQuery>(FriendReferralMetaDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FriendReferralMetaData', 'query', variables);
    },
    FriendReferralConfig(variables: FriendReferralConfigQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FriendReferralConfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FriendReferralConfigQuery>(FriendReferralConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FriendReferralConfig', 'query', variables);
    },
    SaveCompanyReferralConfig(variables: SaveCompanyReferralConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveCompanyReferralConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveCompanyReferralConfigMutation>(SaveCompanyReferralConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveCompanyReferralConfig', 'mutation', variables);
    },
    UseEmailActionsSendEmailCampaignToMe(variables: UseEmailActionsSendEmailCampaignToMeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseEmailActionsSendEmailCampaignToMeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseEmailActionsSendEmailCampaignToMeMutation>(UseEmailActionsSendEmailCampaignToMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UseEmailActionsSendEmailCampaignToMe', 'mutation', variables);
    },
    UseEmailActionsSendDraftEmailToCustomers(variables: UseEmailActionsSendDraftEmailToCustomersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseEmailActionsSendDraftEmailToCustomersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseEmailActionsSendDraftEmailToCustomersMutation>(UseEmailActionsSendDraftEmailToCustomersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UseEmailActionsSendDraftEmailToCustomers', 'mutation', variables);
    },
    UseEmailActionsCreateEmailCampaign(variables: UseEmailActionsCreateEmailCampaignMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseEmailActionsCreateEmailCampaignMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseEmailActionsCreateEmailCampaignMutation>(UseEmailActionsCreateEmailCampaignDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UseEmailActionsCreateEmailCampaign', 'mutation', variables);
    },
    UseEmailActionsUpdateEmailCampaign(variables: UseEmailActionsUpdateEmailCampaignMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseEmailActionsUpdateEmailCampaignMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseEmailActionsUpdateEmailCampaignMutation>(UseEmailActionsUpdateEmailCampaignDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UseEmailActionsUpdateEmailCampaign', 'mutation', variables);
    },
    MarketingTabsVenueByShortId(variables: MarketingTabsVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarketingTabsVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarketingTabsVenueByShortIdQuery>(MarketingTabsVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MarketingTabsVenueByShortId', 'query', variables);
    },
    CompanyId(variables: CompanyIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyIdQuery>(CompanyIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CompanyId', 'query', variables);
    },
    AggregatorsInfo(variables: AggregatorsInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AggregatorsInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AggregatorsInfoQuery>(AggregatorsInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AggregatorsInfo', 'query', variables);
    },
    BrandedAppVenueByShortId(variables: BrandedAppVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandedAppVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandedAppVenueByShortIdQuery>(BrandedAppVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BrandedAppVenueByShortId', 'query', variables);
    },
    SaveCreateCompanyBrandedApp(variables: SaveCreateCompanyBrandedAppMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveCreateCompanyBrandedAppMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveCreateCompanyBrandedAppMutation>(SaveCreateCompanyBrandedAppDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveCreateCompanyBrandedApp', 'mutation', variables);
    },
    SaveUpdateCompanyBrandedApp(variables: SaveUpdateCompanyBrandedAppMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveUpdateCompanyBrandedAppMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveUpdateCompanyBrandedAppMutation>(SaveUpdateCompanyBrandedAppDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveUpdateCompanyBrandedApp', 'mutation', variables);
    },
    ExtensionVenueByShortId(variables: ExtensionVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExtensionVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExtensionVenueByShortIdQuery>(ExtensionVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ExtensionVenueByShortId', 'query', variables);
    },
    FloorPlanSpotsColors(variables: FloorPlanSpotsColorsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FloorPlanSpotsColorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FloorPlanSpotsColorsQuery>(FloorPlanSpotsColorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FloorPlanSpotsColors', 'query', variables);
    },
    UpsertFloorPlanColors(variables: UpsertFloorPlanColorsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertFloorPlanColorsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertFloorPlanColorsMutation>(UpsertFloorPlanColorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpsertFloorPlanColors', 'mutation', variables);
    },
    GoogleAdsConfiguration(variables?: GoogleAdsConfigurationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GoogleAdsConfigurationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GoogleAdsConfigurationQuery>(GoogleAdsConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GoogleAdsConfiguration', 'query', variables);
    },
    SaveGoogleAdsConfiguration(variables: SaveGoogleAdsConfigurationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveGoogleAdsConfigurationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveGoogleAdsConfigurationMutation>(SaveGoogleAdsConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveGoogleAdsConfiguration', 'mutation', variables);
    },
    CreateCompanyRepresentative(variables: CreateCompanyRepresentativeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCompanyRepresentativeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCompanyRepresentativeMutation>(CreateCompanyRepresentativeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateCompanyRepresentative', 'mutation', variables);
    },
    GetCompanyRepresentatives(variables: GetCompanyRepresentativesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCompanyRepresentativesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCompanyRepresentativesQuery>(GetCompanyRepresentativesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCompanyRepresentatives', 'query', variables);
    },
    UpdateCompanyRepresentative(variables: UpdateCompanyRepresentativeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCompanyRepresentativeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyRepresentativeMutation>(UpdateCompanyRepresentativeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCompanyRepresentative', 'mutation', variables);
    },
    GenerateTaxAgreement(variables: GenerateTaxAgreementMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateTaxAgreementMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateTaxAgreementMutation>(GenerateTaxAgreementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GenerateTaxAgreement', 'mutation', variables);
    },
    UploadSignedTaxAgreement(variables: UploadSignedTaxAgreementMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UploadSignedTaxAgreementMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadSignedTaxAgreementMutation>(UploadSignedTaxAgreementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UploadSignedTaxAgreement', 'mutation', variables);
    },
    GetCompanyTaxInformation(variables: GetCompanyTaxInformationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCompanyTaxInformationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCompanyTaxInformationQuery>(GetCompanyTaxInformationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCompanyTaxInformation', 'query', variables);
    },
    UpdateCompanyMunicipality(variables: UpdateCompanyMunicipalityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCompanyMunicipalityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyMunicipalityMutation>(UpdateCompanyMunicipalityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCompanyMunicipality', 'mutation', variables);
    },
    GetBookkeepingAccounts(variables: GetBookkeepingAccountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBookkeepingAccountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBookkeepingAccountsQuery>(GetBookkeepingAccountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBookkeepingAccounts', 'query', variables);
    },
    CreatePenaltyRule(variables: CreatePenaltyRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePenaltyRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePenaltyRuleMutation>(CreatePenaltyRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreatePenaltyRule', 'mutation', variables);
    },
    UpdatePenaltyRule(variables: UpdatePenaltyRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePenaltyRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePenaltyRuleMutation>(UpdatePenaltyRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdatePenaltyRule', 'mutation', variables);
    },
    GetVenueCurrency(variables: GetVenueCurrencyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetVenueCurrencyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetVenueCurrencyQuery>(GetVenueCurrencyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetVenueCurrency', 'query', variables);
    },
    FetchPenaltyRules(variables: FetchPenaltyRulesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchPenaltyRulesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchPenaltyRulesQuery>(FetchPenaltyRulesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchPenaltyRules', 'query', variables);
    },
    FetchPenaltyRule(variables: FetchPenaltyRuleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchPenaltyRuleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchPenaltyRuleQuery>(FetchPenaltyRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchPenaltyRule', 'query', variables);
    },
    DeactivatePenaltyRule(variables: DeactivatePenaltyRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeactivatePenaltyRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeactivatePenaltyRuleMutation>(DeactivatePenaltyRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeactivatePenaltyRule', 'mutation', variables);
    },
    ActivatePenaltyRule(variables: ActivatePenaltyRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivatePenaltyRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivatePenaltyRuleMutation>(ActivatePenaltyRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivatePenaltyRule', 'mutation', variables);
    },
    PrivateSessionSettingsQuery(variables: PrivateSessionSettingsQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrivateSessionSettingsQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrivateSessionSettingsQueryQuery>(PrivateSessionSettingsQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrivateSessionSettingsQuery', 'query', variables);
    },
    SavePrivateSessionSettings(variables: SavePrivateSessionSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SavePrivateSessionSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SavePrivateSessionSettingsMutation>(SavePrivateSessionSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SavePrivateSessionSettings', 'mutation', variables);
    },
    SaveDefaultAvailabilitySchedule(variables: SaveDefaultAvailabilityScheduleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveDefaultAvailabilityScheduleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveDefaultAvailabilityScheduleMutation>(SaveDefaultAvailabilityScheduleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveDefaultAvailabilitySchedule', 'mutation', variables);
    },
    DateSpecificAvailabilityQuery(variables: DateSpecificAvailabilityQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DateSpecificAvailabilityQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DateSpecificAvailabilityQueryQuery>(DateSpecificAvailabilityQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DateSpecificAvailabilityQuery', 'query', variables);
    },
    DeletePrivateSessionDaySpecificAvailability(variables: DeletePrivateSessionDaySpecificAvailabilityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeletePrivateSessionDaySpecificAvailabilityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePrivateSessionDaySpecificAvailabilityMutation>(DeletePrivateSessionDaySpecificAvailabilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeletePrivateSessionDaySpecificAvailability', 'mutation', variables);
    },
    SavePrivateSessionDaySpecificAvailability(variables: SavePrivateSessionDaySpecificAvailabilityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SavePrivateSessionDaySpecificAvailabilityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SavePrivateSessionDaySpecificAvailabilityMutation>(SavePrivateSessionDaySpecificAvailabilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SavePrivateSessionDaySpecificAvailability', 'mutation', variables);
    },
    GetFloorPlans(variables: GetFloorPlansQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetFloorPlansQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFloorPlansQuery>(GetFloorPlansDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetFloorPlans', 'query', variables);
    },
    SubstitutionExtensionSettingsQuery(variables: SubstitutionExtensionSettingsQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SubstitutionExtensionSettingsQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubstitutionExtensionSettingsQueryQuery>(SubstitutionExtensionSettingsQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SubstitutionExtensionSettingsQuery', 'query', variables);
    },
    SaveSubstitutionNotificationSettings(variables: SaveSubstitutionNotificationSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveSubstitutionNotificationSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveSubstitutionNotificationSettingsMutation>(SaveSubstitutionNotificationSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveSubstitutionNotificationSettings', 'mutation', variables);
    },
    VenueByShortId(variables: VenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VenueByShortIdQuery>(VenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VenueByShortId', 'query', variables);
    },
    GetFloorPlan(variables: GetFloorPlanQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetFloorPlanQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFloorPlanQuery>(GetFloorPlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetFloorPlan', 'query', variables);
    },
    UpdateFloorPlan(variables: UpdateFloorPlanMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateFloorPlanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFloorPlanMutation>(UpdateFloorPlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateFloorPlan', 'mutation', variables);
    },
    CreateFloorPlan(variables: CreateFloorPlanMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateFloorPlanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFloorPlanMutation>(CreateFloorPlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateFloorPlan', 'mutation', variables);
    },
    ArchiveFloorPlan(variables: ArchiveFloorPlanMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveFloorPlanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveFloorPlanMutation>(ArchiveFloorPlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchiveFloorPlan', 'mutation', variables);
    },
    SyncBookableSpots(variables: SyncBookableSpotsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SyncBookableSpotsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SyncBookableSpotsMutation>(SyncBookableSpotsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SyncBookableSpots', 'mutation', variables);
    },
    SyncNonBookableSpots(variables: SyncNonBookableSpotsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SyncNonBookableSpotsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SyncNonBookableSpotsMutation>(SyncNonBookableSpotsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SyncNonBookableSpots', 'mutation', variables);
    },
    PublishFloorPlan(variables: PublishFloorPlanMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PublishFloorPlanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublishFloorPlanMutation>(PublishFloorPlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PublishFloorPlan', 'mutation', variables);
    },
    SpotBookingNew(variables: SpotBookingNewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpotBookingNewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpotBookingNewQuery>(SpotBookingNewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SpotBookingNew', 'query', variables);
    },
    ImportsVenueByShortId(variables: ImportsVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ImportsVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImportsVenueByShortIdQuery>(ImportsVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ImportsVenueByShortId', 'query', variables);
    },
    ImportsVenueResultsByShortId(variables: ImportsVenueResultsByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ImportsVenueResultsByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImportsVenueResultsByShortIdQuery>(ImportsVenueResultsByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ImportsVenueResultsByShortId', 'query', variables);
    },
    ImportsMe(variables?: ImportsMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ImportsMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImportsMeQuery>(ImportsMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ImportsMe', 'query', variables);
    },
    GenerateToken(variables: GenerateTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateTokenMutation>(GenerateTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GenerateToken', 'mutation', variables);
    },
    StartImport(variables: StartImportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StartImportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<StartImportMutation>(StartImportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'StartImport', 'mutation', variables);
    },
    CashRegisterAccessUsers(variables: CashRegisterAccessUsersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CashRegisterAccessUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CashRegisterAccessUsersQuery>(CashRegisterAccessUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CashRegisterAccessUsers', 'query', variables);
    },
    SoftwareVersion(variables: SoftwareVersionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SoftwareVersionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SoftwareVersionQuery>(SoftwareVersionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SoftwareVersion', 'query', variables);
    },
    FetchTaxArchives(variables: FetchTaxArchivesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchTaxArchivesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchTaxArchivesQuery>(FetchTaxArchivesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchTaxArchives', 'query', variables);
    },
    CreatePeriod(variables: CreatePeriodMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePeriodMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePeriodMutation>(CreatePeriodDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreatePeriod', 'mutation', variables);
    },
    UpdatePeriod(variables: UpdatePeriodMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePeriodMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePeriodMutation>(UpdatePeriodDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdatePeriod', 'mutation', variables);
    },
    RemovePeriod(variables: RemovePeriodMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemovePeriodMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemovePeriodMutation>(RemovePeriodDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemovePeriod', 'mutation', variables);
    },
    SeasonIdVenueByShortId(variables: SeasonIdVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SeasonIdVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SeasonIdVenueByShortIdQuery>(SeasonIdVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SeasonIdVenueByShortId', 'query', variables);
    },
    SeasonIdPage(variables: SeasonIdPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SeasonIdPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SeasonIdPageQuery>(SeasonIdPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SeasonIdPage', 'query', variables);
    },
    RatesVenueByShortId(variables: RatesVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RatesVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RatesVenueByShortIdQuery>(RatesVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RatesVenueByShortId', 'query', variables);
    },
    RatesCourtGroups(variables: RatesCourtGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RatesCourtGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RatesCourtGroupsQuery>(RatesCourtGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RatesCourtGroups', 'query', variables);
    },
    RatesCourtGroupSeasons(variables: RatesCourtGroupSeasonsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RatesCourtGroupSeasonsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RatesCourtGroupSeasonsQuery>(RatesCourtGroupSeasonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RatesCourtGroupSeasons', 'query', variables);
    },
    UpdateSeason(variables: UpdateSeasonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSeasonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSeasonMutation>(UpdateSeasonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSeason', 'mutation', variables);
    },
    RemoveSeason(variables: RemoveSeasonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveSeasonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSeasonMutation>(RemoveSeasonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveSeason', 'mutation', variables);
    },
    CreateSeason(variables: CreateSeasonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSeasonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSeasonMutation>(CreateSeasonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSeason', 'mutation', variables);
    },
    VenueVenueByShortId(variables: VenueVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VenueVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VenueVenueByShortIdQuery>(VenueVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VenueVenueByShortId', 'query', variables);
    },
    WidgetListVenue(variables: WidgetListVenueQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WidgetListVenueQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WidgetListVenueQuery>(WidgetListVenueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'WidgetListVenue', 'query', variables);
    },
    WidgetEditCompanyWidget(variables: WidgetEditCompanyWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WidgetEditCompanyWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WidgetEditCompanyWidgetQuery>(WidgetEditCompanyWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'WidgetEditCompanyWidget', 'query', variables);
    },
    BrandSettingsQuery(variables: BrandSettingsQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSettingsQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSettingsQueryQuery>(BrandSettingsQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BrandSettingsQuery', 'query', variables);
    },
    CreateCompanyWidgetBrandSettings(variables: CreateCompanyWidgetBrandSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCompanyWidgetBrandSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCompanyWidgetBrandSettingsMutation>(CreateCompanyWidgetBrandSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateCompanyWidgetBrandSettings', 'mutation', variables);
    },
    UpdateCompanyWidgetBrandSettings(variables: UpdateCompanyWidgetBrandSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCompanyWidgetBrandSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyWidgetBrandSettingsMutation>(UpdateCompanyWidgetBrandSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCompanyWidgetBrandSettings', 'mutation', variables);
    },
    ActivitiesVenueByShortId(variables: ActivitiesVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivitiesVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivitiesVenueByShortIdQuery>(ActivitiesVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivitiesVenueByShortId', 'query', variables);
    },
    ActivitiesCompanyWidget(variables: ActivitiesCompanyWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivitiesCompanyWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivitiesCompanyWidgetQuery>(ActivitiesCompanyWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivitiesCompanyWidget', 'query', variables);
    },
    ActivityWidgetTrainers(variables: ActivityWidgetTrainersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivityWidgetTrainersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivityWidgetTrainersQuery>(ActivityWidgetTrainersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivityWidgetTrainers', 'query', variables);
    },
    ActivityWidgetActivityGroups(variables: ActivityWidgetActivityGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivityWidgetActivityGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivityWidgetActivityGroupsQuery>(ActivityWidgetActivityGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivityWidgetActivityGroups', 'query', variables);
    },
    SaveCreateCompanyWidgetActivities(variables: SaveCreateCompanyWidgetActivitiesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveCreateCompanyWidgetActivitiesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveCreateCompanyWidgetActivitiesMutation>(SaveCreateCompanyWidgetActivitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveCreateCompanyWidgetActivities', 'mutation', variables);
    },
    SaveUpdateCompanyWidgetActivities(variables: SaveUpdateCompanyWidgetActivitiesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveUpdateCompanyWidgetActivitiesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveUpdateCompanyWidgetActivitiesMutation>(SaveUpdateCompanyWidgetActivitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveUpdateCompanyWidgetActivities', 'mutation', variables);
    },
    ActivityScheduleVenueByShortId(variables: ActivityScheduleVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivityScheduleVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivityScheduleVenueByShortIdQuery>(ActivityScheduleVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivityScheduleVenueByShortId', 'query', variables);
    },
    ActivityScheduleCompanyWidget(variables: ActivityScheduleCompanyWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivityScheduleCompanyWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivityScheduleCompanyWidgetQuery>(ActivityScheduleCompanyWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivityScheduleCompanyWidget', 'query', variables);
    },
    ActivityScheduleCreateCompanyWidgetActivitySchedule(variables: ActivityScheduleCreateCompanyWidgetActivityScheduleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivityScheduleCreateCompanyWidgetActivityScheduleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivityScheduleCreateCompanyWidgetActivityScheduleMutation>(ActivityScheduleCreateCompanyWidgetActivityScheduleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivityScheduleCreateCompanyWidgetActivitySchedule', 'mutation', variables);
    },
    ActivityScheduleUpdateCompanyWidgetActivitySchedule(variables: ActivityScheduleUpdateCompanyWidgetActivityScheduleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivityScheduleUpdateCompanyWidgetActivityScheduleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivityScheduleUpdateCompanyWidgetActivityScheduleMutation>(ActivityScheduleUpdateCompanyWidgetActivityScheduleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivityScheduleUpdateCompanyWidgetActivitySchedule', 'mutation', variables);
    },
    FilterOptionsCompanyVenues(variables: FilterOptionsCompanyVenuesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FilterOptionsCompanyVenuesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FilterOptionsCompanyVenuesQuery>(FilterOptionsCompanyVenuesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FilterOptionsCompanyVenues', 'query', variables);
    },
    CompanyTeachers(variables: CompanyTeachersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyTeachersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyTeachersQuery>(CompanyTeachersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CompanyTeachers', 'query', variables);
    },
    CompanyActivityGroups(variables: CompanyActivityGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyActivityGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyActivityGroupsQuery>(CompanyActivityGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CompanyActivityGroups', 'query', variables);
    },
    CompanySports(variables: CompanySportsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanySportsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanySportsQuery>(CompanySportsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CompanySports', 'query', variables);
    },
    DefaultTeachersCompanyWidget(variables: DefaultTeachersCompanyWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DefaultTeachersCompanyWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DefaultTeachersCompanyWidgetQuery>(DefaultTeachersCompanyWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DefaultTeachersCompanyWidget', 'query', variables);
    },
    DefaultActivityGroupsCompanyWidget(variables: DefaultActivityGroupsCompanyWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DefaultActivityGroupsCompanyWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DefaultActivityGroupsCompanyWidgetQuery>(DefaultActivityGroupsCompanyWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DefaultActivityGroupsCompanyWidget', 'query', variables);
    },
    DefaultSportsCompanyWidget(variables: DefaultSportsCompanyWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DefaultSportsCompanyWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DefaultSportsCompanyWidgetQuery>(DefaultSportsCompanyWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DefaultSportsCompanyWidget', 'query', variables);
    },
    DefaultVenuesCompanyWidget(variables: DefaultVenuesCompanyWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DefaultVenuesCompanyWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DefaultVenuesCompanyWidgetQuery>(DefaultVenuesCompanyWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DefaultVenuesCompanyWidget', 'query', variables);
    },
    NewsletterVenueByShortId(variables: NewsletterVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NewsletterVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NewsletterVenueByShortIdQuery>(NewsletterVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NewsletterVenueByShortId', 'query', variables);
    },
    NewsletterCompanyWidget(variables: NewsletterCompanyWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NewsletterCompanyWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NewsletterCompanyWidgetQuery>(NewsletterCompanyWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NewsletterCompanyWidget', 'query', variables);
    },
    SaveCreateCompanyWidgetNewsletter(variables: SaveCreateCompanyWidgetNewsletterMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveCreateCompanyWidgetNewsletterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveCreateCompanyWidgetNewsletterMutation>(SaveCreateCompanyWidgetNewsletterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveCreateCompanyWidgetNewsletter', 'mutation', variables);
    },
    SaveUpdateCompanyWidgetNewsletter(variables: SaveUpdateCompanyWidgetNewsletterMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveUpdateCompanyWidgetNewsletterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveUpdateCompanyWidgetNewsletterMutation>(SaveUpdateCompanyWidgetNewsletterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveUpdateCompanyWidgetNewsletter', 'mutation', variables);
    },
    PricesVenueByShortId(variables: PricesVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PricesVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PricesVenueByShortIdQuery>(PricesVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PricesVenueByShortId', 'query', variables);
    },
    PricesCompanyWidget(variables: PricesCompanyWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PricesCompanyWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PricesCompanyWidgetQuery>(PricesCompanyWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PricesCompanyWidget', 'query', variables);
    },
    PricesSaveCreateCompanyWidgetPrices(variables: PricesSaveCreateCompanyWidgetPricesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PricesSaveCreateCompanyWidgetPricesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PricesSaveCreateCompanyWidgetPricesMutation>(PricesSaveCreateCompanyWidgetPricesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PricesSaveCreateCompanyWidgetPrices', 'mutation', variables);
    },
    PricesSaveUpdateCompanyWidgetPrices(variables: PricesSaveUpdateCompanyWidgetPricesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PricesSaveUpdateCompanyWidgetPricesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PricesSaveUpdateCompanyWidgetPricesMutation>(PricesSaveUpdateCompanyWidgetPricesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PricesSaveUpdateCompanyWidgetPrices', 'mutation', variables);
    },
    RecordingCategoriesVenueByShortId(variables: RecordingCategoriesVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecordingCategoriesVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecordingCategoriesVenueByShortIdQuery>(RecordingCategoriesVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RecordingCategoriesVenueByShortId', 'query', variables);
    },
    VideosCompanyWidget(variables: VideosCompanyWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VideosCompanyWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VideosCompanyWidgetQuery>(VideosCompanyWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VideosCompanyWidget', 'query', variables);
    },
    SaveCreateCompanyWidgetVideos(variables: SaveCreateCompanyWidgetVideosMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveCreateCompanyWidgetVideosMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveCreateCompanyWidgetVideosMutation>(SaveCreateCompanyWidgetVideosDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveCreateCompanyWidgetVideos', 'mutation', variables);
    },
    SaveUpdateCompanyWidgetVideos(variables: SaveUpdateCompanyWidgetVideosMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveUpdateCompanyWidgetVideosMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveUpdateCompanyWidgetVideosMutation>(SaveUpdateCompanyWidgetVideosDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveUpdateCompanyWidgetVideos', 'mutation', variables);
    },
    VouchersVenueByShortId(variables: VouchersVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VouchersVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VouchersVenueByShortIdQuery>(VouchersVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VouchersVenueByShortId', 'query', variables);
    },
    VouchersCompanyWidget(variables: VouchersCompanyWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VouchersCompanyWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VouchersCompanyWidgetQuery>(VouchersCompanyWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VouchersCompanyWidget', 'query', variables);
    },
    CreateCompanyWidgetVouchers(variables: CreateCompanyWidgetVouchersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCompanyWidgetVouchersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCompanyWidgetVouchersMutation>(CreateCompanyWidgetVouchersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateCompanyWidgetVouchers', 'mutation', variables);
    },
    UpdateCompanyWidgetVouchers(variables: UpdateCompanyWidgetVouchersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCompanyWidgetVouchersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyWidgetVouchersMutation>(UpdateCompanyWidgetVouchersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCompanyWidgetVouchers', 'mutation', variables);
    },
    DeleteWidgetDeleteCompanyWidget(variables: DeleteWidgetDeleteCompanyWidgetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteWidgetDeleteCompanyWidgetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteWidgetDeleteCompanyWidgetMutation>(DeleteWidgetDeleteCompanyWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteWidgetDeleteCompanyWidget', 'mutation', variables);
    },
    ImageUploadVenueByShortId(variables: ImageUploadVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ImageUploadVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImageUploadVenueByShortIdQuery>(ImageUploadVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ImageUploadVenueByShortId', 'query', variables);
    },
    WidgetOverviewActionAssignWidgetToOverview(variables: WidgetOverviewActionAssignWidgetToOverviewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WidgetOverviewActionAssignWidgetToOverviewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<WidgetOverviewActionAssignWidgetToOverviewMutation>(WidgetOverviewActionAssignWidgetToOverviewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'WidgetOverviewActionAssignWidgetToOverview', 'mutation', variables);
    },
    WidgetOverviewActionUnassignWidgetFromOverview(variables: WidgetOverviewActionUnassignWidgetFromOverviewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WidgetOverviewActionUnassignWidgetFromOverviewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<WidgetOverviewActionUnassignWidgetFromOverviewMutation>(WidgetOverviewActionUnassignWidgetFromOverviewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'WidgetOverviewActionUnassignWidgetFromOverview', 'mutation', variables);
    },
    UseCompanySportsPaginatedQueryVenueByShortId(variables: UseCompanySportsPaginatedQueryVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseCompanySportsPaginatedQueryVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseCompanySportsPaginatedQueryVenueByShortIdQuery>(UseCompanySportsPaginatedQueryVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UseCompanySportsPaginatedQueryVenueByShortId', 'query', variables);
    },
    UseCompanyTeachersPaginatedQueryVenueByShortId(variables: UseCompanyTeachersPaginatedQueryVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseCompanyTeachersPaginatedQueryVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseCompanyTeachersPaginatedQueryVenueByShortIdQuery>(UseCompanyTeachersPaginatedQueryVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UseCompanyTeachersPaginatedQueryVenueByShortId', 'query', variables);
    },
    UseDefaultSportsCompanyPaginatedQueryCompanyWidget(variables: UseDefaultSportsCompanyPaginatedQueryCompanyWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseDefaultSportsCompanyPaginatedQueryCompanyWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseDefaultSportsCompanyPaginatedQueryCompanyWidgetQuery>(UseDefaultSportsCompanyPaginatedQueryCompanyWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UseDefaultSportsCompanyPaginatedQueryCompanyWidget', 'query', variables);
    },
    UseDefaultTeachersCompanyPaginatedQueryCompanyWidget(variables: UseDefaultTeachersCompanyPaginatedQueryCompanyWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseDefaultTeachersCompanyPaginatedQueryCompanyWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseDefaultTeachersCompanyPaginatedQueryCompanyWidgetQuery>(UseDefaultTeachersCompanyPaginatedQueryCompanyWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UseDefaultTeachersCompanyPaginatedQueryCompanyWidget', 'query', variables);
    },
    WidgetCreateVenueByShortId(variables: WidgetCreateVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WidgetCreateVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WidgetCreateVenueByShortIdQuery>(WidgetCreateVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'WidgetCreateVenueByShortId', 'query', variables);
    },
    PublicAppointments(variables: PublicAppointmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PublicAppointmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublicAppointmentsQuery>(PublicAppointmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PublicAppointments', 'query', variables);
    },
    VenueById(variables: VenueByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VenueByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VenueByIdQuery>(VenueByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VenueById', 'query', variables);
    },
    RequestFileUpload(variables: RequestFileUploadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RequestFileUploadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestFileUploadMutation>(RequestFileUploadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RequestFileUpload', 'mutation', variables);
    },
    ConfirmFileUpload(variables: ConfirmFileUploadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConfirmFileUploadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfirmFileUploadMutation>(ConfirmFileUploadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ConfirmFileUpload', 'mutation', variables);
    },
    AmplitudePageLoggerVenueByShortId(variables: AmplitudePageLoggerVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AmplitudePageLoggerVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AmplitudePageLoggerVenueByShortIdQuery>(AmplitudePageLoggerVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AmplitudePageLoggerVenueByShortId', 'query', variables);
    },
    HubspotScriptMe(variables?: HubspotScriptMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<HubspotScriptMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<HubspotScriptMeQuery>(HubspotScriptMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'HubspotScriptMe', 'query', variables);
    },
    MiddlewareSession(variables?: MiddlewareSessionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MiddlewareSessionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MiddlewareSessionQuery>(MiddlewareSessionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MiddlewareSession', 'query', variables);
    },
    DeleteSubstitution(variables: DeleteSubstitutionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteSubstitutionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSubstitutionMutation>(DeleteSubstitutionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteSubstitution', 'mutation', variables);
    },
    CheckAppointmentConflictsV2(variables: CheckAppointmentConflictsV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckAppointmentConflictsV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckAppointmentConflictsV2Query>(CheckAppointmentConflictsV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CheckAppointmentConflictsV2', 'query', variables);
    },
    CustomerSearch(variables: CustomerSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerSearchQuery>(CustomerSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CustomerSearch', 'query', variables);
    },
    FriendReferralReportExportMe(variables?: FriendReferralReportExportMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FriendReferralReportExportMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FriendReferralReportExportMeQuery>(FriendReferralReportExportMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FriendReferralReportExportMe', 'query', variables);
    },
    FriendReferralReportExportVenue(variables: FriendReferralReportExportVenueQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FriendReferralReportExportVenueQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FriendReferralReportExportVenueQuery>(FriendReferralReportExportVenueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FriendReferralReportExportVenue', 'query', variables);
    },
    FriendReferralReportExport(variables: FriendReferralReportExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FriendReferralReportExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FriendReferralReportExportMutation>(FriendReferralReportExportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FriendReferralReportExport', 'mutation', variables);
    },
    HeaderVenueByShortId(variables: HeaderVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<HeaderVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<HeaderVenueByShortIdQuery>(HeaderVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'HeaderVenueByShortId', 'query', variables);
    },
    UserMenuMe(variables?: UserMenuMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserMenuMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserMenuMeQuery>(UserMenuMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserMenuMe', 'query', variables);
    },
    UserMenuVenueByShortId(variables: UserMenuVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserMenuVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserMenuVenueByShortIdQuery>(UserMenuVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserMenuVenueByShortId', 'query', variables);
    },
    VenueSwitcherMe(variables?: VenueSwitcherMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VenueSwitcherMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VenueSwitcherMeQuery>(VenueSwitcherMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VenueSwitcherMe', 'query', variables);
    },
    VenueSwitcherVenueByShortId(variables: VenueSwitcherVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VenueSwitcherVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VenueSwitcherVenueByShortIdQuery>(VenueSwitcherVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VenueSwitcherVenueByShortId', 'query', variables);
    },
    NavigationMe(variables?: NavigationMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NavigationMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NavigationMeQuery>(NavigationMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NavigationMe', 'query', variables);
    },
    NavigationVenueByShortId(variables: NavigationVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NavigationVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NavigationVenueByShortIdQuery>(NavigationVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NavigationVenueByShortId', 'query', variables);
    },
    FetchAllTags(variables: FetchAllTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchAllTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchAllTagsQuery>(FetchAllTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchAllTags', 'query', variables);
    },
    VenueExtensionGuardVenueByShortId(variables: VenueExtensionGuardVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VenueExtensionGuardVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VenueExtensionGuardVenueByShortIdQuery>(VenueExtensionGuardVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VenueExtensionGuardVenueByShortId', 'query', variables);
    },
    ViewerRoleGuardVenueByShortId(variables: ViewerRoleGuardVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ViewerRoleGuardVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ViewerRoleGuardVenueByShortIdQuery>(ViewerRoleGuardVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ViewerRoleGuardVenueByShortId', 'query', variables);
    },
    FeaturePreviewsVenueByShortId(variables: FeaturePreviewsVenueByShortIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FeaturePreviewsVenueByShortIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FeaturePreviewsVenueByShortIdQuery>(FeaturePreviewsVenueByShortIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FeaturePreviewsVenueByShortId', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;